import { gql } from 'graphql-tag';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: any; output: any; }
  AWSDateTime: { input: any; output: any; }
  AWSEmail: { input: any; output: any; }
  AWSIPAddress: { input: any; output: any; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: any; output: any; }
  AWSTime: { input: any; output: any; }
  AWSTimestamp: { input: any; output: any; }
  AWSURL: { input: any; output: any; }
};

export type AiSettings = {
  detail: Scalars['Float']['input'];
  /** @deprecated no longer used */
  humor?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated no longer used */
  length?: InputMaybe<Scalars['Float']['input']>;
  tone: Scalars['Float']['input'];
};

export type AiSettingsOutput = {
  __typename?: 'AISettingsOutput';
  detail: Scalars['Float']['output'];
  tone: Scalars['Float']['output'];
};

export type AccountType =
  | 'AGENCY'
  | 'ENTERPRISE'
  | 'FREE'
  | 'PRO';

export type ActiveBillingProduct = {
  __typename?: 'ActiveBillingProduct';
  accountType?: Maybe<AccountType>;
  activePrice: BillingPrice;
  cancelAt?: Maybe<Scalars['String']['output']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: SubscriptionStatus;
};

export type ActiveUsers = {
  __typename?: 'ActiveUsers';
  pastDay: Scalars['Int']['output'];
  pastWeek: Scalars['Int']['output'];
};

export type AddCandidateNoteInput = {
  candidateId: Scalars['String']['input'];
  content: Scalars['String']['input'];
};

export type AddCandidateToClientTokenInput = {
  candidateId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};

export type AddCompanyMembersToListInput = {
  companyMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listName: Scalars['String']['input'];
};

export type AddContactInfoToCandidateInput = {
  candidateId: Scalars['String']['input'];
  emailAddressInfo: Array<CandidateEmailAddress>;
  phoneNumbers: Array<CandidatePhoneNumberInput>;
};

export type AddDomainCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type AddJobLeadsToListInput = {
  filters?: InputMaybe<ListJobLeadsFilters>;
  jobLeadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listName: Scalars['String']['input'];
};

export type AdminStats = {
  __typename?: 'AdminStats';
  activeUsers: ActiveUsers;
  /** Total number of candidates ingested (broken). */
  candidatesInjested: Scalars['Int']['output'];
  /** Total number of sequences created. */
  sequencesCreated: Scalars['Int']['output'];
  /** Total open vacancies. */
  vacanciesCreated: Scalars['Int']['output'];
};

export type AdminStatsOutput = {
  __typename?: 'AdminStatsOutput';
  jetBridge: AdminStats;
  other: AdminStats;
};

export type AiChat = {
  __typename?: 'AiChat';
  chatId: Scalars['String']['output'];
  rows: Array<ChatRow>;
  vacancy?: Maybe<VacancyOutput>;
};

export type AiChatMessageQueued = {
  __typename?: 'AiChatMessageQueued';
  chatId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export type AiCheck =
  | 'ATTENDED_TOP_SCHOOL'
  | 'EXCELLENT_ENGLISH'
  | 'HOSTS_MEETUPS'
  | 'INTERNATIONAL_EXPERIENCE'
  | 'NOT_JOB_HOPPER'
  | 'OPEN_SOURCE_CONTRIBUTOR'
  | 'REMOTE_WORK_EXP'
  | 'WAS_TECH_LEAD'
  | 'WORKED_FOR_STARTUP';

export type AiPrompt = {
  __typename?: 'AiPrompt';
  canDelete?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type AiPromptInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
};

export type AnswersInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type ApplicationCreated = {
  __typename?: 'ApplicationCreated';
  candidateId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type ApplicationStatus =
  | 'ADDED'
  | 'DISQUALIFIED'
  | 'MAYBE'
  | 'PASSED';

export type ApproveCandidateForVacancyInput = {
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['String']['input'];
  candidateLink?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isGuideNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type Asset = {
  __typename?: 'Asset';
  contentType: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type AssetType =
  | 'CV'
  | 'EMAIL'
  | 'EMAIL_SIGNATURE';

export type AtsAddCandidateEmailInput = {
  confidenceLevel?: InputMaybe<Scalars['Float']['input']>;
  emailAddress: Scalars['String']['input'];
  type?: InputMaybe<EmailType>;
};

export type AtsAddCandidateError = {
  __typename?: 'AtsAddCandidateError';
  message: Scalars['String']['output'];
};

export type AtsAddCandidateInput = {
  atsStageId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the ATS user who is adding the candidate. */
  atsUserId: Scalars['String']['input'];
  atsVacancyId?: InputMaybe<Scalars['String']['input']>;
  candidate: AtsCandidateInput;
  tomboCandidateId: Scalars['String']['input'];
  tomboVacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type AtsAddCandidateResult = AtsAddCandidateError | AtsCandidateOutput;

export type AtsApplication = {
  __typename?: 'AtsApplication';
  addedToATSAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsId?: Maybe<Scalars['String']['output']>;
  candidateId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  rejectedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  vacancyId: Scalars['String']['output'];
};

export type AtsApplicationInput = {
  candidateId: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type AtsApplicationResponse = {
  __typename?: 'AtsApplicationResponse';
  applications: Array<AtsApplication>;
};

export type AtsApplicationStatus =
  | 'ADDED'
  | 'DISQUALIFIED'
  | 'MAYBE'
  | 'PASSED';

export type AtsCandidateInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<AtsAddCandidateEmailInput>>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  githubURL?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AtsCandidateOutput = {
  __typename?: 'AtsCandidateOutput';
  avatarThumbS3Key?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
};

export type AtsFetchApplicationsResponse = {
  __typename?: 'AtsFetchApplicationsResponse';
  applications: Array<AtsApplication>;
};

export type AtsIntegrationStatus = {
  __typename?: 'AtsIntegrationStatus';
  atsProvider?: Maybe<AtsProvider>;
  isConnected: Scalars['Boolean']['output'];
};

export type AtsProvider =
  | 'GREENHOUSE'
  | 'JETBRIDGE'
  | 'LEVER'
  | 'TRACKER';

export type AtsSaveIntegrationCredentialsInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  atsProvider?: InputMaybe<AtsProvider>;
  expiresAt?: InputMaybe<Scalars['Int']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type AtsStage = {
  __typename?: 'AtsStage';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AtsStageResult = {
  __typename?: 'AtsStageResult';
  stages: Array<AtsStage>;
};

export type AtsUpdateApplicationError = {
  __typename?: 'AtsUpdateApplicationError';
  message: Scalars['String']['output'];
};

export type AtsUpdateApplicationOutput = {
  __typename?: 'AtsUpdateApplicationOutput';
  application?: Maybe<AtsApplication>;
};

export type AtsUpdateApplicationResult = AtsUpdateApplicationError | AtsUpdateApplicationOutput;

export type AtsUser = {
  __typename?: 'AtsUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AtsUsersResponse = {
  __typename?: 'AtsUsersResponse';
  users: Array<AtsUser>;
};

export type AtsVacancy = {
  __typename?: 'AtsVacancy';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AtsVacancyResult = {
  __typename?: 'AtsVacancyResult';
  vacancies: Array<AtsVacancy>;
};

export type AudienceSize = {
  __typename?: 'AudienceSize';
  size: Scalars['Int']['output'];
};

export type AuthChallengeToken = {
  __typename?: 'AuthChallengeToken';
  /** Token that can be used for the challenge authentication flow */
  token: Scalars['String']['output'];
};

export type AutomationSettings = {
  __typename?: 'AutomationSettings';
  shouldOptimizeSendTime?: Maybe<Scalars['Boolean']['output']>;
  shouldSendFollowUps?: Maybe<Scalars['Boolean']['output']>;
};

export type AutomationSettingsInput = {
  shouldOptimizeSendTime?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSendFollowUps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BaseError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type BillingPrice = {
  __typename?: 'BillingPrice';
  id: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
  unitAmountCents?: Maybe<Scalars['Int']['output']>;
};

export type BillingProduct = {
  __typename?: 'BillingProduct';
  accountType?: Maybe<AccountType>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prices: Array<BillingPrice>;
};

export type BillingSession = {
  __typename?: 'BillingSession';
  startUrl: Scalars['String']['output'];
};

export type BillingStatus = {
  __typename?: 'BillingStatus';
  accountType: AccountType;
  activeProduct?: Maybe<ActiveBillingProduct>;
  enabledFeatures: Array<Scalars['String']['output']>;
  isSubscriptionActive: Scalars['Boolean']['output'];
  lastPaymentFailedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  quotas: Array<Quota>;
  seats?: Maybe<Scalars['Int']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  teamOwnerId?: Maybe<Scalars['String']['output']>;
};

export type BrandType =
  | 'GLOBAL'
  | 'LUXURY'
  | 'UPSTART';

export type Call = {
  __typename?: 'Call';
  candidateId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  dialAction?: Maybe<DialAction>;
  direction: CallDirection;
  duration?: Maybe<Scalars['Int']['output']>;
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ringbackNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  to: Scalars['String']['output'];
  twilioCallSid: Scalars['String']['output'];
  userMessage?: Maybe<Scalars['String']['output']>;
};

export type CallContactRecordDetails = {
  __typename?: 'CallContactRecordDetails';
  callDuration: Scalars['Int']['output'];
};

export type CallDirection =
  | 'INBOUND'
  | 'OUTBOUND';

export type CancelSequenceInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  sequenceId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelSequenceResponse = {
  __typename?: 'CancelSequenceResponse';
  messagesCount: Scalars['Int']['output'];
};

export type CancelTeamInvite = {
  email: Scalars['String']['input'];
};

export type CancelTeamInviteResult = {
  __typename?: 'CancelTeamInviteResult';
  canceledInviteId: Scalars['String']['output'];
};

export type CandidateApplicationData = {
  __typename?: 'CandidateApplicationData';
  adjustedScore?: Maybe<Scalars['Float']['output']>;
  candidate: CandidateOutput;
  hasCV?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  survey?: Maybe<Array<SurveyData>>;
};

export type CandidateCertificateInput = {
  authority?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timePeriodEndMonth?: InputMaybe<Scalars['Int']['input']>;
  timePeriodEndYear?: InputMaybe<Scalars['Int']['input']>;
  timePeriodStartMonth?: InputMaybe<Scalars['Int']['input']>;
  timePeriodStartYear?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateCompanyExperience = {
  __typename?: 'CandidateCompanyExperience';
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roles?: Maybe<Array<CandidateCompanyRoleExperience>>;
};

export type CandidateCompanyExperienceOutput = {
  __typename?: 'CandidateCompanyExperienceOutput';
  skillsExperience?: Maybe<Array<CandidateSkillExperience>>;
};

export type CandidateCompanyRoleExperience = {
  __typename?: 'CandidateCompanyRoleExperience';
  endDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  technologies?: Maybe<Array<Scalars['String']['output']>>;
};

export type CandidateContactHistory = {
  __typename?: 'CandidateContactHistory';
  items: Array<CandidateContactRecord>;
  total: Scalars['Int']['output'];
};

export type CandidateContactHistoryFilter = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  query?: InputMaybe<Scalars['String']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CandidateContactStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateContactHistoryItem = {
  __typename?: 'CandidateContactHistoryItem';
  createdAt: Scalars['AWSDateTime']['output'];
  gmailThreadId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  messages: Array<MessageItem>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type CandidateContactHistoryResponse = {
  __typename?: 'CandidateContactHistoryResponse';
  items: Array<CandidateContactHistoryItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
  stats: ThreadStats;
  total: Scalars['Int']['output'];
};

export type CandidateContactPendingReason =
  | 'CANDIDATE_EMAIL_MISSING'
  | 'SEQUENCER_NOT_CONNECTED'
  | 'UNKNOWN';

export type CandidateContactRecord = {
  __typename?: 'CandidateContactRecord';
  callDetails?: Maybe<CallContactRecordDetails>;
  emailDetails?: Maybe<EmailContactRecordDetails>;
  /** When the SMS or EMAIL was sent, or when the CALL was placed. */
  placedAt: Scalars['AWSDateTime']['output'];
  /** The ID of the resource (emailCandidateSent/message/callDetail). */
  resourceId: Scalars['String']['output'];
  smsDetails?: Maybe<SmsContactRecordDetails>;
  type: CandidateContactRecordType;
  /** Who contacted the candidate. */
  user: User;
};

export type CandidateContactRecordType =
  | 'CALL'
  | 'EMAIL'
  | 'SMS';

export type CandidateContactStatus =
  | 'ALL'
  | 'EMAIL_BOUNCED'
  | 'EMAIL_PENDING'
  | 'EMAIL_SENT';

export type CandidateData = {
  avatarS3Bucket?: InputMaybe<Scalars['String']['input']>;
  avatarThumbOrigUrl?: InputMaybe<Scalars['String']['input']>;
  avatarThumbS3Key?: InputMaybe<Scalars['String']['input']>;
  birthdayMonth?: InputMaybe<Scalars['Int']['input']>;
  birthdayYear?: InputMaybe<Scalars['Int']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  emailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  githubURL?: InputMaybe<Scalars['String']['input']>;
  hasInterview?: InputMaybe<Scalars['Boolean']['input']>;
  isStudent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  liHeadline?: InputMaybe<Scalars['String']['input']>;
  liSummary?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CandidateEducationInput = {
  degreeName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<SchoolInput>;
  timePeriodEndMonth?: InputMaybe<Scalars['Int']['input']>;
  timePeriodEndYear?: InputMaybe<Scalars['Int']['input']>;
  timePeriodStartMonth?: InputMaybe<Scalars['Int']['input']>;
  timePeriodStartYear?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateEmailAddress = {
  confidenceLevel?: InputMaybe<Scalars['Float']['input']>;
  emailAddress: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  source: EmailSource;
  type: EmailType;
};

export type CandidateEmailAddressOutput = {
  __typename?: 'CandidateEmailAddressOutput';
  confidenceLevel?: Maybe<Scalars['Float']['output']>;
  emailAddress: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: EmailType;
};

export type CandidateEmailOutput = {
  __typename?: 'CandidateEmailOutput';
  confidenceLevel?: Maybe<Scalars['Float']['output']>;
  emailAddress: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Weighted preference to select this address, 0-1. */
  preferenceWeight?: Maybe<Scalars['Float']['output']>;
  type: EmailType;
};

export type CandidateFeedbackChatCreated = {
  __typename?: 'CandidateFeedbackChatCreated';
  aiReplyTaskId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CandidateFormResponseInput = {
  candidateId: Scalars['String']['input'];
  formQuestionId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  responseValue?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateFormResponseOutput = {
  __typename?: 'CandidateFormResponseOutput';
  Candidate: FormCandidateDirectOutput;
  FormQuestion: FormQuestionDirectOutput;
  User: FormUserDirectOutput;
  id: Scalars['String']['output'];
  responseValue?: Maybe<Scalars['String']['output']>;
};

export type CandidateFormResponseRawOutput = {
  __typename?: 'CandidateFormResponseRawOutput';
  id: Scalars['String']['output'];
};

export type CandidateHonorInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  issueMonth?: InputMaybe<Scalars['Int']['input']>;
  issueYear?: InputMaybe<Scalars['Int']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CandidateInListOutput = {
  __typename?: 'CandidateInListOutput';
  candidate: CandidateOutput;
  dateAdded: Scalars['AWSDateTime']['output'];
};

export type CandidateInput = {
  id: Scalars['String']['input'];
};

export type CandidateInterview = {
  __typename?: 'CandidateInterview';
  CandidateInterviewFormSections?: Maybe<Array<CandidateInterviewFormSectionsOutput>>;
  candidateId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: InterviewType;
};

export type CandidateInterviewBlobs = {
  __typename?: 'CandidateInterviewBlobs';
  text: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CandidateInterviewFormSectionsOutput = {
  __typename?: 'CandidateInterviewFormSectionsOutput';
  FormSection?: Maybe<FormSectionOutput>;
  candidateInterviewId: Scalars['String']['output'];
  formSectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CandidateInterviewNote = {
  __typename?: 'CandidateInterviewNote';
  blurredText?: Maybe<Scalars['String']['output']>;
  interviewer?: Maybe<Interviewer>;
  questionId: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CandidateInterviewSectionsInput = {
  candidateId: Scalars['String']['input'];
  interviewId?: InputMaybe<Scalars['String']['input']>;
  sections: Array<Scalars['String']['input']>;
  type: InterviewType;
};

export type CandidateInterviewSummaryReview = {
  __typename?: 'CandidateInterviewSummaryReview';
  interviewer?: Maybe<Interviewer>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CandidateList = {
  __typename?: 'CandidateList';
  candidateCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  vacancyId?: Maybe<Scalars['String']['output']>;
};

export type CandidateListExport = {
  __typename?: 'CandidateListExport';
  csvUrl: Scalars['String']['output'];
};

export type CandidateMatch = {
  __typename?: 'CandidateMatch';
  candidateList?: Maybe<Scalars['Float']['output']>;
};

export type CandidateMatchAlgorithm =
  | 'DEFAULT'
  | 'JOB_TITLE'
  | 'KEYWORDS'
  | 'LLM'
  | 'VACANCY_SCORE';

export type CandidateMultiSelectItem = {
  __typename?: 'CandidateMultiSelectItem';
  label: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type CandidateNote = {
  __typename?: 'CandidateNote';
  author: User;
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type CandidateOutput = {
  __typename?: 'CandidateOutput';
  atsId?: Maybe<Scalars['String']['output']>;
  avatarS3Bucket?: Maybe<Scalars['String']['output']>;
  avatarThumbOrigUrl?: Maybe<Scalars['String']['output']>;
  avatarThumbS3Key?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['AWSDateTime']['output']>;
  candidateLists?: Maybe<Array<CandidateList>>;
  candidatePublicId?: Maybe<Scalars['String']['output']>;
  candidateRawId?: Maybe<Scalars['String']['output']>;
  certificates?: Maybe<Array<Scalars['String']['output']>>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  education?: Maybe<Array<CandidateSchoolExperience>>;
  emailAddresses?: Maybe<Array<CandidateEmailOutput>>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  githubURL?: Maybe<Scalars['String']['output']>;
  hasCV?: Maybe<Scalars['Boolean']['output']>;
  hasInterview?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isStudent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastOpenedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  liHeadline?: Maybe<Scalars['String']['output']>;
  liSummary?: Maybe<Scalars['String']['output']>;
  linkOpens?: Maybe<Array<ShareableLinkOpen>>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  negativeOPCs?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use notesFull instead */
  notes?: Maybe<Array<Scalars['String']['output']>>;
  notesFull?: Maybe<Array<CandidateNote>>;
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  phoneNumbersFull?: Maybe<Array<CandidatePhoneNumberOutput>>;
  positiveOPCs?: Maybe<Array<Scalars['String']['output']>>;
  projects?: Maybe<Array<Project>>;
  skills?: Maybe<Array<CandidateSkillExperience>>;
  slugs?: Maybe<Array<Scalars['String']['output']>>;
  source?: Maybe<CandidateSource>;
  sourceVersion?: Maybe<Scalars['String']['output']>;
  teammateCandidateLists?: Maybe<Array<OtherUserCandidate>>;
  topSkills?: Maybe<TopSkillsOutput>;
  vacancyMatch?: Maybe<CandidateMatch>;
  websites?: Maybe<Array<CandidateWebsiteOutput>>;
  workExperience?: Maybe<Array<WorkExperienceOutput>>;
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
};

export type CandidatePercentageItem = {
  __typename?: 'CandidatePercentageItem';
  label: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CandidatePhoneNumber = {
  __typename?: 'CandidatePhoneNumber';
  number: Scalars['String']['output'];
};

export type CandidatePhoneNumberInput = {
  deviceType?: InputMaybe<PhoneDeviceType>;
  number: Scalars['String']['input'];
  type?: InputMaybe<PhoneType>;
};

export type CandidatePhoneNumberOutput = {
  __typename?: 'CandidatePhoneNumberOutput';
  deviceType?: Maybe<PhoneDeviceType>;
  phoneNumber: Scalars['String']['output'];
  type?: Maybe<PhoneType>;
};

export type CandidateProfileHeader = {
  __typename?: 'CandidateProfileHeader';
  avatarS3Bucket?: Maybe<Scalars['String']['output']>;
  avatarThumbS3Key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  skillSummaries: Array<CandidateMultiSelectItem>;
};

export type CandidateProfileOutput = {
  __typename?: 'CandidateProfileOutput';
  blobs: Array<CandidateInterviewBlobs>;
  candidateId: Scalars['String']['output'];
  education: Array<CandidateSchoolExperience>;
  header: CandidateProfileHeader;
  interviewSummaries: Array<CandidateInterviewSummaryReview>;
  isCandidateAlreadyApproved: Scalars['Boolean']['output'];
  leftColumn: Array<CandidateSection>;
  recentProjects?: Maybe<Array<RecentProject>>;
  rightColumn: Array<CandidateSection>;
  yearsOfExperience: Array<YearsOfExperience>;
};

export type CandidateProfileSkillExperience = {
  __typename?: 'CandidateProfileSkillExperience';
  label: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type CandidatePublicationInput = {
  dateMonth?: InputMaybe<Scalars['Int']['input']>;
  dateYear?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateScaleItem = {
  __typename?: 'CandidateScaleItem';
  label: Scalars['String']['output'];
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CandidateSchoolExperience = {
  __typename?: 'CandidateSchoolExperience';
  degree?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isTopSchool?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CandidateSearch = {
  __typename?: 'CandidateSearch';
  company?: Maybe<Array<NegationOption>>;
  createdBy: CandidateSearchAuthor;
  freeTextSearch?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Array<NegationOption>>;
  location?: Maybe<Array<LocationNegationOption>>;
  name: Scalars['String']['output'];
  school?: Maybe<Array<NegationOption>>;
  skills?: Maybe<Array<NegationOption>>;
};

export type CandidateSearchAuthor = {
  __typename?: 'CandidateSearchAuthor';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CandidateSearchResult = {
  __typename?: 'CandidateSearchResult';
  items: Array<CandidateSearch>;
  total: Scalars['Int']['output'];
};

export type CandidateSection = {
  __typename?: 'CandidateSection';
  elements?: Maybe<Array<SectionElement>>;
  title: Scalars['String']['output'];
};

export type CandidateSelectItem = {
  __typename?: 'CandidateSelectItem';
  label: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CandidateSkillExperience = {
  __typename?: 'CandidateSkillExperience';
  isFulfilled?: Maybe<Scalars['Boolean']['output']>;
  skillName: Scalars['String']['output'];
  yearsOfExperience?: Maybe<Scalars['Float']['output']>;
};

export type CandidateSkillInput = {
  endorsementCount?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seniority?: InputMaybe<Scalars['Float']['input']>;
  validatedByLinkedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CandidateSource =
  | 'BREEZY'
  | 'BROWSER_EXTENSION'
  | 'BROWSER_EXTENSION_LINKEDIN_PUBLIC'
  | 'BROWSER_EXTENSION_LINKEDIN_RECRUITER'
  | 'CV_AI_PARSER'
  | 'GITHUB_CRAWLER'
  | 'INTERVIEW_FORMS'
  | 'LAZY'
  | 'LEGACY_HR_TOOL'
  | 'LINKEDIN'
  | 'PDL'
  | 'REPARSE'
  | 'SH'
  | 'SQL'
  | 'USER_UPLOAD';

export type CandidateStatsCheckList = {
  __typename?: 'CandidateStatsCheckList';
  items?: Maybe<Array<CheckListItem>>;
  questionId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type CandidateStatsSlidersList = {
  __typename?: 'CandidateStatsSlidersList';
  items?: Maybe<Array<Slider>>;
  questionId: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type CandidateUpdated = {
  __typename?: 'CandidateUpdated';
  candidateId: Scalars['String']['output'];
  mergedToCandidateId?: Maybe<Scalars['String']['output']>;
};

export type CandidateUserAction = {
  action: CandidateUserActionType;
  candidateId: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateUserActionType =
  | 'AUTO_LI_INVITE';

export type CandidateVacancyMatch = {
  __typename?: 'CandidateVacancyMatch';
  adjustedMatch?: Maybe<CandidateVacancyMatchMatch>;
  approvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  candidate?: Maybe<CandidateOutput>;
  candidateId: Scalars['String']['output'];
  isNewMatch?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<CandidateVacancyMatchMatch>;
  vacancy: VacancyOutput;
};

export type CandidateVacancyMatchCollection = {
  __typename?: 'CandidateVacancyMatchCollection';
  items: Array<CandidateVacancyMatch>;
  page?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type CandidateVacancyMatchMatch = {
  __typename?: 'CandidateVacancyMatchMatch';
  adjustedMatch?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  match?: Maybe<Scalars['Float']['output']>;
  matchType: MatchType;
  viewedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type CandidateWebsiteInput = {
  __typename?: 'CandidateWebsiteInput';
  label?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CandidateWebsiteOutput = {
  __typename?: 'CandidateWebsiteOutput';
  label?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CandidatesSortBy =
  | 'DATE_ADDED'
  | 'NAME';

export type Certificate = Node & {
  __typename?: 'Certificate';
  authority?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  vertical?: Maybe<Vertical>;
};

export type CertificateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CertificateSearchResponse = SearchResponse & {
  __typename?: 'CertificateSearchResponse';
  items: Array<Certificate>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ChangeTeamRoles = {
  roles: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ChangeTeamRolesResult = {
  __typename?: 'ChangeTeamRolesResult';
  user: UserOutput;
};

export type ChatMicro =
  | 'CREATE_INTERVIEW_QUESTIONS'
  | 'FIND_CANDIDATES'
  | 'GENERATE_BOOLEAN_SEARCH'
  | 'REWRITE_JOB_DESCRIPTION'
  | 'WRITE_JOB_DESCRIPTION';

export type ChatRole =
  | 'assistant'
  | 'function'
  | 'system'
  | 'user';

export type ChatRow = {
  __typename?: 'ChatRow';
  content: Scalars['String']['output'];
  extraDataJSON?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  rating: Scalars['Int']['output'];
  role: ChatRole;
  vacancyId?: Maybe<Scalars['String']['output']>;
};

export type ChatRowInput = {
  content: Scalars['String']['input'];
  role: ChatRole;
};

export type CheckListItem = {
  __typename?: 'CheckListItem';
  label: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ClientInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClientSideBillingSession = {
  __typename?: 'ClientSideBillingSession';
  clientSecret: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type ClientToken = {
  __typename?: 'ClientToken';
  candidates: Array<ClientTokenCandidate>;
  id: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  vacancyId: Scalars['String']['output'];
};

export type ClientTokenCandidate = {
  __typename?: 'ClientTokenCandidate';
  candidateId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  shareableCandidateId: Scalars['String']['output'];
};

export type CommissionPlanType =
  | 'COMPETITIVE'
  | 'UNCAPPED'
  | 'VERY_COMPETITIVE';

export type Company = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyMember = {
  __typename?: 'CompanyMember';
  company?: Maybe<CompanyOutput>;
  emailAddresses: Array<CandidateEmailOutput>;
  firstName?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<CandidatePhoneNumberOutput>;
};

export type CompanyMemberList = {
  __typename?: 'CompanyMemberList';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CompanyOutput = {
  __typename?: 'CompanyOutput';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CompanySize = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanySizeOutput = {
  __typename?: 'CompanySizeOutput';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type ContactHistoryFieldOrder = {
  column: ContactHistoryOrderByField;
  order?: InputMaybe<Order>;
};

export type ContactHistoryOrderByField =
  | 'CANDIDATE_NAME'
  | 'CREATED_AT'
  | 'DELIVERED_AT';

export type Coords = {
  __typename?: 'Coords';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CoordsInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CopyShareableLinkInput = {
  sourceLinkId: Scalars['String']['input'];
};

export type CreateCandidateAiMatch = {
  adjustedMatch?: InputMaybe<Scalars['Float']['input']>;
  aiVersion: Scalars['Int']['input'];
  candidateId: Scalars['String']['input'];
  candidateRawId?: InputMaybe<Scalars['String']['input']>;
  match: Scalars['Float']['input'];
  vacancyId: Scalars['String']['input'];
};

export type CreateCandidateApplication = {
  candidate: CandidateData;
  externalApplicationId?: InputMaybe<Scalars['String']['input']>;
  survey?: InputMaybe<Array<SurveyQuestion>>;
  vacancyId: Scalars['String']['input'];
};

export type CreateCandidateHumanAssistedMatch = {
  candidateLinkedInUrl: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};

export type CreateCandidateMatch = {
  aiMatch?: InputMaybe<CreateCandidateAiMatch>;
  humanAssistedMatch?: InputMaybe<CreateCandidateHumanAssistedMatch>;
};

export type CreateDeleteManyResponse = {
  __typename?: 'CreateDeleteManyResponse';
  count?: Maybe<Scalars['Int']['output']>;
};

export type CreateEmailStubsInput = {
  emailStubs?: InputMaybe<Array<EmailStubInput>>;
  excludeCandidateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<EmailSequenceState>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  vacancyId: Scalars['String']['input'];
};

export type CreateInAppMessageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  audienceTypesNegative: Array<InAppMessageAudienceType>;
  audienceTypesPositive: Array<InAppMessageAudienceType>;
  bodyHtml: Scalars['String']['input'];
};

export type CreateJobTitleInput = {
  title: Scalars['String']['input'];
  vertical?: InputMaybe<Vertical>;
};

export type CreateSequenceTemplateArgsV2 = {
  isFollowUpEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  stageTemplates: Array<SequenceStageTemplateArgs>;
};

export type CreateSequenceTemplateInput = {
  emailTemplates: Array<SequencedEmailTemplate>;
  isEmailFollowUpEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateShareableLink = {
  candidateId: Scalars['String']['input'];
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shouldObfuscate: Scalars['Boolean']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserTaskInput = {
  assigneeUserId: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['String']['input']>;
  deadlineAt: Scalars['AWSDateTime']['input'];
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateVacancyForUserInput = {
  userId: Scalars['String']['input'];
  vacancyData: UpdateVacancyDataInput;
};

export type Cursor = {
  createdAt: Scalars['AWSDateTime']['input'];
  id: Scalars['String']['input'];
};

export type DailySummary = {
  __typename?: 'DailySummary';
  date: Scalars['AWSDateTime']['output'];
  summary: UserActivitySummary;
};

export type DateRange = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DeleteCandidateMatchInput = {
  candidateId: Scalars['String']['input'];
  type?: InputMaybe<MatchType>;
  vacancyId: Scalars['String']['input'];
};

export type DeleteDomainCategoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteLogoInput = {
  logoType: LogoType;
  shareableLinkId?: InputMaybe<Scalars['String']['input']>;
};

export type DemoCandidateOutput = {
  __typename?: 'DemoCandidateOutput';
  avatarS3Bucket?: Maybe<Scalars['String']['output']>;
  avatarThumbOrigUrl?: Maybe<Scalars['String']['output']>;
  avatarThumbS3Key?: Maybe<Scalars['String']['output']>;
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  birthdayYear?: Maybe<Scalars['Int']['output']>;
  candidateLists?: Maybe<Array<CandidateList>>;
  country?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  githubURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isStudent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  liHeadline?: Maybe<Scalars['String']['output']>;
  liSummary?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CandidateSource>;
  sourceVersion?: Maybe<Scalars['String']['output']>;
  vacancyId?: Maybe<Scalars['String']['output']>;
  vacancyMatch?: Maybe<DemoVacancyCandidateMatchOutput>;
};

export type DemoVacancyCandidateMatchOutput = {
  __typename?: 'DemoVacancyCandidateMatchOutput';
  aiChecks?: Maybe<Array<AiCheck>>;
  match: Scalars['Float']['output'];
  mustHaveMatch?: Maybe<VacancyCandidateSkillMatchOutput>;
  niceToHaveMatch?: Maybe<VacancyCandidateSkillMatchOutput>;
};

export type DemoVacancyOutput = {
  __typename?: 'DemoVacancyOutput';
  candidate: DemoCandidateOutput;
  candidateList?: Maybe<CandidateList>;
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  funnelId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  leadUserId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  positionCount: Scalars['Int']['output'];
  priority: VacancyPriority;
  status: VacancyStatus;
};

export type DesiredSkill = {
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  seniority?: InputMaybe<Seniority>;
  skill: DesiredSkillSkill;
  yearsOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export type DesiredSkillSkill = {
  /**
   * Please set id if possible.
   * In the future we should make this required.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DeveloperSearchAttribute = {
  __typename?: 'DeveloperSearchAttribute';
  category: DeveloperSearchAttributeCategory;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  synonyms: Array<Scalars['String']['output']>;
};

export type DeveloperSearchAttributeCategory =
  | 'EDUCATION'
  | 'LOCATION'
  | 'SENIORITY'
  | 'TECHNOLOGIES';

export type DeveloperSearchInput = {
  education?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  rawQuery: Scalars['String']['input'];
  seniority?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
};

export type DeveloperSearchResponse = {
  __typename?: 'DeveloperSearchResponse';
  items: Array<CandidateOutput>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type Dial = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  preRecordedVoicemailMessageId?: InputMaybe<Scalars['String']['input']>;
  ringbackNumber: Scalars['String']['input'];
  to: Scalars['String']['input'];
  useLocalNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DialAction =
  | 'PLAY_VOICEMAIL_IN_BROWSER';

export type DomainCategories = {
  __typename?: 'DomainCategories';
  items: Array<DomainCategory>;
};

export type DomainCategory = {
  __typename?: 'DomainCategory';
  color?: Maybe<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DomainCategorySummary = {
  __typename?: 'DomainCategorySummary';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type DomainTimeSpent = {
  __typename?: 'DomainTimeSpent';
  domain: Scalars['String']['output'];
  timeSpent: Scalars['Float']['output'];
};

export type DomainTimeSpentInput = {
  searchInput?: InputMaybe<SearchInput>;
  timeRange?: InputMaybe<TimeRange>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DomainTimeSpentResponse = {
  __typename?: 'DomainTimeSpentResponse';
  items: Array<DomainTimeSpent>;
  total: Scalars['Int']['output'];
};

export type EditProfileChunk = {
  chunkId: Scalars['String']['input'];
  chunkType: ProfileChunkType;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EmailContactRecordDetails = {
  __typename?: 'EmailContactRecordDetails';
  content: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailProvider =
  | 'GMAIL'
  | 'MICROSOFT';

export type EmailRecipient = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailSequence = {
  __typename?: 'EmailSequence';
  candidate?: Maybe<CandidateOutput>;
  candidateId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  emails: Array<MessageItem>;
  id: Scalars['String']['output'];
  state: EmailSequenceState;
  vacancy?: Maybe<VacancyOutput>;
};

export type EmailSequenceStage = {
  bcc?: InputMaybe<Array<EmailRecipient>>;
  bodyHtml: Scalars['String']['input'];
  cc?: InputMaybe<Array<EmailRecipient>>;
  /** How many days after the previous stage we should send the email. */
  offsetDays: Scalars['Int']['input'];
  /** The stage index in the sequence. */
  stageIndex: Scalars['Int']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  to: Array<EmailRecipient>;
};

export type EmailSequenceState =
  | 'CREATED'
  | 'FILLED_BY_USER'
  | 'PROCESSING'
  | 'READY_TO_FILL_BY_TEMPLATE'
  | 'READY_TO_GENERATE_BY_AI'
  | 'READY_TO_SENT'
  | 'SENT';

export type EmailSource =
  | 'API'
  | 'GITHUB'
  | 'KENDO'
  | 'LINKEDIN'
  | 'OTHER'
  | 'PDL'
  | 'PROXYCURL'
  | 'SH'
  | 'SQL'
  | 'USER_INPUT';

export type EmailStubInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  candidateId: Scalars['String']['input'];
};

export type EmailTemplateOutput = {
  __typename?: 'EmailTemplateOutput';
  afterEmail?: Maybe<Scalars['Int']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  bodyHtml: Scalars['String']['output'];
  canBeEdited?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sendDelayInHours?: Maybe<Scalars['Int']['output']>;
  subject: Scalars['String']['output'];
  type?: Maybe<EmailTemplateType>;
  vacancies?: Maybe<Array<VacancyOutput>>;
};

export type EmailTemplateType =
  | 'EMAIL'
  | 'SMS';

export type EmailType =
  | 'OTHER'
  | 'PRIVATE'
  | 'WORK';

export type EmploymentType =
  | 'BOTH'
  | 'FULL_TIME'
  | 'PART_TIME';

export type Event = {
  __typename?: 'Event';
  color?: Maybe<Scalars['String']['output']>;
  domainCategory?: Maybe<DomainCategory>;
  name: UserActivityEvent;
  offset?: Maybe<Scalars['Float']['output']>;
  recordedAt: Scalars['String']['output'];
  vacancy?: Maybe<Scalars['String']['output']>;
};

export type EventSummary = {
  __typename?: 'EventSummary';
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type EventTypeStat = {
  count?: InputMaybe<Scalars['Int']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
};

export type Feature =
  | 'ats_integration'
  | 'call_minutes'
  | 'call_recording_minutes'
  | 'candidate_match'
  | 'email_lookup'
  | 'email_replies'
  | 'job_leads'
  | 'phone_calls'
  | 'red_flags'
  | 'send_emails'
  | 'send_sms'
  | 'team_performance';

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  atsIntegrations?: Maybe<Scalars['Boolean']['output']>;
  autoInvite?: Maybe<Scalars['Boolean']['output']>;
  candidateMatch?: Maybe<Scalars['Boolean']['output']>;
  candidateSearch?: Maybe<Scalars['Boolean']['output']>;
  clientTokens?: Maybe<Scalars['Boolean']['output']>;
  jobLeads?: Maybe<Scalars['Boolean']['output']>;
  micros?: Maybe<Scalars['Boolean']['output']>;
  skillPopup?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Boolean']['output']>;
  stackRank?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Scalars['Boolean']['output']>;
  telephony?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldOrder = {
  column: Scalars['String']['input'];
  order?: InputMaybe<Order>;
};

export type FileInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type FilterAllVacancies = {
  inStatus?: InputMaybe<Array<VacancyStatus>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type FlowType =
  | 'payment_method_update'
  | 'subscription_cancel'
  | 'subscription_update';

export type FollowUpEmail = {
  bodyHtml: Scalars['String']['input'];
  /** Not used at the moment, BE will decide when to send the email. */
  sendAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type FormCandidateDirectOutput = {
  __typename?: 'FormCandidateDirectOutput';
  id: Scalars['String']['output'];
};

export type FormQuestionDirectOutput = {
  __typename?: 'FormQuestionDirectOutput';
  FormSection?: Maybe<FormSectionDirectOutput>;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questionOptions: Array<Scalars['String']['output']>;
  questionType: QuestionType;
  visibilityType: QuestionVisibilityType;
};

export type FormQuestionOutput = {
  __typename?: 'FormQuestionOutput';
  FormSection?: Maybe<FormSectionOutput>;
  FormSubSection?: Maybe<FormSubSectionOutput>;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questionOptions: Array<Scalars['String']['output']>;
  questionType: QuestionType;
  visibilityType: QuestionVisibilityType;
};

export type FormQuestionSectionOutput = {
  __typename?: 'FormQuestionSectionOutput';
  FormSection?: Maybe<FormSectionOutput>;
  Responses: Array<ResponseOutput>;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  questionOptions: Array<Scalars['String']['output']>;
  questionType: QuestionType;
  visibilityType: QuestionVisibilityType;
};

export type FormQuestionUpdateInput = {
  formSectionId?: InputMaybe<Scalars['String']['input']>;
  formSubSectionId?: InputMaybe<Scalars['String']['input']>;
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  questionOptions: Array<Scalars['String']['input']>;
  questionType: QuestionType;
  visibilityType?: InputMaybe<QuestionVisibilityType>;
};

export type FormQuestionUpdateManyInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type FormSectionData = {
  FormQuestions: Array<FormQuestionUpdateManyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  formSectionGroupId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  staticSectionType?: InputMaybe<StaticSectionType>;
};

export type FormSectionDirectOutput = {
  __typename?: 'FormSectionDirectOutput';
  FormSectionGroup?: Maybe<FormSectionGroupDirectOutput>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  staticSectionType?: Maybe<StaticSectionType>;
};

export type FormSectionGroupData = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FormSectionGroupDirectOutput = {
  __typename?: 'FormSectionGroupDirectOutput';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FormSectionGroupOutput = {
  __typename?: 'FormSectionGroupOutput';
  FormSections: Array<FormSectionDirectOutput>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FormSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  formSectionGroupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  staticSectionType?: InputMaybe<StaticSectionType>;
};

export type FormSectionOutput = {
  __typename?: 'FormSectionOutput';
  FormQuestions: Array<FormQuestionSectionOutput>;
  FormSectionGroup?: Maybe<FormSectionGroupDirectOutput>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  staticSectionType?: Maybe<StaticSectionType>;
};

export type FormSectionUpdateManyInput = {
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type FormSubSectionInput = {
  formSectionId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type FormSubSectionOutput = {
  __typename?: 'FormSubSectionOutput';
  FormQuestions: Array<FormQuestionSectionOutput>;
  FormSection: FormSectionOutput;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type FormTemplateData = {
  FormSections: Array<FormSectionUpdateManyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FormTemplateDirectOutput = {
  __typename?: 'FormTemplateDirectOutput';
  FormSections: Array<FormSectionDirectOutput>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type FormTemplateOutput = {
  __typename?: 'FormTemplateOutput';
  FormSections: Array<FormSectionOutput>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type FormUserDirectOutput = {
  __typename?: 'FormUserDirectOutput';
  id: Scalars['String']['output'];
};

export type FullName = {
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type GalleryPreUpload = {
  filename: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'OTHER';

export type GetAllMessages = {
  filter: InAppMessageFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAllMessagesResponse = {
  __typename?: 'GetAllMessagesResponse';
  messages: Array<InAppMessage>;
  total: Scalars['Int']['output'];
};

export type GetAudienceSizeInput = {
  audienceTypesNegative: Array<InAppMessageAudienceType>;
  audienceTypesPositive: Array<InAppMessageAudienceType>;
};

export type GetCandidateApplicationsInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  excludeCandidateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchInput?: InputMaybe<SearchInput>;
  vacancyId: Scalars['String']['input'];
};

export type GetCandidateExperienceInput = {
  candidateId: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type GetCandidateThreadInput = {
  candidateId: Scalars['String']['input'];
};

export type GetCandidateThreadResponse = {
  __typename?: 'GetCandidateThreadResponse';
  thread?: Maybe<TelephonyMessageThread>;
};

export type GetCandidateVacancyMatchOutput = {
  __typename?: 'GetCandidateVacancyMatchOutput';
  match?: Maybe<VacancyCandidateMatchOutput>;
  vacancy: VacancyOutput;
};

export type GetEmailCompletion = {
  candidateId: Scalars['String']['input'];
  candidateLinkedInUrl: Scalars['String']['input'];
  candidatesFirstName: Scalars['String']['input'];
  commonGroups?: InputMaybe<Array<PromptGroup>>;
  commonSchools?: InputMaybe<Array<PromptSchool>>;
  friendsInCommon?: InputMaybe<Array<Scalars['String']['input']>>;
  settings?: InputMaybe<AiSettings>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  vacancyId: Scalars['String']['input'];
};

export type GetEmailCompletionResponse = {
  __typename?: 'GetEmailCompletionResponse';
  body: Scalars['String']['output'];
  id: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type GetEmailSequenceInput = {
  emailSequenceId: Scalars['String']['input'];
  emailType?: InputMaybe<MassEmailType>;
  generateEmailIfEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetEmailsForInput = {
  candidateId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};

export type GetSkillsForTitle = {
  titles: Array<Scalars['String']['input']>;
};

export type GetVacancyInput = {
  atsLink?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type ImpersonateUser = {
  email: Scalars['String']['input'];
};

export type ImpersonateUserError = BaseError & {
  __typename?: 'ImpersonateUserError';
  message: Scalars['String']['output'];
};

export type ImpersonateUserOutput = {
  __typename?: 'ImpersonateUserOutput';
  authToken: Scalars['String']['output'];
  user: ImpersonateUserOutputUser;
};

export type ImpersonateUserOutputUser = {
  __typename?: 'ImpersonateUserOutputUser';
  tomboUserId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ImpersonateUserResult = ImpersonateUserError | ImpersonateUserOutput;

export type InAppMessage = {
  __typename?: 'InAppMessage';
  audienceTypesNegative: Array<InAppMessageAudienceType>;
  audienceTypesPositive: Array<InAppMessageAudienceType>;
  bodyHtml: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sizeCreated?: Maybe<Scalars['Int']['output']>;
  sizeRead?: Maybe<Scalars['Int']['output']>;
};

export type InAppMessageAudienceType =
  | 'CONNECTED_EMAIL'
  | 'CREATED_VACANCY'
  | 'IN_TEAM'
  | 'MADE_PHONE_CALL'
  | 'SEND_EMAIL'
  | 'SEND_SMS'
  | 'USED_CHAT';

export type InAppMessageFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InAppMessageInteractionType =
  | 'CLICK'
  | 'DISMISS'
  | 'READ';

export type InitParseDescriptionOutput = {
  __typename?: 'InitParseDescriptionOutput';
  clientVacancyChatId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  vacancy?: Maybe<VacancyOutput>;
  vacancyId?: Maybe<Scalars['String']['output']>;
};

export type InitiateCheckoutInput = {
  cancelUrl: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type InterviewLogInput = {
  candidateId: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  interviewId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  type?: InputMaybe<LogType>;
};

export type InterviewLogOutput = {
  __typename?: 'InterviewLogOutput';
  Candidate?: Maybe<FormCandidateDirectOutput>;
  User?: Maybe<User>;
  createdAt: Scalars['AWSDateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: LogType;
};

export type InterviewLogUpdateInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  interviewId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LogType>;
};

export type InterviewType =
  | 'SOFT_SKILLS'
  | 'TECHNICAL';

export type Interviewer = {
  __typename?: 'Interviewer';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  company?: Maybe<InterviewerCompany>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
};

export type InterviewerCompany = {
  __typename?: 'InterviewerCompany';
  name?: Maybe<Scalars['String']['output']>;
};

export type Interviews = {
  __typename?: 'Interviews';
  SOFT_SKILLS?: Maybe<CandidateInterview>;
  TECHNICAL?: Maybe<CandidateInterview>;
};

export type Invite = {
  __typename?: 'Invite';
  /** Time the invite was first sent. */
  createdAt: Scalars['AWSDateTime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** The user who invited this user. */
  inviter: Inviter;
  /** A URL that can be used to join the team. */
  joinUrl: Scalars['String']['output'];
  /** Cognito groups. */
  roles?: Maybe<Array<Scalars['String']['output']>>;
  /** Time the invite was last sent. */
  sentAt: Scalars['AWSDateTime']['output'];
  /** Set if the user has accepted the invite. */
  usedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Set if the user has accepted the invite. */
  userId?: Maybe<Scalars['String']['output']>;
};

export type InviteError = {
  __typename?: 'InviteError';
  message: Scalars['String']['output'];
};

export type InviteResponse = Invite | InviteError;

export type Inviter = {
  __typename?: 'Inviter';
  avatar?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type JobContractType =
  | 'CONTRACT_HIRE'
  | 'DIRECT_HIRE';

export type JobLead = {
  __typename?: 'JobLead';
  companyId: Scalars['String']['output'];
  companyLiUrl?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRevenue?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employeeCountRangeEnd?: Maybe<Scalars['Int']['output']>;
  employeeCountRangeStart?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  jobType?: Maybe<JobContractType>;
  location?: Maybe<Scalars['String']['output']>;
  relatedJobs?: Maybe<Array<JobLead>>;
  salaryRange?: Maybe<Scalars['String']['output']>;
  salaryType?: Maybe<WageType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type JobLeadList = {
  __typename?: 'JobLeadList';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type JobLeadSearch = {
  __typename?: 'JobLeadSearch';
  companySize?: Maybe<Array<CompanySizeOutput>>;
  dateAfter?: Maybe<Scalars['AWSDateTime']['output']>;
  dateBefore?: Maybe<Scalars['AWSDateTime']['output']>;
  employmentType?: Maybe<EmploymentType>;
  haveAiFindSimilarJobTitles?: Maybe<Scalars['Boolean']['output']>;
  hiringCompany?: Maybe<Array<NegationOption>>;
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Array<NegationOption>>;
  jobType?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<NegationOption>>;
  location?: Maybe<Array<LocationNegationOption>>;
  name: Scalars['String']['output'];
  radiusMiles?: Maybe<Scalars['Int']['output']>;
};

export type JobTitle = {
  __typename?: 'JobTitle';
  correlatedJobTitles?: Maybe<Array<JobTitle>>;
  didLookupCorrelations?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  vertical?: Maybe<Vertical>;
};

export type JobTitleSkillsReady = {
  __typename?: 'JobTitleSkillsReady';
  jobTitle: Scalars['String']['output'];
};

export type KeywordsCollection = {
  __typename?: 'KeywordsCollection';
  colorScheme?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  questionId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LanguageInput = {
  name: Scalars['String']['input'];
};

export type LightIndustrialProdType =
  | 'DEFENSE'
  | 'INNOVATIVE'
  | 'LIVE_CHANGING';

export type LightningSendEmailInput = {
  candidateId: Scalars['String']['input'];
  candidateLinkedInUrl: Scalars['String']['input'];
  candidatesFirstName: Scalars['String']['input'];
  commonGroups?: InputMaybe<Array<PromptGroup>>;
  commonSchools?: InputMaybe<Array<PromptSchool>>;
  currentCompany?: InputMaybe<Company>;
  friendsInCommon?: InputMaybe<Array<Scalars['String']['input']>>;
  fullName?: InputMaybe<FullName>;
  location?: InputMaybe<Location>;
  settings?: InputMaybe<AiSettings>;
  vacancyId: Scalars['String']['input'];
};

export type ListAddressesInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListAiPromptsInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListAiPromptsOutput = {
  __typename?: 'ListAiPromptsOutput';
  items: Array<AiPrompt>;
  total: Scalars['Int']['output'];
};

export type ListCallsInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  searchInput?: InputMaybe<SearchInput>;
};

export type ListCallsOutput = {
  __typename?: 'ListCallsOutput';
  items: Array<Call>;
  total: Scalars['Int']['output'];
};

export type ListCandidateApplicationData = {
  __typename?: 'ListCandidateApplicationData';
  items: Array<CandidateApplicationData>;
  total: Scalars['Int']['output'];
  totalCVCount: Scalars['Int']['output'];
};

export type ListCandidateCompaniesOutput = {
  __typename?: 'ListCandidateCompaniesOutput';
  companies: Array<CompanyOutput>;
};

export type ListCandidateEmailsResponse = {
  __typename?: 'ListCandidateEmailsResponse';
  emails: Array<CandidateEmailOutput>;
};

export type ListCandidateJobTitlesOutput = {
  __typename?: 'ListCandidateJobTitlesOutput';
  jobTitles: Array<JobTitle>;
};

export type ListCandidateLocationsOutput = {
  __typename?: 'ListCandidateLocationsOutput';
  locations: Array<LocationOutput>;
};

export type ListCandidateReviewQuestionAnswersOutput = {
  __typename?: 'ListCandidateReviewQuestionAnswersOutput';
  Question?: Maybe<QuestionOutput>;
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type ListCandidateReviewQuestionsOutput = {
  __typename?: 'ListCandidateReviewQuestionsOutput';
  id: Scalars['String']['output'];
  possibleOptions: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ListCandidateSchoolsOutput = {
  __typename?: 'ListCandidateSchoolsOutput';
  schools: Array<SchoolOutput>;
};

export type ListCandidatesInListOutput = {
  __typename?: 'ListCandidatesInListOutput';
  candidates: Array<CandidateOutput>;
  candidatesInList: Array<CandidateInListOutput>;
  nextToken?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ListCompaniesInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListCompaniesOutput = {
  __typename?: 'ListCompaniesOutput';
  items: Array<CompanyOutput>;
  total: Scalars['Int']['output'];
};

export type ListCompanyMemberListsInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListCompanyMemberListsOutput = {
  __typename?: 'ListCompanyMemberListsOutput';
  items: Array<CompanyMemberList>;
  total: Scalars['Int']['output'];
};

export type ListCompanyMembersInListInput = {
  listId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ListCompanyMembersInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyMemberListId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ListCompanyMembersOutput = {
  __typename?: 'ListCompanyMembersOutput';
  items: Array<CompanyMember>;
  total: Scalars['Int']['output'];
};

export type ListJobLeadJobTitlesInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListJobLeadJobTitlesOutput = {
  __typename?: 'ListJobLeadJobTitlesOutput';
  items: Array<JobTitle>;
  total: Scalars['Int']['output'];
};

export type ListJobLeadListsInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListJobLeadListsOutput = {
  __typename?: 'ListJobLeadListsOutput';
  items: Array<JobLeadList>;
  total: Scalars['Int']['output'];
};

export type ListJobLeadSearchesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ListJobLeadSearchesOutput = {
  __typename?: 'ListJobLeadSearchesOutput';
  items: Array<JobLeadSearch>;
  total: Scalars['Int']['output'];
};

export type ListJobLeadsFilters = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Array<CompanySize>>;
  employmentType?: InputMaybe<EmploymentType>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  haveAiFindSimilarJobTitles?: InputMaybe<Scalars['Boolean']['input']>;
  hiringCompany?: InputMaybe<Array<NegationOptionInput>>;
  jobLeadListId?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Array<NegationOptionInput>>;
  jobType?: InputMaybe<JobContractType>;
  keywords?: InputMaybe<Array<NegationOptionInput>>;
  location?: InputMaybe<Array<LocationNegationOptionInput>>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  timeRange?: InputMaybe<TimeRange>;
};

export type ListJobLeadsInput = {
  filters?: InputMaybe<ListJobLeadsFilters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ListJobLeadsOutput = {
  __typename?: 'ListJobLeadsOutput';
  items: Array<JobLead>;
  total: Scalars['Int']['output'];
};

export type ListJobTitlesInput = {
  searchInput?: InputMaybe<SearchInput>;
  vertical?: InputMaybe<Vertical>;
};

export type ListJobTitlesOutput = {
  __typename?: 'ListJobTitlesOutput';
  items: Array<JobTitle>;
  total: Scalars['Int']['output'];
};

export type ListLocationsInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListLocationsOutput = {
  __typename?: 'ListLocationsOutput';
  items: Array<LocationOutput>;
  total: Scalars['Int']['output'];
};

export type ListMessages = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type ListMessagesResponse = {
  __typename?: 'ListMessagesResponse';
  messages: Array<TelephonyMessage>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListPreRecordedMessagesInput = {
  searchInput?: InputMaybe<SearchInput>;
};

export type ListSequenceTemplatesInput = {
  pagination?: InputMaybe<Pagination>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ListSkillPhrasesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  phraseType?: InputMaybe<SkillPhraseType>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<Vertical>;
};

export type ListTeamInvitesResult = {
  __typename?: 'ListTeamInvitesResult';
  invites: Array<Invite>;
  team: Team;
};

export type ListThreads = {
  cursor?: InputMaybe<Cursor>;
  filter?: InputMaybe<ThreadFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use filter instead */
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListThreadsResponse = {
  __typename?: 'ListThreadsResponse';
  threads: Array<TelephonyMessageThread>;
  total: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type ListUserTasksInput = {
  assigneeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  showAssignedToMe?: InputMaybe<Scalars['Boolean']['input']>;
  showCompletedTasks?: InputMaybe<Scalars['Boolean']['input']>;
  showCreatedByMe?: InputMaybe<Scalars['Boolean']['input']>;
  showPendingTasks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListUserWithoutVacancies = {
  __typename?: 'ListUserWithoutVacancies';
  total?: Maybe<Scalars['Int']['output']>;
  users: Array<UserOutput>;
};

export type ListUserWithoutVacanciesInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type ListVacanciesOutput = SearchResponse & {
  __typename?: 'ListVacanciesOutput';
  items: Array<VacancyOutput>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Location = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type LocationNegationOption = {
  __typename?: 'LocationNegationOption';
  coords?: Maybe<Coords>;
  negative?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type LocationNegationOptionInput = {
  coords?: InputMaybe<CoordsInput>;
  negative?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type LocationOutput = {
  __typename?: 'LocationOutput';
  coords?: Maybe<Coords>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationType =
  | 'HYBRID'
  | 'ONSITE'
  | 'REMOTE';

export type LogType =
  | 'AUTOMATIC'
  | 'INTERNAL'
  | 'PRIVATE'
  | 'PUBLIC';

export type LogoType =
  | 'SHAREABLE_CANDIDATE'
  | 'TENANT';

export type LookUpContactInfoResponseAsync = LookUpEmailResponseAsync | PaymentRequiredError;

export type LookUpEmailInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  currentCompany?: InputMaybe<Company>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<FullName>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Location>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  wantEmail?: InputMaybe<Scalars['Boolean']['input']>;
  wantPhone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LookUpEmailResponseAsync = {
  __typename?: 'LookUpEmailResponseAsync';
  candidateId?: Maybe<Scalars['String']['output']>;
  candidateUnsubscribed?: Maybe<Scalars['Boolean']['output']>;
  emails?: Maybe<Array<CandidateEmailOutput>>;
  phoneNumbers?: Maybe<Array<CandidatePhoneNumberOutput>>;
  /** @deprecated Use phoneNumbers instead */
  phones?: Maybe<Array<CandidatePhoneNumber>>;
  taskId?: Maybe<Scalars['String']['output']>;
  unsubscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type MailingSettings = {
  __typename?: 'MailingSettings';
  aiSettings?: Maybe<AiSettingsOutput>;
  automationSettings?: Maybe<AutomationSettings>;
};

export type MailingSettingsInput = {
  aiSettings?: InputMaybe<AiSettings>;
  automationSettings?: InputMaybe<AutomationSettingsInput>;
};

export type MarkMessageAsRead = {
  messageIds: Array<Scalars['String']['input']>;
};

export type MassEmailType =
  | 'APPLICATIONS'
  | 'IMPORT'
  | 'SEARCH';

export type MatchType =
  | 'AI'
  | 'HUMAN_ASSISTED';

export type MessageDirection =
  | 'INBOUND'
  | 'OUTBOUND';

export type MessageInteraction = {
  __typename?: 'MessageInteraction';
  openedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type MessageItem = {
  __typename?: 'MessageItem';
  bcc: Array<Scalars['String']['output']>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  candidate?: Maybe<CandidateOutput>;
  cc: Array<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Email opens. */
  interactions?: Maybe<Array<Maybe<MessageInteraction>>>;
  isBounced: Scalars['Boolean']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isReplied: Scalars['Boolean']['output'];
  pendingReason?: Maybe<CandidateContactPendingReason>;
  sendAfter?: Maybe<Scalars['AWSDateTime']['output']>;
  sentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  sequence?: Maybe<Sequence>;
  sequencerMessageId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
  user?: Maybe<UserOutput>;
  vacancy?: Maybe<VacancyOutput>;
  webLink?: Maybe<Scalars['String']['output']>;
};

export type MessageSent = {
  messageId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

export type MessageSentEvent = {
  __typename?: 'MessageSentEvent';
  messageId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  threadId?: Maybe<Scalars['String']['output']>;
};

export type MessageVoteInput = {
  messageId: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type Metric = {
  __typename?: 'Metric';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type MetricInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type MetricWithValue = {
  __typename?: 'MetricWithValue';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ModifySubscriptionInput = {
  priceId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addAiPrompt: AiPrompt;
  addCandidate?: Maybe<CandidateOutput>;
  addCandidateFormResponse: Array<CandidateFormResponseOutput>;
  addCandidateNote: ResourceCreated;
  addCandidateToClientToken: ClientToken;
  addCandidateToLists: CandidateOutput;
  addCompanyMembersToList: ResourceCreatedMany;
  addContactInfoToCandidate: CandidateOutput;
  addDomainCategory: DomainCategory;
  addFormQuestion: FormQuestionDirectOutput;
  addFormSection: FormSectionOutput;
  addFormSectionGroup: FormSectionGroupDirectOutput;
  addFormSubSection: FormSectionOutput;
  addFormTemplate: FormTemplateOutput;
  addInterviewLog: InterviewLogOutput;
  addJobLeadsToList: ResourceCreatedMany;
  addSkillPhrase: SkillPhrase;
  addSlugToCandidate: ResourceCreated;
  adminDisableUser: ResourceDeleted;
  adminEnableUser: ResourceCreated;
  approveCandidateForVacancy: ResourceCreated;
  approveCandidateMatch?: Maybe<ResourceCreated>;
  assignVacancyMeta?: Maybe<VacancyOutput>;
  /**
   * Add a candidate to the ATS.
   * Optionall add them to a vacancy and stage in the ATS.
   */
  atsAddCandidate: AtsAddCandidateResult;
  /**
   * Save credentials for an ATS integration.
   * Will overwrite any existing ATS integration credentials.
   * A tenant can only have one ATS integration at a time.
   */
  atsSaveIntegrationCredentials: AtsIntegrationStatus;
  atsUpdateApplication: AtsUpdateApplicationResult;
  billUserForEmailLookupReveal: BillingStatus;
  cancelSequence: CancelSequenceResponse;
  /** Cancel team invite. If user is already in team, this will do nothing. */
  cancelTeamInvite: CancelTeamInviteResult;
  candidateUpdated: CandidateUpdated;
  /**
   * Change a user's role in the team.
   * Must be team admin.
   */
  changeTeamRoles: ChangeTeamRolesResult;
  copyShareableLink: ShareableLinkCreated;
  createCandidateApplications: Array<ApplicationCreated>;
  createCandidateFeedbackChat: CandidateFeedbackChatCreated;
  createCandidateList: CandidateList;
  createCustomerPortalSession: PortalSession;
  createInAppMessage: ResourceCreated;
  createJobTitle: JobTitle;
  createNewCandidateMatch: NewCandidateMatch;
  /** @deprecated Field no longer supported */
  createSequenceTemplate: SequenceTemplate;
  createSequenceTemplateV2: SequenceTemplate;
  createShareableLink: ShareableLinkCreated;
  createSkill: UpdateSkillOutput;
  createUserTask: ResourceCreated;
  /** @deprecated Use `createVacancy2` instead - we will do a swap in near future */
  createVacancy?: Maybe<VacancyOutput>;
  createVacancyForUser: ResourceCreated;
  createVacancyFromJobLead: VacancyOutput;
  deleteAiPrompt: ResourceDeleted;
  deleteCandidateMatch: ResourceDeletedMany;
  deleteCandidateSearch: ResourceDeleted;
  deleteCompanyMemberList: ResourceDeleted;
  deleteDomainCategory: DomainCategory;
  deleteEmails: Array<ResourceDeleted>;
  deleteJobLeadList: ResourceDeleted;
  deleteJobLeadSearch: JobLeadSearch;
  deleteLogo: ResourceDeleted;
  deleteSequenceTemplate: ResourceDeleted;
  deleteSkill: UpdateSkillOutput;
  deleteSkillPhrase: ResourceCreated;
  deleteUserTask: ResourceDeleted;
  deleteVacancy?: Maybe<ResourceDeleted>;
  /** Place an outbound call and ring back to a specified number. */
  dial: Call;
  disableTenant: Tenant;
  editProfileChunk?: Maybe<ResourceCreated>;
  enableTenant: Tenant;
  fetchCompanyInformation: CompanyOutput;
  /**
   * Generate a token that can be used for the challenge/response authentication flow.
   * Used to sign in the extension.
   */
  generateAuthChallengeToken: AuthChallengeToken;
  getEmailCompletion: GetEmailCompletionResponse;
  getEmailSequenceDetails: EmailSequence;
  getEmailsFor: Array<MessageItem>;
  /** Get a temporary access token for Twilio Voice API. */
  getVoiceToken: TwilioToken;
  impersonateUser: ImpersonateUserResult;
  initParseDescription: InitParseDescriptionOutput;
  initiateCheckout: BillingSession;
  initiateVacancyClientTokenCheckout: ClientSideBillingSession;
  jobTitleSkillsAvailable: JobTitleSkillsReady;
  lightningSendEmail: SendEmailAsUserResult;
  lookUpContactInfoAsyncV2: LookUpContactInfoResponseAsync;
  markMessagesAsRead: Array<ResourceCreated>;
  markUserTaskAsDone: ResourceCreated;
  markUserTaskAsNotDone: ResourceCreated;
  mergeSkills: UpdateSkillOutput;
  messageSent: MessageSentEvent;
  modifySubscription: BillingStatus;
  onboardUser: UserOutput;
  /** Play a pre-recorded message while on an active call. */
  playMessageOnCall: Call;
  presignUploadPublicAssets: UploadAssetsOutput;
  reIngestCandidate: ResourceCreated;
  recordCandidateUserAction?: Maybe<ResourceCreated>;
  recordInteraction: ResourceCreated;
  recordMatchViewed?: Maybe<ResourceCreated>;
  recordUserActivity?: Maybe<ResourceCreated>;
  recordUserInvite: ResourceCreated;
  removeCandidateFromList: ResourceCreated;
  removeCandidateSlug: ResourceCreated;
  removeCompanyMembersFromList: ResourceDeletedMany;
  removeInterviewGalleryItem: UpdateMany;
  removeJobLeadsFromList: ResourceDeletedMany;
  /** Remove user from team. */
  removeUserFromTeam: RemoveUserFromTeamResponse;
  requestUploadCandidateResume: PresignedUrl;
  requestUploadInterviewGalleryItem: PreUploadUrl;
  requestUploadLogo: PresignedUrl;
  requestUploadPreRecordedMessage: PresignedUrl;
  saveAttributeTraining?: Maybe<ResourceCreated>;
  saveCandidateSearch: CandidateSearch;
  saveHumanMatch: ResourceCreated;
  saveJetBridgeAuth: AtsIntegrationStatus;
  saveQuestion?: Maybe<CreateDeleteManyResponse>;
  saveSequencerAuth: SequencerAuthStatus;
  saveTrainedEmail: TrainEmail;
  sendAiEmails: SendMassAiEmailResult;
  sendChatMessage: AiChatMessageQueued;
  sendContactSequence: SendContactSequenceResult;
  sendCustomAtsProviderRequest: ResourceCreated;
  /** @deprecated use sendContactSequence */
  sendEmailAsUser?: Maybe<SendEmailAsUserResult>;
  sendMessage: TelephonyMessage;
  sendSlackNotification?: Maybe<ResourceCreated>;
  /** Invite user to team. If user is already in team, this will resend the invite. */
  sendTeamInvite: InviteResponse;
  /** Set the name of the tenant. */
  setTeamName: SetTeamNameResult;
  touchAiPrompt: AiPrompt;
  unauthenticateAtsIntegration: AtsIntegrationStatus;
  unauthenticateSequencer: SequencerAuthStatus;
  /** Change some call parameters, mid-call. */
  updateCall: Call;
  updateCandidate?: Maybe<CandidateOutput>;
  updateCandidateFormResponse: UpdateMany;
  updateCandidateInterviewSections: CandidateInterview;
  updateCandidateSearch: CandidateSearch;
  updateDomainCategory: DomainCategory;
  updateEmails: Array<ResourceCreated>;
  updateFormQuestion: UpdateMany;
  updateFormSection: UpdateMany;
  updateFormSectionGroup: UpdateMany;
  updateFormSubSection: FormSectionOutput;
  updateFormTemplate: UpdateMany;
  updateInterviewLog: UpdateMany;
  updateMessage: ResourceCreated;
  /** @deprecated Field no longer supported */
  updateSequenceTemplate: SequenceTemplate;
  updateSequenceTemplateV2: SequenceTemplate;
  updateShareableLink: ShareableLinkCreated;
  updateSkill: UpdateSkillOutput;
  updateTaskStatus: Task;
  updateTenant: Tenant;
  updateThread: ResourceCreated;
  updateUser: UserOutput;
  updateUserPreferences: UserPreferences;
  updateVacancy?: Maybe<VacancyOutput>;
  updateVacancy2: VacancyOutput;
  updateVerificationCandidateEmail?: Maybe<ResourceCreated>;
  upsertCandidateLinkedIn: ResourceCreated;
  upsertJobLeadSearch: JobLeadSearch;
  upsertVacancy: VacancyOutput;
  /**
   * Use an invite code to join a team.
   * Must be logged in.
   */
  useInvite: UseInviteResult;
  vacancyUpdated: VacancyOutput;
  voteOnMessage: ChatRow;
};


export type MutationAddAiPromptArgs = {
  input: AiPromptInput;
};


export type MutationAddCandidateArgs = {
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  rawCandidateData: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVersion: Scalars['String']['input'];
};


export type MutationAddCandidateFormResponseArgs = {
  data: Array<CandidateFormResponseInput>;
  sections: Array<Scalars['String']['input']>;
  type: InterviewType;
};


export type MutationAddCandidateNoteArgs = {
  input: AddCandidateNoteInput;
};


export type MutationAddCandidateToClientTokenArgs = {
  input: AddCandidateToClientTokenInput;
};


export type MutationAddCandidateToListsArgs = {
  candidateId: Scalars['String']['input'];
  vacancyLists: Array<VacancyList>;
};


export type MutationAddCompanyMembersToListArgs = {
  input: AddCompanyMembersToListInput;
};


export type MutationAddContactInfoToCandidateArgs = {
  input: AddContactInfoToCandidateInput;
};


export type MutationAddDomainCategoryArgs = {
  input: AddDomainCategoryInput;
};


export type MutationAddFormQuestionArgs = {
  data: FormQuestionUpdateInput;
};


export type MutationAddFormSectionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  formSectionGroupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationAddFormSectionGroupArgs = {
  name: Scalars['String']['input'];
};


export type MutationAddFormSubSectionArgs = {
  data: FormSubSectionInput;
};


export type MutationAddFormTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAddInterviewLogArgs = {
  data: InterviewLogInput;
};


export type MutationAddJobLeadsToListArgs = {
  input: AddJobLeadsToListInput;
};


export type MutationAddSkillPhraseArgs = {
  input: SkillPhraseInput;
};


export type MutationAddSlugToCandidateArgs = {
  candidateId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationAdminDisableUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminEnableUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationApproveCandidateForVacancyArgs = {
  input: ApproveCandidateForVacancyInput;
};


export type MutationApproveCandidateMatchArgs = {
  matchId: Scalars['String']['input'];
};


export type MutationAssignVacancyMetaArgs = {
  key: Scalars['String']['input'];
  meta: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
};


export type MutationAtsAddCandidateArgs = {
  input: AtsAddCandidateInput;
};


export type MutationAtsSaveIntegrationCredentialsArgs = {
  input: AtsSaveIntegrationCredentialsInput;
};


export type MutationAtsUpdateApplicationArgs = {
  update: UpdateApplicationInput;
};


export type MutationBillUserForEmailLookupRevealArgs = {
  candidateId: Scalars['String']['input'];
};


export type MutationCancelSequenceArgs = {
  input: CancelSequenceInput;
};


export type MutationCancelTeamInviteArgs = {
  input: CancelTeamInvite;
};


export type MutationCandidateUpdatedArgs = {
  candidateId: Scalars['String']['input'];
  mergedToCandidateId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeTeamRolesArgs = {
  input: ChangeTeamRoles;
};


export type MutationCopyShareableLinkArgs = {
  input: CopyShareableLinkInput;
};


export type MutationCreateCandidateApplicationsArgs = {
  input: Array<CreateCandidateApplication>;
};


export type MutationCreateCandidateFeedbackChatArgs = {
  comment: Scalars['String']['input'];
  shareableLinkId: Scalars['String']['input'];
};


export type MutationCreateCandidateListArgs = {
  name: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerPortalSessionArgs = {
  flowType?: InputMaybe<FlowType>;
  returnUrl: Scalars['String']['input'];
};


export type MutationCreateInAppMessageArgs = {
  input: CreateInAppMessageInput;
};


export type MutationCreateJobTitleArgs = {
  input: CreateJobTitleInput;
};


export type MutationCreateNewCandidateMatchArgs = {
  input: CreateCandidateMatch;
};


export type MutationCreateSequenceTemplateArgs = {
  input: CreateSequenceTemplateInput;
};


export type MutationCreateSequenceTemplateV2Args = {
  input: CreateSequenceTemplateArgsV2;
};


export type MutationCreateShareableLinkArgs = {
  input: CreateShareableLink;
};


export type MutationCreateSkillArgs = {
  categoryId: Scalars['String']['input'];
  skillName: Scalars['String']['input'];
};


export type MutationCreateUserTaskArgs = {
  input: CreateUserTaskInput;
};


export type MutationCreateVacancyArgs = {
  aiChecks?: InputMaybe<Array<AiCheck>>;
  atsLink?: InputMaybe<Scalars['String']['input']>;
  benefitsTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<ClientInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isStackRankRequired?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<LocationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  positiveOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  previousIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredCertificates?: InputMaybe<Array<CertificateInput>>;
  responsibilitiesFragment?: InputMaybe<Scalars['String']['input']>;
  seniority?: InputMaybe<Seniority>;
  skills?: InputMaybe<Array<DesiredSkill>>;
  status?: InputMaybe<VacancyStatus>;
  vertical: Vertical;
};


export type MutationCreateVacancyForUserArgs = {
  input: CreateVacancyForUserInput;
};


export type MutationCreateVacancyFromJobLeadArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAiPromptArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCandidateMatchArgs = {
  input: DeleteCandidateMatchInput;
};


export type MutationDeleteCandidateSearchArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCompanyMemberListArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDomainCategoryArgs = {
  input: DeleteDomainCategoryInput;
};


export type MutationDeleteEmailsArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type MutationDeleteJobLeadListArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteJobLeadSearchArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLogoArgs = {
  input: DeleteLogoInput;
};


export type MutationDeleteSequenceTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSkillArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSkillPhraseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVacancyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDialArgs = {
  input: Dial;
};


export type MutationDisableTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditProfileChunkArgs = {
  input: EditProfileChunk;
};


export type MutationEnableTenantArgs = {
  id: Scalars['String']['input'];
};


export type MutationFetchCompanyInformationArgs = {
  id: Scalars['String']['input'];
};


export type MutationGetEmailCompletionArgs = {
  input: GetEmailCompletion;
};


export type MutationGetEmailSequenceDetailsArgs = {
  input: GetEmailSequenceInput;
};


export type MutationGetEmailsForArgs = {
  input: GetEmailsForInput;
};


export type MutationImpersonateUserArgs = {
  input: ImpersonateUser;
};


export type MutationInitParseDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parseForBenefitsTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForDisclosureTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForElevatorPitchTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForNameTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForResponsibilitiesTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForSkillsTaskId?: InputMaybe<Scalars['String']['input']>;
  shouldCreateClientVacancyChat?: InputMaybe<Scalars['Boolean']['input']>;
  shouldGenerateName?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Array<ParseTask>>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
  vertical: Vertical;
};


export type MutationInitiateCheckoutArgs = {
  session: InitiateCheckoutInput;
};


export type MutationInitiateVacancyClientTokenCheckoutArgs = {
  input: VacancyClientTokenCheckout;
};


export type MutationJobTitleSkillsAvailableArgs = {
  jobTitle: Scalars['String']['input'];
};


export type MutationLightningSendEmailArgs = {
  input: LightningSendEmailInput;
};


export type MutationLookUpContactInfoAsyncV2Args = {
  input: LookUpEmailInput;
};


export type MutationMarkMessagesAsReadArgs = {
  input: MarkMessageAsRead;
};


export type MutationMarkUserTaskAsDoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkUserTaskAsNotDoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationMergeSkillsArgs = {
  oldSkillId: Scalars['String']['input'];
  toSynonymOfSkill: Scalars['String']['input'];
};


export type MutationMessageSentArgs = {
  input: MessageSent;
};


export type MutationModifySubscriptionArgs = {
  input: ModifySubscriptionInput;
};


export type MutationOnboardUserArgs = {
  input: OnboardUserInput;
};


export type MutationPlayMessageOnCallArgs = {
  input: PlayMessageOnCallInput;
};


export type MutationPresignUploadPublicAssetsArgs = {
  input: PresignUploadAssetsInput;
};


export type MutationReIngestCandidateArgs = {
  candidateId: Scalars['String']['input'];
};


export type MutationRecordCandidateUserActionArgs = {
  input: CandidateUserAction;
};


export type MutationRecordInteractionArgs = {
  input: RecordInteraction;
};


export type MutationRecordMatchViewedArgs = {
  matchId: Scalars['String']['input'];
};


export type MutationRecordUserActivityArgs = {
  userActivity: UserActivityArgs;
};


export type MutationRecordUserInviteArgs = {
  input: RecordUserInvite;
};


export type MutationRemoveCandidateFromListArgs = {
  candidateId: Scalars['String']['input'];
  listId: Scalars['String']['input'];
};


export type MutationRemoveCandidateSlugArgs = {
  candidateId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationRemoveCompanyMembersFromListArgs = {
  input: RemoveCompanyMembersFromListInput;
};


export type MutationRemoveInterviewGalleryItemArgs = {
  data: CandidateFormResponseInput;
  s3Key: Scalars['String']['input'];
};


export type MutationRemoveJobLeadsFromListArgs = {
  input: RemoveJobLeadsFromListInput;
};


export type MutationRemoveUserFromTeamArgs = {
  input: RemoveUserFromTeam;
};


export type MutationRequestUploadCandidateResumeArgs = {
  input: RequestUploadCandidateResume;
};


export type MutationRequestUploadInterviewGalleryItemArgs = {
  data: GalleryPreUpload;
};


export type MutationRequestUploadLogoArgs = {
  input: RequestUploadLogoInput;
};


export type MutationRequestUploadPreRecordedMessageArgs = {
  input: RequestUploadPreRecordedMessageInput;
};


export type MutationSaveAttributeTrainingArgs = {
  input: SaveAttributeTrainingInput;
};


export type MutationSaveCandidateSearchArgs = {
  input: SaveCandidateSearch;
};


export type MutationSaveHumanMatchArgs = {
  input: SaveHumanMatch;
};


export type MutationSaveJetBridgeAuthArgs = {
  auth: SaveJetBridgeAuthInput;
};


export type MutationSaveQuestionArgs = {
  answers: Array<AnswersInput>;
  candidateId: Scalars['String']['input'];
};


export type MutationSaveSequencerAuthArgs = {
  auth: SaveSequencerAuthInput;
};


export type MutationSaveTrainedEmailArgs = {
  input: SaveTrainedEmailInput;
};


export type MutationSendAiEmailsArgs = {
  input: Array<SendAiEmailsInput>;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendContactSequenceArgs = {
  input: SendContactSequenceArgs;
};


export type MutationSendCustomAtsProviderRequestArgs = {
  input: SendCustomAtsProviderRequestInput;
};


export type MutationSendEmailAsUserArgs = {
  mail: SendEmailAsUserInput;
};


export type MutationSendMessageArgs = {
  input: SendMessage;
};


export type MutationSendSlackNotificationArgs = {
  input: SendSlackNotificationInput;
};


export type MutationSendTeamInviteArgs = {
  input: SendTeamInvite;
};


export type MutationSetTeamNameArgs = {
  input: SetTeamName;
};


export type MutationTouchAiPromptArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateCallArgs = {
  input: UpdateCallInput;
};


export type MutationUpdateCandidateArgs = {
  candidateId: Scalars['String']['input'];
  data: CandidateData;
};


export type MutationUpdateCandidateFormResponseArgs = {
  data: CandidateFormResponseInput;
};


export type MutationUpdateCandidateInterviewSectionsArgs = {
  data: CandidateInterviewSectionsInput;
};


export type MutationUpdateCandidateSearchArgs = {
  data: SaveCandidateSearch;
  id: Scalars['String']['input'];
};


export type MutationUpdateDomainCategoryArgs = {
  input: UpdateDomainCategoryInput;
};


export type MutationUpdateEmailsArgs = {
  input: UpdateEmailsInput;
};


export type MutationUpdateFormQuestionArgs = {
  data: FormQuestionUpdateInput;
  questionId: Scalars['String']['input'];
};


export type MutationUpdateFormSectionArgs = {
  data: FormSectionData;
  sectionId: Scalars['String']['input'];
};


export type MutationUpdateFormSectionGroupArgs = {
  data: FormSectionGroupData;
  formSectionGroupId: Scalars['String']['input'];
};


export type MutationUpdateFormSubSectionArgs = {
  data: FormSubSectionInput;
};


export type MutationUpdateFormTemplateArgs = {
  data: FormTemplateData;
  templateId: Scalars['String']['input'];
};


export type MutationUpdateInterviewLogArgs = {
  data: InterviewLogUpdateInput;
  logId: Scalars['String']['input'];
};


export type MutationUpdateMessageArgs = {
  id: Scalars['String']['input'];
  input: UpdateInAppMessageInput;
};


export type MutationUpdateSequenceTemplateArgs = {
  input: UpdateSequenceTemplateInput;
};


export type MutationUpdateSequenceTemplateV2Args = {
  input: UpdateSequenceTemplateArgsV2;
};


export type MutationUpdateShareableLinkArgs = {
  input: UpdateShareableLinkInput;
};


export type MutationUpdateSkillArgs = {
  id: Scalars['String']['input'];
  newSkillName?: InputMaybe<Scalars['String']['input']>;
  related?: InputMaybe<Array<RelatedSkillInput>>;
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateTaskStatusArgs = {
  id: Scalars['String']['input'];
  update: TaskStatusUpdate;
};


export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


export type MutationUpdateThreadArgs = {
  input: UpdateThreadInput;
};


export type MutationUpdateUserArgs = {
  user: UserInput;
};


export type MutationUpdateUserPreferencesArgs = {
  preferences: UserPreferencesInput;
};


export type MutationUpdateVacancyArgs = {
  aiChecks?: InputMaybe<Array<AiCheck>>;
  atsLink?: InputMaybe<Scalars['String']['input']>;
  benefitsTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  isStackRankRequired?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Array<LocationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  positionType?: InputMaybe<PositionType>;
  positiveOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  previousIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitmentType?: InputMaybe<PositionType>;
  requiredCertificates?: InputMaybe<Array<CertificateInput>>;
  responsibilitiesFragment?: InputMaybe<Scalars['String']['input']>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  shouldSearchCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  skills?: InputMaybe<Array<DesiredSkill>>;
  vacancyId: Scalars['String']['input'];
  vacancyStatus?: InputMaybe<VacancyStatus>;
  vertical?: InputMaybe<Vertical>;
};


export type MutationUpdateVacancy2Args = {
  input: UpdateVacancy2Input;
};


export type MutationUpdateVerificationCandidateEmailArgs = {
  candidateId: Scalars['String']['input'];
  emailId: Scalars['String']['input'];
};


export type MutationUpsertCandidateLinkedInArgs = {
  linkedInUrl: Scalars['String']['input'];
  source: CandidateSource;
  sourceVersion: Scalars['String']['input'];
};


export type MutationUpsertJobLeadSearchArgs = {
  input: UpsertJobLeadSearchInput;
};


export type MutationUpsertVacancyArgs = {
  input: UpsertVacancyInput;
};


export type MutationUseInviteArgs = {
  code: Scalars['String']['input'];
};


export type MutationVacancyUpdatedArgs = {
  stringifiedVacancy: Scalars['String']['input'];
};


export type MutationVoteOnMessageArgs = {
  input: MessageVoteInput;
};

export type NegationOption = {
  __typename?: 'NegationOption';
  negative?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type NegationOptionInput = {
  negative?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type NewCandidateMatch = {
  __typename?: 'NewCandidateMatch';
  adjustedMatch?: Maybe<Scalars['Float']['output']>;
  candidateId: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  match?: Maybe<Scalars['Float']['output']>;
  vacancyId: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['String']['output'];
};

export type NotFoundError = BaseError & {
  __typename?: 'NotFoundError';
  message?: Maybe<Scalars['String']['output']>;
};

export type NumericalItem = {
  __typename?: 'NumericalItem';
  label: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  type: NumericalQuetionType;
  value: Scalars['String']['output'];
};

export type NumericalQuetionType =
  | 'MONETARY'
  | 'NUMERICAL'
  | 'NUMERICAL_PERCENTAGE';

export type OffsetPagination = {
  offset: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type OnboardUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailProvider?: InputMaybe<EmailProvider>;
  jdRewriteCustomInstructions?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  recruitmentType?: InputMaybe<PositionType>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateTos?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Vertical>;
};

export type OptionDualState =
  | 'NEGATIVE'
  | 'POSITIVE';

export type Order =
  | 'ASC'
  | 'DESC';

export type OtherUserCandidate = {
  __typename?: 'OtherUserCandidate';
  claimedCandidate: Scalars['Boolean']['output'];
  list: CandidateList;
  user: User;
};

export type Pagination = {
  nextToken?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};

export type ParseTask =
  | 'BenefitsSummary'
  | 'CompanyElevatorPitch'
  | 'IdealCandidate'
  | 'JobTitle'
  | 'KeyWords'
  | 'MostImportantSkills'
  | 'Responsibilities'
  | 'Skills'
  | 'VacancyName';

export type ParsedVacancy = {
  __typename?: 'ParsedVacancy';
  benefitsTemplateFragment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionText?: Maybe<Scalars['String']['output']>;
  elevatorPitch?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredStack: Array<Scalars['String']['output']>;
  responsibilitiesTemplateFragment?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  top3Skills?: Maybe<Array<Scalars['String']['output']>>;
  vertical: Vertical;
};

export type PayDescription =
  | 'ABOVE_INDUSTRY_AVERAGE_PACKAGE'
  | 'ABOVE_INDUSTRY_AVERAGE_WAGE'
  | 'COMPETITIVE_PACKAGE'
  | 'COMPETITIVE_WAGE'
  | 'INDUSTRY_AVERAGE_PACKAGE'
  | 'INDUSTRY_AVERAGE_WAGE'
  | 'TOP_OF_THE_MARKET_PACKAGE'
  | 'TOP_OF_THE_MARKET_WAGE'
  | 'VERY_COMPETITIVE_PACKAGE'
  | 'VERY_COMPETITIVE_WAGE';

export type PaymentRequiredError = BaseError & {
  __typename?: 'PaymentRequiredError';
  feature: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type PhoneDeviceType =
  | 'MOBILE'
  | 'OTHER';

export type PhoneType =
  | 'OTHER'
  | 'PRIVATE'
  | 'WORK';

export type PlayMessageOnCallInput = {
  callSid: Scalars['String']['input'];
  preRecordedMessageId: Scalars['String']['input'];
};

export type PolarizationSlider = {
  __typename?: 'PolarizationSlider';
  leftLabel: Scalars['String']['output'];
  rightLabel: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PortalSession = {
  __typename?: 'PortalSession';
  redirectUrl: Scalars['String']['output'];
};

export type PositionFor =
  | 'AN_EXCITING_NEW_FIRM'
  | 'A_LEADING_FIRM_IN_THEIR_SPECIALTY'
  | 'A_WELL_ESTABLISHED_FIRM'
  | 'DISRUPTIVE_INDUSTRY_PLAYER'
  | 'ESTABLISHED_COMPANY'
  | 'ESTABLISHED_INDUSTRY_PLAYER'
  | 'FOR_A_GLOBAL_BRAND'
  | 'MAJOR_DISTRIBUTOR_IN_THEIR_SPACE'
  | 'STARTUP_ROCKETSHIP'
  | 'WELL_FINANCED_STARTUP'
  | 'WELL_FUNDED_NEW_COMPANY'
  | 'WELL_KNOWN_LEGAL_BRAND';

export type PositionType =
  | 'CLIENT'
  | 'INTERNAL'
  | 'STAFFING';

export type PreRecordedMessage = {
  __typename?: 'PreRecordedMessage';
  asset?: Maybe<Asset>;
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
};

export type PreRecordedMessageWithUrl = {
  __typename?: 'PreRecordedMessageWithUrl';
  message: PreRecordedMessage;
  url: Scalars['String']['output'];
};

export type PreRecordedMessages = {
  __typename?: 'PreRecordedMessages';
  items: Array<PreRecordedMessage>;
  total: Scalars['Int']['output'];
};

export type PreUploadUrl = {
  __typename?: 'PreUploadUrl';
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type PresignUploadAssetsInput = {
  files: Array<FileInput>;
  type: AssetType;
};

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  candidateId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProfileChunkType =
  | 'EXPERIENCE_ROLE'
  | 'PROJECT';

export type Project = {
  __typename?: 'Project';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  skills?: Maybe<Array<Skill>>;
  timePeriodEndMonth?: Maybe<Scalars['Int']['output']>;
  timePeriodEndYear?: Maybe<Scalars['Int']['output']>;
  timePeriodStartMonth?: Maybe<Scalars['Int']['output']>;
  timePeriodStartYear?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PromptCandidateJob = {
  company: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PromptCert = {
  name: Scalars['String']['input'];
};

export type PromptGroup = {
  name: Scalars['String']['input'];
};

export type PromptPrivateWebsite = {
  url: Scalars['String']['input'];
};

export type PromptPublication = {
  title: Scalars['String']['input'];
};

export type PromptSchool = {
  name: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  adminListUsers: UserList;
  adminStats: AdminStatsOutput;
  /** Get applications for a candidate/vacancy. */
  atsApplication: AtsApplicationResponse;
  atsStage: AtsStageResult;
  /** Get all users in the ATS. */
  atsUser: AtsUsersResponse;
  atsVacancy: AtsVacancyResult;
  candidateContactHistory: CandidateContactHistory;
  candidateSearch: CandidateSearchResult;
  chatHealth: ResourceCreated;
  companyMemberLists: ListCompanyMemberListsOutput;
  domainCategories: DomainCategories;
  domainTimeSpent: DomainTimeSpentResponse;
  getAllMessages: GetAllMessagesResponse;
  getAllTeamMetrics: Array<Metric>;
  getAllVacancyMetrics?: Maybe<Array<Metric>>;
  getAtsIntegrationStatus: AtsIntegrationStatus;
  getAudienceSize: AudienceSize;
  getBillingStatus: BillingStatus;
  getCandidate: CandidateOutput;
  /** Get applications created by a user for a specific vacancy. */
  getCandidateApplications: ListCandidateApplicationData;
  getCandidateExperience?: Maybe<CandidateCompanyExperienceOutput>;
  getCandidateList?: Maybe<CandidateList>;
  getCandidateListExport: CandidateListExport;
  getCandidateProfile?: Maybe<CandidateProfileOutput>;
  getCandidateThread: GetCandidateThreadResponse;
  getCandidateVacancyMatch: GetCandidateVacancyMatchOutput;
  getChat: AiChat;
  getCvDownloadLink: PresignedUrl;
  getDemoVacancy: DemoVacancyOutput;
  getDemoVacancyMatch: GetCandidateVacancyMatchOutput;
  getEmailsToTrain: Array<TrainEmail>;
  getFormQuestion: FormQuestionOutput;
  getFormSection: FormSectionOutput;
  getFormTemplate: FormTemplateOutput;
  getJobLead: JobLead;
  getMessagesForUser: GetAllMessagesResponse;
  getPreRecordedMessage: PreRecordedMessageWithUrl;
  getSequencerAuthStatus: SequencerAuthStatus;
  getShadowProfile: ShadowProfile;
  getSkillsForTitle: Array<SkillsForType>;
  getTeamPerformance: TeamPerformance;
  getUser: UserOutput;
  getVacancy?: Maybe<VacancyOutput>;
  jobLeadLists: ListJobLeadListsOutput;
  listAddresses: Array<Scalars['String']['output']>;
  listAiPrompts?: Maybe<ListAiPromptsOutput>;
  /** Get all customers. */
  listAllTenants: TenantList;
  /** BackOffice view of all vacancies. */
  listAllVacancies: ListVacanciesOutput;
  /** Get a list of all the calls made by the user. */
  listCalls: ListCallsOutput;
  listCandidateCompanies: ListCandidateCompaniesOutput;
  listCandidateContactHistory: CandidateContactHistoryResponse;
  listCandidateEmails: ListCandidateEmailsResponse;
  listCandidateFormResponses: Array<CandidateFormResponseOutput>;
  listCandidateInterviews: Interviews;
  listCandidateJobTitles: ListCandidateJobTitlesOutput;
  listCandidateLists?: Maybe<Array<CandidateList>>;
  listCandidateLocations: ListCandidateLocationsOutput;
  listCandidateReviewQuestionAnswers: Array<ListCandidateReviewQuestionAnswersOutput>;
  listCandidateReviewQuestions: Array<QuestionOutput>;
  listCandidateScheduledEmails: Array<ScheduledEmails>;
  listCandidateSchools: ListCandidateSchoolsOutput;
  listCandidateVacancyMatches: CandidateVacancyMatchCollection;
  listCandidatesInList: ListCandidatesInListOutput;
  listCompanies: ListLocationsOutput;
  listCompanyMembers: ListCompanyMembersOutput;
  listFormQuestions: Array<FormQuestionOutput>;
  listFormSectionGroups: Array<FormSectionGroupOutput>;
  listFormSections: Array<FormSectionDirectOutput>;
  listFormTemplates: Array<FormTemplateDirectOutput>;
  listInterviewLogs: Array<InterviewLogOutput>;
  listJobLeadJobTitles: ListJobLeadJobTitlesOutput;
  listJobLeadSearches: ListJobLeadSearchesOutput;
  listJobLeads: ListJobLeadsOutput;
  listJobTitles: ListJobTitlesOutput;
  listLocations: ListLocationsOutput;
  listMessages: ListMessagesResponse;
  listPreRecordedMessages: PreRecordedMessages;
  listProducts: Array<BillingProduct>;
  listSequenceTemplates: SequenceTemplatesPaginated;
  listSkillPhrases: SkillPhrases;
  listTeamInvites: ListTeamInvitesResult;
  listThreads: ListThreadsResponse;
  listTopCandidateVacancyMatches: Array<CandidateVacancyMatch>;
  listUserTasks: UserTasks;
  listUsersOfSameTenant: Array<UserOutput>;
  listUsersWithoutVacancies: ListUserWithoutVacancies;
  listVacancies: ListVacanciesOutput;
  searchCandidates: SearchCandidatesOutput;
  searchCertificates: CertificateSearchResponse;
  searchSchools: SchoolSearchResponse;
  searchSkills: SkillSearchResponse;
  searchSkillsLike: Array<SearchSkillsSkillOutput>;
  skillCategories: Array<SkillCategory_2>;
  team: Team;
  userActivities: TeamUserActivity;
  userPersonalStats: UserActivity;
};


export type QueryAdminListUsersArgs = {
  input: SearchInput;
};


export type QueryAdminStatsArgs = {
  timeRange?: InputMaybe<TimeRange>;
};


export type QueryAtsApplicationArgs = {
  input: AtsApplicationInput;
};


export type QueryCandidateContactHistoryArgs = {
  candidateId: Scalars['String']['input'];
  pagination: OffsetPagination;
};


export type QueryCandidateSearchArgs = {
  input: SearchInput;
};


export type QueryCompanyMemberListsArgs = {
  input?: InputMaybe<ListCompanyMemberListsInput>;
};


export type QueryDomainTimeSpentArgs = {
  input: DomainTimeSpentInput;
};


export type QueryGetAllMessagesArgs = {
  input: GetAllMessages;
};


export type QueryGetAudienceSizeArgs = {
  input: GetAudienceSizeInput;
};


export type QueryGetCandidateArgs = {
  input: CandidateInput;
};


export type QueryGetCandidateApplicationsArgs = {
  input: GetCandidateApplicationsInput;
};


export type QueryGetCandidateExperienceArgs = {
  input: GetCandidateExperienceInput;
};


export type QueryGetCandidateListArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCandidateListExportArgs = {
  listId: Scalars['String']['input'];
};


export type QueryGetCandidateProfileArgs = {
  candidateInput: CandidateInput;
  userType?: InputMaybe<RequestCandidateProfileAs>;
};


export type QueryGetCandidateThreadArgs = {
  input: GetCandidateThreadInput;
};


export type QueryGetCandidateVacancyMatchArgs = {
  algorithm?: InputMaybe<CandidateMatchAlgorithm>;
  candidateId: Scalars['String']['input'];
  candidateRawId?: InputMaybe<Scalars['String']['input']>;
  markAsViewed?: InputMaybe<Scalars['Boolean']['input']>;
  vacancyId: Scalars['String']['input'];
};


export type QueryGetChatArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryGetCvDownloadLinkArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryGetFormQuestionArgs = {
  questionId: Scalars['String']['input'];
};


export type QueryGetFormSectionArgs = {
  sectionId: Scalars['String']['input'];
};


export type QueryGetFormTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type QueryGetJobLeadArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPreRecordedMessageArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetShadowProfileArgs = {
  shareableLinkId: Scalars['String']['input'];
};


export type QueryGetSkillsForTitleArgs = {
  input: GetSkillsForTitle;
};


export type QueryGetTeamPerformanceArgs = {
  timeRange: TimeRange;
};


export type QueryGetVacancyArgs = {
  input: GetVacancyInput;
};


export type QueryJobLeadListsArgs = {
  input?: InputMaybe<ListJobLeadListsInput>;
};


export type QueryListAddressesArgs = {
  input: ListAddressesInput;
};


export type QueryListAiPromptsArgs = {
  input?: InputMaybe<ListAiPromptsInput>;
};


export type QueryListAllTenantsArgs = {
  input: OffsetPagination;
};


export type QueryListAllVacanciesArgs = {
  input: FilterAllVacancies;
};


export type QueryListCallsArgs = {
  input: ListCallsInput;
};


export type QueryListCandidateCompaniesArgs = {
  input: SearchInput;
};


export type QueryListCandidateContactHistoryArgs = {
  filter?: InputMaybe<CandidateContactHistoryFilter>;
  pagination?: InputMaybe<OffsetPagination>;
};


export type QueryListCandidateEmailsArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryListCandidateFormResponsesArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryListCandidateInterviewsArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryListCandidateJobTitlesArgs = {
  input: SearchInput;
};


export type QueryListCandidateListsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FieldOrder>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListCandidateLocationsArgs = {
  input: SearchInput;
};


export type QueryListCandidateReviewQuestionAnswersArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryListCandidateScheduledEmailsArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryListCandidateSchoolsArgs = {
  input: SearchInput;
};


export type QueryListCandidateVacancyMatchesArgs = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  includeNoApproved?: InputMaybe<Scalars['Boolean']['input']>;
  includeVacanciesWithoutMatches?: InputMaybe<Scalars['Boolean']['input']>;
  kickOffMatchesForOpenVacancies?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MatchType>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidatesInListArgs = {
  listId: Scalars['String']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CandidatesSortBy>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryListCompaniesArgs = {
  input?: InputMaybe<ListCompaniesInput>;
};


export type QueryListCompanyMembersArgs = {
  input: ListCompanyMembersInput;
};


export type QueryListFormQuestionsArgs = {
  sectionId: Scalars['String']['input'];
};


export type QueryListInterviewLogsArgs = {
  candidateId: Scalars['String']['input'];
};


export type QueryListJobLeadJobTitlesArgs = {
  input: ListJobLeadJobTitlesInput;
};


export type QueryListJobLeadSearchesArgs = {
  input: ListJobLeadSearchesInput;
};


export type QueryListJobLeadsArgs = {
  input: ListJobLeadsInput;
};


export type QueryListJobTitlesArgs = {
  input: ListJobTitlesInput;
};


export type QueryListLocationsArgs = {
  input?: InputMaybe<ListLocationsInput>;
};


export type QueryListMessagesArgs = {
  input: ListMessages;
};


export type QueryListPreRecordedMessagesArgs = {
  input: ListPreRecordedMessagesInput;
};


export type QueryListSequenceTemplatesArgs = {
  input: ListSequenceTemplatesInput;
};


export type QueryListSkillPhrasesArgs = {
  input: ListSkillPhrasesInput;
};


export type QueryListThreadsArgs = {
  input: ListThreads;
};


export type QueryListTopCandidateVacancyMatchesArgs = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserTasksArgs = {
  input: ListUserTasksInput;
};


export type QueryListUsersWithoutVacanciesArgs = {
  input: ListUserWithoutVacanciesInput;
};


export type QueryListVacanciesArgs = {
  crossTenantSearch?: InputMaybe<Scalars['Boolean']['input']>;
  forStackRank?: InputMaybe<Scalars['Boolean']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  inStatus?: InputMaybe<Array<VacancyStatus>>;
  includeNewMatchesCount?: InputMaybe<Scalars['Boolean']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  onlyWithOpenTokens?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<FieldOrder>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
  vacancyIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySearchCandidatesArgs = {
  input: SearchCandidatesInput;
};


export type QuerySearchCertificatesArgs = {
  input: SearchInput;
};


export type QuerySearchSchoolsArgs = {
  input: SearchInput;
};


export type QuerySearchSkillsArgs = {
  input: SearchSkillInput;
};


export type QuerySearchSkillsLikeArgs = {
  page: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  take: Scalars['Int']['input'];
};


export type QueryUserActivitiesArgs = {
  input: UserActivitiesInput;
};


export type QueryUserPersonalStatsArgs = {
  input: UserPersonalStatsInput;
};

export type QuestionOutput = {
  __typename?: 'QuestionOutput';
  id: Scalars['String']['output'];
  possibleOptions: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type QuestionType =
  | 'BOOLEAN'
  | 'FREEFORM'
  | 'GALLERY'
  | 'MONETARY'
  | 'MULTISELECT'
  | 'NUMERICAL'
  | 'NUMERICAL_PERCENTAGE'
  | 'PERCENTAGE'
  | 'SCALE'
  | 'SELECT'
  | 'TAGS';

export type QuestionVisibilityType =
  | 'ADMIN'
  | 'PUBLIC'
  | 'REGISTERED_USER'
  | 'SUBSCRIBER';

export type Quota = {
  __typename?: 'Quota';
  feature: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type QuotaExceededError = BaseError & {
  __typename?: 'QuotaExceededError';
  limit: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  used: Scalars['Int']['output'];
};

export type RecentProject = {
  blurredText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RecordInteraction = {
  id: Scalars['String']['input'];
  interactionType: InAppMessageInteractionType;
};

export type RecordUserInvite = {
  candidateLinkedInUrl: Scalars['String']['input'];
};

export type RelatedSkill = {
  __typename?: 'RelatedSkill';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  strength: Scalars['Float']['output'];
  synonyms: Array<Scalars['String']['output']>;
};

export type RelatedSkillBase = {
  __typename?: 'RelatedSkillBase';
  name: Scalars['String']['output'];
  strength: Scalars['Float']['output'];
};

export type RelatedSkillInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  strength: Scalars['Float']['input'];
  synonyms: Array<Scalars['String']['input']>;
};

export type RelatedSkillsOutput = {
  __typename?: 'RelatedSkillsOutput';
  skills: Array<SkillInfo>;
};

export type RemoveCompanyMembersFromListInput = {
  companyMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listId: Scalars['String']['input'];
};

export type RemoveJobLeadsFromListInput = {
  filters?: InputMaybe<ListJobLeadsFilters>;
  jobLeadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  listId: Scalars['String']['input'];
};

export type RemoveUserFromTeam = {
  userId: Scalars['String']['input'];
};

export type RemoveUserFromTeamError = {
  __typename?: 'RemoveUserFromTeamError';
  message: Scalars['String']['output'];
};

export type RemoveUserFromTeamResponse = RemoveUserFromTeamError | RemoveUserFromTeamResult;

export type RemoveUserFromTeamResult = {
  __typename?: 'RemoveUserFromTeamResult';
  message: Scalars['String']['output'];
};

export type RequestCandidateProfileAs =
  | 'ADMIN'
  | 'ANONYMOUS'
  | 'CANDIDATE'
  | 'CLIENT'
  | 'PAID_CLIENT';

export type RequestUploadCandidateResume = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type RequestUploadLogoInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  logoType: LogoType;
  shareableLinkId?: InputMaybe<Scalars['String']['input']>;
};

export type RequestUploadPreRecordedMessageInput = {
  contentType: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type ResourceCreated = {
  __typename?: 'ResourceCreated';
  id?: Maybe<Scalars['String']['output']>;
};

export type ResourceCreatedMany = {
  __typename?: 'ResourceCreatedMany';
  count: Scalars['Int']['output'];
};

export type ResourceDeleted = {
  __typename?: 'ResourceDeleted';
  id: Scalars['String']['output'];
};

export type ResourceDeletedMany = {
  __typename?: 'ResourceDeletedMany';
  count: Scalars['Int']['output'];
};

export type ResponseOutput = {
  __typename?: 'ResponseOutput';
  User: User;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  responseValue?: Maybe<Scalars['String']['output']>;
};

export type SmsContactRecordDetails = {
  __typename?: 'SMSContactRecordDetails';
  content: Scalars['String']['output'];
};

export type SmsSequenceStage = {
  body: Scalars['String']['input'];
  /** How many days after the previous stage we should send the SMS. */
  offsetDays: Scalars['Int']['input'];
  phoneNumber: Scalars['String']['input'];
  /** The stage index in the sequence. */
  stageIndex: Scalars['Int']['input'];
};

export type SaveAttributeTrainingInput = {
  candidateId: Scalars['String']['input'];
  currentModelPrediction: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type SaveCandidateSearch = {
  company?: InputMaybe<Array<NegationOptionInput>>;
  freeTextSearch?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Array<NegationOptionInput>>;
  location?: InputMaybe<Array<LocationNegationOptionInput>>;
  name: Scalars['String']['input'];
  school?: InputMaybe<Array<NegationOptionInput>>;
  skills?: InputMaybe<Array<NegationOptionInput>>;
};

export type SaveHumanMatch = {
  candidateId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  match: Scalars['Int']['input'];
  vacancyId: Scalars['String']['input'];
};

export type SaveJetBridgeAuthInput = {
  codeVerifier: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SaveSequencerAuthInput = {
  provider: EmailProvider;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userGoogleScope?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  userMsScope?: InputMaybe<Scalars['String']['input']>;
  userSignature?: InputMaybe<Scalars['String']['input']>;
  userToken: Scalars['String']['input'];
};

export type SaveTrainedEmailInput = {
  id: Scalars['String']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  trainingEmailCasual: Scalars['String']['input'];
  trainingEmailFunny: Scalars['String']['input'];
  trainingEmailNeutral: Scalars['String']['input'];
  trainingEmailProfessional: Scalars['String']['input'];
};

export type ScheduledEmails = {
  __typename?: 'ScheduledEmails';
  emailSequenceId?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  sendAfter?: Maybe<Scalars['AWSDateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type School = Node & {
  __typename?: 'School';
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
};

export type SchoolInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolOutput = {
  __typename?: 'SchoolOutput';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SchoolSearchResponse = SearchResponse & {
  __typename?: 'SchoolSearchResponse';
  items: Array<School>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SearchCandidatesFilters = {
  companies?: InputMaybe<Array<NegationOptionInput>>;
  jobTitles?: InputMaybe<Array<NegationOptionInput>>;
  locations?: InputMaybe<Array<LocationNegationOptionInput>>;
  schools?: InputMaybe<Array<NegationOptionInput>>;
  skills?: InputMaybe<Array<NegationOptionInput>>;
};

export type SearchCandidatesInput = {
  filters?: InputMaybe<SearchCandidatesFilters>;
  searchInput: SearchInput;
};

export type SearchCandidatesOutput = {
  __typename?: 'SearchCandidatesOutput';
  items: Array<CandidateOutput>;
  total: Scalars['Int']['output'];
};

export type SearchInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchRelatedSkill = {
  __typename?: 'SearchRelatedSkill';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  strength: Scalars['Float']['output'];
  synonyms: Array<Scalars['String']['output']>;
};

export type SearchResponse = {
  items: Array<Node>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SearchSkillInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<Vertical>;
};

export type SearchSkillsSkillOutput = {
  __typename?: 'SearchSkillsSkillOutput';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regex?: Maybe<Scalars['String']['output']>;
  related: Array<SearchRelatedSkill>;
  skillCategory?: Maybe<SkillCategory_2>;
  synonyms?: Maybe<Array<Scalars['String']['output']>>;
};

export type SectionElement = CandidateInterviewNote | CandidatePercentageItem | CandidateScaleItem | CandidateSelectItem | CandidateStatsCheckList | CandidateStatsSlidersList | CheckListItem | KeywordsCollection | NumericalItem;

export type SendAiEmailsInput = {
  includeFollowups?: InputMaybe<Scalars['Boolean']['input']>;
  optimizeSendTime?: InputMaybe<Scalars['Boolean']['input']>;
  sequenceId: Scalars['String']['input'];
};

export type SendChatMessageInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  chatRowInput: Array<ChatRowInput>;
  extraDataJSON?: InputMaybe<Scalars['String']['input']>;
  micro?: InputMaybe<ChatMicro>;
};

export type SendContactSequenceArgs = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  /** Sequence stages that will be used to contact a candidate. */
  emailStages: Array<EmailSequenceStage>;
  sendAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
  /** The ID of the sequence template that was used to generate a sequence. */
  sequenceTemplateId?: InputMaybe<Scalars['String']['input']>;
  smsStages: Array<SmsSequenceStage>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type SendContactSequenceResult = PaymentRequiredError | SendContactSequenceSuccess | SendContactSequenceValidationError;

export type SendContactSequenceSuccess = {
  __typename?: 'SendContactSequenceSuccess';
  /** Mail was not sent; recipient is blocked from receiving emails. */
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Mail was not sent, may be sent later if an email address is found.
   * Set if we don't know the candidate's email address yet.
   */
  isDeferred: Scalars['Boolean']['output'];
};

export type SendContactSequenceValidationError = {
  __typename?: 'SendContactSequenceValidationError';
  message?: Maybe<Scalars['String']['output']>;
};

export type SendCustomAtsProviderRequestInput = {
  atsLink: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailAsUserInput = {
  bcc?: InputMaybe<Array<EmailRecipient>>;
  bodyHtml: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<EmailRecipient>>;
  followUpEmails?: InputMaybe<Array<FollowUpEmail>>;
  generatedEmailId?: InputMaybe<Scalars['String']['input']>;
  sendAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
  /** @deprecated no longer used */
  sequenceType?: InputMaybe<SequenceType>;
  sms?: InputMaybe<SendSmsAsUser>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<EmailRecipient>>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type SendEmailAsUserResult = PaymentRequiredError | QuotaExceededError | SendEmailAsUserSuccess;

export type SendEmailAsUserSuccess = {
  __typename?: 'SendEmailAsUserSuccess';
  /** Mail was not sent; recipient is blocked from receiving emails. */
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** Mail was not sent, may be sent later if an email address is found. */
  isDeferred: Scalars['Boolean']['output'];
};

export type SendMassAiEmailResult = PaymentRequiredError | QuotaExceededError | SendMassAiEmailResultSuccess;

export type SendMassAiEmailResultSuccess = {
  __typename?: 'SendMassAiEmailResultSuccess';
  count: Scalars['Int']['output'];
};

export type SendMessage = {
  body: Scalars['String']['input'];
  candidateId?: InputMaybe<Scalars['String']['input']>;
  jobLeadId?: InputMaybe<Scalars['String']['input']>;
  parentMessageId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Scheduled time to send the message.
   * Must be between 15 minutes and 35 days from now.
   */
  sendAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  to: Scalars['String']['input'];
};

export type SendSmsAsUser = {
  /** After which email we should send the SMS. */
  afterEmail: Scalars['Int']['input'];
  body: Scalars['String']['input'];
  /** How many hours we should wait before sending the SMS. */
  plusHours: Scalars['Int']['input'];
  to: Scalars['String']['input'];
};

export type SendSlackNotificationInput = {
  extraData?: InputMaybe<Scalars['String']['input']>;
  type: SendSlackNotificationType;
};

export type SendSlackNotificationType =
  | 'PAYWALL_PRESENTED';

export type SendTeamInvite = {
  email: Scalars['String']['input'];
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Seniority =
  | 'ANY'
  | 'INTERN'
  | 'JUNIOR'
  | 'LEAD'
  | 'MID'
  | 'PRINCIPAL'
  | 'SENIOR';

export type Sequence = {
  __typename?: 'Sequence';
  bcc: Array<Scalars['String']['output']>;
  cc: Array<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
};

export type SequenceStageTemplate = {
  __typename?: 'SequenceStageTemplate';
  bodyHtml: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sequencePosition: Scalars['Int']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  type: SequenceStageTemplateType;
};

export type SequenceStageTemplateArgs = {
  bodyHtml: Scalars['String']['input'];
  sequencePosition: Scalars['Int']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  type: SequenceStageTemplateType;
};

export type SequenceStageTemplateType =
  | 'EMAIL'
  | 'SMS';

export type SequenceTemplate = {
  __typename?: 'SequenceTemplate';
  canBeEdited: Scalars['Boolean']['output'];
  createdBy: SequenceTemplateAuthor;
  id: Scalars['String']['output'];
  isEmailFollowUpEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  stageTemplates: Array<SequenceStageTemplate>;
};

export type SequenceTemplateAuthor = {
  __typename?: 'SequenceTemplateAuthor';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SequenceTemplatesPaginated = {
  __typename?: 'SequenceTemplatesPaginated';
  items: Array<SequenceTemplate>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type SequenceType =
  | 'BASIC'
  | 'CUSTOM';

export type SequencedEmailTemplate = {
  bodyHtml: Scalars['String']['input'];
  hasCustomVariables?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
};

export type SequencerAuthStatus = {
  __typename?: 'SequencerAuthStatus';
  canSendSequences: Scalars['Boolean']['output'];
  didSendEmails?: Maybe<Scalars['Boolean']['output']>;
  enabledProviders: Array<EmailProvider>;
  id: Scalars['String']['output'];
  isConnected: Scalars['Boolean']['output'];
  isGmailEnabled: Scalars['Boolean']['output'];
  isMicrosoftEnabled: Scalars['Boolean']['output'];
  provider?: Maybe<EmailProvider>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userGoogleScope?: Maybe<Scalars['String']['output']>;
  userMsScope?: Maybe<Scalars['String']['output']>;
  userSignature?: Maybe<Scalars['String']['output']>;
};

export type SetTeamName = {
  name: Scalars['String']['input'];
};

export type SetTeamNameResult = {
  __typename?: 'SetTeamNameResult';
  team: Team;
};

/** Shareable candidate profile. */
export type ShadowProfile = {
  __typename?: 'ShadowProfile';
  ctaTitle?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  feedbackChatId?: Maybe<Scalars['String']['output']>;
  isObfuscated?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<ShadowProfileLogo>;
  profile: CandidateOutput;
  title?: Maybe<Scalars['String']['output']>;
};

export type ShadowProfileLogo = {
  __typename?: 'ShadowProfileLogo';
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};

export type ShareableLinkCreated = {
  __typename?: 'ShareableLinkCreated';
  candidateSnapShot: Scalars['String']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ShareableLinkOpen = {
  __typename?: 'ShareableLinkOpen';
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['AWSDateTime']['output'];
};

/** A skill that a candidate can have. */
export type Skill = Node & {
  __typename?: 'Skill';
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The date when this skill was added to the system.
   * Helps users to set realistic years of experience.
   */
  existsSince?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regex?: Maybe<Scalars['String']['output']>;
  skillCategory?: Maybe<SkillCategory_2>;
  /** Alternative names for this skill. */
  synonyms?: Maybe<Array<Scalars['String']['output']>>;
};

export type SkillCategory_2 = Node & {
  __typename?: 'SkillCategory_2';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  vertical?: Maybe<Vertical>;
};

export type SkillInfo = {
  __typename?: 'SkillInfo';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  related: Array<RelatedSkillBase>;
};

export type SkillInfoWithSynonyms = {
  __typename?: 'SkillInfoWithSynonyms';
  name: Scalars['String']['output'];
  regex?: Maybe<Scalars['String']['output']>;
  related?: Maybe<Array<RelatedSkill>>;
  synonyms?: Maybe<Array<Scalars['String']['output']>>;
};

export type SkillPhrase = {
  __typename?: 'SkillPhrase';
  id: Scalars['String']['output'];
  phrase: Scalars['String']['output'];
  phraseType: SkillPhraseType;
  vertical: Vertical;
};

export type SkillPhraseInput = {
  phrase: Scalars['String']['input'];
  phraseType: SkillPhraseType;
  vertical: Vertical;
};

export type SkillPhraseType =
  | 'NEGATIVE'
  | 'POSITIVE';

export type SkillPhrases = {
  __typename?: 'SkillPhrases';
  items: Array<SkillPhrase>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SkillSearchResponse = SearchResponse & {
  __typename?: 'SkillSearchResponse';
  items: Array<Skill>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SkillSeniority = {
  __typename?: 'SkillSeniority';
  name: Scalars['String']['output'];
  seniority: Scalars['Float']['output'];
};

export type SkillsForType = {
  __typename?: 'SkillsForType';
  /** True if the skills are being fetched asynchronously. */
  isGettingAsync: Scalars['Boolean']['output'];
  skills: Array<RelatedSkill>;
  title: Scalars['String']['output'];
};

export type Slider = PolarizationSlider | ValueSlider;

export type StaticSectionType =
  | 'BLOBS'
  | 'EXP_KEY_WORDS'
  | 'PUBLIC_NOTES'
  | 'RECENT_PROJECTS'
  | 'YEARS_OF_EXP';

export type StatsType =
  | 'SUMMARY'
  | 'TIMELINE';

export type Subscription = {
  __typename?: 'Subscription';
  messageSent: MessageSentEvent;
  newCandidateMatch: NewCandidateMatch;
  newVacancyMatch: NewCandidateMatch;
  onAddEmailsToCandidate: CandidateOutput;
  onCallUpdated: Call;
  onCandidateUpdated: CandidateUpdated;
  onContactInfoAddedToCandidate: CandidateOutput;
  onJobTitleSkillsAvailable: JobTitleSkillsReady;
  onTaskStatusUpdate: Task;
  onVacancyUpdated?: Maybe<VacancyOutput>;
};


export type SubscriptionMessageSentArgs = {
  tenantId: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionNewCandidateMatchArgs = {
  candidateId: Scalars['String']['input'];
};


export type SubscriptionNewVacancyMatchArgs = {
  vacancyId: Scalars['String']['input'];
};


export type SubscriptionOnAddEmailsToCandidateArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionOnCallUpdatedArgs = {
  twilioCallSid: Scalars['String']['input'];
};


export type SubscriptionOnCandidateUpdatedArgs = {
  candidateId: Scalars['String']['input'];
};


export type SubscriptionOnContactInfoAddedToCandidateArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionOnJobTitleSkillsAvailableArgs = {
  jobTitle: Scalars['String']['input'];
};


export type SubscriptionOnTaskStatusUpdateArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionOnVacancyUpdatedArgs = {
  id: Scalars['String']['input'];
};

export type SubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'paused'
  | 'trialing'
  | 'unpaid';

export type SurveyData = {
  __typename?: 'SurveyData';
  answer: Scalars['String']['output'];
  favorableAnswer?: Maybe<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  result: Scalars['String']['output'];
};

export type SurveyQuestion = {
  answer: Scalars['String']['input'];
  favorableAnswer?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  result: Scalars['Boolean']['input'];
};

export type Task = {
  __typename?: 'Task';
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  status: TaskStatus;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type TaskStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'STARTED'
  | 'UNKNOWN';

export type TaskStatusUpdate = {
  data?: InputMaybe<Scalars['String']['input']>;
  status: TaskStatus;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a tenant. */
export type Team = {
  __typename?: 'Team';
  accountType?: Maybe<AccountType>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  lastPaymentFailedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  seats: Scalars['Int']['output'];
};

export type TeamPerformance = {
  __typename?: 'TeamPerformance';
  topPerformers?: Maybe<Array<UserStats>>;
  underPerformers?: Maybe<Array<UserStats>>;
};

export type TeamUserActivity = {
  __typename?: 'TeamUserActivity';
  average: UserActivityTeamAverage;
  highlights: UserActivityHighlights;
  users: UserActivityUsers;
};

export type TelephonyMessage = {
  __typename?: 'TelephonyMessage';
  body: Scalars['String']['output'];
  direction: MessageDirection;
  errorCode?: Maybe<Scalars['Int']['output']>;
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Pending message may be canceled if the sequence was aborted. */
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  messageSid?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Scheduled time to send the message. */
  sendAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Set if the message has been sent. */
  sentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  threadId: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type TelephonyMessageThread = {
  __typename?: 'TelephonyMessageThread';
  candidate?: Maybe<CandidateOutput>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastMessageAt: Scalars['AWSDateTime']['output'];
  messages: Array<TelephonyMessage>;
  unreadCount: Scalars['Int']['output'];
};

export type Tenant = {
  __typename?: 'Tenant';
  accountType?: Maybe<AccountType>;
  createdAt: Scalars['AWSDateTime']['output'];
  creator?: Maybe<UserOutput>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isTrackingUserActivity?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<UserOutput>;
};

export type TenantList = {
  __typename?: 'TenantList';
  items: Array<Tenant>;
  total: Scalars['Int']['output'];
};

export type ThreadFilter =
  /** Return only threads with unread messages. */
  | 'UNREAD'
  /** Return only threads with replies (received a reply from a candidate). */
  | 'WITH_REPLIES';

/**
 * Statistics about threads.
 * A thread is counted as opened if at least one message was opened.
 * Same for replied and bounced.
 * Sent is the total number of threads that have at least one sent message.
 */
export type ThreadStats = {
  __typename?: 'ThreadStats';
  bounced: Scalars['Int']['output'];
  opened: Scalars['Int']['output'];
  replied: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type TimeRange = {
  end?: InputMaybe<Scalars['AWSDateTime']['input']>;
  start?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type TopSkillsOutput = {
  __typename?: 'TopSkillsOutput';
  skills: Array<SkillSeniority>;
};

export type TrainEmail = {
  __typename?: 'TrainEmail';
  aiEmail?: Maybe<Scalars['String']['output']>;
  candidate?: Maybe<TrainEmailCandidate>;
  id: Scalars['String']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  trainingEmail?: Maybe<Scalars['String']['output']>;
};

export type TrainEmailCandidate = {
  __typename?: 'TrainEmailCandidate';
  id: Scalars['String']['output'];
  linkedInUrl: Scalars['String']['output'];
};

export type TwilioToken = {
  __typename?: 'TwilioToken';
  token: Scalars['String']['output'];
};

export type UpdateApplicationInput = {
  candidateId: Scalars['String']['input'];
  status: ApplicationStatus;
  vacancyId: Scalars['String']['input'];
};

export type UpdateCallInput = {
  callSid: Scalars['String']['input'];
  dialAction?: InputMaybe<DialAction>;
  id?: InputMaybe<Scalars['String']['input']>;
  preRecordedVoicemailMessageId?: InputMaybe<Scalars['String']['input']>;
  ringbackNumber?: InputMaybe<Scalars['String']['input']>;
  userMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDomainCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  clearEmailBody?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCandidateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sequenceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<EmailSequenceState>;
  subject?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInAppMessageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  audienceTypesNegative?: InputMaybe<Array<InAppMessageAudienceType>>;
  audienceTypesPositive?: InputMaybe<Array<InAppMessageAudienceType>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMany = {
  __typename?: 'UpdateMany';
  count: Scalars['Int']['output'];
};

export type UpdateSequenceTemplateArgsV2 = {
  id: Scalars['String']['input'];
  isFollowUpEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  stageTemplates: Array<SequenceStageTemplateArgs>;
};

export type UpdateSequenceTemplateInput = {
  emailTemplates: Array<SequencedEmailTemplate>;
  id: Scalars['String']['input'];
  isEmailFollowUpEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateShareableLinkInput = {
  candidateSnapShot?: InputMaybe<Scalars['String']['input']>;
  ctaTitle?: InputMaybe<Scalars['String']['input']>;
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  match?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSkillOutput = {
  __typename?: 'UpdateSkillOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateTenantInput = {
  id: Scalars['ID']['input'];
  isTrackingUserActivity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateThreadInput = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobLeadId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  threadId: Scalars['String']['input'];
};

export type UpdateVacancy2Input = {
  data: UpdateVacancyDataInput;
  vacancyId: Scalars['String']['input'];
};

export type UpdateVacancyDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  advancementOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  aiChecks?: InputMaybe<Array<AiCheck>>;
  allowedToDisclosePayRange?: InputMaybe<Scalars['Boolean']['input']>;
  appendSkills?: InputMaybe<Array<DesiredSkill>>;
  apprenticeshipProgram?: InputMaybe<Scalars['Boolean']['input']>;
  atsLink?: InputMaybe<Scalars['String']['input']>;
  autonomy?: InputMaybe<Scalars['Boolean']['input']>;
  benefits?: InputMaybe<Array<Scalars['String']['input']>>;
  benefitsTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandType?: InputMaybe<Array<BrandType>>;
  buildLitigationSkills?: InputMaybe<Scalars['Boolean']['input']>;
  buildTeam?: InputMaybe<Scalars['Boolean']['input']>;
  buzzwordsCloud?: InputMaybe<Array<Scalars['String']['input']>>;
  clientContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Field no longer supported */
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientOriginationBonus?: InputMaybe<Scalars['Boolean']['input']>;
  commissionPlan?: InputMaybe<CommissionPlanType>;
  compPlanInfo?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyUrl?: InputMaybe<Scalars['String']['input']>;
  correlatedJobTitleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  equityOptionsOffered?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hasGrowthOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  idealCandidateProfile?: InputMaybe<Scalars['String']['input']>;
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  innovativeProduct?: InputMaybe<Scalars['Boolean']['input']>;
  isEnriched?: InputMaybe<Scalars['Boolean']['input']>;
  isStackRankRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `jobTitleId` instead */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobTitleFull?: InputMaybe<VacancyJobTitleInput>;
  /** @deprecated Use `jobTitleFull` instead */
  jobTitleId?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  lightIndustrialProdType?: InputMaybe<LightIndustrialProdType>;
  location?: InputMaybe<Array<LocationInput>>;
  locationType?: InputMaybe<LocationType>;
  name?: InputMaybe<Scalars['String']['input']>;
  negativeOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  nightShiftPayDifferential?: InputMaybe<Scalars['String']['input']>;
  organizationTypeDescription?: InputMaybe<Scalars['String']['input']>;
  paidSickLeave?: InputMaybe<Scalars['Boolean']['input']>;
  payDescription?: InputMaybe<PayDescription>;
  payRange?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberAcceptsText?: InputMaybe<Scalars['Boolean']['input']>;
  positionFor?: InputMaybe<Array<PositionFor>>;
  positiveOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  previousIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  productInfo?: InputMaybe<Scalars['String']['input']>;
  recruitmentType?: InputMaybe<PositionType>;
  relocationAssistance?: InputMaybe<Scalars['Boolean']['input']>;
  requiredCertificates?: InputMaybe<Array<CertificateInput>>;
  responsibilitiesFragment?: InputMaybe<Scalars['String']['input']>;
  revealCompany?: InputMaybe<Scalars['Boolean']['input']>;
  salesOpportunityInfo?: InputMaybe<Scalars['String']['input']>;
  scaleExistingProduct?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  seniority?: InputMaybe<Seniority>;
  shouldSearchCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  signOnBonus?: InputMaybe<Scalars['Boolean']['input']>;
  signOnBonusValue?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<DesiredSkill>>;
  thirdPartyLinkText?: InputMaybe<Scalars['String']['input']>;
  thirdPartyLinkURL?: InputMaybe<Scalars['String']['input']>;
  top3Skills?: InputMaybe<Array<Scalars['String']['input']>>;
  typicalWorkingHours?: InputMaybe<Scalars['String']['input']>;
  vacancyStatus?: InputMaybe<VacancyStatus>;
  vertical?: InputMaybe<Vertical>;
  wageType?: InputMaybe<WageType>;
};

export type UploadAssetsOutput = {
  __typename?: 'UploadAssetsOutput';
  presignedUrls: Array<PresignedUrl>;
};

export type UpsertJobLeadSearchInput = {
  companySize?: InputMaybe<Array<CompanySize>>;
  dateAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
  dateBefore?: InputMaybe<Scalars['AWSDateTime']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  haveAiFindSimilarJobTitles?: InputMaybe<Scalars['Boolean']['input']>;
  hiringCompany?: InputMaybe<Array<NegationOptionInput>>;
  jobTitle?: InputMaybe<Array<NegationOptionInput>>;
  jobType?: InputMaybe<JobContractType>;
  keywords?: InputMaybe<Array<NegationOptionInput>>;
  location?: InputMaybe<Array<LocationNegationOptionInput>>;
  name: Scalars['String']['input'];
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertVacancyInput = {
  data: UpdateVacancyDataInput;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type UseInviteResult = {
  __typename?: 'UseInviteResult';
  error?: Maybe<Scalars['String']['output']>;
  rateLimited: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UserActivitiesInput = {
  includeIndividualEvents?: InputMaybe<Scalars['Boolean']['input']>;
  searchInput?: InputMaybe<SearchInput>;
  skipCloseProximityEvents?: InputMaybe<Scalars['Boolean']['input']>;
  skippedIndividualEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<UserActivitySummarySortBy>;
  timeRange?: InputMaybe<TimeRange>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vacancyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserActivity = Node & {
  __typename?: 'UserActivity';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  dailySummaries: Array<DailySummary>;
  events: Array<Event>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  summary: UserActivitySummary;
  timeZone?: Maybe<Scalars['String']['output']>;
  vacancySummaries: Array<VacancyStats>;
};

export type UserActivityArgs = {
  attributes?: InputMaybe<Scalars['AWSJSON']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<UserActivityEvent>;
  eventTypeStats?: InputMaybe<EventTypeStat>;
  recordedAt?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type UserActivityEvent =
  | 'ATS_PAGE_CLOSED'
  | 'ATS_PAGE_OPENED'
  | 'AUTO_INVITE_SENT'
  | 'CALENDAR_PAGE_CLOSED'
  | 'CALENDAR_PAGE_OPENED'
  | 'CANDIDATE_PAGE_CLOSED'
  | 'CANDIDATE_PAGE_OPENED'
  | 'COMMUNICATION_PAGE_CLOSED'
  | 'COMMUNICATION_PAGE_OPENED'
  | 'EMAIL_REPLY_RECEIVED'
  | 'FILE_CLOSED'
  | 'FILE_OPENED'
  | 'GENERATE_EMAIL_CLICKED'
  | 'GMAIL_EMAIL'
  | 'GMAIL_EMAIL_CLOSED'
  | 'GMAIL_INBOX'
  | 'GMAIL_INBOX_CLOSED'
  | 'LI_CONNECTION_REQUEST_SENT'
  | 'MAIL_EMAIL'
  | 'MAIL_EMAIL_CLOSED'
  | 'MAIL_INBOX'
  | 'MAIL_INBOX_CLOSED'
  | 'OTHER_PAGE_CLOSED'
  | 'OTHER_PAGE_OPENED'
  | 'PAGE_SCROLLED'
  | 'PRODUCTIVITY_PAGE_CLOSED'
  | 'PRODUCTIVITY_PAGE_OPENED'
  | 'SEARCH_PAGE_CLOSED'
  | 'SEARCH_PAGE_OPENED'
  | 'SEND_EMAIL_CLICKED'
  | 'WORK_OTHER_PAGE_CLOSED'
  | 'WORK_OTHER_PAGE_OPENED';

export type UserActivityHighlights = {
  __typename?: 'UserActivityHighlights';
  topPerformer: UserActivity;
  underPerformers: Array<UserActivity>;
};

export type UserActivityPagination = {
  __typename?: 'UserActivityPagination';
  total: Scalars['Int']['output'];
};

export type UserActivitySummary = {
  __typename?: 'UserActivitySummary';
  atsPageOpened: Scalars['Int']['output'];
  autoInviteSent: Scalars['Int']['output'];
  calendarPageOpened: Scalars['Int']['output'];
  communicationPageOpened: Scalars['Int']['output'];
  domainCategorySummary?: Maybe<Array<DomainCategorySummary>>;
  emailRepliesReceived: Scalars['Int']['output'];
  emailsSent: Scalars['Int']['output'];
  fileOpened: Scalars['Int']['output'];
  /** @deprecated In favor of mailInboxOpened */
  gmailInboxOpened: Scalars['Int']['output'];
  hoursWorked: Scalars['Float']['output'];
  liConnectionRequestSent: Scalars['Int']['output'];
  mailInboxOpened: Scalars['Int']['output'];
  productivityPageOpened: Scalars['Int']['output'];
  profilesViewed: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  workOtherPageOpened: Scalars['Int']['output'];
};

export type UserActivitySummarySortBy = {
  column: UserActivitySummarySortColumn;
  order: Order;
};

export type UserActivitySummarySortColumn =
  | 'EMAILS_SENT'
  | 'EMAIL_REPLIES_RECEIVED'
  | 'HOURS_WORKED'
  | 'PROFILES_VIEWED'
  | 'SCORE';

export type UserActivityTeamAverage = {
  __typename?: 'UserActivityTeamAverage';
  emailRepliesReceived: Scalars['Float']['output'];
  emailsSent: Scalars['Float']['output'];
  hoursWorked: Scalars['Float']['output'];
  profilesViewed: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type UserActivityUsers = SearchResponse & {
  __typename?: 'UserActivityUsers';
  items: Array<UserActivity>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type UserInput = {
  atsId?: InputMaybe<Scalars['String']['input']>;
  autoInvite?: InputMaybe<Scalars['Boolean']['input']>;
  bccAtsAddress?: InputMaybe<Scalars['String']['input']>;
  calendlyLink?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailSignature?: InputMaybe<Scalars['String']['input']>;
  jdRewriteCustomInstructions?: InputMaybe<Scalars['String']['input']>;
  linkedInConnectionRequestNote?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shouldGetStatsUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  tosAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserList = {
  __typename?: 'UserList';
  items: Array<UserOutput>;
  total: Scalars['Int']['output'];
};

export type UserOutput = {
  __typename?: 'UserOutput';
  atsId?: Maybe<Scalars['String']['output']>;
  autoInvite?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bccAtsAddress?: Maybe<Scalars['String']['output']>;
  calendlyLink?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  emailAddress: Scalars['String']['output'];
  emailProvider?: Maybe<EmailProvider>;
  emailSignature?: Maybe<Scalars['String']['output']>;
  featureFlags: FeatureFlags;
  id: Scalars['String']['output'];
  isTenantOwner: Scalars['Boolean']['output'];
  jdRewriteCustomInstructions?: Maybe<Scalars['String']['output']>;
  latestExtensionVersion?: Maybe<Scalars['String']['output']>;
  linkedInConnectionRequestNote?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  roles: Array<Scalars['String']['output']>;
  sequencerEmailAddress?: Maybe<Scalars['String']['output']>;
  shouldGetStatsUpdate?: Maybe<Scalars['Boolean']['output']>;
  tenant: Tenant;
  tenantId: Scalars['String']['output'];
  tenantLogoKey?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  tosAcceptedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  userName: Scalars['String']['output'];
};

export type UserPersonalStatsInput = {
  timeRange: TimeRange;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  mailingAiSettings?: Maybe<AiSettingsOutput>;
  mailingAutomationSettings?: Maybe<AutomationSettings>;
};

export type UserPreferencesInput = {
  mailingAiSettings?: InputMaybe<AiSettings>;
  mailingAutomationSettings?: InputMaybe<AutomationSettingsInput>;
};

export type UserStats = {
  __typename?: 'UserStats';
  metrics?: Maybe<Array<MetricWithValue>>;
  user: User;
};

export type UserStatsResponse = {
  __typename?: 'UserStatsResponse';
  nextToken?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  userStats: Array<UserStats>;
};

export type UserTask = {
  __typename?: 'UserTask';
  Assignee: User;
  Candidate?: Maybe<CandidateOutput>;
  Creator?: Maybe<User>;
  assigneeUserId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  creatorUserId?: Maybe<Scalars['String']['output']>;
  deadlineAt?: Maybe<Scalars['AWSDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doneAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type UserTasks = {
  __typename?: 'UserTasks';
  items: Array<UserTask>;
  total: Scalars['Int']['output'];
};

export type VacancyActivityResponse = {
  __typename?: 'VacancyActivityResponse';
  nextToken?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
  userStats: Array<UserStats>;
  vacancyStats: Array<MetricWithValue>;
};

export type VacancyCandidateMatchOutput = {
  __typename?: 'VacancyCandidateMatchOutput';
  adjustedMatch?: Maybe<Scalars['Float']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  /** Strength of candidate match for this vacancy. 0-1 */
  match: Scalars['Float']['output'];
  /** @deprecated Field no longer supported */
  mustHaveMatch?: Maybe<VacancyCandidateSkillMatchOutput>;
  /** @deprecated Field no longer supported */
  niceToHaveMatch?: Maybe<VacancyCandidateSkillMatchOutput>;
};

export type VacancyCandidateSkillMatchItem = {
  __typename?: 'VacancyCandidateSkillMatchItem';
  match: Scalars['Float']['output'];
  /** @deprecated Field no longer supported */
  matchType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type VacancyCandidateSkillMatchOutput = {
  __typename?: 'VacancyCandidateSkillMatchOutput';
  skills: Array<VacancyCandidateSkillMatchItem>;
};

export type VacancyClientTokenCheckout = {
  vacancyId: Scalars['String']['input'];
};

export type VacancyJobTitleInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type VacancyList = {
  listId: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
};

export type VacancyLocation = {
  __typename?: 'VacancyLocation';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  district?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type VacancyOutput = Node & {
  __typename?: 'VacancyOutput';
  address?: Maybe<Scalars['String']['output']>;
  advancementOpportunity?: Maybe<Scalars['Boolean']['output']>;
  aiChecks?: Maybe<Array<AiCheck>>;
  allowedToDisclosePayRange?: Maybe<Scalars['Boolean']['output']>;
  applicationCount?: Maybe<Scalars['Int']['output']>;
  apprenticeshipProgram?: Maybe<Scalars['Boolean']['output']>;
  atsId?: Maybe<Scalars['String']['output']>;
  atsLink?: Maybe<Scalars['String']['output']>;
  autonomy?: Maybe<Scalars['Boolean']['output']>;
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  benefitsTemplateFragment?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  brandType?: Maybe<Array<BrandType>>;
  buildLitigationSkills?: Maybe<Scalars['Boolean']['output']>;
  buildTeam?: Maybe<Scalars['Boolean']['output']>;
  buzzwordsCloud?: Maybe<Array<Scalars['String']['output']>>;
  clientContact?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  clientName?: Maybe<Scalars['String']['output']>;
  clientOriginationBonus?: Maybe<Scalars['Boolean']['output']>;
  clientTokens?: Maybe<Array<ClientToken>>;
  commissionPlan?: Maybe<CommissionPlanType>;
  compPlanInfo?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disclosureTemplateFragment?: Maybe<Scalars['String']['output']>;
  elevatorPitch?: Maybe<Scalars['String']['output']>;
  /** @deprecated Email templates are deprecated */
  emailTemplate?: Maybe<Array<EmailTemplateOutput>>;
  employmentType?: Maybe<EmploymentType>;
  equityOptionsOffered?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  funnelId?: Maybe<Scalars['String']['output']>;
  hasGrowthOpportunities?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  idealCandidateProfile?: Maybe<Scalars['String']['output']>;
  innovativeProduct?: Maybe<Scalars['Boolean']['output']>;
  isAIGenerated?: Maybe<Scalars['Boolean']['output']>;
  isEnriched?: Maybe<Scalars['Boolean']['output']>;
  isStackRankRequired?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `jobTitleFull` instead */
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobTitleFull?: Maybe<JobTitle>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  leadUser?: Maybe<UserOutput>;
  leadUserId?: Maybe<Scalars['String']['output']>;
  lightIndustrialProdType?: Maybe<LightIndustrialProdType>;
  location?: Maybe<Array<VacancyLocation>>;
  locationType?: Maybe<LocationType>;
  name: Scalars['String']['output'];
  negativeOPCs?: Maybe<Array<Scalars['String']['output']>>;
  negativeSkillPhrases?: Maybe<Array<Scalars['String']['output']>>;
  newMatchesCount?: Maybe<Scalars['Int']['output']>;
  nightShiftPayDifferential?: Maybe<Scalars['String']['output']>;
  organizationTypeDescription?: Maybe<Scalars['String']['output']>;
  paidSickLeave?: Maybe<Scalars['Boolean']['output']>;
  payDescription?: Maybe<PayDescription>;
  payRange?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberAcceptsText?: Maybe<Scalars['Boolean']['output']>;
  positionCount?: Maybe<Scalars['Int']['output']>;
  positionFor?: Maybe<Array<PositionFor>>;
  positiveOPCs?: Maybe<Array<Scalars['String']['output']>>;
  previousIndustries?: Maybe<Array<Scalars['String']['output']>>;
  priority?: Maybe<VacancyPriority>;
  productInfo?: Maybe<Scalars['String']['output']>;
  recruitmentType?: Maybe<PositionType>;
  relocationAssistance?: Maybe<Scalars['Boolean']['output']>;
  requiredCertificates?: Maybe<Array<Certificate>>;
  responsibilitiesFragment?: Maybe<Scalars['String']['output']>;
  revealCompany?: Maybe<Scalars['Boolean']['output']>;
  salesOpportunityInfo?: Maybe<Scalars['String']['output']>;
  scaleExistingProduct?: Maybe<Scalars['Boolean']['output']>;
  schedulingLink?: Maybe<Scalars['String']['output']>;
  signOnBonus?: Maybe<Scalars['Boolean']['output']>;
  signOnBonusValue?: Maybe<Scalars['Int']['output']>;
  skills?: Maybe<Array<VacancySkill>>;
  status: VacancyStatus;
  tenantId?: Maybe<Scalars['String']['output']>;
  thirdPartyLinkText?: Maybe<Scalars['String']['output']>;
  thirdPartyLinkURL?: Maybe<Scalars['String']['output']>;
  top3Skills?: Maybe<Array<Scalars['String']['output']>>;
  typicalWorkingHours?: Maybe<Scalars['String']['output']>;
  vertical?: Maybe<Vertical>;
  wageType?: Maybe<WageType>;
};

export type VacancyPriority =
  | 'BACKFILL'
  | 'CRUCIAL'
  | 'NORMAL'
  | 'PAUSED';

export type VacancySearchResult = {
  __typename?: 'VacancySearchResult';
  nextToken?: Maybe<Scalars['String']['output']>;
  vacancies: Array<VacancyOutput>;
};

/** A skill that is required or desired for a vacancy. */
export type VacancySkill = {
  __typename?: 'VacancySkill';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  skill: Skill;
  yearsOfExperience?: Maybe<Scalars['Int']['output']>;
};

export type VacancyStats = {
  __typename?: 'VacancyStats';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  summary: UserActivitySummary;
};

export type VacancyStatus =
  | 'CLOSED'
  | 'DRAFT'
  | 'OPEN';

export type ValueSlider = {
  __typename?: 'ValueSlider';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Vertical =
  | 'ACCOUNTING'
  | 'ANY'
  | 'CONSTRUCTION'
  | 'CUSTOMER_SERVICE'
  | 'EDUCATION'
  | 'ENVIRONMENTAL_SUSTAINABLE'
  | 'EXECUTIVE'
  | 'HEALTHCARE'
  | 'LEGAL'
  | 'LIGHT_INDUSTRIAL'
  | 'MANUFACTORING'
  | 'OTHER'
  | 'RECRUITING'
  | 'SALES'
  | 'SOFTWARE';

export type WageType =
  | 'HOURLY'
  | 'MONTHLY'
  | 'YEARLY';

export type WorkExperienceOutput = {
  __typename?: 'WorkExperienceOutput';
  company?: Maybe<CompanyOutput>;
  id?: Maybe<Scalars['String']['output']>;
  isTopCompany?: Maybe<Scalars['Boolean']['output']>;
  roles: Array<WorkExperienceRoleOutput>;
};

export type WorkExperienceRoleOutput = {
  __typename?: 'WorkExperienceRoleOutput';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['AWSDateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Skill>>;
  start?: Maybe<Scalars['AWSDateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type YearsOfExperience = {
  __typename?: 'YearsOfExperience';
  label: Scalars['String']['output'];
  yearsOfExperience: Scalars['String']['output'];
};

export type AddressesQueryVariables = Exact<{
  input: ListAddressesInput;
}>;


export type AddressesQuery = { __typename?: 'Query', listAddresses: Array<string> };

export type ImpersonateUserMutationVariables = Exact<{
  input: ImpersonateUser;
}>;


export type ImpersonateUserMutation = { __typename?: 'Mutation', impersonateUser: { __typename?: 'ImpersonateUserError', message: string } | { __typename?: 'ImpersonateUserOutput', authToken: string, user: { __typename?: 'ImpersonateUserOutputUser', tomboUserId: string, username: string } } };

export type AdminSearchSkillsLikeQueryVariables = Exact<{
  query: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type AdminSearchSkillsLikeQuery = { __typename?: 'Query', searchSkillsLike: Array<{ __typename?: 'SearchSkillsSkillOutput', id: string, name: string, synonyms?: Array<string> | null | undefined, regex?: string | null | undefined, description?: string | null | undefined, related: Array<{ __typename?: 'SearchRelatedSkill', id: string, name: string, strength: number, synonyms: Array<string> }>, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined }> };

export type AdminCreateSkillMutationVariables = Exact<{
  skillName: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
}>;


export type AdminCreateSkillMutation = { __typename?: 'Mutation', createSkill: { __typename?: 'UpdateSkillOutput', success: boolean } };

export type AdminUpdateSkillMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newSkillName?: InputMaybe<Scalars['String']['input']>;
  related?: InputMaybe<Array<RelatedSkillInput>>;
  synonyms?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type AdminUpdateSkillMutation = { __typename?: 'Mutation', updateSkill: { __typename?: 'UpdateSkillOutput', success: boolean } };

export type AdminDeleteSkillMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteSkillMutation = { __typename?: 'Mutation', deleteSkill: { __typename?: 'UpdateSkillOutput', success: boolean } };

export type AdminStatsFieldsFragment = { __typename?: 'AdminStats', vacanciesCreated: number, sequencesCreated: number, candidatesInjested: number };

export type AdminStatsQueryVariables = Exact<{
  timeRange?: InputMaybe<TimeRange>;
}>;


export type AdminStatsQuery = { __typename?: 'Query', adminStats: { __typename?: 'AdminStatsOutput', jetBridge: { __typename?: 'AdminStats', vacanciesCreated: number, sequencesCreated: number, candidatesInjested: number }, other: { __typename?: 'AdminStats', vacanciesCreated: number, sequencesCreated: number, candidatesInjested: number } } };

export type TenantFragment = { __typename?: 'Tenant', id: string, name: string, emailAddress?: string | null | undefined, createdAt: any, accountType?: AccountType | null | undefined, deletedAt?: any | null | undefined, creator?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined, owner?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined };

export type AdminListAllTenantsQueryVariables = Exact<{
  input: OffsetPagination;
}>;


export type AdminListAllTenantsQuery = { __typename?: 'Query', listAllTenants: { __typename?: 'TenantList', total: number, items: Array<{ __typename?: 'Tenant', id: string, name: string, emailAddress?: string | null | undefined, createdAt: any, accountType?: AccountType | null | undefined, deletedAt?: any | null | undefined, creator?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined, owner?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined }> } };

export type AdminDisableTenantMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDisableTenantMutation = { __typename?: 'Mutation', disableTenant: { __typename?: 'Tenant', id: string, name: string, emailAddress?: string | null | undefined, createdAt: any, accountType?: AccountType | null | undefined, deletedAt?: any | null | undefined, creator?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined, owner?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined } };

export type AdminEnableTenantMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminEnableTenantMutation = { __typename?: 'Mutation', enableTenant: { __typename?: 'Tenant', id: string, name: string, emailAddress?: string | null | undefined, createdAt: any, accountType?: AccountType | null | undefined, deletedAt?: any | null | undefined, creator?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined, owner?: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } | null | undefined } };

export type AdminListAllVacanciesQueryVariables = Exact<{
  input: FilterAllVacancies;
}>;


export type AdminListAllVacanciesQuery = { __typename?: 'Query', listAllVacancies: { __typename?: 'ListVacanciesOutput', page: number, total: number, items: Array<{ __typename?: 'VacancyOutput', isAIGenerated?: boolean | null | undefined, responsibilitiesFragment?: string | null | undefined, benefitsTemplateFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, elevatorPitch?: string | null | undefined, id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined }> } };

export type CreateVacancyForUserMutationVariables = Exact<{
  input: CreateVacancyForUserInput;
}>;


export type CreateVacancyForUserMutation = { __typename?: 'Mutation', createVacancyForUser: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type SaveAttributeTrainingMutationVariables = Exact<{
  input: SaveAttributeTrainingInput;
}>;


export type SaveAttributeTrainingMutation = { __typename?: 'Mutation', saveAttributeTraining?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type AtsIntegrationStatusFragmentFragment = { __typename?: 'AtsIntegrationStatus', isConnected: boolean, atsProvider?: AtsProvider | null | undefined };

export type AtsUserFragment = { __typename?: 'AtsUser', id: string, name: string, email: string, avatarUrl?: string | null | undefined };

export type AtsSaveIntegrationCredentialsMutationVariables = Exact<{
  input: AtsSaveIntegrationCredentialsInput;
}>;


export type AtsSaveIntegrationCredentialsMutation = { __typename?: 'Mutation', atsSaveIntegrationCredentials: { __typename?: 'AtsIntegrationStatus', isConnected: boolean, atsProvider?: AtsProvider | null | undefined } };

export type AtsStageFragment = { __typename?: 'AtsStage', id: string, name: string };

export type ListAtsStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAtsStagesQuery = { __typename?: 'Query', atsStage: { __typename?: 'AtsStageResult', stages: Array<{ __typename?: 'AtsStage', id: string, name: string }> } };

export type ListAtsVacanciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAtsVacanciesQuery = { __typename?: 'Query', atsVacancy: { __typename?: 'AtsVacancyResult', vacancies: Array<{ __typename?: 'AtsVacancy', id: string, name: string }> } };

export type AtsApplicationFragmentFragment = { __typename?: 'AtsApplication', id: string, createdAt: any, updatedAt: any, rejectedAt?: any | null | undefined, status: string, rejectionReason?: string | null | undefined, atsId?: string | null | undefined, addedToATSAt?: any | null | undefined, candidateId: string, vacancyId: string };

export type ApplicationsForCandidateAndVacancyQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
  vacancyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApplicationsForCandidateAndVacancyQuery = { __typename?: 'Query', atsApplication: { __typename?: 'AtsApplicationResponse', applications: Array<{ __typename?: 'AtsApplication', id: string, createdAt: any, updatedAt: any, rejectedAt?: any | null | undefined, status: string, rejectionReason?: string | null | undefined, atsId?: string | null | undefined, addedToATSAt?: any | null | undefined, candidateId: string, vacancyId: string }> } };

export type AtsAddCandidateMutationVariables = Exact<{
  input: AtsAddCandidateInput;
}>;


export type AtsAddCandidateMutation = { __typename?: 'Mutation', atsAddCandidate: { __typename?: 'AtsAddCandidateError', message: string } | { __typename?: 'AtsCandidateOutput', id?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined, avatarThumbS3Key?: string | null | undefined } };

export type AtsUpdateApplicationMutationVariables = Exact<{
  update: UpdateApplicationInput;
}>;


export type AtsUpdateApplicationMutation = { __typename?: 'Mutation', atsUpdateApplication: { __typename?: 'AtsUpdateApplicationError', message: string } | { __typename?: 'AtsUpdateApplicationOutput', application?: { __typename?: 'AtsApplication', id: string, status: string } | null | undefined } };

export type UnauthenticateAtsIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type UnauthenticateAtsIntegrationMutation = { __typename?: 'Mutation', unauthenticateAtsIntegration: { __typename?: 'AtsIntegrationStatus', isConnected: boolean, atsProvider?: AtsProvider | null | undefined } };

export type GetAtsIntegrationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAtsIntegrationStatusQuery = { __typename?: 'Query', getAtsIntegrationStatus: { __typename?: 'AtsIntegrationStatus', isConnected: boolean, atsProvider?: AtsProvider | null | undefined } };

export type ListAtsUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAtsUsersQuery = { __typename?: 'Query', atsUser: { __typename?: 'AtsUsersResponse', users: Array<{ __typename?: 'AtsUser', id: string, name: string, email: string, avatarUrl?: string | null | undefined }> } };

export type SendCustomAtsProviderRequestMutationVariables = Exact<{
  input: SendCustomAtsProviderRequestInput;
}>;


export type SendCustomAtsProviderRequestMutation = { __typename?: 'Mutation', sendCustomAtsProviderRequest: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type BillingPriceFragmentFragment = { __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined };

export type BillingProductFragmentFragment = { __typename?: 'BillingProduct', id: string, name: string, description?: string | null | undefined, features?: Array<string | null | undefined> | null | undefined, accountType?: AccountType | null | undefined, prices: Array<{ __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined }> };

export type BillingStatusFragmentFragment = { __typename?: 'BillingStatus', teamName?: string | null | undefined, teamOwnerId?: string | null | undefined, isSubscriptionActive: boolean, accountType: AccountType, seats?: number | null | undefined, enabledFeatures: Array<string>, lastPaymentFailedAt?: any | null | undefined, quotas: Array<{ __typename?: 'Quota', feature: string, limit?: number | null | undefined, used?: number | null | undefined }>, activeProduct?: { __typename?: 'ActiveBillingProduct', id: string, name: string, description?: string | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd?: boolean | null | undefined, status: SubscriptionStatus, accountType?: AccountType | null | undefined, activePrice: { __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined } } | null | undefined };

export type GetBillingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingStatusQuery = { __typename?: 'Query', getBillingStatus: { __typename?: 'BillingStatus', teamName?: string | null | undefined, teamOwnerId?: string | null | undefined, isSubscriptionActive: boolean, accountType: AccountType, seats?: number | null | undefined, enabledFeatures: Array<string>, lastPaymentFailedAt?: any | null | undefined, quotas: Array<{ __typename?: 'Quota', feature: string, limit?: number | null | undefined, used?: number | null | undefined }>, activeProduct?: { __typename?: 'ActiveBillingProduct', id: string, name: string, description?: string | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd?: boolean | null | undefined, status: SubscriptionStatus, accountType?: AccountType | null | undefined, activePrice: { __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined } } | null | undefined }, listProducts: Array<{ __typename?: 'BillingProduct', id: string, name: string, description?: string | null | undefined, features?: Array<string | null | undefined> | null | undefined, accountType?: AccountType | null | undefined, prices: Array<{ __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined }> }> };

export type InitiateCheckoutSessionMutationVariables = Exact<{
  input: InitiateCheckoutInput;
}>;


export type InitiateCheckoutSessionMutation = { __typename?: 'Mutation', initiateCheckout: { __typename?: 'BillingSession', startUrl: string } };

export type CreateBillingPortalSessionMutationVariables = Exact<{
  returnUrl: Scalars['String']['input'];
  flowType?: InputMaybe<FlowType>;
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createCustomerPortalSession: { __typename?: 'PortalSession', redirectUrl: string } };

export type ModifySubscriptionMutationVariables = Exact<{
  input: ModifySubscriptionInput;
}>;


export type ModifySubscriptionMutation = { __typename?: 'Mutation', modifySubscription: { __typename?: 'BillingStatus', teamName?: string | null | undefined, teamOwnerId?: string | null | undefined, isSubscriptionActive: boolean, accountType: AccountType, seats?: number | null | undefined, enabledFeatures: Array<string>, lastPaymentFailedAt?: any | null | undefined, quotas: Array<{ __typename?: 'Quota', feature: string, limit?: number | null | undefined, used?: number | null | undefined }>, activeProduct?: { __typename?: 'ActiveBillingProduct', id: string, name: string, description?: string | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd?: boolean | null | undefined, status: SubscriptionStatus, accountType?: AccountType | null | undefined, activePrice: { __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined } } | null | undefined } };

export type BillUserForEmailLookupRevealMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type BillUserForEmailLookupRevealMutation = { __typename?: 'Mutation', billUserForEmailLookupReveal: { __typename?: 'BillingStatus', isSubscriptionActive: boolean } };

export type CandidateEmailFragmentFragment = { __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType, name?: string | null | undefined, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined };

export type BaseCandidateInfoFragmentFragment = { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined, candidateRawId?: string | null | undefined, githubURL?: string | null | undefined, yearsOfExperience?: number | null | undefined, atsId?: string | null | undefined, workExperience?: Array<{ __typename?: 'WorkExperienceOutput', id?: string | null | undefined, isTopCompany?: boolean | null | undefined, company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined, roles: Array<{ __typename?: 'WorkExperienceRoleOutput', id?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, start?: any | null | undefined, end?: any | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> }> | null | undefined, teammateCandidateLists?: Array<{ __typename?: 'OtherUserCandidate', claimedCandidate: boolean, user: { __typename?: 'User', id: string, name?: string | null | undefined }, list: { __typename?: 'CandidateList', id: string, name: string } }> | null | undefined, candidateLists?: Array<{ __typename?: 'CandidateList', id: string, vacancyId?: string | null | undefined, name: string }> | null | undefined, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType, name?: string | null | undefined, confidenceLevel?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined, deviceType?: PhoneDeviceType | null | undefined }> | null | undefined };

export type GetCandidateQueryVariables = Exact<{
  input: CandidateInput;
}>;


export type GetCandidateQuery = { __typename?: 'Query', getCandidate: { __typename?: 'CandidateOutput', id: string, phoneNumbers?: Array<string> | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined, avatarS3Bucket?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, avatarThumbOrigUrl?: string | null | undefined, githubURL?: string | null | undefined, liHeadline?: string | null | undefined, liSummary?: string | null | undefined, isStudent?: boolean | null | undefined, country?: string | null | undefined, birthday?: any | null | undefined, source?: CandidateSource | null | undefined, sourceVersion?: string | null | undefined, candidateRawId?: string | null | undefined, yearsOfExperience?: number | null | undefined, hasInterview?: boolean | null | undefined, atsId?: string | null | undefined, slugs?: Array<string> | null | undefined, notes?: Array<string> | null | undefined, certificates?: Array<string> | null | undefined, hasCV?: boolean | null | undefined, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType, name?: string | null | undefined, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined }> | null | undefined, websites?: Array<{ __typename?: 'CandidateWebsiteOutput', url: string, label?: string | null | undefined }> | null | undefined, linkOpens?: Array<{ __typename?: 'ShareableLinkOpen', name?: string | null | undefined, openedAt: any, location?: string | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined, deviceType?: PhoneDeviceType | null | undefined }> | null | undefined, notesFull?: Array<{ __typename?: 'CandidateNote', id: string, content: string, author: { __typename?: 'User', id: string, name?: string | null | undefined } }> | null | undefined, workExperience?: Array<{ __typename?: 'WorkExperienceOutput', id?: string | null | undefined, isTopCompany?: boolean | null | undefined, company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined, roles: Array<{ __typename?: 'WorkExperienceRoleOutput', id?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, start?: any | null | undefined, end?: any | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> }> | null | undefined, projects?: Array<{ __typename?: 'Project', id: string, title?: string | null | undefined, description?: string | null | undefined, timePeriodStartMonth?: number | null | undefined, timePeriodStartYear?: number | null | undefined, timePeriodEndMonth?: number | null | undefined, timePeriodEndYear?: number | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> | null | undefined, education?: Array<{ __typename?: 'CandidateSchoolExperience', id: string, name?: string | null | undefined, isTopSchool?: boolean | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, degree?: string | null | undefined }> | null | undefined, skills?: Array<{ __typename?: 'CandidateSkillExperience', skillName: string, yearsOfExperience?: number | null | undefined }> | null | undefined } };

export type CandidateSearchOutputFragment = { __typename?: 'CandidateSearch', id: string, name: string, freeTextSearch?: string | null | undefined, createdBy: { __typename?: 'CandidateSearchAuthor', id: string, name?: string | null | undefined }, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, skills?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, company?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, school?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined };

type SectionElementFragment_CandidateInterviewNote_Fragment = { __typename: 'CandidateInterviewNote' };

type SectionElementFragment_CandidatePercentageItem_Fragment = { __typename: 'CandidatePercentageItem', label: string, value: string };

type SectionElementFragment_CandidateScaleItem_Fragment = { __typename: 'CandidateScaleItem', label: string, min: string, max: string, value: string };

type SectionElementFragment_CandidateSelectItem_Fragment = { __typename: 'CandidateSelectItem', label: string, value: string };

type SectionElementFragment_CandidateStatsCheckList_Fragment = { __typename: 'CandidateStatsCheckList', title?: string | null | undefined, items?: Array<{ __typename?: 'CheckListItem', value: string, label: string }> | null | undefined };

type SectionElementFragment_CandidateStatsSlidersList_Fragment = { __typename: 'CandidateStatsSlidersList', text?: string | null | undefined, items?: Array<{ __typename?: 'PolarizationSlider', leftLabel: string, rightLabel: string, value: string } | { __typename?: 'ValueSlider', label: string, value: string }> | null | undefined };

type SectionElementFragment_CheckListItem_Fragment = { __typename: 'CheckListItem' };

type SectionElementFragment_KeywordsCollection_Fragment = { __typename: 'KeywordsCollection', title?: string | null | undefined, keywords?: Array<string> | null | undefined };

type SectionElementFragment_NumericalItem_Fragment = { __typename: 'NumericalItem' };

export type SectionElementFragmentFragment = SectionElementFragment_CandidateInterviewNote_Fragment | SectionElementFragment_CandidatePercentageItem_Fragment | SectionElementFragment_CandidateScaleItem_Fragment | SectionElementFragment_CandidateSelectItem_Fragment | SectionElementFragment_CandidateStatsCheckList_Fragment | SectionElementFragment_CandidateStatsSlidersList_Fragment | SectionElementFragment_CheckListItem_Fragment | SectionElementFragment_KeywordsCollection_Fragment | SectionElementFragment_NumericalItem_Fragment;

export type CandidateProfileFragment = { __typename?: 'CandidateProfileOutput', candidateId: string, header: { __typename?: 'CandidateProfileHeader', name: string, avatarS3Bucket?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, skillSummaries: Array<{ __typename?: 'CandidateMultiSelectItem', label: string, value: Array<string> }> }, leftColumn: Array<{ __typename?: 'CandidateSection', title: string, elements?: Array<{ __typename: 'CandidateInterviewNote' } | { __typename: 'CandidatePercentageItem', label: string, value: string } | { __typename: 'CandidateScaleItem', label: string, min: string, max: string, value: string } | { __typename: 'CandidateSelectItem', label: string, value: string } | { __typename: 'CandidateStatsCheckList', title?: string | null | undefined, items?: Array<{ __typename?: 'CheckListItem', value: string, label: string }> | null | undefined } | { __typename: 'CandidateStatsSlidersList', text?: string | null | undefined, items?: Array<{ __typename?: 'PolarizationSlider', leftLabel: string, rightLabel: string, value: string } | { __typename?: 'ValueSlider', label: string, value: string }> | null | undefined } | { __typename: 'CheckListItem' } | { __typename: 'KeywordsCollection', title?: string | null | undefined, keywords?: Array<string> | null | undefined } | { __typename: 'NumericalItem' }> | null | undefined }>, rightColumn: Array<{ __typename?: 'CandidateSection', title: string, elements?: Array<{ __typename: 'CandidateInterviewNote' } | { __typename: 'CandidatePercentageItem', label: string, value: string } | { __typename: 'CandidateScaleItem', label: string, min: string, max: string, value: string } | { __typename: 'CandidateSelectItem', label: string, value: string } | { __typename: 'CandidateStatsCheckList', title?: string | null | undefined, items?: Array<{ __typename?: 'CheckListItem', value: string, label: string }> | null | undefined } | { __typename: 'CandidateStatsSlidersList', text?: string | null | undefined, items?: Array<{ __typename?: 'PolarizationSlider', leftLabel: string, rightLabel: string, value: string } | { __typename?: 'ValueSlider', label: string, value: string }> | null | undefined } | { __typename: 'CheckListItem' } | { __typename: 'KeywordsCollection', title?: string | null | undefined, keywords?: Array<string> | null | undefined } | { __typename: 'NumericalItem' }> | null | undefined }>, education: Array<{ __typename?: 'CandidateSchoolExperience', id: string, name?: string | null | undefined, isTopSchool?: boolean | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, degree?: string | null | undefined }> };

export type GetCandidateProfileQueryVariables = Exact<{
  candidateInput: CandidateInput;
}>;


export type GetCandidateProfileQuery = { __typename?: 'Query', getCandidateProfile?: { __typename?: 'CandidateProfileOutput', candidateId: string, header: { __typename?: 'CandidateProfileHeader', name: string, avatarS3Bucket?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, skillSummaries: Array<{ __typename?: 'CandidateMultiSelectItem', label: string, value: Array<string> }> }, leftColumn: Array<{ __typename?: 'CandidateSection', title: string, elements?: Array<{ __typename: 'CandidateInterviewNote' } | { __typename: 'CandidatePercentageItem', label: string, value: string } | { __typename: 'CandidateScaleItem', label: string, min: string, max: string, value: string } | { __typename: 'CandidateSelectItem', label: string, value: string } | { __typename: 'CandidateStatsCheckList', title?: string | null | undefined, items?: Array<{ __typename?: 'CheckListItem', value: string, label: string }> | null | undefined } | { __typename: 'CandidateStatsSlidersList', text?: string | null | undefined, items?: Array<{ __typename?: 'PolarizationSlider', leftLabel: string, rightLabel: string, value: string } | { __typename?: 'ValueSlider', label: string, value: string }> | null | undefined } | { __typename: 'CheckListItem' } | { __typename: 'KeywordsCollection', title?: string | null | undefined, keywords?: Array<string> | null | undefined } | { __typename: 'NumericalItem' }> | null | undefined }>, rightColumn: Array<{ __typename?: 'CandidateSection', title: string, elements?: Array<{ __typename: 'CandidateInterviewNote' } | { __typename: 'CandidatePercentageItem', label: string, value: string } | { __typename: 'CandidateScaleItem', label: string, min: string, max: string, value: string } | { __typename: 'CandidateSelectItem', label: string, value: string } | { __typename: 'CandidateStatsCheckList', title?: string | null | undefined, items?: Array<{ __typename?: 'CheckListItem', value: string, label: string }> | null | undefined } | { __typename: 'CandidateStatsSlidersList', text?: string | null | undefined, items?: Array<{ __typename?: 'PolarizationSlider', leftLabel: string, rightLabel: string, value: string } | { __typename?: 'ValueSlider', label: string, value: string }> | null | undefined } | { __typename: 'CheckListItem' } | { __typename: 'KeywordsCollection', title?: string | null | undefined, keywords?: Array<string> | null | undefined } | { __typename: 'NumericalItem' }> | null | undefined }>, education: Array<{ __typename?: 'CandidateSchoolExperience', id: string, name?: string | null | undefined, isTopSchool?: boolean | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, degree?: string | null | undefined }> } | null | undefined };

export type ContactInfoFragment = { __typename?: 'CandidateOutput', id: string, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', name?: string | null | undefined, emailAddress: string, type: EmailType, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined }> | null | undefined };

export type OnAddEmailsToCandidateSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OnAddEmailsToCandidateSubscriptionSubscription = { __typename?: 'Subscription', onAddEmailsToCandidate: { __typename?: 'CandidateOutput', id: string, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', name?: string | null | undefined, emailAddress: string, type: EmailType, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined }> | null | undefined } };

export type OnContactInfoAddedToCandidateSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OnContactInfoAddedToCandidateSubscription = { __typename?: 'Subscription', onContactInfoAddedToCandidate: { __typename?: 'CandidateOutput', id: string, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', name?: string | null | undefined, emailAddress: string, type: EmailType, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined }> | null | undefined } };

export type AddContactInfoToCandidateMutationVariables = Exact<{
  input: AddContactInfoToCandidateInput;
}>;


export type AddContactInfoToCandidateMutation = { __typename?: 'Mutation', addContactInfoToCandidate: { __typename?: 'CandidateOutput', id: string, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', name?: string | null | undefined, emailAddress: string, type: EmailType, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined }> | null | undefined } };

export type UpdateCandidateMutationMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  data: CandidateData;
}>;


export type UpdateCandidateMutationMutation = { __typename?: 'Mutation', updateCandidate?: { __typename?: 'CandidateOutput', id: string, notes?: Array<string> | null | undefined } | null | undefined };

export type ListCandidateEmailsQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type ListCandidateEmailsQuery = { __typename?: 'Query', listCandidateEmails: { __typename?: 'ListCandidateEmailsResponse', emails: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType, name?: string | null | undefined, confidenceLevel?: number | null | undefined, preferenceWeight?: number | null | undefined }> } };

export type DeleteSlugCandidateMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type DeleteSlugCandidateMutation = { __typename?: 'Mutation', removeCandidateSlug: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type AddCandidateSlugMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type AddCandidateSlugMutation = { __typename?: 'Mutation', addSlugToCandidate: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type CreateCandidateApplicationMutationVariables = Exact<{
  input: Array<CreateCandidateApplication>;
}>;


export type CreateCandidateApplicationMutation = { __typename?: 'Mutation', createCandidateApplications: Array<{ __typename?: 'ApplicationCreated', id: string }> };

export type AddCandidateMutationVariables = Exact<{
  source: Scalars['String']['input'];
  sourceVersion: Scalars['String']['input'];
  rawCandidateData: Scalars['String']['input'];
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCandidateMutation = { __typename?: 'Mutation', addCandidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined, candidateRawId?: string | null | undefined, githubURL?: string | null | undefined, yearsOfExperience?: number | null | undefined, atsId?: string | null | undefined, workExperience?: Array<{ __typename?: 'WorkExperienceOutput', id?: string | null | undefined, isTopCompany?: boolean | null | undefined, company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined, roles: Array<{ __typename?: 'WorkExperienceRoleOutput', id?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, start?: any | null | undefined, end?: any | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> }> | null | undefined, teammateCandidateLists?: Array<{ __typename?: 'OtherUserCandidate', claimedCandidate: boolean, user: { __typename?: 'User', id: string, name?: string | null | undefined }, list: { __typename?: 'CandidateList', id: string, name: string } }> | null | undefined, candidateLists?: Array<{ __typename?: 'CandidateList', id: string, vacancyId?: string | null | undefined, name: string }> | null | undefined, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType, name?: string | null | undefined, confidenceLevel?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined, deviceType?: PhoneDeviceType | null | undefined }> | null | undefined } | null | undefined };

export type CreateCandidateFromExtensionMutationVariables = Exact<{
  source: Scalars['String']['input'];
  sourceVersion: Scalars['String']['input'];
  rawCandidateData: Scalars['String']['input'];
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCandidateFromExtensionMutation = { __typename?: 'Mutation', addCandidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined, candidateRawId?: string | null | undefined, githubURL?: string | null | undefined, yearsOfExperience?: number | null | undefined, atsId?: string | null | undefined, workExperience?: Array<{ __typename?: 'WorkExperienceOutput', id?: string | null | undefined, isTopCompany?: boolean | null | undefined, company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined, roles: Array<{ __typename?: 'WorkExperienceRoleOutput', id?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, start?: any | null | undefined, end?: any | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> }> | null | undefined, teammateCandidateLists?: Array<{ __typename?: 'OtherUserCandidate', claimedCandidate: boolean, user: { __typename?: 'User', id: string, name?: string | null | undefined }, list: { __typename?: 'CandidateList', id: string, name: string } }> | null | undefined, candidateLists?: Array<{ __typename?: 'CandidateList', id: string, vacancyId?: string | null | undefined, name: string }> | null | undefined, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType, name?: string | null | undefined, confidenceLevel?: number | null | undefined }> | null | undefined, phoneNumbersFull?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined, deviceType?: PhoneDeviceType | null | undefined }> | null | undefined } | null | undefined };

export type GetCandidateExperienceQueryVariables = Exact<{
  input: GetCandidateExperienceInput;
}>;


export type GetCandidateExperienceQuery = { __typename?: 'Query', getCandidateExperience?: { __typename?: 'CandidateCompanyExperienceOutput', skillsExperience?: Array<{ __typename?: 'CandidateSkillExperience', skillName: string, yearsOfExperience?: number | null | undefined, isFulfilled?: boolean | null | undefined }> | null | undefined } | null | undefined };

export type GetCvDownloadLinkQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type GetCvDownloadLinkQuery = { __typename?: 'Query', getCvDownloadLink: { __typename?: 'PresignedUrl', url: string } };

export type AddCandidateNoteMutationVariables = Exact<{
  input: AddCandidateNoteInput;
}>;


export type AddCandidateNoteMutation = { __typename?: 'Mutation', addCandidateNote: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type CreateShareableLinkMutationVariables = Exact<{
  input: CreateShareableLink;
}>;


export type CreateShareableLinkMutation = { __typename?: 'Mutation', createShareableLink: { __typename?: 'ShareableLinkCreated', id: string, url: string } };

export type CopyShareableLinkMutationVariables = Exact<{
  input: CopyShareableLinkInput;
}>;


export type CopyShareableLinkMutation = { __typename?: 'Mutation', copyShareableLink: { __typename?: 'ShareableLinkCreated', id: string, url: string } };

export type ReIngestCandidateMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type ReIngestCandidateMutation = { __typename?: 'Mutation', reIngestCandidate: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type EditProfileChunkMutationVariables = Exact<{
  input: EditProfileChunk;
}>;


export type EditProfileChunkMutation = { __typename?: 'Mutation', editProfileChunk?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type UpdateShareableLinkMutationVariables = Exact<{
  input: UpdateShareableLinkInput;
}>;


export type UpdateShareableLinkMutation = { __typename?: 'Mutation', updateShareableLink: { __typename?: 'ShareableLinkCreated', id: string } };

export type SearchCandidatesQueryVariables = Exact<{
  input: SearchCandidatesInput;
}>;


export type SearchCandidatesQuery = { __typename?: 'Query', searchCandidates: { __typename?: 'SearchCandidatesOutput', total: number, items: Array<{ __typename?: 'CandidateOutput', id: string, createdAt?: any | null | undefined, lastOpenedAt?: any | null | undefined, fullName?: string | null | undefined, liHeadline?: string | null | undefined, linkedInUrl?: string | null | undefined, githubURL?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, skills?: Array<{ __typename?: 'CandidateSkillExperience', skillName: string, yearsOfExperience?: number | null | undefined }> | null | undefined }> } };

export type ListCandidateCompaniesQueryVariables = Exact<{
  input: SearchInput;
}>;


export type ListCandidateCompaniesQuery = { __typename?: 'Query', listCandidateCompanies: { __typename?: 'ListCandidateCompaniesOutput', companies: Array<{ __typename?: 'CompanyOutput', id: string, name: string }> } };

export type ListCandidateLocationsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type ListCandidateLocationsQuery = { __typename?: 'Query', listCandidateLocations: { __typename?: 'ListCandidateLocationsOutput', locations: Array<{ __typename?: 'LocationOutput', id: string, name: string }> } };

export type ListCandidateJobTitlesQueryVariables = Exact<{
  input: SearchInput;
}>;


export type ListCandidateJobTitlesQuery = { __typename?: 'Query', listCandidateJobTitles: { __typename?: 'ListCandidateJobTitlesOutput', jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: string }> } };

export type ListCandidateSchoolsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type ListCandidateSchoolsQuery = { __typename?: 'Query', listCandidateSchools: { __typename?: 'ListCandidateSchoolsOutput', schools: Array<{ __typename?: 'SchoolOutput', id: string, name: string }> } };

export type RecordUserInviteMutationVariables = Exact<{
  input: RecordUserInvite;
}>;


export type RecordUserInviteMutation = { __typename?: 'Mutation', recordUserInvite: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type SaveCandidateSearchMutationVariables = Exact<{
  input: SaveCandidateSearch;
}>;


export type SaveCandidateSearchMutation = { __typename?: 'Mutation', saveCandidateSearch: { __typename?: 'CandidateSearch', id: string, name: string, freeTextSearch?: string | null | undefined, createdBy: { __typename?: 'CandidateSearchAuthor', id: string, name?: string | null | undefined }, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, skills?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, company?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, school?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined } };

export type CandidateSearchQueryVariables = Exact<{
  input: SearchInput;
}>;


export type CandidateSearchQuery = { __typename?: 'Query', candidateSearch: { __typename?: 'CandidateSearchResult', total: number, items: Array<{ __typename?: 'CandidateSearch', id: string, name: string, freeTextSearch?: string | null | undefined, createdBy: { __typename?: 'CandidateSearchAuthor', id: string, name?: string | null | undefined }, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, skills?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, company?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, school?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined }> } };

export type UpdateCandidateSearchMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: SaveCandidateSearch;
}>;


export type UpdateCandidateSearchMutation = { __typename?: 'Mutation', updateCandidateSearch: { __typename?: 'CandidateSearch', id: string, name: string, freeTextSearch?: string | null | undefined, createdBy: { __typename?: 'CandidateSearchAuthor', id: string, name?: string | null | undefined }, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, skills?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, company?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, school?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined } };

export type DeleteCandidateSearchMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCandidateSearchMutation = { __typename?: 'Mutation', deleteCandidateSearch: { __typename?: 'ResourceDeleted', id: string } };

export type CandidateContactHistoryQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
  pagination: OffsetPagination;
}>;


export type CandidateContactHistoryQuery = { __typename?: 'Query', candidateContactHistory: { __typename?: 'CandidateContactHistory', total: number, items: Array<{ __typename?: 'CandidateContactRecord', resourceId: string, type: CandidateContactRecordType, placedAt: any, user: { __typename?: 'User', id: string, name?: string | null | undefined }, emailDetails?: { __typename?: 'EmailContactRecordDetails', subject: string, content: string } | null | undefined, smsDetails?: { __typename?: 'SMSContactRecordDetails', content: string } | null | undefined, callDetails?: { __typename?: 'CallContactRecordDetails', callDuration: number } | null | undefined }> } };

export type GetShadowProfileQueryVariables = Exact<{
  shareableLinkId: Scalars['String']['input'];
}>;


export type GetShadowProfileQuery = { __typename?: 'Query', getShadowProfile: { __typename?: 'ShadowProfile', title?: string | null | undefined, isObfuscated?: boolean | null | undefined, ctaTitle?: string | null | undefined, ctaUrl?: string | null | undefined, feedbackChatId?: string | null | undefined, logo?: { __typename?: 'ShadowProfileLogo', s3Bucket: string, s3Key: string } | null | undefined, profile: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarS3Bucket?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, avatarThumbOrigUrl?: string | null | undefined, liHeadline?: string | null | undefined, liSummary?: string | null | undefined, isStudent?: boolean | null | undefined, country?: string | null | undefined, yearsOfExperience?: number | null | undefined, certificates?: Array<string> | null | undefined, websites?: Array<{ __typename?: 'CandidateWebsiteOutput', url: string, label?: string | null | undefined }> | null | undefined, workExperience?: Array<{ __typename?: 'WorkExperienceOutput', id?: string | null | undefined, isTopCompany?: boolean | null | undefined, company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined, roles: Array<{ __typename?: 'WorkExperienceRoleOutput', id?: string | null | undefined, title?: string | null | undefined, description?: string | null | undefined, start?: any | null | undefined, end?: any | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> }> | null | undefined, projects?: Array<{ __typename?: 'Project', id: string, title?: string | null | undefined, description?: string | null | undefined, timePeriodStartMonth?: number | null | undefined, timePeriodStartYear?: number | null | undefined, timePeriodEndMonth?: number | null | undefined, timePeriodEndYear?: number | null | undefined, skills?: Array<{ __typename?: 'Skill', id: string, name: string }> | null | undefined }> | null | undefined, education?: Array<{ __typename?: 'CandidateSchoolExperience', id: string, name?: string | null | undefined, isTopSchool?: boolean | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, degree?: string | null | undefined }> | null | undefined, skills?: Array<{ __typename?: 'CandidateSkillExperience', skillName: string, yearsOfExperience?: number | null | undefined }> | null | undefined } } };

export type CreateCandidateFeedbackChatMutationVariables = Exact<{
  shareableLinkId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type CreateCandidateFeedbackChatMutation = { __typename?: 'Mutation', createCandidateFeedbackChat: { __typename?: 'CandidateFeedbackChatCreated', id: string, aiReplyTaskId: string } };

export type OnCandidateUpdatedSubscriptionVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type OnCandidateUpdatedSubscription = { __typename?: 'Subscription', onCandidateUpdated: { __typename?: 'CandidateUpdated', candidateId: string, mergedToCandidateId?: string | null | undefined } };

export type CandidateUpdatedMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  mergedToCandidateId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CandidateUpdatedMutation = { __typename?: 'Mutation', candidateUpdated: { __typename?: 'CandidateUpdated', candidateId: string, mergedToCandidateId?: string | null | undefined } };

export type CreateCandidateApplicationsMutationVariables = Exact<{
  input: Array<CreateCandidateApplication>;
}>;


export type CreateCandidateApplicationsMutation = { __typename?: 'Mutation', createCandidateApplications: Array<{ __typename?: 'ApplicationCreated', id: string }> };

export type CandidateInterviewFragmentFragment = { __typename?: 'CandidateInterview', id: string, type: InterviewType, candidateId: string, CandidateInterviewFormSections?: Array<{ __typename?: 'CandidateInterviewFormSectionsOutput', id: string, formSectionId: string, candidateInterviewId: string, FormSection?: { __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, staticSectionType?: StaticSectionType | null | undefined, FormQuestions: Array<{ __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> }> } | null | undefined }> | null | undefined };

export type InterviewCandidateProfileQueryQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type InterviewCandidateProfileQueryQuery = { __typename?: 'Query', listCandidateInterviews: { __typename?: 'Interviews', SOFT_SKILLS?: { __typename?: 'CandidateInterview', id: string, type: InterviewType, candidateId: string, CandidateInterviewFormSections?: Array<{ __typename?: 'CandidateInterviewFormSectionsOutput', id: string, formSectionId: string, candidateInterviewId: string, FormSection?: { __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, staticSectionType?: StaticSectionType | null | undefined, FormQuestions: Array<{ __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> }> } | null | undefined }> | null | undefined } | null | undefined, TECHNICAL?: { __typename?: 'CandidateInterview', id: string, type: InterviewType, candidateId: string, CandidateInterviewFormSections?: Array<{ __typename?: 'CandidateInterviewFormSectionsOutput', id: string, formSectionId: string, candidateInterviewId: string, FormSection?: { __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, staticSectionType?: StaticSectionType | null | undefined, FormQuestions: Array<{ __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> }> } | null | undefined }> | null | undefined } | null | undefined }, getCandidate: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, linkedInUrl?: string | null | undefined, phoneNumbers?: Array<string> | null | undefined, slugs?: Array<string> | null | undefined, birthday?: any | null | undefined, githubURL?: string | null | undefined, emailAddresses?: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType }> | null | undefined, websites?: Array<{ __typename?: 'CandidateWebsiteOutput', url: string, label?: string | null | undefined }> | null | undefined } };

export type UpdateCandidateInterviewSectionsMutationVariables = Exact<{
  data: CandidateInterviewSectionsInput;
}>;


export type UpdateCandidateInterviewSectionsMutation = { __typename?: 'Mutation', updateCandidateInterviewSections: { __typename?: 'CandidateInterview', id: string, type: InterviewType, candidateId: string, CandidateInterviewFormSections?: Array<{ __typename?: 'CandidateInterviewFormSectionsOutput', id: string, formSectionId: string, candidateInterviewId: string, FormSection?: { __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, staticSectionType?: StaticSectionType | null | undefined, FormQuestions: Array<{ __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> }> } | null | undefined }> | null | undefined } };

export type FormQuestionFragmentFragment = { __typename?: 'FormQuestionDirectOutput', id: string, label: string, hint?: string | null | undefined, questionType: QuestionType, questionOptions: Array<string>, isHidden: boolean, visibilityType: QuestionVisibilityType, order: number, FormSection?: { __typename?: 'FormSectionDirectOutput', id: string, name: string, order: number, staticSectionType?: StaticSectionType | null | undefined } | null | undefined };

export type AddCandidateFormResponseMutationVariables = Exact<{
  data: Array<CandidateFormResponseInput>;
  sections: Array<Scalars['String']['input']>;
  type: InterviewType;
}>;


export type AddCandidateFormResponseMutation = { __typename?: 'Mutation', addCandidateFormResponse: Array<{ __typename?: 'CandidateFormResponseOutput', id: string, responseValue?: string | null | undefined, FormQuestion: { __typename?: 'FormQuestionDirectOutput', id: string, label: string, hint?: string | null | undefined, questionType: QuestionType, questionOptions: Array<string>, isHidden: boolean, visibilityType: QuestionVisibilityType, order: number, FormSection?: { __typename?: 'FormSectionDirectOutput', id: string, name: string, order: number, staticSectionType?: StaticSectionType | null | undefined } | null | undefined }, Candidate: { __typename?: 'FormCandidateDirectOutput', id: string }, User: { __typename?: 'FormUserDirectOutput', id: string } }> };

export type GetCandidateListExportQueryVariables = Exact<{
  listId: Scalars['String']['input'];
}>;


export type GetCandidateListExportQuery = { __typename?: 'Query', getCandidateListExport: { __typename?: 'CandidateListExport', csvUrl: string } };

export type ListTopMatchesQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
  take: Scalars['Int']['input'];
}>;


export type ListTopMatchesQuery = { __typename?: 'Query', listTopCandidateVacancyMatches: Array<{ __typename?: 'CandidateVacancyMatch', candidateId: string, vacancy: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined }, match?: { __typename?: 'CandidateVacancyMatchMatch', match?: number | null | undefined } | null | undefined }> };

export type GetCandidateVacancyMatchWithExperienceQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
}>;


export type GetCandidateVacancyMatchWithExperienceQuery = { __typename?: 'Query', getCandidateVacancyMatch: { __typename?: 'GetCandidateVacancyMatchOutput', vacancy: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined }, match?: { __typename?: 'VacancyCandidateMatchOutput', match: number, adjustedMatch?: number | null | undefined, mustHaveMatch?: { __typename?: 'VacancyCandidateSkillMatchOutput', skills: Array<{ __typename?: 'VacancyCandidateSkillMatchItem', match: number, name: string, matchType?: string | null | undefined }> } | null | undefined, niceToHaveMatch?: { __typename?: 'VacancyCandidateSkillMatchOutput', skills: Array<{ __typename?: 'VacancyCandidateSkillMatchItem', match: number, matchType?: string | null | undefined, name: string }> } | null | undefined } | null | undefined }, getCandidateExperience?: { __typename?: 'CandidateCompanyExperienceOutput', skillsExperience?: Array<{ __typename?: 'CandidateSkillExperience', skillName: string, yearsOfExperience?: number | null | undefined, isFulfilled?: boolean | null | undefined }> | null | undefined } | null | undefined };

export type GetCandidateVacancyMatchQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
  candidateRawId?: InputMaybe<Scalars['String']['input']>;
  markAsViewed?: InputMaybe<Scalars['Boolean']['input']>;
  algorithm?: InputMaybe<CandidateMatchAlgorithm>;
}>;


export type GetCandidateVacancyMatchQuery = { __typename?: 'Query', getCandidateVacancyMatch: { __typename?: 'GetCandidateVacancyMatchOutput', vacancy: { __typename?: 'VacancyOutput', id: string, name: string }, match?: { __typename?: 'VacancyCandidateMatchOutput', match: number, explanation?: string | null | undefined, adjustedMatch?: number | null | undefined, mustHaveMatch?: { __typename?: 'VacancyCandidateSkillMatchOutput', skills: Array<{ __typename?: 'VacancyCandidateSkillMatchItem', match: number, name: string, matchType?: string | null | undefined }> } | null | undefined, niceToHaveMatch?: { __typename?: 'VacancyCandidateSkillMatchOutput', skills: Array<{ __typename?: 'VacancyCandidateSkillMatchItem', match: number, matchType?: string | null | undefined, name: string }> } | null | undefined } | null | undefined } };

export type NewCandidateMatchSubscriptionVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type NewCandidateMatchSubscription = { __typename?: 'Subscription', newCandidateMatch: { __typename?: 'NewCandidateMatch', id: string, candidateId: string, vacancyId: string, clientId?: string | null | undefined, match?: number | null | undefined, adjustedMatch?: number | null | undefined } };

export type NewVacancyMatchSubscriptionVariables = Exact<{
  vacancyId: Scalars['String']['input'];
}>;


export type NewVacancyMatchSubscription = { __typename?: 'Subscription', newVacancyMatch: { __typename?: 'NewCandidateMatch', id: string, candidateId: string, vacancyId: string, clientId?: string | null | undefined, match?: number | null | undefined, adjustedMatch?: number | null | undefined } };

export type SearchCertificatesQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchCertificatesQuery = { __typename?: 'Query', searchCertificates: { __typename?: 'CertificateSearchResponse', total: number, page: number, items: Array<{ __typename?: 'Certificate', name: string, id: string }> } };

export type ChatMessageFieldsFragment = { __typename?: 'ChatRow', id?: string | null | undefined, index?: number | null | undefined, role: ChatRole, content: string, rating: number, extraDataJSON?: string | null | undefined, vacancyId?: string | null | undefined };

export type MessageVoteMutationVariables = Exact<{
  input: MessageVoteInput;
}>;


export type MessageVoteMutation = { __typename?: 'Mutation', voteOnMessage: { __typename?: 'ChatRow', id?: string | null | undefined, index?: number | null | undefined, role: ChatRole, content: string, rating: number, extraDataJSON?: string | null | undefined, vacancyId?: string | null | undefined } };

export type SendAiChatMessageMutationVariables = Exact<{
  input: SendChatMessageInput;
}>;


export type SendAiChatMessageMutation = { __typename?: 'Mutation', sendChatMessage: { __typename?: 'AiChatMessageQueued', chatId: string, taskId: string } };

export type GetChatQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
}>;


export type GetChatQuery = { __typename?: 'Query', getChat: { __typename?: 'AiChat', chatId: string, rows: Array<{ __typename?: 'ChatRow', id?: string | null | undefined, index?: number | null | undefined, role: ChatRole, content: string, rating: number, extraDataJSON?: string | null | undefined, vacancyId?: string | null | undefined }>, vacancy?: { __typename?: 'VacancyOutput', id: string, createdAt: any, name: string, description?: string | null | undefined, status: VacancyStatus, vertical?: Vertical | null | undefined, atsLink?: string | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string } | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } | null | undefined } };

export type AiPromptFragment = { __typename?: 'AiPrompt', id: string, prompt: string, name: string, canDelete?: boolean | null | undefined };

export type ListAiPromptsQueryVariables = Exact<{
  input: ListAiPromptsInput;
}>;


export type ListAiPromptsQuery = { __typename?: 'Query', listAiPrompts?: { __typename?: 'ListAiPromptsOutput', total: number, items: Array<{ __typename?: 'AiPrompt', id: string, prompt: string, name: string, canDelete?: boolean | null | undefined }> } | null | undefined };

export type AddAiPromptMutationVariables = Exact<{
  input: AiPromptInput;
}>;


export type AddAiPromptMutation = { __typename?: 'Mutation', addAiPrompt: { __typename?: 'AiPrompt', id: string, prompt: string, name: string, canDelete?: boolean | null | undefined } };

export type DeleteAiPromptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAiPromptMutation = { __typename?: 'Mutation', deleteAiPrompt: { __typename?: 'ResourceDeleted', id: string } };

export type TouchAiPromptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TouchAiPromptMutation = { __typename?: 'Mutation', touchAiPrompt: { __typename?: 'AiPrompt', id: string, prompt: string, name: string, canDelete?: boolean | null | undefined } };

export type ChatHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatHealthQuery = { __typename?: 'Query', chatHealth: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type InitiateVacancyClientTokenCheckoutMutationVariables = Exact<{
  input: VacancyClientTokenCheckout;
}>;


export type InitiateVacancyClientTokenCheckoutMutation = { __typename?: 'Mutation', initiateVacancyClientTokenCheckout: { __typename?: 'ClientSideBillingSession', sessionId: string, clientSecret: string } };

export type AddCandidateToClientTokenMutationVariables = Exact<{
  input: AddCandidateToClientTokenInput;
}>;


export type AddCandidateToClientTokenMutation = { __typename?: 'Mutation', addCandidateToClientToken: { __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> } };

type LookUpContactInfoAsyncFragment_LookUpEmailResponseAsync_Fragment = { __typename: 'LookUpEmailResponseAsync', candidateId?: string | null | undefined, unsubscribed?: boolean | null | undefined, taskId?: string | null | undefined, emails?: Array<{ __typename?: 'CandidateEmailOutput', name?: string | null | undefined, emailAddress: string, type: EmailType, confidenceLevel?: number | null | undefined }> | null | undefined, phones?: Array<{ __typename?: 'CandidatePhoneNumber', number: string }> | null | undefined, phoneNumbers?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined, deviceType?: PhoneDeviceType | null | undefined }> | null | undefined };

type LookUpContactInfoAsyncFragment_PaymentRequiredError_Fragment = { __typename: 'PaymentRequiredError', message?: string | null | undefined, feature: string, limit?: number | null | undefined, used?: number | null | undefined };

export type LookUpContactInfoAsyncFragmentFragment = LookUpContactInfoAsyncFragment_LookUpEmailResponseAsync_Fragment | LookUpContactInfoAsyncFragment_PaymentRequiredError_Fragment;

export type LookUpEmailAsyncV2MutationVariables = Exact<{
  input: LookUpEmailInput;
}>;


export type LookUpEmailAsyncV2Mutation = { __typename?: 'Mutation', lookUpContactInfoAsyncV2: { __typename: 'LookUpEmailResponseAsync', candidateId?: string | null | undefined, unsubscribed?: boolean | null | undefined, taskId?: string | null | undefined, emails?: Array<{ __typename?: 'CandidateEmailOutput', name?: string | null | undefined, emailAddress: string, type: EmailType, confidenceLevel?: number | null | undefined }> | null | undefined, phones?: Array<{ __typename?: 'CandidatePhoneNumber', number: string }> | null | undefined, phoneNumbers?: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined, deviceType?: PhoneDeviceType | null | undefined }> | null | undefined } | { __typename: 'PaymentRequiredError', message?: string | null | undefined, feature: string, limit?: number | null | undefined, used?: number | null | undefined } };

export type GetVoiceTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetVoiceTokenMutation = { __typename?: 'Mutation', getVoiceToken: { __typename?: 'TwilioToken', token: string } };

export type CallDetailFragment = { __typename?: 'Call', id: string, twilioCallSid: string, from: string, to: string, status: string, ringbackNumber?: string | null | undefined, direction: CallDirection, candidateId?: string | null | undefined, createdAt: any, duration?: number | null | undefined, userMessage?: string | null | undefined };

export type DialMutationVariables = Exact<{
  input: Dial;
}>;


export type DialMutation = { __typename?: 'Mutation', dial: { __typename?: 'Call', id: string, twilioCallSid: string, from: string, to: string, status: string, ringbackNumber?: string | null | undefined, direction: CallDirection, candidateId?: string | null | undefined, createdAt: any, duration?: number | null | undefined, userMessage?: string | null | undefined } };

export type RequestUploadPreRecordedMessageMutationVariables = Exact<{
  input: RequestUploadPreRecordedMessageInput;
}>;


export type RequestUploadPreRecordedMessageMutation = { __typename?: 'Mutation', requestUploadPreRecordedMessage: { __typename?: 'PresignedUrl', url: string, key?: string | null | undefined } };

export type PlayMessageOnCallMutationVariables = Exact<{
  input: PlayMessageOnCallInput;
}>;


export type PlayMessageOnCallMutation = { __typename?: 'Mutation', playMessageOnCall: { __typename?: 'Call', id: string } };

export type UpdateCallMutationVariables = Exact<{
  input: UpdateCallInput;
}>;


export type UpdateCallMutation = { __typename?: 'Mutation', updateCall: { __typename?: 'Call', id: string, userMessage?: string | null | undefined } };

export type PrecordedMessageDetailFragment = { __typename?: 'PreRecordedMessage', id: string, title: string, description?: string | null | undefined, transcript?: string | null | undefined, duration?: number | null | undefined, createdAt: any, asset?: { __typename?: 'Asset', size: number, s3Key: string, contentType: string } | null | undefined };

export type ListPreRecordedMessagesQueryVariables = Exact<{
  input: ListPreRecordedMessagesInput;
}>;


export type ListPreRecordedMessagesQuery = { __typename?: 'Query', listPreRecordedMessages: { __typename?: 'PreRecordedMessages', total: number, items: Array<{ __typename?: 'PreRecordedMessage', id: string, title: string, description?: string | null | undefined, transcript?: string | null | undefined, duration?: number | null | undefined, createdAt: any, asset?: { __typename?: 'Asset', size: number, s3Key: string, contentType: string } | null | undefined }> } };

export type GetPreRecordedMessageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPreRecordedMessageQuery = { __typename?: 'Query', getPreRecordedMessage: { __typename?: 'PreRecordedMessageWithUrl', url: string, message: { __typename?: 'PreRecordedMessage', id: string, title: string, description?: string | null | undefined, transcript?: string | null | undefined, duration?: number | null | undefined, createdAt: any, asset?: { __typename?: 'Asset', size: number, s3Key: string, contentType: string } | null | undefined } } };

export type ListCallsQueryVariables = Exact<{
  input: ListCallsInput;
}>;


export type ListCallsQuery = { __typename?: 'Query', listCalls: { __typename?: 'ListCallsOutput', total: number, items: Array<{ __typename?: 'Call', id: string, twilioCallSid: string, from: string, to: string, status: string, ringbackNumber?: string | null | undefined, direction: CallDirection, candidateId?: string | null | undefined, createdAt: any, duration?: number | null | undefined, userMessage?: string | null | undefined }> } };

export type OnCallUpdatedSubscriptionVariables = Exact<{
  twilioCallSid: Scalars['String']['input'];
}>;


export type OnCallUpdatedSubscription = { __typename?: 'Subscription', onCallUpdated: { __typename?: 'Call', id: string, twilioCallSid: string, userMessage?: string | null | undefined, dialAction?: DialAction | null | undefined, status: string } };

export type RequestUploadCandidateResumeMutationVariables = Exact<{
  vacancyId?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type RequestUploadCandidateResumeMutation = { __typename?: 'Mutation', requestUploadCandidateResume: { __typename?: 'PresignedUrl', url: string, candidateId?: string | null | undefined } };

export type DomainCategoryFragment = { __typename?: 'DomainCategory', id: string, name: string, color?: string | null | undefined, domains: Array<string> };

export type DomainCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainCategoriesQuery = { __typename?: 'Query', domainCategories: { __typename?: 'DomainCategories', items: Array<{ __typename?: 'DomainCategory', id: string, name: string, color?: string | null | undefined, domains: Array<string> }> } };

export type CreateDomainCategoryMutationVariables = Exact<{
  input: AddDomainCategoryInput;
}>;


export type CreateDomainCategoryMutation = { __typename?: 'Mutation', addDomainCategory: { __typename?: 'DomainCategory', id: string, name: string, color?: string | null | undefined, domains: Array<string> } };

export type UpdateDomainCategoryMutationVariables = Exact<{
  input: UpdateDomainCategoryInput;
}>;


export type UpdateDomainCategoryMutation = { __typename?: 'Mutation', updateDomainCategory: { __typename?: 'DomainCategory', id: string, name: string, color?: string | null | undefined, domains: Array<string> } };

export type DeleteDomainCategoryMutationVariables = Exact<{
  input: DeleteDomainCategoryInput;
}>;


export type DeleteDomainCategoryMutation = { __typename?: 'Mutation', deleteDomainCategory: { __typename?: 'DomainCategory', id: string, name: string, color?: string | null | undefined, domains: Array<string> } };

export type ListInAppMessagesQueryVariables = Exact<{
  input: GetAllMessages;
}>;


export type ListInAppMessagesQuery = { __typename?: 'Query', getAllMessages: { __typename?: 'GetAllMessagesResponse', total: number, messages: Array<{ __typename?: 'InAppMessage', id: string, audienceTypesPositive: Array<InAppMessageAudienceType>, audienceTypesNegative: Array<InAppMessageAudienceType>, bodyHtml: string, sizeCreated?: number | null | undefined, sizeRead?: number | null | undefined }> } };

export type GetAudienceSizeQueryVariables = Exact<{
  input: GetAudienceSizeInput;
}>;


export type GetAudienceSizeQuery = { __typename?: 'Query', getAudienceSize: { __typename?: 'AudienceSize', size: number } };

export type CreateInAppMessageMutationVariables = Exact<{
  input: CreateInAppMessageInput;
}>;


export type CreateInAppMessageMutation = { __typename?: 'Mutation', createInAppMessage: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type RecordInAppMessageInteractionMutationVariables = Exact<{
  input: RecordInteraction;
}>;


export type RecordInAppMessageInteractionMutation = { __typename?: 'Mutation', recordInteraction: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type UpdateInAppMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateInAppMessageInput;
}>;


export type UpdateInAppMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type GetAllInAppMessagesForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInAppMessagesForUserQuery = { __typename?: 'Query', getMessagesForUser: { __typename?: 'GetAllMessagesResponse', total: number, messages: Array<{ __typename?: 'InAppMessage', id: string, bodyHtml: string }> } };

export type InterviewProfilerListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewProfilerListingsQuery = { __typename?: 'Query', listFormSections: Array<{ __typename?: 'FormSectionDirectOutput', id: string, name: string, order: number, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined }>, listFormTemplates: Array<{ __typename?: 'FormTemplateDirectOutput', id: string, name: string, tags: Array<string>, FormSections: Array<{ __typename?: 'FormSectionDirectOutput', id: string, name: string, order: number, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined }> }> };

export type GetFormQuestionQueryVariables = Exact<{
  questionId: Scalars['String']['input'];
}>;


export type GetFormQuestionQuery = { __typename?: 'Query', getFormQuestion: { __typename?: 'FormQuestionOutput', id: string, label: string, hint?: string | null | undefined, questionType: QuestionType, questionOptions: Array<string>, isHidden: boolean, visibilityType: QuestionVisibilityType, order: number } };

export type AddFormQuestionMutationVariables = Exact<{
  label: Scalars['String']['input'];
  hint?: InputMaybe<Scalars['String']['input']>;
  questionType: QuestionType;
  questionOptions: Array<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  visibilityType?: InputMaybe<QuestionVisibilityType>;
  formSectionId?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
}>;


export type AddFormQuestionMutation = { __typename?: 'Mutation', addFormQuestion: { __typename?: 'FormQuestionDirectOutput', id: string, label: string, hint?: string | null | undefined, questionType: QuestionType, questionOptions: Array<string>, isHidden: boolean, visibilityType: QuestionVisibilityType, order: number, FormSection?: { __typename?: 'FormSectionDirectOutput', id: string, name: string, order: number, staticSectionType?: StaticSectionType | null | undefined } | null | undefined } };

export type UpdateFormQuestionMutationVariables = Exact<{
  questionId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  hint?: InputMaybe<Scalars['String']['input']>;
  questionType: QuestionType;
  questionOptions: Array<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  visibilityType?: InputMaybe<QuestionVisibilityType>;
  formSectionId?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateFormQuestionMutation = { __typename?: 'Mutation', updateFormQuestion: { __typename?: 'UpdateMany', count: number } };

export type RequestUploadInterviewGalleryItemMutationVariables = Exact<{
  data: GalleryPreUpload;
}>;


export type RequestUploadInterviewGalleryItemMutation = { __typename?: 'Mutation', requestUploadInterviewGalleryItem: { __typename?: 'PreUploadUrl', uploadUrl: string, s3Key: string } };

export type RemoveInterviewGalleryItemMutationVariables = Exact<{
  data: CandidateFormResponseInput;
  s3Key: Scalars['String']['input'];
}>;


export type RemoveInterviewGalleryItemMutation = { __typename?: 'Mutation', removeInterviewGalleryItem: { __typename?: 'UpdateMany', count: number } };

export type FormSectionQuestionFragmentFragment = { __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> };

export type FormSectionGroupFragmentFragment = { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string };

export type ListFormSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFormSectionsQuery = { __typename?: 'Query', listFormSections: Array<{ __typename?: 'FormSectionDirectOutput', id: string, name: string, description?: string | null | undefined, order: number, staticSectionType?: StaticSectionType | null | undefined, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined }> };

export type GetFormSectionQueryVariables = Exact<{
  sectionId: Scalars['String']['input'];
}>;


export type GetFormSectionQuery = { __typename?: 'Query', getFormSection: { __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, staticSectionType?: StaticSectionType | null | undefined, FormQuestions: Array<{ __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> }>, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined } };

export type AddFormSectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  formSectionGroupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddFormSectionMutation = { __typename?: 'Mutation', addFormSection: { __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, staticSectionType?: StaticSectionType | null | undefined, FormQuestions: Array<{ __typename?: 'FormQuestionSectionOutput', id: string, label: string, hint?: string | null | undefined, isHidden: boolean, visibilityType: QuestionVisibilityType, questionType: QuestionType, questionOptions: Array<string>, order: number, Responses: Array<{ __typename?: 'ResponseOutput', id: string, responseValue?: string | null | undefined, createdAt: any, User: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined } }> }>, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined } };

export type UpdateFormSectionMutationVariables = Exact<{
  sectionId: Scalars['String']['input'];
  data: FormSectionData;
}>;


export type UpdateFormSectionMutation = { __typename?: 'Mutation', updateFormSection: { __typename?: 'UpdateMany', count: number } };

export type ListFormSectionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFormSectionGroupsQuery = { __typename?: 'Query', listFormSectionGroups: Array<{ __typename?: 'FormSectionGroupOutput', id: string, name: string, FormSections: Array<{ __typename?: 'FormSectionDirectOutput', id: string, name: string, order: number }> }> };

export type AddFormSectionGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AddFormSectionGroupMutation = { __typename?: 'Mutation', addFormSectionGroup: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } };

export type UpdateFormSectionGroupMutationVariables = Exact<{
  formSectionGroupId: Scalars['String']['input'];
  data: FormSectionGroupData;
}>;


export type UpdateFormSectionGroupMutation = { __typename?: 'Mutation', updateFormSectionGroup: { __typename?: 'UpdateMany', count: number } };

export type ListFormTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFormTemplatesQuery = { __typename?: 'Query', listFormTemplates: Array<{ __typename?: 'FormTemplateDirectOutput', id: string, name: string, description?: string | null | undefined, tags: Array<string>, FormSections: Array<{ __typename?: 'FormSectionDirectOutput', id: string, name: string, description?: string | null | undefined, order: number, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined }> }> };

export type GetFormTemplateQueryVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type GetFormTemplateQuery = { __typename?: 'Query', getFormTemplate: { __typename?: 'FormTemplateOutput', id: string, name: string, description?: string | null | undefined, tags: Array<string>, FormSections: Array<{ __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined }> } };

export type AddFormTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type AddFormTemplateMutation = { __typename?: 'Mutation', addFormTemplate: { __typename?: 'FormTemplateOutput', id: string, name: string, description?: string | null | undefined, tags: Array<string>, FormSections: Array<{ __typename?: 'FormSectionOutput', id: string, name: string, description?: string | null | undefined, order: number, FormSectionGroup?: { __typename?: 'FormSectionGroupDirectOutput', id: string, name: string } | null | undefined }> } };

export type UpdateFormTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  data: FormTemplateData;
}>;


export type UpdateFormTemplateMutation = { __typename?: 'Mutation', updateFormTemplate: { __typename?: 'UpdateMany', count: number } };

export type SaveJetBridgeAuthMutationVariables = Exact<{
  auth: SaveJetBridgeAuthInput;
}>;


export type SaveJetBridgeAuthMutation = { __typename?: 'Mutation', saveJetBridgeAuth: { __typename?: 'AtsIntegrationStatus', isConnected: boolean, atsProvider?: AtsProvider | null | undefined } };

export type JobLeadFragment = { __typename?: 'JobLead', id: string, createdAt?: any | null | undefined, title?: string | null | undefined, description?: string | null | undefined, location?: string | null | undefined, companyId: string, companyName?: string | null | undefined, companyUrl?: string | null | undefined, companyLiUrl?: string | null | undefined, companyRevenue?: string | null | undefined, salaryRange?: string | null | undefined, salaryType?: WageType | null | undefined, jobType?: JobContractType | null | undefined, employeeCountRangeStart?: number | null | undefined, employeeCountRangeEnd?: number | null | undefined };

export type NegationOptionFragment = { __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined };

export type JobLeadSearchFragment = { __typename?: 'JobLeadSearch', id: string, name: string, haveAiFindSimilarJobTitles?: boolean | null | undefined, dateAfter?: any | null | undefined, dateBefore?: any | null | undefined, jobType?: string | null | undefined, employmentType?: EmploymentType | null | undefined, radiusMiles?: number | null | undefined, keywords?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined, coords?: { __typename?: 'Coords', lat: number, lng: number } | null | undefined }> | null | undefined, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, hiringCompany?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, companySize?: Array<{ __typename?: 'CompanySizeOutput', min?: number | null | undefined, max?: number | null | undefined }> | null | undefined };

export type ListJobLeadsQueryVariables = Exact<{
  input: ListJobLeadsInput;
}>;


export type ListJobLeadsQuery = { __typename?: 'Query', listJobLeads: { __typename?: 'ListJobLeadsOutput', total: number, items: Array<{ __typename?: 'JobLead', id: string, createdAt?: any | null | undefined, title?: string | null | undefined, description?: string | null | undefined, location?: string | null | undefined, companyId: string, companyName?: string | null | undefined, companyUrl?: string | null | undefined, companyLiUrl?: string | null | undefined, companyRevenue?: string | null | undefined, salaryRange?: string | null | undefined, salaryType?: WageType | null | undefined, jobType?: JobContractType | null | undefined, employeeCountRangeStart?: number | null | undefined, employeeCountRangeEnd?: number | null | undefined }> } };

export type GetJobLeadQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetJobLeadQuery = { __typename?: 'Query', getJobLead: { __typename?: 'JobLead', id: string, createdAt?: any | null | undefined, title?: string | null | undefined, description?: string | null | undefined, location?: string | null | undefined, companyId: string, companyName?: string | null | undefined, companyUrl?: string | null | undefined, companyLiUrl?: string | null | undefined, companyRevenue?: string | null | undefined, salaryRange?: string | null | undefined, salaryType?: WageType | null | undefined, jobType?: JobContractType | null | undefined, employeeCountRangeStart?: number | null | undefined, employeeCountRangeEnd?: number | null | undefined, relatedJobs?: Array<{ __typename?: 'JobLead', id: string, title?: string | null | undefined }> | null | undefined } };

export type ListJobLeadSearchesQueryVariables = Exact<{
  input: ListJobLeadSearchesInput;
}>;


export type ListJobLeadSearchesQuery = { __typename?: 'Query', listJobLeadSearches: { __typename?: 'ListJobLeadSearchesOutput', total: number, items: Array<{ __typename?: 'JobLeadSearch', id: string, name: string, haveAiFindSimilarJobTitles?: boolean | null | undefined, dateAfter?: any | null | undefined, dateBefore?: any | null | undefined, jobType?: string | null | undefined, employmentType?: EmploymentType | null | undefined, radiusMiles?: number | null | undefined, keywords?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined, coords?: { __typename?: 'Coords', lat: number, lng: number } | null | undefined }> | null | undefined, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, hiringCompany?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, companySize?: Array<{ __typename?: 'CompanySizeOutput', min?: number | null | undefined, max?: number | null | undefined }> | null | undefined }> } };

export type ListCompanyMembersQueryVariables = Exact<{
  input: ListCompanyMembersInput;
}>;


export type ListCompanyMembersQuery = { __typename?: 'Query', listCompanyMembers: { __typename?: 'ListCompanyMembersOutput', total: number, items: Array<{ __typename?: 'CompanyMember', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined, headline?: string | null | undefined, emailAddresses: Array<{ __typename?: 'CandidateEmailOutput', emailAddress: string, type: EmailType }>, phoneNumbers: Array<{ __typename?: 'CandidatePhoneNumberOutput', phoneNumber: string, type?: PhoneType | null | undefined }>, company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined }> } };

export type JobLeadListsQueryVariables = Exact<{
  input: ListJobLeadListsInput;
}>;


export type JobLeadListsQuery = { __typename?: 'Query', jobLeadLists: { __typename?: 'ListJobLeadListsOutput', total: number, items: Array<{ __typename?: 'JobLeadList', id: string, name: string }> } };

export type CompanyMemberListsQueryVariables = Exact<{
  input: ListCompanyMemberListsInput;
}>;


export type CompanyMemberListsQuery = { __typename?: 'Query', companyMemberLists: { __typename?: 'ListCompanyMemberListsOutput', total: number, items: Array<{ __typename?: 'CompanyMemberList', id: string, name: string }> } };

export type ListLocationsQueryVariables = Exact<{
  input: ListLocationsInput;
}>;


export type ListLocationsQuery = { __typename?: 'Query', listLocations: { __typename?: 'ListLocationsOutput', total: number, items: Array<{ __typename?: 'LocationOutput', id: string, name: string, coords?: { __typename?: 'Coords', lat: number, lng: number } | null | undefined }> } };

export type ListCompaniesQueryVariables = Exact<{
  input: ListCompaniesInput;
}>;


export type ListCompaniesQuery = { __typename?: 'Query', listCompanies: { __typename?: 'ListLocationsOutput', total: number, items: Array<{ __typename?: 'LocationOutput', id: string, name: string }> } };

export type ListJobLeadJobTitlesQueryVariables = Exact<{
  input: ListJobLeadJobTitlesInput;
}>;


export type ListJobLeadJobTitlesQuery = { __typename?: 'Query', listJobLeadJobTitles: { __typename?: 'ListJobLeadJobTitlesOutput', total: number, items: Array<{ __typename?: 'JobTitle', id: string, title: string }> } };

export type CreateVacancyFromJobLeadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CreateVacancyFromJobLeadMutation = { __typename?: 'Mutation', createVacancyFromJobLead: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } };

export type UpsertJobLeadSearchMutationVariables = Exact<{
  input: UpsertJobLeadSearchInput;
}>;


export type UpsertJobLeadSearchMutation = { __typename?: 'Mutation', upsertJobLeadSearch: { __typename?: 'JobLeadSearch', id: string, name: string, haveAiFindSimilarJobTitles?: boolean | null | undefined, dateAfter?: any | null | undefined, dateBefore?: any | null | undefined, jobType?: string | null | undefined, employmentType?: EmploymentType | null | undefined, radiusMiles?: number | null | undefined, keywords?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, location?: Array<{ __typename?: 'LocationNegationOption', value: string, negative?: boolean | null | undefined, coords?: { __typename?: 'Coords', lat: number, lng: number } | null | undefined }> | null | undefined, jobTitle?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, hiringCompany?: Array<{ __typename?: 'NegationOption', value: string, negative?: boolean | null | undefined }> | null | undefined, companySize?: Array<{ __typename?: 'CompanySizeOutput', min?: number | null | undefined, max?: number | null | undefined }> | null | undefined } };

export type DeleteJobLeadSearchMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteJobLeadSearchMutation = { __typename?: 'Mutation', deleteJobLeadSearch: { __typename?: 'JobLeadSearch', id: string } };

export type AddJobLeadsToListMutationVariables = Exact<{
  input: AddJobLeadsToListInput;
}>;


export type AddJobLeadsToListMutation = { __typename?: 'Mutation', addJobLeadsToList: { __typename?: 'ResourceCreatedMany', count: number } };

export type RemoveJobLeadsFromListMutationVariables = Exact<{
  input: RemoveJobLeadsFromListInput;
}>;


export type RemoveJobLeadsFromListMutation = { __typename?: 'Mutation', removeJobLeadsFromList: { __typename?: 'ResourceDeletedMany', count: number } };

export type AddCompanyMembersToListMutationVariables = Exact<{
  input: AddCompanyMembersToListInput;
}>;


export type AddCompanyMembersToListMutation = { __typename?: 'Mutation', addCompanyMembersToList: { __typename?: 'ResourceCreatedMany', count: number } };

export type RemoveCompanyMembersFromListMutationVariables = Exact<{
  input: RemoveCompanyMembersFromListInput;
}>;


export type RemoveCompanyMembersFromListMutation = { __typename?: 'Mutation', removeCompanyMembersFromList: { __typename?: 'ResourceDeletedMany', count: number } };

export type FetchCompanyInformationMutationVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type FetchCompanyInformationMutation = { __typename?: 'Mutation', fetchCompanyInformation: { __typename?: 'CompanyOutput', id: string, name: string } };

export type DeleteJobLeadListMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteJobLeadListMutation = { __typename?: 'Mutation', deleteJobLeadList: { __typename?: 'ResourceDeleted', id: string } };

export type DeleteCompanyMemberListMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCompanyMemberListMutation = { __typename?: 'Mutation', deleteCompanyMemberList: { __typename?: 'ResourceDeleted', id: string } };

export type SequencerAuthStatusFragmentFragment = { __typename?: 'SequencerAuthStatus', enabledProviders: Array<EmailProvider>, id: string, isConnected: boolean, userEmail?: string | null | undefined, provider?: EmailProvider | null | undefined, isGmailEnabled: boolean, isMicrosoftEnabled: boolean, canSendSequences: boolean, userGoogleScope?: string | null | undefined, userMsScope?: string | null | undefined, userSignature?: string | null | undefined, didSendEmails?: boolean | null | undefined };

export type SaveSequencerAuthMutationVariables = Exact<{
  auth: SaveSequencerAuthInput;
}>;


export type SaveSequencerAuthMutation = { __typename?: 'Mutation', saveSequencerAuth: { __typename?: 'SequencerAuthStatus', enabledProviders: Array<EmailProvider>, id: string, isConnected: boolean, userEmail?: string | null | undefined, provider?: EmailProvider | null | undefined, isGmailEnabled: boolean, isMicrosoftEnabled: boolean, canSendSequences: boolean, userGoogleScope?: string | null | undefined, userMsScope?: string | null | undefined, userSignature?: string | null | undefined, didSendEmails?: boolean | null | undefined } };

export type GetSequencerAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSequencerAuthStatusQuery = { __typename?: 'Query', getSequencerAuthStatus: { __typename?: 'SequencerAuthStatus', enabledProviders: Array<EmailProvider>, id: string, isConnected: boolean, userEmail?: string | null | undefined, provider?: EmailProvider | null | undefined, isGmailEnabled: boolean, isMicrosoftEnabled: boolean, canSendSequences: boolean, userGoogleScope?: string | null | undefined, userMsScope?: string | null | undefined, userSignature?: string | null | undefined, didSendEmails?: boolean | null | undefined } };

export type SendContactSequenceMutationVariables = Exact<{
  input: SendContactSequenceArgs;
}>;


export type SendContactSequenceMutation = { __typename?: 'Mutation', sendContactSequence: { __typename: 'PaymentRequiredError', message?: string | null | undefined, feature: string, limit?: number | null | undefined, used?: number | null | undefined } | { __typename: 'SendContactSequenceSuccess', isDeferred: boolean, isBlocked?: boolean | null | undefined } | { __typename: 'SendContactSequenceValidationError', message?: string | null | undefined } };

type SendContactSequenceOutput_PaymentRequiredError_Fragment = { __typename: 'PaymentRequiredError', message?: string | null | undefined, feature: string, limit?: number | null | undefined, used?: number | null | undefined };

type SendContactSequenceOutput_SendContactSequenceSuccess_Fragment = { __typename: 'SendContactSequenceSuccess', isDeferred: boolean, isBlocked?: boolean | null | undefined };

type SendContactSequenceOutput_SendContactSequenceValidationError_Fragment = { __typename: 'SendContactSequenceValidationError', message?: string | null | undefined };

export type SendContactSequenceOutputFragment = SendContactSequenceOutput_PaymentRequiredError_Fragment | SendContactSequenceOutput_SendContactSequenceSuccess_Fragment | SendContactSequenceOutput_SendContactSequenceValidationError_Fragment;

export type UnauthenticateSequencerMutationVariables = Exact<{ [key: string]: never; }>;


export type UnauthenticateSequencerMutation = { __typename?: 'Mutation', unauthenticateSequencer: { __typename?: 'SequencerAuthStatus', enabledProviders: Array<EmailProvider>, id: string, isConnected: boolean, userEmail?: string | null | undefined, provider?: EmailProvider | null | undefined, isGmailEnabled: boolean, isMicrosoftEnabled: boolean, canSendSequences: boolean, userGoogleScope?: string | null | undefined, userMsScope?: string | null | undefined, userSignature?: string | null | undefined, didSendEmails?: boolean | null | undefined } };

export type MessageItemFragment = { __typename?: 'MessageItem', id?: string | null | undefined, sentAt?: any | null | undefined, sendAfter?: any | null | undefined, from?: string | null | undefined, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject?: string | null | undefined, bodyHtml?: string | null | undefined, deliveredAt?: any | null | undefined, isBounced: boolean, isReplied: boolean, isCanceled: boolean, webLink?: string | null | undefined, user?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined } | null | undefined, sequence?: { __typename?: 'Sequence', isActive: boolean } | null | undefined };

export type MessageItemWithTrackingFragment = { __typename?: 'MessageItem', id?: string | null | undefined, sentAt?: any | null | undefined, sendAfter?: any | null | undefined, from?: string | null | undefined, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject?: string | null | undefined, bodyHtml?: string | null | undefined, deliveredAt?: any | null | undefined, isBounced: boolean, isReplied: boolean, isCanceled: boolean, webLink?: string | null | undefined, interactions?: Array<{ __typename?: 'MessageInteraction', openedAt?: any | null | undefined } | null | undefined> | null | undefined, user?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined } | null | undefined, sequence?: { __typename?: 'Sequence', isActive: boolean } | null | undefined };

export type CandidateContactHistoryItemFragment = { __typename?: 'CandidateContactHistoryItem', id: string, threadId?: string | null | undefined, gmailThreadId?: string | null | undefined, messages: Array<{ __typename?: 'MessageItem', id?: string | null | undefined, sentAt?: any | null | undefined, sendAfter?: any | null | undefined, from?: string | null | undefined, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject?: string | null | undefined, bodyHtml?: string | null | undefined, deliveredAt?: any | null | undefined, isBounced: boolean, isReplied: boolean, isCanceled: boolean, webLink?: string | null | undefined, user?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined } | null | undefined, sequence?: { __typename?: 'Sequence', isActive: boolean } | null | undefined }> };

export type CandidateContactHistoryItemWithTrackingFragment = { __typename?: 'CandidateContactHistoryItem', id: string, threadId?: string | null | undefined, gmailThreadId?: string | null | undefined, messages: Array<{ __typename?: 'MessageItem', id?: string | null | undefined, sentAt?: any | null | undefined, sendAfter?: any | null | undefined, from?: string | null | undefined, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject?: string | null | undefined, bodyHtml?: string | null | undefined, deliveredAt?: any | null | undefined, isBounced: boolean, isReplied: boolean, isCanceled: boolean, webLink?: string | null | undefined, interactions?: Array<{ __typename?: 'MessageInteraction', openedAt?: any | null | undefined } | null | undefined> | null | undefined, user?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined } | null | undefined, sequence?: { __typename?: 'Sequence', isActive: boolean } | null | undefined }> };

export type CandidateContactHistoryStatsFragment = { __typename?: 'ThreadStats', sent: number, opened: number, replied: number, bounced: number };

export type ListCandidateContactHistoryQueryVariables = Exact<{
  filter?: InputMaybe<CandidateContactHistoryFilter>;
  pagination?: InputMaybe<OffsetPagination>;
}>;


export type ListCandidateContactHistoryQuery = { __typename?: 'Query', listCandidateContactHistory: { __typename?: 'CandidateContactHistoryResponse', total: number, nextToken?: string | null | undefined, items: Array<{ __typename?: 'CandidateContactHistoryItem', id: string, threadId?: string | null | undefined, gmailThreadId?: string | null | undefined, messages: Array<{ __typename?: 'MessageItem', id?: string | null | undefined, sentAt?: any | null | undefined, sendAfter?: any | null | undefined, from?: string | null | undefined, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject?: string | null | undefined, bodyHtml?: string | null | undefined, deliveredAt?: any | null | undefined, isBounced: boolean, isReplied: boolean, isCanceled: boolean, webLink?: string | null | undefined, user?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined } | null | undefined, sequence?: { __typename?: 'Sequence', isActive: boolean } | null | undefined }> }>, stats: { __typename?: 'ThreadStats', sent: number, opened: number, replied: number, bounced: number } } };

export type ListCandidateContactHistoryWithTrackingQueryVariables = Exact<{
  filter?: InputMaybe<CandidateContactHistoryFilter>;
  pagination?: InputMaybe<OffsetPagination>;
}>;


export type ListCandidateContactHistoryWithTrackingQuery = { __typename?: 'Query', listCandidateContactHistory: { __typename?: 'CandidateContactHistoryResponse', total: number, nextToken?: string | null | undefined, items: Array<{ __typename?: 'CandidateContactHistoryItem', id: string, threadId?: string | null | undefined, gmailThreadId?: string | null | undefined, messages: Array<{ __typename?: 'MessageItem', id?: string | null | undefined, sentAt?: any | null | undefined, sendAfter?: any | null | undefined, from?: string | null | undefined, to: Array<string>, cc: Array<string>, bcc: Array<string>, subject?: string | null | undefined, bodyHtml?: string | null | undefined, deliveredAt?: any | null | undefined, isBounced: boolean, isReplied: boolean, isCanceled: boolean, webLink?: string | null | undefined, interactions?: Array<{ __typename?: 'MessageInteraction', openedAt?: any | null | undefined } | null | undefined> | null | undefined, user?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined } | null | undefined, sequence?: { __typename?: 'Sequence', isActive: boolean } | null | undefined }> }>, stats: { __typename?: 'ThreadStats', sent: number, opened: number, replied: number, bounced: number } } };

export type GetEmailCompletionMutationVariables = Exact<{
  input: GetEmailCompletion;
}>;


export type GetEmailCompletionMutation = { __typename?: 'Mutation', getEmailCompletion: { __typename?: 'GetEmailCompletionResponse', subject: string, body: string, id: string } };

export type SaveEmailToTrainMutationVariables = Exact<{
  input: SaveTrainedEmailInput;
}>;


export type SaveEmailToTrainMutation = { __typename?: 'Mutation', saveTrainedEmail: { __typename?: 'TrainEmail', id: string } };

export type GetEmailsToTrainQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailsToTrainQuery = { __typename?: 'Query', getEmailsToTrain: Array<{ __typename?: 'TrainEmail', id: string, prompt?: string | null | undefined, aiEmail?: string | null | undefined, trainingEmail?: string | null | undefined, candidate?: { __typename?: 'TrainEmailCandidate', id: string, linkedInUrl: string } | null | undefined }> };

export type CancelSequenceMutationVariables = Exact<{
  input: CancelSequenceInput;
}>;


export type CancelSequenceMutation = { __typename?: 'Mutation', cancelSequence: { __typename?: 'CancelSequenceResponse', messagesCount: number } };

export type ListCandidateScheduledEmailsQueryVariables = Exact<{
  candidateId: Scalars['String']['input'];
}>;


export type ListCandidateScheduledEmailsQuery = { __typename?: 'Query', listCandidateScheduledEmails: Array<{ __typename?: 'ScheduledEmails', sendAfter?: any | null | undefined, from?: string | null | undefined, subject?: string | null | undefined, threadId?: string | null | undefined, emailSequenceId?: string | null | undefined }> };

export type UpdateSequencesMutationVariables = Exact<{
  input: UpdateEmailsInput;
}>;


export type UpdateSequencesMutation = { __typename?: 'Mutation', updateEmails: Array<{ __typename?: 'ResourceCreated', id?: string | null | undefined }> };

export type GetEmailSequenceDetailsMutationVariables = Exact<{
  input: GetEmailSequenceInput;
}>;


export type GetEmailSequenceDetailsMutation = { __typename?: 'Mutation', getEmailSequenceDetails: { __typename?: 'EmailSequence', id: string, state: EmailSequenceState, emails: Array<{ __typename?: 'MessageItem', subject?: string | null | undefined, bodyHtml?: string | null | undefined }> } };

export type PresignUploadPublicAssetsMutationVariables = Exact<{
  input: PresignUploadAssetsInput;
}>;


export type PresignUploadPublicAssetsMutation = { __typename?: 'Mutation', presignUploadPublicAssets: { __typename?: 'UploadAssetsOutput', presignedUrls: Array<{ __typename?: 'PresignedUrl', url: string, key?: string | null | undefined, fileName?: string | null | undefined }> } };

export type SaveHumanMatchMutationVariables = Exact<{
  input: SaveHumanMatch;
}>;


export type SaveHumanMatchMutation = { __typename?: 'Mutation', saveHumanMatch: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type RecordMatchViewedMutationVariables = Exact<{
  matchId: Scalars['String']['input'];
}>;


export type RecordMatchViewedMutation = { __typename?: 'Mutation', recordMatchViewed?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type ApproveCandidateMatchMutationVariables = Exact<{
  matchId: Scalars['String']['input'];
}>;


export type ApproveCandidateMatchMutation = { __typename?: 'Mutation', approveCandidateMatch?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type ListCandidateVacancyMatchesQueryVariables = Exact<{
  vacancyId?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  includeNoApproved?: InputMaybe<Scalars['Boolean']['input']>;
  includeVacanciesWithoutMatches?: InputMaybe<Scalars['Boolean']['input']>;
  kickOffMatchesForOpenVacancies?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<MatchType>;
}>;


export type ListCandidateVacancyMatchesQuery = { __typename?: 'Query', listCandidateVacancyMatches: { __typename?: 'CandidateVacancyMatchCollection', page?: number | null | undefined, total: number, items: Array<{ __typename?: 'CandidateVacancyMatch', approvedAt?: any | null | undefined, isNewMatch?: boolean | null | undefined, vacancy: { __typename?: 'VacancyOutput', id: string, name: string }, match?: { __typename?: 'CandidateVacancyMatchMatch', id: string, match?: number | null | undefined, matchType: MatchType, viewedAt?: any | null | undefined, createdAt: any } | null | undefined, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, liHeadline?: string | null | undefined, avatarS3Bucket?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, linkedInUrl?: string | null | undefined } | null | undefined }> } };

export type CreateCandidateVacancyMatchMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
  candidateLinkedInUrl: Scalars['String']['input'];
}>;


export type CreateCandidateVacancyMatchMutation = { __typename?: 'Mutation', createNewCandidateMatch: { __typename?: 'NewCandidateMatch', id: string } };

export type DeleteCandidateVacancyMatchMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
  candidateId: Scalars['String']['input'];
}>;


export type DeleteCandidateVacancyMatchMutation = { __typename?: 'Mutation', deleteCandidateMatch: { __typename?: 'ResourceDeletedMany', count: number } };

export type SendSlackNotificationMutationVariables = Exact<{
  input: SendSlackNotificationInput;
}>;


export type SendSlackNotificationMutation = { __typename?: 'Mutation', sendSlackNotification?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type GetAllTeamMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTeamMetricsQuery = { __typename?: 'Query', getAllTeamMetrics: Array<{ __typename?: 'Metric', id: string, label: string }> };

export type GetTeamPerformanceQueryVariables = Exact<{
  startedAt: Scalars['AWSDateTime']['input'];
  endedAt: Scalars['AWSDateTime']['input'];
}>;


export type GetTeamPerformanceQuery = { __typename?: 'Query', getTeamPerformance: { __typename?: 'TeamPerformance', topPerformers?: Array<{ __typename?: 'UserStats', user: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined }, metrics?: Array<{ __typename?: 'MetricWithValue', id: string, label: string, value?: string | null | undefined }> | null | undefined }> | null | undefined, underPerformers?: Array<{ __typename?: 'UserStats', user: { __typename?: 'User', id: string, name?: string | null | undefined, avatar?: string | null | undefined }, metrics?: Array<{ __typename?: 'MetricWithValue', id: string, label: string, value?: string | null | undefined }> | null | undefined }> | null | undefined } };

export type SearchSchoolsQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchSchoolsQuery = { __typename?: 'Query', searchSchools: { __typename?: 'SchoolSearchResponse', total: number, page: number, items: Array<{ __typename?: 'School', name: string, location: string, countryCode: string, rank?: number | null | undefined }> } };

export type SequenceTemplateFragmentFragment = { __typename?: 'SequenceTemplate', id: string, name: string, isEmailFollowUpEnabled: boolean, canBeEdited: boolean, stageTemplates: Array<{ __typename?: 'SequenceStageTemplate', id: string, type: SequenceStageTemplateType, sequencePosition: number, bodyHtml: string, subject?: string | null | undefined }>, createdBy: { __typename?: 'SequenceTemplateAuthor', id: string, name?: string | null | undefined } };

export type ListSequenceTemplatesQueryVariables = Exact<{
  input: ListSequenceTemplatesInput;
}>;


export type ListSequenceTemplatesQuery = { __typename?: 'Query', listSequenceTemplates: { __typename?: 'SequenceTemplatesPaginated', nextToken?: string | null | undefined, total: number, items: Array<{ __typename?: 'SequenceTemplate', id: string, name: string, isEmailFollowUpEnabled: boolean, canBeEdited: boolean, stageTemplates: Array<{ __typename?: 'SequenceStageTemplate', id: string, type: SequenceStageTemplateType, sequencePosition: number, bodyHtml: string, subject?: string | null | undefined }>, createdBy: { __typename?: 'SequenceTemplateAuthor', id: string, name?: string | null | undefined } }> } };

export type CreateSequenceTemplateMutationVariables = Exact<{
  input: CreateSequenceTemplateArgsV2;
}>;


export type CreateSequenceTemplateMutation = { __typename?: 'Mutation', createSequenceTemplateV2: { __typename?: 'SequenceTemplate', id: string, name: string, isEmailFollowUpEnabled: boolean, canBeEdited: boolean, stageTemplates: Array<{ __typename?: 'SequenceStageTemplate', id: string, type: SequenceStageTemplateType, sequencePosition: number, bodyHtml: string, subject?: string | null | undefined }>, createdBy: { __typename?: 'SequenceTemplateAuthor', id: string, name?: string | null | undefined } } };

export type UpdateSequenceTemplateMutationVariables = Exact<{
  input: UpdateSequenceTemplateArgsV2;
}>;


export type UpdateSequenceTemplateMutation = { __typename?: 'Mutation', updateSequenceTemplateV2: { __typename?: 'SequenceTemplate', id: string, name: string, isEmailFollowUpEnabled: boolean, canBeEdited: boolean, stageTemplates: Array<{ __typename?: 'SequenceStageTemplate', id: string, type: SequenceStageTemplateType, sequencePosition: number, bodyHtml: string, subject?: string | null | undefined }>, createdBy: { __typename?: 'SequenceTemplateAuthor', id: string, name?: string | null | undefined } } };

export type DeleteSequenceTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSequenceTemplateMutation = { __typename?: 'Mutation', deleteSequenceTemplate: { __typename?: 'ResourceDeleted', id: string } };

export type SearchSkillsQueryVariables = Exact<{
  input: SearchSkillInput;
}>;


export type SearchSkillsQuery = { __typename?: 'Query', searchSkills: { __typename?: 'SkillSearchResponse', total: number, page: number, items: Array<{ __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined }> } };

export type GetSkillsForTitlesQueryVariables = Exact<{
  input: GetSkillsForTitle;
}>;


export type GetSkillsForTitlesQuery = { __typename?: 'Query', getSkillsForTitle: Array<{ __typename?: 'SkillsForType', title: string, isGettingAsync: boolean, skills: Array<{ __typename?: 'RelatedSkill', name: string, synonyms: Array<string> }> }> };

export type OnJobTitleSkillsAvailableSubscriptionVariables = Exact<{
  jobTitle: Scalars['String']['input'];
}>;


export type OnJobTitleSkillsAvailableSubscription = { __typename?: 'Subscription', onJobTitleSkillsAvailable: { __typename?: 'JobTitleSkillsReady', jobTitle: string } };

export type JobTitleSkillsAvailableMutationVariables = Exact<{
  jobTitle: Scalars['String']['input'];
}>;


export type JobTitleSkillsAvailableMutation = { __typename?: 'Mutation', jobTitleSkillsAvailable: { __typename?: 'JobTitleSkillsReady', jobTitle: string } };

export type SkillFragment = { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined };

export type SkillPhraseFieldsFragment = { __typename?: 'SkillPhrase', id: string, phrase: string, phraseType: SkillPhraseType, vertical: Vertical };

export type ListSkillPhrasesQueryVariables = Exact<{
  input: ListSkillPhrasesInput;
}>;


export type ListSkillPhrasesQuery = { __typename?: 'Query', listSkillPhrases: { __typename?: 'SkillPhrases', total?: number | null | undefined, items: Array<{ __typename?: 'SkillPhrase', id: string, phrase: string, phraseType: SkillPhraseType, vertical: Vertical }> } };

export type AddSkillPhraseMutationVariables = Exact<{
  input: SkillPhraseInput;
}>;


export type AddSkillPhraseMutation = { __typename?: 'Mutation', addSkillPhrase: { __typename?: 'SkillPhrase', id: string, phrase: string, phraseType: SkillPhraseType, vertical: Vertical } };

export type DeleteSkillPhraseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSkillPhraseMutation = { __typename?: 'Mutation', deleteSkillPhrase: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type MessageThreadCandidateFragment = { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined };

export type TelephonyMessageFragment = { __typename?: 'TelephonyMessage', id: string, threadId: string, direction: MessageDirection, from: string, to: string, body: string, sentAt?: any | null | undefined, readAt?: any | null | undefined, messageSid?: string | null | undefined, status?: string | null | undefined, errorCode?: number | null | undefined, isCanceled?: boolean | null | undefined };

export type MessageSentFragment = { __typename?: 'MessageSentEvent', tenantId: string, threadId?: string | null | undefined, messageId?: string | null | undefined };

export type MessageThreadFragment = { __typename?: 'TelephonyMessageThread', id: string, label: string, unreadCount: number, createdAt: any, lastMessageAt: any, messages: Array<{ __typename?: 'TelephonyMessage', id: string, threadId: string, direction: MessageDirection, from: string, to: string, body: string, sentAt?: any | null | undefined, readAt?: any | null | undefined, messageSid?: string | null | undefined, status?: string | null | undefined, errorCode?: number | null | undefined, isCanceled?: boolean | null | undefined }>, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined };

export type CandidateThreadFragment = { __typename?: 'TelephonyMessageThread', id: string, label: string, createdAt: any, lastMessageAt: any, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined };

export type ListMessageThreadsQueryVariables = Exact<{
  input: ListThreads;
}>;


export type ListMessageThreadsQuery = { __typename?: 'Query', listThreads: { __typename?: 'ListThreadsResponse', total: number, unreadCount: number, threads: Array<{ __typename?: 'TelephonyMessageThread', id: string, label: string, unreadCount: number, createdAt: any, lastMessageAt: any, messages: Array<{ __typename?: 'TelephonyMessage', id: string, threadId: string, direction: MessageDirection, from: string, to: string, body: string, sentAt?: any | null | undefined, readAt?: any | null | undefined, messageSid?: string | null | undefined, status?: string | null | undefined, errorCode?: number | null | undefined, isCanceled?: boolean | null | undefined }>, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined }> } };

export type ListThreadMessagesQueryVariables = Exact<{
  input: ListMessages;
}>;


export type ListThreadMessagesQuery = { __typename?: 'Query', listMessages: { __typename?: 'ListMessagesResponse', total?: number | null | undefined, messages: Array<{ __typename?: 'TelephonyMessage', id: string, threadId: string, direction: MessageDirection, from: string, to: string, body: string, sentAt?: any | null | undefined, readAt?: any | null | undefined, messageSid?: string | null | undefined, status?: string | null | undefined, errorCode?: number | null | undefined, isCanceled?: boolean | null | undefined }> } };

export type GetCandidateThreadQueryVariables = Exact<{
  input: GetCandidateThreadInput;
}>;


export type GetCandidateThreadQuery = { __typename?: 'Query', getCandidateThread: { __typename?: 'GetCandidateThreadResponse', thread?: { __typename?: 'TelephonyMessageThread', id: string, label: string, createdAt: any, lastMessageAt: any, candidate?: { __typename?: 'CandidateOutput', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined } };

export type SendMessageMutationVariables = Exact<{
  input: SendMessage;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: { __typename?: 'TelephonyMessage', id: string, threadId: string, direction: MessageDirection, from: string, to: string, body: string, sentAt?: any | null | undefined, readAt?: any | null | undefined, messageSid?: string | null | undefined, status?: string | null | undefined, errorCode?: number | null | undefined, isCanceled?: boolean | null | undefined } };

export type MessageSentMutationVariables = Exact<{
  input: MessageSent;
}>;


export type MessageSentMutation = { __typename?: 'Mutation', messageSent: { __typename?: 'MessageSentEvent', tenantId: string, threadId?: string | null | undefined, messageId?: string | null | undefined } };

export type MarkMessagesAsReadMutationVariables = Exact<{
  input: MarkMessageAsRead;
}>;


export type MarkMessagesAsReadMutation = { __typename?: 'Mutation', markMessagesAsRead: Array<{ __typename?: 'ResourceCreated', id?: string | null | undefined }> };

export type UpdateThreadMutationVariables = Exact<{
  input: UpdateThreadInput;
}>;


export type UpdateThreadMutation = { __typename?: 'Mutation', updateThread: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type OnMessageSentSubscriptionVariables = Exact<{
  tenantId: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
}>;


export type OnMessageSentSubscription = { __typename?: 'Subscription', messageSent: { __typename?: 'MessageSentEvent', tenantId: string, threadId?: string | null | undefined, messageId?: string | null | undefined } };

export type OnTaskStatusUpdateSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OnTaskStatusUpdateSubscription = { __typename?: 'Subscription', onTaskStatusUpdate: { __typename?: 'Task', id: string, status: TaskStatus, timestamp?: string | null | undefined, data?: string | null | undefined } };

export type UpdateTaskStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  update: TaskStatusUpdate;
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', updateTaskStatus: { __typename?: 'Task', id: string, status: TaskStatus, timestamp?: string | null | undefined, data?: string | null | undefined } };

export type TeamFragment = { __typename?: 'Team', id: string, name: string, createdAt: any, seats: number, accountType?: AccountType | null | undefined, lastPaymentFailedAt?: any | null | undefined };

export type InviteFragment = { __typename?: 'Invite', id: string, emailAddress: string, usedAt?: any | null | undefined, userId?: string | null | undefined, roles?: Array<string> | null | undefined, createdAt: any, sentAt: any, joinUrl: string, inviter: { __typename?: 'Inviter', id: string, name?: string | null | undefined, emailAddress: string, avatar?: string | null | undefined } };

type InviteResult_Invite_Fragment = { __typename: 'Invite', id: string, emailAddress: string, usedAt?: any | null | undefined, userId?: string | null | undefined, roles?: Array<string> | null | undefined, createdAt: any, sentAt: any, joinUrl: string, inviter: { __typename?: 'Inviter', id: string, name?: string | null | undefined, emailAddress: string, avatar?: string | null | undefined } };

type InviteResult_InviteError_Fragment = { __typename: 'InviteError', message: string };

export type InviteResultFragment = InviteResult_Invite_Fragment | InviteResult_InviteError_Fragment;

type RemoveUserFromTeamResult_RemoveUserFromTeamError_Fragment = { __typename: 'RemoveUserFromTeamError', message: string };

type RemoveUserFromTeamResult_RemoveUserFromTeamResult_Fragment = { __typename: 'RemoveUserFromTeamResult', message: string };

export type RemoveUserFromTeamResultFragment = RemoveUserFromTeamResult_RemoveUserFromTeamError_Fragment | RemoveUserFromTeamResult_RemoveUserFromTeamResult_Fragment;

export type UseInviteMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type UseInviteMutation = { __typename?: 'Mutation', useInvite: { __typename?: 'UseInviteResult', success: boolean, error?: string | null | undefined, rateLimited: boolean, team?: { __typename?: 'Team', id: string, name: string, createdAt: any, seats: number, accountType?: AccountType | null | undefined, lastPaymentFailedAt?: any | null | undefined } | null | undefined } };

export type TeamQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string, createdAt: any, seats: number, accountType?: AccountType | null | undefined, lastPaymentFailedAt?: any | null | undefined } };

export type ListTeamInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTeamInvitesQuery = { __typename?: 'Query', listTeamInvites: { __typename?: 'ListTeamInvitesResult', team: { __typename?: 'Team', id: string, name: string, createdAt: any, seats: number, accountType?: AccountType | null | undefined, lastPaymentFailedAt?: any | null | undefined }, invites: Array<{ __typename?: 'Invite', id: string, emailAddress: string, usedAt?: any | null | undefined, userId?: string | null | undefined, roles?: Array<string> | null | undefined, createdAt: any, sentAt: any, joinUrl: string, inviter: { __typename?: 'Inviter', id: string, name?: string | null | undefined, emailAddress: string, avatar?: string | null | undefined } }> } };

export type SendTeamInviteMutationVariables = Exact<{
  input: SendTeamInvite;
}>;


export type SendTeamInviteMutation = { __typename?: 'Mutation', sendTeamInvite: { __typename: 'Invite', id: string, emailAddress: string, usedAt?: any | null | undefined, userId?: string | null | undefined, roles?: Array<string> | null | undefined, createdAt: any, sentAt: any, joinUrl: string, inviter: { __typename?: 'Inviter', id: string, name?: string | null | undefined, emailAddress: string, avatar?: string | null | undefined } } | { __typename: 'InviteError', message: string } };

export type CancelTeamInviteMutationVariables = Exact<{
  input: CancelTeamInvite;
}>;


export type CancelTeamInviteMutation = { __typename?: 'Mutation', cancelTeamInvite: { __typename?: 'CancelTeamInviteResult', canceledInviteId: string } };

export type RemoveUserFromTeamMutationVariables = Exact<{
  input: RemoveUserFromTeam;
}>;


export type RemoveUserFromTeamMutation = { __typename?: 'Mutation', removeUserFromTeam: { __typename: 'RemoveUserFromTeamError', message: string } | { __typename: 'RemoveUserFromTeamResult', message: string } };

export type SetTeamNameMutationVariables = Exact<{
  input: SetTeamName;
}>;


export type SetTeamNameMutation = { __typename?: 'Mutation', setTeamName: { __typename?: 'SetTeamNameResult', team: { __typename?: 'Team', id: string, name: string, createdAt: any, seats: number, accountType?: AccountType | null | undefined, lastPaymentFailedAt?: any | null | undefined } } };

export type ChangeTeamRolesMutationVariables = Exact<{
  input: ChangeTeamRoles;
}>;


export type ChangeTeamRolesMutation = { __typename?: 'Mutation', changeTeamRoles: { __typename?: 'ChangeTeamRolesResult', user: { __typename?: 'UserOutput', roles: Array<string> } } };

export type UpdateTenantMutationVariables = Exact<{
  input: UpdateTenantInput;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } };

export type RecordUserActivityMutationVariables = Exact<{
  userActivity: UserActivityArgs;
}>;


export type RecordUserActivityMutation = { __typename?: 'Mutation', recordUserActivity?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type UserFragment = { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } };

export type UserPreferencesFragment = { __typename?: 'UserPreferences', mailingAiSettings?: { __typename?: 'AISettingsOutput', tone: number, detail: number } | null | undefined, mailingAutomationSettings?: { __typename?: 'AutomationSettings', shouldSendFollowUps?: boolean | null | undefined, shouldOptimizeSendTime?: boolean | null | undefined } | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } } };

export type GenerateAuthChallengeTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateAuthChallengeTokenMutation = { __typename?: 'Mutation', generateAuthChallengeToken: { __typename?: 'AuthChallengeToken', token: string } };

export type OnboardUserMutationVariables = Exact<{
  input: OnboardUserInput;
}>;


export type OnboardUserMutation = { __typename?: 'Mutation', onboardUser: { __typename?: 'UserOutput', id: string } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserOutput', id: string, name?: string | null | undefined, emailAddress: string, calendlyLink?: string | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, atsId?: string | null | undefined } };

export type ListUsersOfSameTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUsersOfSameTenantQuery = { __typename?: 'Query', listUsersOfSameTenant: Array<{ __typename?: 'UserOutput', id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, linkedInConnectionRequestNote?: string | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } }> };

export type AuthenticationContextQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthenticationContextQuery = { __typename?: 'Query', getUser: { __typename?: 'UserOutput', userName: string, linkedInConnectionRequestNote?: string | null | undefined, bccAtsAddress?: string | null | undefined, jdRewriteCustomInstructions?: string | null | undefined, tenantLogoKey?: string | null | undefined, shouldGetStatsUpdate?: boolean | null | undefined, id: string, tenantId: string, linkedInUrl?: string | null | undefined, calendlyLink?: string | null | undefined, name?: string | null | undefined, timeZone?: string | null | undefined, emailAddress: string, avatarUrl?: string | null | undefined, isTenantOwner: boolean, roles: Array<string>, sequencerEmailAddress?: string | null | undefined, latestExtensionVersion?: string | null | undefined, emailProvider?: EmailProvider | null | undefined, autoInvite?: boolean | null | undefined, emailSignature?: string | null | undefined, atsId?: string | null | undefined, featureFlags: { __typename?: 'FeatureFlags', atsIntegrations?: boolean | null | undefined, clientTokens?: boolean | null | undefined, skillPopup?: boolean | null | undefined, candidateMatch?: boolean | null | undefined, stackRank?: boolean | null | undefined, micros?: boolean | null | undefined, candidateSearch?: boolean | null | undefined, jobLeads?: boolean | null | undefined, telephony?: boolean | null | undefined, sms?: boolean | null | undefined, tasks?: boolean | null | undefined, autoInvite?: boolean | null | undefined }, preferences?: { __typename?: 'UserPreferences', mailingAiSettings?: { __typename?: 'AISettingsOutput', tone: number, detail: number } | null | undefined, mailingAutomationSettings?: { __typename?: 'AutomationSettings', shouldSendFollowUps?: boolean | null | undefined, shouldOptimizeSendTime?: boolean | null | undefined } | null | undefined } | null | undefined, tenant: { __typename?: 'Tenant', id: string, isTrackingUserActivity?: boolean | null | undefined } }, getBillingStatus: { __typename?: 'BillingStatus', teamName?: string | null | undefined, teamOwnerId?: string | null | undefined, isSubscriptionActive: boolean, accountType: AccountType, seats?: number | null | undefined, enabledFeatures: Array<string>, lastPaymentFailedAt?: any | null | undefined, quotas: Array<{ __typename?: 'Quota', feature: string, limit?: number | null | undefined, used?: number | null | undefined }>, activeProduct?: { __typename?: 'ActiveBillingProduct', id: string, name: string, description?: string | null | undefined, cancelAt?: string | null | undefined, cancelAtPeriodEnd?: boolean | null | undefined, status: SubscriptionStatus, accountType?: AccountType | null | undefined, activePrice: { __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined } } | null | undefined }, listProducts: Array<{ __typename?: 'BillingProduct', id: string, name: string, description?: string | null | undefined, features?: Array<string | null | undefined> | null | undefined, accountType?: AccountType | null | undefined, prices: Array<{ __typename?: 'BillingPrice', id: string, unitAmountCents?: number | null | undefined, interval?: string | null | undefined, intervalCount?: number | null | undefined, trialPeriodDays?: number | null | undefined }> }>, getAtsIntegrationStatus: { __typename?: 'AtsIntegrationStatus', isConnected: boolean, atsProvider?: AtsProvider | null | undefined }, getSequencerAuthStatus: { __typename?: 'SequencerAuthStatus', enabledProviders: Array<EmailProvider>, id: string, isConnected: boolean, userEmail?: string | null | undefined, provider?: EmailProvider | null | undefined, isGmailEnabled: boolean, isMicrosoftEnabled: boolean, canSendSequences: boolean, userGoogleScope?: string | null | undefined, userMsScope?: string | null | undefined, userSignature?: string | null | undefined, didSendEmails?: boolean | null | undefined } };

export type RecordCandidateUserActionMutationVariables = Exact<{
  input: CandidateUserAction;
}>;


export type RecordCandidateUserActionMutation = { __typename?: 'Mutation', recordCandidateUserAction?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type RequestUploadLogoMutationVariables = Exact<{
  input: RequestUploadLogoInput;
}>;


export type RequestUploadLogoMutation = { __typename?: 'Mutation', requestUploadLogo: { __typename?: 'PresignedUrl', url: string, key?: string | null | undefined } };

export type ListUsersWithoutVacanciesQueryVariables = Exact<{
  input: ListUserWithoutVacanciesInput;
}>;


export type ListUsersWithoutVacanciesQuery = { __typename?: 'Query', listUsersWithoutVacancies: { __typename?: 'ListUserWithoutVacancies', total?: number | null | undefined, users: Array<{ __typename?: 'UserOutput', id: string, linkedInUrl?: string | null | undefined, name?: string | null | undefined, avatarUrl?: string | null | undefined, emailAddress: string }> } };

export type DeleteLogoMutationVariables = Exact<{
  input: DeleteLogoInput;
}>;


export type DeleteLogoMutation = { __typename?: 'Mutation', deleteLogo: { __typename?: 'ResourceDeleted', id: string } };

export type UpdateUserPreferencesMutationVariables = Exact<{
  preferences: UserPreferencesInput;
}>;


export type UpdateUserPreferencesMutation = { __typename?: 'Mutation', updateUserPreferences: { __typename?: 'UserPreferences', mailingAiSettings?: { __typename?: 'AISettingsOutput', tone: number, detail: number } | null | undefined, mailingAutomationSettings?: { __typename?: 'AutomationSettings', shouldSendFollowUps?: boolean | null | undefined, shouldOptimizeSendTime?: boolean | null | undefined } | null | undefined } };

export type AdminDisableUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminDisableUserMutation = { __typename?: 'Mutation', adminDisableUser: { __typename?: 'ResourceDeleted', id: string } };

export type AdminEnableUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type AdminEnableUserMutation = { __typename?: 'Mutation', adminEnableUser: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type AdminListAllUsersQueryVariables = Exact<{
  input: SearchInput;
}>;


export type AdminListAllUsersQuery = { __typename?: 'Query', adminListUsers: { __typename?: 'UserList', total: number, items: Array<{ __typename?: 'UserOutput', id: string, name?: string | null | undefined, emailAddress: string, deletedAt?: any | null | undefined, tenant: { __typename?: 'Tenant', id: string, name: string } }> } };

export type GetUserFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFeatureFlagsQuery = { __typename?: 'Query', getUser: { __typename?: 'UserOutput', featureFlags: { __typename?: 'FeatureFlags', atsIntegrations?: boolean | null | undefined, clientTokens?: boolean | null | undefined, skillPopup?: boolean | null | undefined, candidateMatch?: boolean | null | undefined, stackRank?: boolean | null | undefined, micros?: boolean | null | undefined, candidateSearch?: boolean | null | undefined, jobLeads?: boolean | null | undefined, telephony?: boolean | null | undefined, sms?: boolean | null | undefined, tasks?: boolean | null | undefined } } };

export type RecordLiConnectionRequestSentMutationVariables = Exact<{
  url: Scalars['String']['input'];
  recordedAt?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordLiConnectionRequestSentMutation = { __typename?: 'Mutation', recordUserActivity?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type UserPersonalStatsQueryVariables = Exact<{
  input: UserPersonalStatsInput;
}>;


export type UserPersonalStatsQuery = { __typename?: 'Query', userPersonalStats: { __typename?: 'UserActivity', id: string, name: string, avatarUrl?: string | null | undefined, summary: { __typename?: 'UserActivitySummary', autoInviteSent: number } } };

export type RecordUserActivityMutationMutationVariables = Exact<{
  event?: InputMaybe<UserActivityEvent>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  recordedAt?: InputMaybe<Scalars['String']['input']>;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Scalars['AWSJSON']['input']>;
}>;


export type RecordUserActivityMutationMutation = { __typename?: 'Mutation', recordUserActivity?: { __typename?: 'ResourceCreated', id?: string | null | undefined } | null | undefined };

export type SummaryFieldsFragment = { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined };

export type GetUserActivityEventsQueryVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  timeRange: TimeRange;
  skipCloseProximityEvents?: InputMaybe<Scalars['Boolean']['input']>;
  skippedIndividualEvents?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type GetUserActivityEventsQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', users: { __typename?: 'UserActivityUsers', items: Array<{ __typename?: 'UserActivity', id: string, name: string, avatarUrl?: string | null | undefined, timeZone?: string | null | undefined, events: Array<{ __typename?: 'Event', name: UserActivityEvent, recordedAt: string, vacancy?: string | null | undefined, offset?: number | null | undefined, color?: string | null | undefined, domainCategory?: { __typename?: 'DomainCategory', id: string, name: string, color?: string | null | undefined } | null | undefined }>, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }> } } };

export type GetVacancySummariesQueryVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  timeRange: TimeRange;
}>;


export type GetVacancySummariesQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', users: { __typename?: 'UserActivityUsers', items: Array<{ __typename?: 'UserActivity', id: string, name: string, avatarUrl?: string | null | undefined, timeZone?: string | null | undefined, vacancySummaries: Array<{ __typename?: 'VacancyStats', id?: string | null | undefined, name?: string | null | undefined, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }> }> } } };

export type GetUserActivitySummariesQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange: TimeRange;
  sortBy?: InputMaybe<UserActivitySummarySortBy>;
  searchInput?: InputMaybe<SearchInput>;
}>;


export type GetUserActivitySummariesQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', users: { __typename?: 'UserActivityUsers', total: number, items: Array<{ __typename?: 'UserActivity', id: string, name: string, avatarUrl?: string | null | undefined, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }> } } };

export type GetUserActivityHighlightsQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange: TimeRange;
}>;


export type GetUserActivityHighlightsQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', highlights: { __typename?: 'UserActivityHighlights', topPerformer: { __typename?: 'UserActivity', id: string, name: string, avatarUrl?: string | null | undefined, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }, underPerformers: Array<{ __typename?: 'UserActivity', id: string, name: string, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }> } } };

export type GetVacancyUserActivitiesQueryVariables = Exact<{
  vacancyIds: Array<Scalars['ID']['input']>;
}>;


export type GetVacancyUserActivitiesQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', users: { __typename?: 'UserActivityUsers', items: Array<{ __typename?: 'UserActivity', id: string, name: string, avatarUrl?: string | null | undefined, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }> } } };

export type GetUserActivitySummaryForEachDayQueryVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  timeRange: TimeRange;
}>;


export type GetUserActivitySummaryForEachDayQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', users: { __typename?: 'UserActivityUsers', items: Array<{ __typename?: 'UserActivity', id: string, name: string, dailySummaries: Array<{ __typename?: 'DailySummary', date: any, summary: { __typename?: 'UserActivitySummary', profilesViewed: number, gmailInboxOpened: number, mailInboxOpened: number, calendarPageOpened: number, communicationPageOpened: number, fileOpened: number, productivityPageOpened: number, emailsSent: number, emailRepliesReceived: number, atsPageOpened: number, liConnectionRequestSent: number, workOtherPageOpened: number, autoInviteSent: number, hoursWorked: number, score: number, domainCategorySummary?: Array<{ __typename?: 'DomainCategorySummary', id: string, name: string, total: number, color?: string | null | undefined }> | null | undefined } }> }> } } };

export type GetUserActivityTeamAverageQueryVariables = Exact<{
  timeRange?: InputMaybe<TimeRange>;
}>;


export type GetUserActivityTeamAverageQuery = { __typename?: 'Query', userActivities: { __typename?: 'TeamUserActivity', average: { __typename?: 'UserActivityTeamAverage', profilesViewed: number, emailsSent: number, emailRepliesReceived: number, hoursWorked: number, score: number } } };

export type DomainTimeSpentQueryVariables = Exact<{
  input: DomainTimeSpentInput;
}>;


export type DomainTimeSpentQuery = { __typename?: 'Query', domainTimeSpent: { __typename?: 'DomainTimeSpentResponse', total: number, items: Array<{ __typename?: 'DomainTimeSpent', domain: string, timeSpent: number }> } };

export type ListUserTasksQueryVariables = Exact<{
  input: ListUserTasksInput;
}>;


export type ListUserTasksQuery = { __typename?: 'Query', listUserTasks: { __typename?: 'UserTasks', total: number, items: Array<{ __typename?: 'UserTask', id: string, title: string, description?: string | null | undefined, assigneeUserId: string, creatorUserId?: string | null | undefined, createdAt: any, deadlineAt?: any | null | undefined, doneAt?: any | null | undefined, Assignee: { __typename?: 'User', name?: string | null | undefined }, Creator?: { __typename?: 'User', name?: string | null | undefined } | null | undefined, Candidate?: { __typename?: 'CandidateOutput', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string } | null | undefined }> } };

export type CreateUserTaskMutationVariables = Exact<{
  input: CreateUserTaskInput;
}>;


export type CreateUserTaskMutation = { __typename?: 'Mutation', createUserTask: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type MarkUserTaskAsDoneMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkUserTaskAsDoneMutation = { __typename?: 'Mutation', markUserTaskAsDone: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type MarkUserTaskAsNotDoneMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkUserTaskAsNotDoneMutation = { __typename?: 'Mutation', markUserTaskAsNotDone: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type DeleteUserTaskMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUserTaskMutation = { __typename?: 'Mutation', deleteUserTask: { __typename?: 'ResourceDeleted', id: string } };

export type CloseVacancyMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
}>;


export type CloseVacancyMutation = { __typename?: 'Mutation', updateVacancy?: { __typename?: 'VacancyOutput', id: string, status: VacancyStatus } | null | undefined };

export type UpdateVacancyMetaMutationVariables = Exact<{
  key: Scalars['String']['input'];
  meta: Scalars['String']['input'];
  vacancyId: Scalars['String']['input'];
}>;


export type UpdateVacancyMetaMutation = { __typename?: 'Mutation', assignVacancyMeta?: { __typename?: 'VacancyOutput', id: string } | null | undefined };

export type UpdateVacancyStateMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
  vacancyStatus: VacancyStatus;
}>;


export type UpdateVacancyStateMutation = { __typename?: 'Mutation', updateVacancy?: { __typename?: 'VacancyOutput', id: string } | null | undefined };

export type GetFullVacancyInfoQueryVariables = Exact<{
  vacancyId: Scalars['String']['input'];
}>;


export type GetFullVacancyInfoQuery = { __typename?: 'Query', getVacancy?: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', city?: string | null | undefined, country: string, region?: string | null | undefined }> | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } | null | undefined };

export type FindVacancyByLinkQueryVariables = Exact<{
  atsLink: Scalars['String']['input'];
}>;


export type FindVacancyByLinkQuery = { __typename?: 'Query', getVacancy?: { __typename?: 'VacancyOutput', id: string, name: string } | null | undefined };

export type GetVacancySkillsQueryVariables = Exact<{
  vacancyId: Scalars['String']['input'];
}>;


export type GetVacancySkillsQuery = { __typename?: 'Query', getVacancy?: { __typename?: 'VacancyOutput', id: string, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, skill: { __typename?: 'Skill', id: string, name: string } }> | null | undefined } | null | undefined };

export type AddSkillsToVacancyMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
  appendSkills?: InputMaybe<Array<DesiredSkill>>;
}>;


export type AddSkillsToVacancyMutation = { __typename?: 'Mutation', updateVacancy2: { __typename?: 'VacancyOutput', id: string } };

export type UpdateVacancyMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  atsLink?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Array<LocationInput>>;
  vacancyStatus?: InputMaybe<VacancyStatus>;
  skills?: InputMaybe<Array<DesiredSkill>>;
  requiredCertificates?: InputMaybe<Array<CertificateInput>>;
  previousIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  aiChecks?: InputMaybe<Array<AiCheck>>;
  vertical?: InputMaybe<Vertical>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  benefitsTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  responsibilitiesFragment?: InputMaybe<Scalars['String']['input']>;
  disclosureTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  positiveOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  negativeOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  isStackRankRequired?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSearchCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  positionType?: InputMaybe<PositionType>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVacancyMutation = { __typename?: 'Mutation', updateVacancy?: { __typename?: 'VacancyOutput', id: string, name: string, description?: string | null | undefined, vertical?: Vertical | null | undefined, elevatorPitch?: string | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, clientName?: string | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, skill: { __typename?: 'Skill', id: string, name: string } }> | null | undefined } | null | undefined };

export type UpdateVacancy2MutationVariables = Exact<{
  input: UpdateVacancy2Input;
}>;


export type UpdateVacancy2Mutation = { __typename?: 'Mutation', updateVacancy2: { __typename?: 'VacancyOutput', id: string, name: string, description?: string | null | undefined, vertical?: Vertical | null | undefined, elevatorPitch?: string | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, clientName?: string | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, skill: { __typename?: 'Skill', id: string, name: string } }> | null | undefined } };

export type UpsertVacancyMutationVariables = Exact<{
  input: UpsertVacancyInput;
}>;


export type UpsertVacancyMutation = { __typename?: 'Mutation', upsertVacancy: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } };

export type DashboardListVacanciesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  inStatus?: InputMaybe<Array<VacancyStatus>>;
  vacancyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  forStackRank?: InputMaybe<Scalars['Boolean']['input']>;
  includeNewMatchesCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DashboardListVacanciesQuery = { __typename?: 'Query', listVacancies: { __typename?: 'ListVacanciesOutput', page: number, total: number, items: Array<{ __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined }> } };

export type ListVacanciesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FieldOrder>>;
  inStatus?: InputMaybe<Array<VacancyStatus>>;
  take: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListVacanciesQuery = { __typename?: 'Query', listVacancies: { __typename?: 'ListVacanciesOutput', page: number, total: number, items: Array<{ __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined }> } };

export type SearchVacanciesQueryQueryVariables = Exact<{
  name: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  inStatus?: InputMaybe<Array<VacancyStatus>>;
  crossTenantSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchVacanciesQueryQuery = { __typename?: 'Query', listVacancies: { __typename?: 'ListVacanciesOutput', items: Array<{ __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined }> } };

export type SearchVacanciesLiteQueryVariables = Exact<{
  name: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  inStatus?: InputMaybe<Array<VacancyStatus>>;
  crossTenantSearch?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithOpenTokens?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchVacanciesLiteQuery = { __typename?: 'Query', listVacancies: { __typename?: 'ListVacanciesOutput', items: Array<{ __typename?: 'VacancyOutput', id: string, name: string, clientName?: string | null | undefined, status: VacancyStatus, atsLink?: string | null | undefined, isEnriched?: boolean | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined }> } };

export type CreateVacancyMutationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  client?: InputMaybe<ClientInput>;
  location?: InputMaybe<Array<LocationInput>>;
  skills?: InputMaybe<Array<DesiredSkill>>;
  requiredCertificates?: InputMaybe<Array<CertificateInput>>;
  previousIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  aiChecks?: InputMaybe<Array<AiCheck>>;
  vertical: Vertical;
  atsLink?: InputMaybe<Scalars['String']['input']>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  benefitsTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  responsibilitiesFragment?: InputMaybe<Scalars['String']['input']>;
  disclosureTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VacancyStatus>;
  positiveOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  negativeOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  isStackRankRequired?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateVacancyMutationMutation = { __typename?: 'Mutation', createVacancy?: { __typename?: 'VacancyOutput', id: string, name: string } | null | undefined };

export type RemoveCandidateFromListMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  listId: Scalars['String']['input'];
}>;


export type RemoveCandidateFromListMutation = { __typename?: 'Mutation', removeCandidateFromList: { __typename?: 'ResourceCreated', id?: string | null | undefined } };

export type AddCandidateToListsMutationVariables = Exact<{
  candidateId: Scalars['String']['input'];
  vacancyLists: Array<VacancyList>;
}>;


export type AddCandidateToListsMutation = { __typename?: 'Mutation', addCandidateToLists: { __typename?: 'CandidateOutput', id: string } };

export type GetMiniVacancyByIdQueryVariables = Exact<{
  vacancyId: Scalars['String']['input'];
}>;


export type GetMiniVacancyByIdQuery = { __typename?: 'Query', getVacancy?: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } | null | undefined };

export type CreateMiniVacancyMutationVariables = Exact<{
  clientId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  requiredCertificates?: InputMaybe<Array<CertificateInput>>;
  skills?: InputMaybe<Array<DesiredSkill>>;
  location?: InputMaybe<Array<LocationInput>>;
  vertical: Vertical;
  atsLink?: InputMaybe<Scalars['String']['input']>;
  elevatorPitch?: InputMaybe<Scalars['String']['input']>;
  benefitsTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  responsibilitiesFragment?: InputMaybe<Scalars['String']['input']>;
  disclosureTemplateFragment?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VacancyStatus>;
  positiveOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  negativeOPCs?: InputMaybe<Array<Scalars['String']['input']>>;
  isStackRankRequired?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMiniVacancyMutation = { __typename?: 'Mutation', createVacancy?: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } | null | undefined };

export type DeleteVacancyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteVacancyMutation = { __typename?: 'Mutation', deleteVacancy?: { __typename?: 'ResourceDeleted', id: string } | null | undefined };

export type InitParseDescriptionMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vertical: Vertical;
  vacancyId?: InputMaybe<Scalars['String']['input']>;
  shouldGenerateName?: InputMaybe<Scalars['Boolean']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  parseForNameTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForSkillsTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForElevatorPitchTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForBenefitsTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForDisclosureTaskId?: InputMaybe<Scalars['String']['input']>;
  parseForResponsibilitiesTaskId?: InputMaybe<Scalars['String']['input']>;
  shouldCreateClientVacancyChat?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Array<ParseTask>>;
}>;


export type InitParseDescriptionMutation = { __typename?: 'Mutation', initParseDescription: { __typename?: 'InitParseDescriptionOutput', success: boolean, vacancyId?: string | null | undefined, taskId?: string | null | undefined, clientVacancyChatId?: string | null | undefined, vacancy?: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } | null | undefined } };

export type OnVacancyUpdatedSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OnVacancyUpdatedSubscription = { __typename?: 'Subscription', onVacancyUpdated?: { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined } | null | undefined };

export type VacancyUpdatedMutationVariables = Exact<{
  stringifiedVacancy: Scalars['String']['input'];
}>;


export type VacancyUpdatedMutation = { __typename?: 'Mutation', vacancyUpdated: { __typename?: 'VacancyOutput', id: string, name: string, description?: string | null | undefined, top3Skills?: Array<string> | null | undefined, vertical?: Vertical | null | undefined, atsLink?: string | null | undefined, elevatorPitch?: string | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', id: string, name: string }> | null | undefined } };

export type GetCandidateApplicationsQueryVariables = Exact<{
  input: GetCandidateApplicationsInput;
}>;


export type GetCandidateApplicationsQuery = { __typename?: 'Query', getCandidateApplications: { __typename?: 'ListCandidateApplicationData', total: number, totalCVCount: number, items: Array<{ __typename?: 'CandidateApplicationData', id: string, score?: number | null | undefined, status?: string | null | undefined, hasCV?: boolean | null | undefined, candidate: { __typename?: 'CandidateOutput', id: string, avatarS3Bucket?: string | null | undefined, avatarThumbS3Key?: string | null | undefined, avatarThumbOrigUrl?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, liHeadline?: string | null | undefined, linkedInUrl?: string | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, workExperience?: Array<{ __typename?: 'WorkExperienceOutput', company?: { __typename?: 'CompanyOutput', id: string, name: string } | null | undefined }> | null | undefined }, survey?: Array<{ __typename?: 'SurveyData', question: string, result: string, isRequired?: boolean | null | undefined, answer: string, favorableAnswer?: string | null | undefined }> | null | undefined }> } };

export type ListJobTitlesQueryVariables = Exact<{
  input: ListJobTitlesInput;
}>;


export type ListJobTitlesQuery = { __typename?: 'Query', listJobTitles: { __typename?: 'ListJobTitlesOutput', total: number, items: Array<{ __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined }> } };

export type CreateJobTitleMutationVariables = Exact<{
  input: CreateJobTitleInput;
}>;


export type CreateJobTitleMutation = { __typename?: 'Mutation', createJobTitle: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } };

export type VacancySkillFragment = { __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } };

export type ClientTokenFragment = { __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> };

export type VacancySummaryFragment = { __typename?: 'VacancyOutput', id: string, createdAt: any, name: string, description?: string | null | undefined, status: VacancyStatus, vertical?: Vertical | null | undefined, atsLink?: string | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string } | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined };

export type VacancyOutputFragmentFragment = { __typename?: 'VacancyOutput', id: string, name: string, isEnriched?: boolean | null | undefined, description?: string | null | undefined, priority?: VacancyPriority | null | undefined, status: VacancyStatus, leadUserId?: string | null | undefined, createdAt: any, funnelId?: string | null | undefined, positionCount?: number | null | undefined, clientName?: string | null | undefined, vertical?: Vertical | null | undefined, tenantId?: string | null | undefined, atsId?: string | null | undefined, atsLink?: string | null | undefined, top3Skills?: Array<string> | null | undefined, positiveOPCs?: Array<string> | null | undefined, negativeOPCs?: Array<string> | null | undefined, isStackRankRequired?: boolean | null | undefined, recruitmentType?: PositionType | null | undefined, schedulingLink?: string | null | undefined, brandType?: Array<BrandType> | null | undefined, brandName?: string | null | undefined, positionFor?: Array<PositionFor> | null | undefined, payDescription?: PayDescription | null | undefined, externalId?: string | null | undefined, revealCompany?: boolean | null | undefined, companyName?: string | null | undefined, companyUrl?: string | null | undefined, phoneNumber?: string | null | undefined, phoneNumberAcceptsText?: boolean | null | undefined, thirdPartyLinkURL?: string | null | undefined, thirdPartyLinkText?: string | null | undefined, previousIndustries?: Array<string> | null | undefined, aiChecks?: Array<AiCheck> | null | undefined, negativeSkillPhrases?: Array<string> | null | undefined, applicationCount?: number | null | undefined, elevatorPitch?: string | null | undefined, isAIGenerated?: boolean | null | undefined, benefitsTemplateFragment?: string | null | undefined, responsibilitiesFragment?: string | null | undefined, disclosureTemplateFragment?: string | null | undefined, payRange?: string | null | undefined, wageType?: WageType | null | undefined, benefits?: Array<string> | null | undefined, clientOriginationBonus?: boolean | null | undefined, locationType?: LocationType | null | undefined, allowedToDisclosePayRange?: boolean | null | undefined, signOnBonus?: boolean | null | undefined, signOnBonusValue?: number | null | undefined, commissionPlan?: CommissionPlanType | null | undefined, typicalWorkingHours?: string | null | undefined, paidSickLeave?: boolean | null | undefined, hasGrowthOpportunities?: boolean | null | undefined, equityOptionsOffered?: boolean | null | undefined, buildTeam?: boolean | null | undefined, innovativeProduct?: boolean | null | undefined, scaleExistingProduct?: boolean | null | undefined, buzzwordsCloud?: Array<string> | null | undefined, organizationTypeDescription?: string | null | undefined, clientContact?: boolean | null | undefined, autonomy?: boolean | null | undefined, buildLitigationSkills?: boolean | null | undefined, lightIndustrialProdType?: LightIndustrialProdType | null | undefined, apprenticeshipProgram?: boolean | null | undefined, advancementOpportunity?: boolean | null | undefined, nightShiftPayDifferential?: string | null | undefined, employmentType?: EmploymentType | null | undefined, relocationAssistance?: boolean | null | undefined, productInfo?: string | null | undefined, salesOpportunityInfo?: string | null | undefined, compPlanInfo?: string | null | undefined, newMatchesCount?: number | null | undefined, keywords?: Array<string> | null | undefined, idealCandidateProfile?: string | null | undefined, address?: string | null | undefined, jobTitleFull?: { __typename?: 'JobTitle', id: string, title: string, correlatedJobTitles?: Array<{ __typename?: 'JobTitle', id: string, title: string }> | null | undefined } | null | undefined, requiredCertificates?: Array<{ __typename?: 'Certificate', name: string, id: string }> | null | undefined, skills?: Array<{ __typename?: 'VacancySkill', yearsOfExperience?: number | null | undefined, isRequired?: boolean | null | undefined, skill: { __typename?: 'Skill', id: string, name: string, description?: string | null | undefined, existsSince?: any | null | undefined, regex?: string | null | undefined, synonyms?: Array<string> | null | undefined, skillCategory?: { __typename?: 'SkillCategory_2', id: string, name: string, vertical?: Vertical | null | undefined } | null | undefined } }> | null | undefined, location?: Array<{ __typename?: 'VacancyLocation', country: string }> | null | undefined, leadUser?: { __typename?: 'UserOutput', id: string, name?: string | null | undefined } | null | undefined, clientTokens?: Array<{ __typename?: 'ClientToken', id: string, vacancyId: string, size: number, candidates: Array<{ __typename?: 'ClientTokenCandidate', candidateId: string, shareableCandidateId: string, firstName: string, lastName: string }> }> | null | undefined };

export const AdminStatsFieldsFragmentDoc = gql`
    fragment AdminStatsFields on AdminStats {
  vacanciesCreated
  sequencesCreated
  candidatesInjested
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserOutput {
  id
  tenantId
  linkedInUrl
  calendlyLink
  name
  timeZone
  emailAddress
  avatarUrl
  isTenantOwner
  roles
  sequencerEmailAddress
  latestExtensionVersion
  emailProvider
  linkedInConnectionRequestNote
  autoInvite
  emailSignature
  tenant {
    id
    isTrackingUserActivity
  }
  atsId
}
    `;
export const TenantFragmentDoc = gql`
    fragment Tenant on Tenant {
  id
  name
  emailAddress
  createdAt
  creator {
    ...User
  }
  owner {
    ...User
  }
  accountType
  deletedAt
}
    ${UserFragmentDoc}`;
export const AtsIntegrationStatusFragmentFragmentDoc = gql`
    fragment AtsIntegrationStatusFragment on AtsIntegrationStatus {
  isConnected
  atsProvider
}
    `;
export const AtsUserFragmentDoc = gql`
    fragment AtsUser on AtsUser {
  id
  name
  email
  avatarUrl
}
    `;
export const AtsStageFragmentDoc = gql`
    fragment AtsStage on AtsStage {
  id
  name
}
    `;
export const AtsApplicationFragmentFragmentDoc = gql`
    fragment AtsApplicationFragment on AtsApplication {
  id
  createdAt
  updatedAt
  rejectedAt
  status
  rejectionReason
  atsId
  addedToATSAt
  candidateId
  vacancyId
}
    `;
export const BillingPriceFragmentFragmentDoc = gql`
    fragment BillingPriceFragment on BillingPrice {
  id
  unitAmountCents
  interval
  intervalCount
  trialPeriodDays
}
    `;
export const BillingProductFragmentFragmentDoc = gql`
    fragment BillingProductFragment on BillingProduct {
  id
  name
  description
  features
  accountType
  prices {
    ...BillingPriceFragment
  }
}
    ${BillingPriceFragmentFragmentDoc}`;
export const BillingStatusFragmentFragmentDoc = gql`
    fragment BillingStatusFragment on BillingStatus {
  teamName
  teamOwnerId
  isSubscriptionActive
  accountType
  seats
  quotas {
    feature
    limit
    used
  }
  enabledFeatures
  activeProduct {
    id
    name
    description
    cancelAt
    cancelAtPeriodEnd
    status
    accountType
    activePrice {
      ...BillingPriceFragment
    }
  }
  lastPaymentFailedAt
}
    ${BillingPriceFragmentFragmentDoc}`;
export const CandidateEmailFragmentFragmentDoc = gql`
    fragment CandidateEmailFragment on CandidateEmailOutput {
  emailAddress
  type
  name
  confidenceLevel
  preferenceWeight
}
    `;
export const BaseCandidateInfoFragmentFragmentDoc = gql`
    fragment BaseCandidateInfoFragment on CandidateOutput {
  id
  firstName
  lastName
  linkedInUrl
  candidateRawId
  githubURL
  yearsOfExperience
  atsId
  workExperience {
    id
    company {
      id
      name
    }
    isTopCompany
    roles {
      id
      title
      description
      start
      end
      skills {
        id
        name
      }
    }
  }
  teammateCandidateLists {
    claimedCandidate
    user {
      id
      name
    }
    list {
      id
      name
    }
  }
  candidateLists {
    id
    vacancyId
    name
  }
  emailAddresses {
    emailAddress
    type
    name
    confidenceLevel
  }
  phoneNumbersFull {
    phoneNumber
    type
    deviceType
  }
}
    `;
export const CandidateSearchOutputFragmentDoc = gql`
    fragment CandidateSearchOutput on CandidateSearch {
  id
  name
  createdBy {
    id
    name
  }
  freeTextSearch
  jobTitle {
    value
    negative
  }
  location {
    value
    negative
  }
  skills {
    value
    negative
  }
  company {
    value
    negative
  }
  school {
    value
    negative
  }
}
    `;
export const SectionElementFragmentFragmentDoc = gql`
    fragment SectionElementFragment on SectionElement {
  __typename
  ... on CandidatePercentageItem {
    label
    value
  }
  ... on CandidateSelectItem {
    label
    value
  }
  ... on CandidateScaleItem {
    label
    min
    max
    value
  }
  ... on CandidateStatsCheckList {
    title
    items {
      value
      label
    }
  }
  ... on KeywordsCollection {
    title
    keywords
  }
  ... on CandidateStatsSlidersList {
    text
    items {
      ... on ValueSlider {
        label
        value
      }
      ... on PolarizationSlider {
        leftLabel
        rightLabel
        value
      }
    }
  }
}
    `;
export const CandidateProfileFragmentDoc = gql`
    fragment CandidateProfile on CandidateProfileOutput {
  candidateId
  header {
    name
    avatarS3Bucket
    avatarThumbS3Key
    skillSummaries {
      label
      value
    }
  }
  leftColumn {
    title
    elements {
      ...SectionElementFragment
    }
  }
  rightColumn {
    title
    elements {
      ...SectionElementFragment
    }
  }
  education {
    id
    name
    isTopSchool
    startDate
    endDate
    degree
  }
}
    ${SectionElementFragmentFragmentDoc}`;
export const ContactInfoFragmentDoc = gql`
    fragment ContactInfo on CandidateOutput {
  id
  emailAddresses {
    name
    emailAddress
    type
    confidenceLevel
    preferenceWeight
  }
  phoneNumbersFull {
    phoneNumber
    type
  }
}
    `;
export const CandidateInterviewFragmentFragmentDoc = gql`
    fragment CandidateInterviewFragment on CandidateInterview {
  id
  type
  candidateId
  CandidateInterviewFormSections {
    id
    formSectionId
    candidateInterviewId
    FormSection {
      id
      name
      description
      order
      staticSectionType
      FormQuestions {
        id
        label
        hint
        isHidden
        visibilityType
        questionType
        questionOptions
        order
        Responses {
          id
          responseValue
          createdAt
          User {
            id
            name
            avatar
          }
        }
      }
    }
  }
}
    `;
export const FormQuestionFragmentFragmentDoc = gql`
    fragment FormQuestionFragment on FormQuestionDirectOutput {
  id
  label
  hint
  questionType
  questionOptions
  isHidden
  visibilityType
  order
  FormSection {
    id
    name
    order
    staticSectionType
  }
}
    `;
export const ChatMessageFieldsFragmentDoc = gql`
    fragment ChatMessageFields on ChatRow {
  id
  index
  role
  content
  rating
  extraDataJSON
  vacancyId
}
    `;
export const AiPromptFragmentDoc = gql`
    fragment AiPrompt on AiPrompt {
  id
  prompt
  name
  canDelete
}
    `;
export const LookUpContactInfoAsyncFragmentFragmentDoc = gql`
    fragment LookUpContactInfoAsyncFragment on LookUpContactInfoResponseAsync {
  __typename
  ... on LookUpEmailResponseAsync {
    candidateId
    unsubscribed
    taskId
    emails {
      name
      emailAddress
      type
      confidenceLevel
    }
    phones {
      number
    }
    phoneNumbers {
      phoneNumber
      type
      deviceType
    }
  }
  ... on PaymentRequiredError {
    message
    feature
    limit
    used
  }
}
    `;
export const CallDetailFragmentDoc = gql`
    fragment CallDetail on Call {
  id
  twilioCallSid
  from
  to
  status
  ringbackNumber
  direction
  candidateId
  createdAt
  duration
  userMessage
}
    `;
export const PrecordedMessageDetailFragmentDoc = gql`
    fragment PrecordedMessageDetail on PreRecordedMessage {
  id
  title
  description
  transcript
  duration
  createdAt
  asset {
    size
    s3Key
    contentType
  }
}
    `;
export const DomainCategoryFragmentDoc = gql`
    fragment DomainCategory on DomainCategory {
  id
  name
  color
  domains
}
    `;
export const FormSectionQuestionFragmentFragmentDoc = gql`
    fragment FormSectionQuestionFragment on FormQuestionSectionOutput {
  id
  label
  hint
  isHidden
  visibilityType
  questionType
  questionOptions
  order
  Responses {
    id
    responseValue
    createdAt
    User {
      id
      name
      avatar
    }
  }
}
    `;
export const FormSectionGroupFragmentFragmentDoc = gql`
    fragment FormSectionGroupFragment on FormSectionGroupDirectOutput {
  id
  name
}
    `;
export const JobLeadFragmentDoc = gql`
    fragment JobLead on JobLead {
  id
  createdAt
  title
  description
  location
  companyId
  companyName
  companyUrl
  companyLiUrl
  companyRevenue
  salaryRange
  salaryType
  jobType
  employeeCountRangeStart
  employeeCountRangeEnd
}
    `;
export const NegationOptionFragmentDoc = gql`
    fragment NegationOption on NegationOption {
  value
  negative
}
    `;
export const JobLeadSearchFragmentDoc = gql`
    fragment JobLeadSearch on JobLeadSearch {
  id
  name
  keywords {
    ...NegationOption
  }
  location {
    value
    negative
    coords {
      lat
      lng
    }
  }
  jobTitle {
    ...NegationOption
  }
  hiringCompany {
    ...NegationOption
  }
  companySize {
    min
    max
  }
  haveAiFindSimilarJobTitles
  dateAfter
  dateBefore
  jobType
  employmentType
  radiusMiles
}
    ${NegationOptionFragmentDoc}`;
export const SequencerAuthStatusFragmentFragmentDoc = gql`
    fragment SequencerAuthStatusFragment on SequencerAuthStatus {
  enabledProviders
  id
  isConnected
  userEmail
  provider
  isGmailEnabled
  isMicrosoftEnabled
  canSendSequences
  userGoogleScope
  userMsScope
  userSignature
  didSendEmails
}
    `;
export const SendContactSequenceOutputFragmentDoc = gql`
    fragment SendContactSequenceOutput on SendContactSequenceResult {
  __typename
  ... on SendContactSequenceSuccess {
    isDeferred
    isBlocked
  }
  ... on SendContactSequenceValidationError {
    message
  }
  ... on PaymentRequiredError {
    message
    feature
    limit
    used
  }
}
    `;
export const MessageItemFragmentDoc = gql`
    fragment MessageItem on MessageItem {
  id
  sentAt
  sendAfter
  from
  to
  cc
  bcc
  subject
  bodyHtml
  deliveredAt
  isBounced
  isReplied
  isCanceled
  user {
    id
    name
    avatarUrl
  }
  candidate {
    id
    firstName
    lastName
    linkedInUrl
  }
  vacancy {
    id
    name
    clientName
  }
  sequence {
    isActive
  }
  webLink
}
    `;
export const CandidateContactHistoryItemFragmentDoc = gql`
    fragment CandidateContactHistoryItem on CandidateContactHistoryItem {
  id
  threadId
  gmailThreadId
  messages {
    ...MessageItem
  }
}
    ${MessageItemFragmentDoc}`;
export const MessageItemWithTrackingFragmentDoc = gql`
    fragment MessageItemWithTracking on MessageItem {
  ...MessageItem
  interactions {
    openedAt
  }
}
    ${MessageItemFragmentDoc}`;
export const CandidateContactHistoryItemWithTrackingFragmentDoc = gql`
    fragment CandidateContactHistoryItemWithTracking on CandidateContactHistoryItem {
  ...CandidateContactHistoryItem
  messages {
    ...MessageItemWithTracking
  }
}
    ${CandidateContactHistoryItemFragmentDoc}
${MessageItemWithTrackingFragmentDoc}`;
export const CandidateContactHistoryStatsFragmentDoc = gql`
    fragment CandidateContactHistoryStats on ThreadStats {
  sent
  opened
  replied
  bounced
}
    `;
export const SequenceTemplateFragmentFragmentDoc = gql`
    fragment SequenceTemplateFragment on SequenceTemplate {
  id
  name
  isEmailFollowUpEnabled
  canBeEdited
  stageTemplates {
    id
    type
    sequencePosition
    bodyHtml
    subject
  }
  createdBy {
    id
    name
  }
}
    `;
export const SkillPhraseFieldsFragmentDoc = gql`
    fragment SkillPhraseFields on SkillPhrase {
  id
  phrase
  phraseType
  vertical
}
    `;
export const MessageSentFragmentDoc = gql`
    fragment MessageSent on MessageSentEvent {
  tenantId
  threadId
  messageId
}
    `;
export const TelephonyMessageFragmentDoc = gql`
    fragment TelephonyMessage on TelephonyMessage {
  id
  threadId
  direction
  from
  to
  body
  sentAt
  readAt
  messageSid
  status
  errorCode
  isCanceled
}
    `;
export const MessageThreadCandidateFragmentDoc = gql`
    fragment MessageThreadCandidate on CandidateOutput {
  id
  firstName
  lastName
}
    `;
export const MessageThreadFragmentDoc = gql`
    fragment MessageThread on TelephonyMessageThread {
  id
  label
  unreadCount
  createdAt
  lastMessageAt
  messages {
    ...TelephonyMessage
  }
  candidate {
    ...MessageThreadCandidate
  }
}
    ${TelephonyMessageFragmentDoc}
${MessageThreadCandidateFragmentDoc}`;
export const CandidateThreadFragmentDoc = gql`
    fragment CandidateThread on TelephonyMessageThread {
  id
  label
  createdAt
  lastMessageAt
  candidate {
    ...MessageThreadCandidate
  }
}
    ${MessageThreadCandidateFragmentDoc}`;
export const TeamFragmentDoc = gql`
    fragment Team on Team {
  id
  name
  createdAt
  seats
  accountType
  lastPaymentFailedAt
}
    `;
export const InviteFragmentDoc = gql`
    fragment Invite on Invite {
  id
  emailAddress
  usedAt
  userId
  roles
  createdAt
  sentAt
  joinUrl
  inviter {
    id
    name
    emailAddress
    avatar
  }
}
    `;
export const InviteResultFragmentDoc = gql`
    fragment InviteResult on InviteResponse {
  __typename
  ... on Invite {
    ...Invite
  }
  ... on InviteError {
    message
  }
}
    ${InviteFragmentDoc}`;
export const RemoveUserFromTeamResultFragmentDoc = gql`
    fragment RemoveUserFromTeamResult on RemoveUserFromTeamResponse {
  __typename
  ... on RemoveUserFromTeamError {
    message
  }
  ... on RemoveUserFromTeamResult {
    message
  }
}
    `;
export const UserPreferencesFragmentDoc = gql`
    fragment UserPreferences on UserPreferences {
  mailingAiSettings {
    tone
    detail
  }
  mailingAutomationSettings {
    shouldSendFollowUps
    shouldOptimizeSendTime
  }
}
    `;
export const SummaryFieldsFragmentDoc = gql`
    fragment SummaryFields on UserActivitySummary {
  profilesViewed
  gmailInboxOpened
  mailInboxOpened
  calendarPageOpened
  communicationPageOpened
  fileOpened
  productivityPageOpened
  emailsSent
  emailRepliesReceived
  atsPageOpened
  liConnectionRequestSent
  workOtherPageOpened
  autoInviteSent
  hoursWorked
  score
  domainCategorySummary {
    id
    name
    total
    color
  }
}
    `;
export const SkillFragmentDoc = gql`
    fragment Skill on Skill {
  id
  name
  description
  existsSince
  regex
  synonyms
  skillCategory {
    id
    name
    vertical
  }
}
    `;
export const VacancySkillFragmentDoc = gql`
    fragment VacancySkill on VacancySkill {
  skill {
    ...Skill
  }
  yearsOfExperience
  isRequired
}
    ${SkillFragmentDoc}`;
export const ClientTokenFragmentDoc = gql`
    fragment ClientToken on ClientToken {
  id
  vacancyId
  candidates {
    candidateId
    shareableCandidateId
    firstName
    lastName
  }
  size
}
    `;
export const VacancySummaryFragmentDoc = gql`
    fragment VacancySummary on VacancyOutput {
  id
  createdAt
  name
  jobTitleFull {
    id
    title
  }
  description
  status
  vertical
  atsLink
  skills {
    ...VacancySkill
  }
  keywords
  idealCandidateProfile
  clientTokens {
    ...ClientToken
  }
}
    ${VacancySkillFragmentDoc}
${ClientTokenFragmentDoc}`;
export const VacancyOutputFragmentFragmentDoc = gql`
    fragment VacancyOutputFragment on VacancyOutput {
  id
  name
  isEnriched
  jobTitleFull {
    id
    title
    correlatedJobTitles {
      id
      title
    }
  }
  description
  priority
  status
  leadUserId
  createdAt
  funnelId
  positionCount
  clientName
  vertical
  tenantId
  atsId
  atsLink
  requiredCertificates {
    name
    id
  }
  top3Skills
  skills {
    ...VacancySkill
  }
  location {
    country
  }
  positiveOPCs
  negativeOPCs
  isStackRankRequired
  recruitmentType
  schedulingLink
  brandType
  brandName
  positionFor
  payDescription
  externalId
  revealCompany
  leadUser {
    id
    name
  }
  companyName
  companyUrl
  phoneNumber
  phoneNumberAcceptsText
  thirdPartyLinkURL
  thirdPartyLinkText
  previousIndustries
  aiChecks
  negativeSkillPhrases
  applicationCount
  elevatorPitch
  isAIGenerated
  benefitsTemplateFragment
  responsibilitiesFragment
  disclosureTemplateFragment
  payRange
  wageType
  benefits
  clientOriginationBonus
  locationType
  allowedToDisclosePayRange
  signOnBonus
  signOnBonusValue
  commissionPlan
  typicalWorkingHours
  paidSickLeave
  hasGrowthOpportunities
  equityOptionsOffered
  buildTeam
  innovativeProduct
  scaleExistingProduct
  buzzwordsCloud
  organizationTypeDescription
  clientContact
  autonomy
  buildLitigationSkills
  lightIndustrialProdType
  apprenticeshipProgram
  advancementOpportunity
  nightShiftPayDifferential
  employmentType
  relocationAssistance
  productInfo
  salesOpportunityInfo
  compPlanInfo
  newMatchesCount
  keywords
  idealCandidateProfile
  address
  clientTokens {
    ...ClientToken
  }
}
    ${VacancySkillFragmentDoc}
${ClientTokenFragmentDoc}`;
export const AddressesDocument = gql`
    query Addresses($input: ListAddressesInput!) {
  listAddresses(input: $input)
}
    `;

/**
 * __useAddressesQuery__
 *
 * To run a query within a React component, call `useAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressesQuery(baseOptions: Apollo.QueryHookOptions<AddressesQuery, AddressesQueryVariables> & ({ variables: AddressesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, options);
      }
export function useAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressesQuery, AddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, options);
        }
export function useAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressesQuery, AddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressesQuery, AddressesQueryVariables>(AddressesDocument, options);
        }
export type AddressesQueryHookResult = ReturnType<typeof useAddressesQuery>;
export type AddressesLazyQueryHookResult = ReturnType<typeof useAddressesLazyQuery>;
export type AddressesSuspenseQueryHookResult = ReturnType<typeof useAddressesSuspenseQuery>;
export type AddressesQueryResult = Apollo.QueryResult<AddressesQuery, AddressesQueryVariables>;
export const ImpersonateUserDocument = gql`
    mutation ImpersonateUser($input: ImpersonateUser!) {
  impersonateUser(input: $input) {
    ... on ImpersonateUserOutput {
      authToken
      user {
        tomboUserId
        username
      }
    }
    ... on ImpersonateUserError {
      message
    }
  }
}
    `;
export type ImpersonateUserMutationFn = Apollo.MutationFunction<ImpersonateUserMutation, ImpersonateUserMutationVariables>;

/**
 * __useImpersonateUserMutation__
 *
 * To run a mutation, you first call `useImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateUserMutation, { data, loading, error }] = useImpersonateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImpersonateUserMutation(baseOptions?: Apollo.MutationHookOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpersonateUserMutation, ImpersonateUserMutationVariables>(ImpersonateUserDocument, options);
      }
export type ImpersonateUserMutationHookResult = ReturnType<typeof useImpersonateUserMutation>;
export type ImpersonateUserMutationResult = Apollo.MutationResult<ImpersonateUserMutation>;
export type ImpersonateUserMutationOptions = Apollo.BaseMutationOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>;
export const AdminSearchSkillsLikeDocument = gql`
    query AdminSearchSkillsLike($query: String!, $page: Int!, $take: Int!) {
  searchSkillsLike(query: $query, page: $page, take: $take) {
    related {
      id
      name
      strength
      synonyms
    }
    id
    name
    synonyms
    regex
    description
    skillCategory {
      id
      name
      vertical
    }
  }
}
    `;

/**
 * __useAdminSearchSkillsLikeQuery__
 *
 * To run a query within a React component, call `useAdminSearchSkillsLikeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSearchSkillsLikeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSearchSkillsLikeQuery({
 *   variables: {
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useAdminSearchSkillsLikeQuery(baseOptions: Apollo.QueryHookOptions<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables> & ({ variables: AdminSearchSkillsLikeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables>(AdminSearchSkillsLikeDocument, options);
      }
export function useAdminSearchSkillsLikeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables>(AdminSearchSkillsLikeDocument, options);
        }
export function useAdminSearchSkillsLikeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables>(AdminSearchSkillsLikeDocument, options);
        }
export type AdminSearchSkillsLikeQueryHookResult = ReturnType<typeof useAdminSearchSkillsLikeQuery>;
export type AdminSearchSkillsLikeLazyQueryHookResult = ReturnType<typeof useAdminSearchSkillsLikeLazyQuery>;
export type AdminSearchSkillsLikeSuspenseQueryHookResult = ReturnType<typeof useAdminSearchSkillsLikeSuspenseQuery>;
export type AdminSearchSkillsLikeQueryResult = Apollo.QueryResult<AdminSearchSkillsLikeQuery, AdminSearchSkillsLikeQueryVariables>;
export const AdminCreateSkillDocument = gql`
    mutation AdminCreateSkill($skillName: String!, $categoryId: String!) {
  createSkill(skillName: $skillName, categoryId: $categoryId) {
    success
  }
}
    `;
export type AdminCreateSkillMutationFn = Apollo.MutationFunction<AdminCreateSkillMutation, AdminCreateSkillMutationVariables>;

/**
 * __useAdminCreateSkillMutation__
 *
 * To run a mutation, you first call `useAdminCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSkillMutation, { data, loading, error }] = useAdminCreateSkillMutation({
 *   variables: {
 *      skillName: // value for 'skillName'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useAdminCreateSkillMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateSkillMutation, AdminCreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSkillMutation, AdminCreateSkillMutationVariables>(AdminCreateSkillDocument, options);
      }
export type AdminCreateSkillMutationHookResult = ReturnType<typeof useAdminCreateSkillMutation>;
export type AdminCreateSkillMutationResult = Apollo.MutationResult<AdminCreateSkillMutation>;
export type AdminCreateSkillMutationOptions = Apollo.BaseMutationOptions<AdminCreateSkillMutation, AdminCreateSkillMutationVariables>;
export const AdminUpdateSkillDocument = gql`
    mutation AdminUpdateSkill($id: String!, $newSkillName: String, $related: [RelatedSkillInput!], $synonyms: [String!]) {
  updateSkill(
    id: $id
    newSkillName: $newSkillName
    related: $related
    synonyms: $synonyms
  ) {
    success
  }
}
    `;
export type AdminUpdateSkillMutationFn = Apollo.MutationFunction<AdminUpdateSkillMutation, AdminUpdateSkillMutationVariables>;

/**
 * __useAdminUpdateSkillMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSkillMutation, { data, loading, error }] = useAdminUpdateSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newSkillName: // value for 'newSkillName'
 *      related: // value for 'related'
 *      synonyms: // value for 'synonyms'
 *   },
 * });
 */
export function useAdminUpdateSkillMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSkillMutation, AdminUpdateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSkillMutation, AdminUpdateSkillMutationVariables>(AdminUpdateSkillDocument, options);
      }
export type AdminUpdateSkillMutationHookResult = ReturnType<typeof useAdminUpdateSkillMutation>;
export type AdminUpdateSkillMutationResult = Apollo.MutationResult<AdminUpdateSkillMutation>;
export type AdminUpdateSkillMutationOptions = Apollo.BaseMutationOptions<AdminUpdateSkillMutation, AdminUpdateSkillMutationVariables>;
export const AdminDeleteSkillDocument = gql`
    mutation AdminDeleteSkill($id: String!) {
  deleteSkill(id: $id) {
    success
  }
}
    `;
export type AdminDeleteSkillMutationFn = Apollo.MutationFunction<AdminDeleteSkillMutation, AdminDeleteSkillMutationVariables>;

/**
 * __useAdminDeleteSkillMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSkillMutation, { data, loading, error }] = useAdminDeleteSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteSkillMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteSkillMutation, AdminDeleteSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteSkillMutation, AdminDeleteSkillMutationVariables>(AdminDeleteSkillDocument, options);
      }
export type AdminDeleteSkillMutationHookResult = ReturnType<typeof useAdminDeleteSkillMutation>;
export type AdminDeleteSkillMutationResult = Apollo.MutationResult<AdminDeleteSkillMutation>;
export type AdminDeleteSkillMutationOptions = Apollo.BaseMutationOptions<AdminDeleteSkillMutation, AdminDeleteSkillMutationVariables>;
export const AdminStatsDocument = gql`
    query AdminStats($timeRange: TimeRange) {
  adminStats(timeRange: $timeRange) {
    jetBridge {
      ...AdminStatsFields
    }
    other {
      ...AdminStatsFields
    }
  }
}
    ${AdminStatsFieldsFragmentDoc}`;

/**
 * __useAdminStatsQuery__
 *
 * To run a query within a React component, call `useAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminStatsQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useAdminStatsQuery(baseOptions?: Apollo.QueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
      }
export function useAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
        }
export function useAdminStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminStatsQuery, AdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminStatsQuery, AdminStatsQueryVariables>(AdminStatsDocument, options);
        }
export type AdminStatsQueryHookResult = ReturnType<typeof useAdminStatsQuery>;
export type AdminStatsLazyQueryHookResult = ReturnType<typeof useAdminStatsLazyQuery>;
export type AdminStatsSuspenseQueryHookResult = ReturnType<typeof useAdminStatsSuspenseQuery>;
export type AdminStatsQueryResult = Apollo.QueryResult<AdminStatsQuery, AdminStatsQueryVariables>;
export const AdminListAllTenantsDocument = gql`
    query AdminListAllTenants($input: OffsetPagination!) {
  listAllTenants(input: $input) {
    items {
      ...Tenant
    }
    total
  }
}
    ${TenantFragmentDoc}`;

/**
 * __useAdminListAllTenantsQuery__
 *
 * To run a query within a React component, call `useAdminListAllTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListAllTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListAllTenantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminListAllTenantsQuery(baseOptions: Apollo.QueryHookOptions<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables> & ({ variables: AdminListAllTenantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables>(AdminListAllTenantsDocument, options);
      }
export function useAdminListAllTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables>(AdminListAllTenantsDocument, options);
        }
export function useAdminListAllTenantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables>(AdminListAllTenantsDocument, options);
        }
export type AdminListAllTenantsQueryHookResult = ReturnType<typeof useAdminListAllTenantsQuery>;
export type AdminListAllTenantsLazyQueryHookResult = ReturnType<typeof useAdminListAllTenantsLazyQuery>;
export type AdminListAllTenantsSuspenseQueryHookResult = ReturnType<typeof useAdminListAllTenantsSuspenseQuery>;
export type AdminListAllTenantsQueryResult = Apollo.QueryResult<AdminListAllTenantsQuery, AdminListAllTenantsQueryVariables>;
export const AdminDisableTenantDocument = gql`
    mutation AdminDisableTenant($id: String!) {
  disableTenant(id: $id) {
    ...Tenant
  }
}
    ${TenantFragmentDoc}`;
export type AdminDisableTenantMutationFn = Apollo.MutationFunction<AdminDisableTenantMutation, AdminDisableTenantMutationVariables>;

/**
 * __useAdminDisableTenantMutation__
 *
 * To run a mutation, you first call `useAdminDisableTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisableTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisableTenantMutation, { data, loading, error }] = useAdminDisableTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDisableTenantMutation(baseOptions?: Apollo.MutationHookOptions<AdminDisableTenantMutation, AdminDisableTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDisableTenantMutation, AdminDisableTenantMutationVariables>(AdminDisableTenantDocument, options);
      }
export type AdminDisableTenantMutationHookResult = ReturnType<typeof useAdminDisableTenantMutation>;
export type AdminDisableTenantMutationResult = Apollo.MutationResult<AdminDisableTenantMutation>;
export type AdminDisableTenantMutationOptions = Apollo.BaseMutationOptions<AdminDisableTenantMutation, AdminDisableTenantMutationVariables>;
export const AdminEnableTenantDocument = gql`
    mutation AdminEnableTenant($id: String!) {
  enableTenant(id: $id) {
    ...Tenant
  }
}
    ${TenantFragmentDoc}`;
export type AdminEnableTenantMutationFn = Apollo.MutationFunction<AdminEnableTenantMutation, AdminEnableTenantMutationVariables>;

/**
 * __useAdminEnableTenantMutation__
 *
 * To run a mutation, you first call `useAdminEnableTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEnableTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEnableTenantMutation, { data, loading, error }] = useAdminEnableTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminEnableTenantMutation(baseOptions?: Apollo.MutationHookOptions<AdminEnableTenantMutation, AdminEnableTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminEnableTenantMutation, AdminEnableTenantMutationVariables>(AdminEnableTenantDocument, options);
      }
export type AdminEnableTenantMutationHookResult = ReturnType<typeof useAdminEnableTenantMutation>;
export type AdminEnableTenantMutationResult = Apollo.MutationResult<AdminEnableTenantMutation>;
export type AdminEnableTenantMutationOptions = Apollo.BaseMutationOptions<AdminEnableTenantMutation, AdminEnableTenantMutationVariables>;
export const AdminListAllVacanciesDocument = gql`
    query AdminListAllVacancies($input: FilterAllVacancies!) {
  listAllVacancies(input: $input) {
    page
    total
    items {
      ...VacancyOutputFragment
      isAIGenerated
      responsibilitiesFragment
      benefitsTemplateFragment
      disclosureTemplateFragment
      elevatorPitch
    }
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useAdminListAllVacanciesQuery__
 *
 * To run a query within a React component, call `useAdminListAllVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListAllVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListAllVacanciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminListAllVacanciesQuery(baseOptions: Apollo.QueryHookOptions<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables> & ({ variables: AdminListAllVacanciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables>(AdminListAllVacanciesDocument, options);
      }
export function useAdminListAllVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables>(AdminListAllVacanciesDocument, options);
        }
export function useAdminListAllVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables>(AdminListAllVacanciesDocument, options);
        }
export type AdminListAllVacanciesQueryHookResult = ReturnType<typeof useAdminListAllVacanciesQuery>;
export type AdminListAllVacanciesLazyQueryHookResult = ReturnType<typeof useAdminListAllVacanciesLazyQuery>;
export type AdminListAllVacanciesSuspenseQueryHookResult = ReturnType<typeof useAdminListAllVacanciesSuspenseQuery>;
export type AdminListAllVacanciesQueryResult = Apollo.QueryResult<AdminListAllVacanciesQuery, AdminListAllVacanciesQueryVariables>;
export const CreateVacancyForUserDocument = gql`
    mutation CreateVacancyForUser($input: CreateVacancyForUserInput!) {
  createVacancyForUser(input: $input) {
    id
  }
}
    `;
export type CreateVacancyForUserMutationFn = Apollo.MutationFunction<CreateVacancyForUserMutation, CreateVacancyForUserMutationVariables>;

/**
 * __useCreateVacancyForUserMutation__
 *
 * To run a mutation, you first call `useCreateVacancyForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacancyForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacancyForUserMutation, { data, loading, error }] = useCreateVacancyForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVacancyForUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacancyForUserMutation, CreateVacancyForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVacancyForUserMutation, CreateVacancyForUserMutationVariables>(CreateVacancyForUserDocument, options);
      }
export type CreateVacancyForUserMutationHookResult = ReturnType<typeof useCreateVacancyForUserMutation>;
export type CreateVacancyForUserMutationResult = Apollo.MutationResult<CreateVacancyForUserMutation>;
export type CreateVacancyForUserMutationOptions = Apollo.BaseMutationOptions<CreateVacancyForUserMutation, CreateVacancyForUserMutationVariables>;
export const SaveAttributeTrainingDocument = gql`
    mutation SaveAttributeTraining($input: SaveAttributeTrainingInput!) {
  saveAttributeTraining(input: $input) {
    id
  }
}
    `;
export type SaveAttributeTrainingMutationFn = Apollo.MutationFunction<SaveAttributeTrainingMutation, SaveAttributeTrainingMutationVariables>;

/**
 * __useSaveAttributeTrainingMutation__
 *
 * To run a mutation, you first call `useSaveAttributeTrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAttributeTrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAttributeTrainingMutation, { data, loading, error }] = useSaveAttributeTrainingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAttributeTrainingMutation(baseOptions?: Apollo.MutationHookOptions<SaveAttributeTrainingMutation, SaveAttributeTrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAttributeTrainingMutation, SaveAttributeTrainingMutationVariables>(SaveAttributeTrainingDocument, options);
      }
export type SaveAttributeTrainingMutationHookResult = ReturnType<typeof useSaveAttributeTrainingMutation>;
export type SaveAttributeTrainingMutationResult = Apollo.MutationResult<SaveAttributeTrainingMutation>;
export type SaveAttributeTrainingMutationOptions = Apollo.BaseMutationOptions<SaveAttributeTrainingMutation, SaveAttributeTrainingMutationVariables>;
export const AtsSaveIntegrationCredentialsDocument = gql`
    mutation AtsSaveIntegrationCredentials($input: AtsSaveIntegrationCredentialsInput!) {
  atsSaveIntegrationCredentials(input: $input) {
    ...AtsIntegrationStatusFragment
  }
}
    ${AtsIntegrationStatusFragmentFragmentDoc}`;
export type AtsSaveIntegrationCredentialsMutationFn = Apollo.MutationFunction<AtsSaveIntegrationCredentialsMutation, AtsSaveIntegrationCredentialsMutationVariables>;

/**
 * __useAtsSaveIntegrationCredentialsMutation__
 *
 * To run a mutation, you first call `useAtsSaveIntegrationCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtsSaveIntegrationCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atsSaveIntegrationCredentialsMutation, { data, loading, error }] = useAtsSaveIntegrationCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsSaveIntegrationCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<AtsSaveIntegrationCredentialsMutation, AtsSaveIntegrationCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AtsSaveIntegrationCredentialsMutation, AtsSaveIntegrationCredentialsMutationVariables>(AtsSaveIntegrationCredentialsDocument, options);
      }
export type AtsSaveIntegrationCredentialsMutationHookResult = ReturnType<typeof useAtsSaveIntegrationCredentialsMutation>;
export type AtsSaveIntegrationCredentialsMutationResult = Apollo.MutationResult<AtsSaveIntegrationCredentialsMutation>;
export type AtsSaveIntegrationCredentialsMutationOptions = Apollo.BaseMutationOptions<AtsSaveIntegrationCredentialsMutation, AtsSaveIntegrationCredentialsMutationVariables>;
export const ListAtsStagesDocument = gql`
    query ListAtsStages {
  atsStage {
    stages {
      ...AtsStage
    }
  }
}
    ${AtsStageFragmentDoc}`;

/**
 * __useListAtsStagesQuery__
 *
 * To run a query within a React component, call `useListAtsStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAtsStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAtsStagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAtsStagesQuery(baseOptions?: Apollo.QueryHookOptions<ListAtsStagesQuery, ListAtsStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAtsStagesQuery, ListAtsStagesQueryVariables>(ListAtsStagesDocument, options);
      }
export function useListAtsStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAtsStagesQuery, ListAtsStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAtsStagesQuery, ListAtsStagesQueryVariables>(ListAtsStagesDocument, options);
        }
export function useListAtsStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAtsStagesQuery, ListAtsStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAtsStagesQuery, ListAtsStagesQueryVariables>(ListAtsStagesDocument, options);
        }
export type ListAtsStagesQueryHookResult = ReturnType<typeof useListAtsStagesQuery>;
export type ListAtsStagesLazyQueryHookResult = ReturnType<typeof useListAtsStagesLazyQuery>;
export type ListAtsStagesSuspenseQueryHookResult = ReturnType<typeof useListAtsStagesSuspenseQuery>;
export type ListAtsStagesQueryResult = Apollo.QueryResult<ListAtsStagesQuery, ListAtsStagesQueryVariables>;
export const ListAtsVacanciesDocument = gql`
    query ListAtsVacancies {
  atsVacancy {
    vacancies {
      id
      name
    }
  }
}
    `;

/**
 * __useListAtsVacanciesQuery__
 *
 * To run a query within a React component, call `useListAtsVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAtsVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAtsVacanciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAtsVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>(ListAtsVacanciesDocument, options);
      }
export function useListAtsVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>(ListAtsVacanciesDocument, options);
        }
export function useListAtsVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>(ListAtsVacanciesDocument, options);
        }
export type ListAtsVacanciesQueryHookResult = ReturnType<typeof useListAtsVacanciesQuery>;
export type ListAtsVacanciesLazyQueryHookResult = ReturnType<typeof useListAtsVacanciesLazyQuery>;
export type ListAtsVacanciesSuspenseQueryHookResult = ReturnType<typeof useListAtsVacanciesSuspenseQuery>;
export type ListAtsVacanciesQueryResult = Apollo.QueryResult<ListAtsVacanciesQuery, ListAtsVacanciesQueryVariables>;
export const ApplicationsForCandidateAndVacancyDocument = gql`
    query ApplicationsForCandidateAndVacancy($candidateId: String!, $vacancyId: String) {
  atsApplication(input: {candidateId: $candidateId, vacancyId: $vacancyId}) {
    applications {
      ...AtsApplicationFragment
    }
  }
}
    ${AtsApplicationFragmentFragmentDoc}`;

/**
 * __useApplicationsForCandidateAndVacancyQuery__
 *
 * To run a query within a React component, call `useApplicationsForCandidateAndVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsForCandidateAndVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsForCandidateAndVacancyQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useApplicationsForCandidateAndVacancyQuery(baseOptions: Apollo.QueryHookOptions<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables> & ({ variables: ApplicationsForCandidateAndVacancyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables>(ApplicationsForCandidateAndVacancyDocument, options);
      }
export function useApplicationsForCandidateAndVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables>(ApplicationsForCandidateAndVacancyDocument, options);
        }
export function useApplicationsForCandidateAndVacancySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables>(ApplicationsForCandidateAndVacancyDocument, options);
        }
export type ApplicationsForCandidateAndVacancyQueryHookResult = ReturnType<typeof useApplicationsForCandidateAndVacancyQuery>;
export type ApplicationsForCandidateAndVacancyLazyQueryHookResult = ReturnType<typeof useApplicationsForCandidateAndVacancyLazyQuery>;
export type ApplicationsForCandidateAndVacancySuspenseQueryHookResult = ReturnType<typeof useApplicationsForCandidateAndVacancySuspenseQuery>;
export type ApplicationsForCandidateAndVacancyQueryResult = Apollo.QueryResult<ApplicationsForCandidateAndVacancyQuery, ApplicationsForCandidateAndVacancyQueryVariables>;
export const AtsAddCandidateDocument = gql`
    mutation atsAddCandidate($input: AtsAddCandidateInput!) {
  atsAddCandidate(input: $input) {
    ... on AtsCandidateOutput {
      id
      firstName
      lastName
      linkedInUrl
      avatarThumbS3Key
    }
    ... on AtsAddCandidateError {
      message
    }
  }
}
    `;
export type AtsAddCandidateMutationFn = Apollo.MutationFunction<AtsAddCandidateMutation, AtsAddCandidateMutationVariables>;

/**
 * __useAtsAddCandidateMutation__
 *
 * To run a mutation, you first call `useAtsAddCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtsAddCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atsAddCandidateMutation, { data, loading, error }] = useAtsAddCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsAddCandidateMutation(baseOptions?: Apollo.MutationHookOptions<AtsAddCandidateMutation, AtsAddCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AtsAddCandidateMutation, AtsAddCandidateMutationVariables>(AtsAddCandidateDocument, options);
      }
export type AtsAddCandidateMutationHookResult = ReturnType<typeof useAtsAddCandidateMutation>;
export type AtsAddCandidateMutationResult = Apollo.MutationResult<AtsAddCandidateMutation>;
export type AtsAddCandidateMutationOptions = Apollo.BaseMutationOptions<AtsAddCandidateMutation, AtsAddCandidateMutationVariables>;
export const AtsUpdateApplicationDocument = gql`
    mutation AtsUpdateApplication($update: UpdateApplicationInput!) {
  atsUpdateApplication(update: $update) {
    ... on AtsUpdateApplicationOutput {
      application {
        id
        status
      }
    }
    ... on AtsUpdateApplicationError {
      message
    }
  }
}
    `;
export type AtsUpdateApplicationMutationFn = Apollo.MutationFunction<AtsUpdateApplicationMutation, AtsUpdateApplicationMutationVariables>;

/**
 * __useAtsUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useAtsUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtsUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atsUpdateApplicationMutation, { data, loading, error }] = useAtsUpdateApplicationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useAtsUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AtsUpdateApplicationMutation, AtsUpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AtsUpdateApplicationMutation, AtsUpdateApplicationMutationVariables>(AtsUpdateApplicationDocument, options);
      }
export type AtsUpdateApplicationMutationHookResult = ReturnType<typeof useAtsUpdateApplicationMutation>;
export type AtsUpdateApplicationMutationResult = Apollo.MutationResult<AtsUpdateApplicationMutation>;
export type AtsUpdateApplicationMutationOptions = Apollo.BaseMutationOptions<AtsUpdateApplicationMutation, AtsUpdateApplicationMutationVariables>;
export const UnauthenticateAtsIntegrationDocument = gql`
    mutation UnauthenticateAtsIntegration {
  unauthenticateAtsIntegration {
    ...AtsIntegrationStatusFragment
  }
}
    ${AtsIntegrationStatusFragmentFragmentDoc}`;
export type UnauthenticateAtsIntegrationMutationFn = Apollo.MutationFunction<UnauthenticateAtsIntegrationMutation, UnauthenticateAtsIntegrationMutationVariables>;

/**
 * __useUnauthenticateAtsIntegrationMutation__
 *
 * To run a mutation, you first call `useUnauthenticateAtsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnauthenticateAtsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unauthenticateAtsIntegrationMutation, { data, loading, error }] = useUnauthenticateAtsIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnauthenticateAtsIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UnauthenticateAtsIntegrationMutation, UnauthenticateAtsIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnauthenticateAtsIntegrationMutation, UnauthenticateAtsIntegrationMutationVariables>(UnauthenticateAtsIntegrationDocument, options);
      }
export type UnauthenticateAtsIntegrationMutationHookResult = ReturnType<typeof useUnauthenticateAtsIntegrationMutation>;
export type UnauthenticateAtsIntegrationMutationResult = Apollo.MutationResult<UnauthenticateAtsIntegrationMutation>;
export type UnauthenticateAtsIntegrationMutationOptions = Apollo.BaseMutationOptions<UnauthenticateAtsIntegrationMutation, UnauthenticateAtsIntegrationMutationVariables>;
export const GetAtsIntegrationStatusDocument = gql`
    query GetAtsIntegrationStatus {
  getAtsIntegrationStatus {
    ...AtsIntegrationStatusFragment
  }
}
    ${AtsIntegrationStatusFragmentFragmentDoc}`;

/**
 * __useGetAtsIntegrationStatusQuery__
 *
 * To run a query within a React component, call `useGetAtsIntegrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtsIntegrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtsIntegrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAtsIntegrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>(GetAtsIntegrationStatusDocument, options);
      }
export function useGetAtsIntegrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>(GetAtsIntegrationStatusDocument, options);
        }
export function useGetAtsIntegrationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>(GetAtsIntegrationStatusDocument, options);
        }
export type GetAtsIntegrationStatusQueryHookResult = ReturnType<typeof useGetAtsIntegrationStatusQuery>;
export type GetAtsIntegrationStatusLazyQueryHookResult = ReturnType<typeof useGetAtsIntegrationStatusLazyQuery>;
export type GetAtsIntegrationStatusSuspenseQueryHookResult = ReturnType<typeof useGetAtsIntegrationStatusSuspenseQuery>;
export type GetAtsIntegrationStatusQueryResult = Apollo.QueryResult<GetAtsIntegrationStatusQuery, GetAtsIntegrationStatusQueryVariables>;
export const ListAtsUsersDocument = gql`
    query ListAtsUsers {
  atsUser {
    users {
      ...AtsUser
    }
  }
}
    ${AtsUserFragmentDoc}`;

/**
 * __useListAtsUsersQuery__
 *
 * To run a query within a React component, call `useListAtsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAtsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAtsUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAtsUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAtsUsersQuery, ListAtsUsersQueryVariables>(ListAtsUsersDocument, options);
      }
export function useListAtsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAtsUsersQuery, ListAtsUsersQueryVariables>(ListAtsUsersDocument, options);
        }
export function useListAtsUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAtsUsersQuery, ListAtsUsersQueryVariables>(ListAtsUsersDocument, options);
        }
export type ListAtsUsersQueryHookResult = ReturnType<typeof useListAtsUsersQuery>;
export type ListAtsUsersLazyQueryHookResult = ReturnType<typeof useListAtsUsersLazyQuery>;
export type ListAtsUsersSuspenseQueryHookResult = ReturnType<typeof useListAtsUsersSuspenseQuery>;
export type ListAtsUsersQueryResult = Apollo.QueryResult<ListAtsUsersQuery, ListAtsUsersQueryVariables>;
export const SendCustomAtsProviderRequestDocument = gql`
    mutation SendCustomAtsProviderRequest($input: SendCustomAtsProviderRequestInput!) {
  sendCustomAtsProviderRequest(input: $input) {
    id
  }
}
    `;
export type SendCustomAtsProviderRequestMutationFn = Apollo.MutationFunction<SendCustomAtsProviderRequestMutation, SendCustomAtsProviderRequestMutationVariables>;

/**
 * __useSendCustomAtsProviderRequestMutation__
 *
 * To run a mutation, you first call `useSendCustomAtsProviderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomAtsProviderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomAtsProviderRequestMutation, { data, loading, error }] = useSendCustomAtsProviderRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCustomAtsProviderRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendCustomAtsProviderRequestMutation, SendCustomAtsProviderRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCustomAtsProviderRequestMutation, SendCustomAtsProviderRequestMutationVariables>(SendCustomAtsProviderRequestDocument, options);
      }
export type SendCustomAtsProviderRequestMutationHookResult = ReturnType<typeof useSendCustomAtsProviderRequestMutation>;
export type SendCustomAtsProviderRequestMutationResult = Apollo.MutationResult<SendCustomAtsProviderRequestMutation>;
export type SendCustomAtsProviderRequestMutationOptions = Apollo.BaseMutationOptions<SendCustomAtsProviderRequestMutation, SendCustomAtsProviderRequestMutationVariables>;
export const GetBillingStatusDocument = gql`
    query GetBillingStatus {
  getBillingStatus {
    ...BillingStatusFragment
  }
  listProducts {
    ...BillingProductFragment
  }
}
    ${BillingStatusFragmentFragmentDoc}
${BillingProductFragmentFragmentDoc}`;

/**
 * __useGetBillingStatusQuery__
 *
 * To run a query within a React component, call `useGetBillingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingStatusQuery, GetBillingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingStatusQuery, GetBillingStatusQueryVariables>(GetBillingStatusDocument, options);
      }
export function useGetBillingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingStatusQuery, GetBillingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingStatusQuery, GetBillingStatusQueryVariables>(GetBillingStatusDocument, options);
        }
export function useGetBillingStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBillingStatusQuery, GetBillingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBillingStatusQuery, GetBillingStatusQueryVariables>(GetBillingStatusDocument, options);
        }
export type GetBillingStatusQueryHookResult = ReturnType<typeof useGetBillingStatusQuery>;
export type GetBillingStatusLazyQueryHookResult = ReturnType<typeof useGetBillingStatusLazyQuery>;
export type GetBillingStatusSuspenseQueryHookResult = ReturnType<typeof useGetBillingStatusSuspenseQuery>;
export type GetBillingStatusQueryResult = Apollo.QueryResult<GetBillingStatusQuery, GetBillingStatusQueryVariables>;
export const InitiateCheckoutSessionDocument = gql`
    mutation InitiateCheckoutSession($input: InitiateCheckoutInput!) {
  initiateCheckout(session: $input) {
    startUrl
  }
}
    `;
export type InitiateCheckoutSessionMutationFn = Apollo.MutationFunction<InitiateCheckoutSessionMutation, InitiateCheckoutSessionMutationVariables>;

/**
 * __useInitiateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useInitiateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateCheckoutSessionMutation, { data, loading, error }] = useInitiateCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<InitiateCheckoutSessionMutation, InitiateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateCheckoutSessionMutation, InitiateCheckoutSessionMutationVariables>(InitiateCheckoutSessionDocument, options);
      }
export type InitiateCheckoutSessionMutationHookResult = ReturnType<typeof useInitiateCheckoutSessionMutation>;
export type InitiateCheckoutSessionMutationResult = Apollo.MutationResult<InitiateCheckoutSessionMutation>;
export type InitiateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<InitiateCheckoutSessionMutation, InitiateCheckoutSessionMutationVariables>;
export const CreateBillingPortalSessionDocument = gql`
    mutation CreateBillingPortalSession($returnUrl: String!, $flowType: FlowType) {
  createCustomerPortalSession(returnUrl: $returnUrl, flowType: $flowType) {
    redirectUrl
  }
}
    `;
export type CreateBillingPortalSessionMutationFn = Apollo.MutationFunction<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;

/**
 * __useCreateBillingPortalSessionMutation__
 *
 * To run a mutation, you first call `useCreateBillingPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingPortalSessionMutation, { data, loading, error }] = useCreateBillingPortalSessionMutation({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *      flowType: // value for 'flowType'
 *   },
 * });
 */
export function useCreateBillingPortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>(CreateBillingPortalSessionDocument, options);
      }
export type CreateBillingPortalSessionMutationHookResult = ReturnType<typeof useCreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationResult = Apollo.MutationResult<CreateBillingPortalSessionMutation>;
export type CreateBillingPortalSessionMutationOptions = Apollo.BaseMutationOptions<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const ModifySubscriptionDocument = gql`
    mutation ModifySubscription($input: ModifySubscriptionInput!) {
  modifySubscription(input: $input) {
    ...BillingStatusFragment
  }
}
    ${BillingStatusFragmentFragmentDoc}`;
export type ModifySubscriptionMutationFn = Apollo.MutationFunction<ModifySubscriptionMutation, ModifySubscriptionMutationVariables>;

/**
 * __useModifySubscriptionMutation__
 *
 * To run a mutation, you first call `useModifySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifySubscriptionMutation, { data, loading, error }] = useModifySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ModifySubscriptionMutation, ModifySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifySubscriptionMutation, ModifySubscriptionMutationVariables>(ModifySubscriptionDocument, options);
      }
export type ModifySubscriptionMutationHookResult = ReturnType<typeof useModifySubscriptionMutation>;
export type ModifySubscriptionMutationResult = Apollo.MutationResult<ModifySubscriptionMutation>;
export type ModifySubscriptionMutationOptions = Apollo.BaseMutationOptions<ModifySubscriptionMutation, ModifySubscriptionMutationVariables>;
export const BillUserForEmailLookupRevealDocument = gql`
    mutation BillUserForEmailLookupReveal($candidateId: String!) {
  billUserForEmailLookupReveal(candidateId: $candidateId) {
    isSubscriptionActive
  }
}
    `;
export type BillUserForEmailLookupRevealMutationFn = Apollo.MutationFunction<BillUserForEmailLookupRevealMutation, BillUserForEmailLookupRevealMutationVariables>;

/**
 * __useBillUserForEmailLookupRevealMutation__
 *
 * To run a mutation, you first call `useBillUserForEmailLookupRevealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillUserForEmailLookupRevealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billUserForEmailLookupRevealMutation, { data, loading, error }] = useBillUserForEmailLookupRevealMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useBillUserForEmailLookupRevealMutation(baseOptions?: Apollo.MutationHookOptions<BillUserForEmailLookupRevealMutation, BillUserForEmailLookupRevealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillUserForEmailLookupRevealMutation, BillUserForEmailLookupRevealMutationVariables>(BillUserForEmailLookupRevealDocument, options);
      }
export type BillUserForEmailLookupRevealMutationHookResult = ReturnType<typeof useBillUserForEmailLookupRevealMutation>;
export type BillUserForEmailLookupRevealMutationResult = Apollo.MutationResult<BillUserForEmailLookupRevealMutation>;
export type BillUserForEmailLookupRevealMutationOptions = Apollo.BaseMutationOptions<BillUserForEmailLookupRevealMutation, BillUserForEmailLookupRevealMutationVariables>;
export const GetCandidateDocument = gql`
    query GetCandidate($input: CandidateInput!) {
  getCandidate(input: $input) {
    id
    emailAddresses {
      ...CandidateEmailFragment
    }
    websites {
      url
      label
    }
    linkOpens {
      name
      openedAt
      location
    }
    phoneNumbers
    phoneNumbersFull {
      phoneNumber
      type
      deviceType
    }
    firstName
    lastName
    linkedInUrl
    avatarS3Bucket
    avatarThumbS3Key
    avatarThumbOrigUrl
    githubURL
    liHeadline
    liSummary
    isStudent
    country
    birthday
    source
    sourceVersion
    candidateRawId
    yearsOfExperience
    hasInterview
    atsId
    slugs
    notes
    notesFull {
      id
      content
      author {
        id
        name
      }
    }
    workExperience {
      id
      company {
        id
        name
      }
      isTopCompany
      roles {
        id
        title
        description
        start
        end
        skills {
          id
          name
        }
      }
    }
    projects {
      id
      title
      description
      skills {
        id
        name
      }
      timePeriodStartMonth
      timePeriodStartYear
      timePeriodEndMonth
      timePeriodEndYear
    }
    education {
      id
      name
      isTopSchool
      startDate
      endDate
      degree
    }
    certificates
    hasCV
    skills {
      skillName
      yearsOfExperience
    }
  }
}
    ${CandidateEmailFragmentFragmentDoc}`;

/**
 * __useGetCandidateQuery__
 *
 * To run a query within a React component, call `useGetCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables> & ({ variables: GetCandidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
      }
export function useGetCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
        }
export function useGetCandidateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
        }
export type GetCandidateQueryHookResult = ReturnType<typeof useGetCandidateQuery>;
export type GetCandidateLazyQueryHookResult = ReturnType<typeof useGetCandidateLazyQuery>;
export type GetCandidateSuspenseQueryHookResult = ReturnType<typeof useGetCandidateSuspenseQuery>;
export type GetCandidateQueryResult = Apollo.QueryResult<GetCandidateQuery, GetCandidateQueryVariables>;
export const GetCandidateProfileDocument = gql`
    query GetCandidateProfile($candidateInput: CandidateInput!) {
  getCandidateProfile(candidateInput: $candidateInput) {
    ...CandidateProfile
  }
}
    ${CandidateProfileFragmentDoc}`;

/**
 * __useGetCandidateProfileQuery__
 *
 * To run a query within a React component, call `useGetCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProfileQuery({
 *   variables: {
 *      candidateInput: // value for 'candidateInput'
 *   },
 * });
 */
export function useGetCandidateProfileQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateProfileQuery, GetCandidateProfileQueryVariables> & ({ variables: GetCandidateProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>(GetCandidateProfileDocument, options);
      }
export function useGetCandidateProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>(GetCandidateProfileDocument, options);
        }
export function useGetCandidateProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>(GetCandidateProfileDocument, options);
        }
export type GetCandidateProfileQueryHookResult = ReturnType<typeof useGetCandidateProfileQuery>;
export type GetCandidateProfileLazyQueryHookResult = ReturnType<typeof useGetCandidateProfileLazyQuery>;
export type GetCandidateProfileSuspenseQueryHookResult = ReturnType<typeof useGetCandidateProfileSuspenseQuery>;
export type GetCandidateProfileQueryResult = Apollo.QueryResult<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>;
export const OnAddEmailsToCandidateSubscriptionDocument = gql`
    subscription OnAddEmailsToCandidateSubscription($id: String!) {
  onAddEmailsToCandidate(id: $id) {
    ...ContactInfo
  }
}
    ${ContactInfoFragmentDoc}`;

/**
 * __useOnAddEmailsToCandidateSubscriptionSubscription__
 *
 * To run a query within a React component, call `useOnAddEmailsToCandidateSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAddEmailsToCandidateSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAddEmailsToCandidateSubscriptionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnAddEmailsToCandidateSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnAddEmailsToCandidateSubscriptionSubscription, OnAddEmailsToCandidateSubscriptionSubscriptionVariables> & ({ variables: OnAddEmailsToCandidateSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnAddEmailsToCandidateSubscriptionSubscription, OnAddEmailsToCandidateSubscriptionSubscriptionVariables>(OnAddEmailsToCandidateSubscriptionDocument, options);
      }
export type OnAddEmailsToCandidateSubscriptionSubscriptionHookResult = ReturnType<typeof useOnAddEmailsToCandidateSubscriptionSubscription>;
export type OnAddEmailsToCandidateSubscriptionSubscriptionResult = Apollo.SubscriptionResult<OnAddEmailsToCandidateSubscriptionSubscription>;
export const OnContactInfoAddedToCandidateDocument = gql`
    subscription OnContactInfoAddedToCandidate($id: String!) {
  onContactInfoAddedToCandidate(id: $id) {
    ...ContactInfo
  }
}
    ${ContactInfoFragmentDoc}`;

/**
 * __useOnContactInfoAddedToCandidateSubscription__
 *
 * To run a query within a React component, call `useOnContactInfoAddedToCandidateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnContactInfoAddedToCandidateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnContactInfoAddedToCandidateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnContactInfoAddedToCandidateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnContactInfoAddedToCandidateSubscription, OnContactInfoAddedToCandidateSubscriptionVariables> & ({ variables: OnContactInfoAddedToCandidateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnContactInfoAddedToCandidateSubscription, OnContactInfoAddedToCandidateSubscriptionVariables>(OnContactInfoAddedToCandidateDocument, options);
      }
export type OnContactInfoAddedToCandidateSubscriptionHookResult = ReturnType<typeof useOnContactInfoAddedToCandidateSubscription>;
export type OnContactInfoAddedToCandidateSubscriptionResult = Apollo.SubscriptionResult<OnContactInfoAddedToCandidateSubscription>;
export const AddContactInfoToCandidateDocument = gql`
    mutation AddContactInfoToCandidate($input: AddContactInfoToCandidateInput!) {
  addContactInfoToCandidate(input: $input) {
    id
    emailAddresses {
      name
      emailAddress
      type
      confidenceLevel
      preferenceWeight
    }
    phoneNumbersFull {
      phoneNumber
      type
    }
  }
}
    `;
export type AddContactInfoToCandidateMutationFn = Apollo.MutationFunction<AddContactInfoToCandidateMutation, AddContactInfoToCandidateMutationVariables>;

/**
 * __useAddContactInfoToCandidateMutation__
 *
 * To run a mutation, you first call `useAddContactInfoToCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactInfoToCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactInfoToCandidateMutation, { data, loading, error }] = useAddContactInfoToCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContactInfoToCandidateMutation(baseOptions?: Apollo.MutationHookOptions<AddContactInfoToCandidateMutation, AddContactInfoToCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactInfoToCandidateMutation, AddContactInfoToCandidateMutationVariables>(AddContactInfoToCandidateDocument, options);
      }
export type AddContactInfoToCandidateMutationHookResult = ReturnType<typeof useAddContactInfoToCandidateMutation>;
export type AddContactInfoToCandidateMutationResult = Apollo.MutationResult<AddContactInfoToCandidateMutation>;
export type AddContactInfoToCandidateMutationOptions = Apollo.BaseMutationOptions<AddContactInfoToCandidateMutation, AddContactInfoToCandidateMutationVariables>;
export const UpdateCandidateMutationDocument = gql`
    mutation UpdateCandidateMutation($candidateId: String!, $data: CandidateData!) {
  updateCandidate(candidateId: $candidateId, data: $data) {
    id
    notes
  }
}
    `;
export type UpdateCandidateMutationMutationFn = Apollo.MutationFunction<UpdateCandidateMutationMutation, UpdateCandidateMutationMutationVariables>;

/**
 * __useUpdateCandidateMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateMutationMutation, { data, loading, error }] = useUpdateCandidateMutationMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCandidateMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateMutationMutation, UpdateCandidateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateMutationMutation, UpdateCandidateMutationMutationVariables>(UpdateCandidateMutationDocument, options);
      }
export type UpdateCandidateMutationMutationHookResult = ReturnType<typeof useUpdateCandidateMutationMutation>;
export type UpdateCandidateMutationMutationResult = Apollo.MutationResult<UpdateCandidateMutationMutation>;
export type UpdateCandidateMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateMutationMutation, UpdateCandidateMutationMutationVariables>;
export const ListCandidateEmailsDocument = gql`
    query ListCandidateEmails($candidateId: String!) {
  listCandidateEmails(candidateId: $candidateId) {
    emails {
      ...CandidateEmailFragment
    }
  }
}
    ${CandidateEmailFragmentFragmentDoc}`;

/**
 * __useListCandidateEmailsQuery__
 *
 * To run a query within a React component, call `useListCandidateEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateEmailsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useListCandidateEmailsQuery(baseOptions: Apollo.QueryHookOptions<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables> & ({ variables: ListCandidateEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>(ListCandidateEmailsDocument, options);
      }
export function useListCandidateEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>(ListCandidateEmailsDocument, options);
        }
export function useListCandidateEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>(ListCandidateEmailsDocument, options);
        }
export type ListCandidateEmailsQueryHookResult = ReturnType<typeof useListCandidateEmailsQuery>;
export type ListCandidateEmailsLazyQueryHookResult = ReturnType<typeof useListCandidateEmailsLazyQuery>;
export type ListCandidateEmailsSuspenseQueryHookResult = ReturnType<typeof useListCandidateEmailsSuspenseQuery>;
export type ListCandidateEmailsQueryResult = Apollo.QueryResult<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>;
export const DeleteSlugCandidateDocument = gql`
    mutation DeleteSlugCandidate($candidateId: String!, $slug: String!) {
  removeCandidateSlug(candidateId: $candidateId, slug: $slug) {
    id
  }
}
    `;
export type DeleteSlugCandidateMutationFn = Apollo.MutationFunction<DeleteSlugCandidateMutation, DeleteSlugCandidateMutationVariables>;

/**
 * __useDeleteSlugCandidateMutation__
 *
 * To run a mutation, you first call `useDeleteSlugCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSlugCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSlugCandidateMutation, { data, loading, error }] = useDeleteSlugCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDeleteSlugCandidateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSlugCandidateMutation, DeleteSlugCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSlugCandidateMutation, DeleteSlugCandidateMutationVariables>(DeleteSlugCandidateDocument, options);
      }
export type DeleteSlugCandidateMutationHookResult = ReturnType<typeof useDeleteSlugCandidateMutation>;
export type DeleteSlugCandidateMutationResult = Apollo.MutationResult<DeleteSlugCandidateMutation>;
export type DeleteSlugCandidateMutationOptions = Apollo.BaseMutationOptions<DeleteSlugCandidateMutation, DeleteSlugCandidateMutationVariables>;
export const AddCandidateSlugDocument = gql`
    mutation AddCandidateSlug($candidateId: String!, $slug: String!) {
  addSlugToCandidate(candidateId: $candidateId, slug: $slug) {
    id
  }
}
    `;
export type AddCandidateSlugMutationFn = Apollo.MutationFunction<AddCandidateSlugMutation, AddCandidateSlugMutationVariables>;

/**
 * __useAddCandidateSlugMutation__
 *
 * To run a mutation, you first call `useAddCandidateSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateSlugMutation, { data, loading, error }] = useAddCandidateSlugMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAddCandidateSlugMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidateSlugMutation, AddCandidateSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidateSlugMutation, AddCandidateSlugMutationVariables>(AddCandidateSlugDocument, options);
      }
export type AddCandidateSlugMutationHookResult = ReturnType<typeof useAddCandidateSlugMutation>;
export type AddCandidateSlugMutationResult = Apollo.MutationResult<AddCandidateSlugMutation>;
export type AddCandidateSlugMutationOptions = Apollo.BaseMutationOptions<AddCandidateSlugMutation, AddCandidateSlugMutationVariables>;
export const CreateCandidateApplicationDocument = gql`
    mutation CreateCandidateApplication($input: [CreateCandidateApplication!]!) {
  createCandidateApplications(input: $input) {
    id
  }
}
    `;
export type CreateCandidateApplicationMutationFn = Apollo.MutationFunction<CreateCandidateApplicationMutation, CreateCandidateApplicationMutationVariables>;

/**
 * __useCreateCandidateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateCandidateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateApplicationMutation, { data, loading, error }] = useCreateCandidateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateApplicationMutation, CreateCandidateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateApplicationMutation, CreateCandidateApplicationMutationVariables>(CreateCandidateApplicationDocument, options);
      }
export type CreateCandidateApplicationMutationHookResult = ReturnType<typeof useCreateCandidateApplicationMutation>;
export type CreateCandidateApplicationMutationResult = Apollo.MutationResult<CreateCandidateApplicationMutation>;
export type CreateCandidateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateCandidateApplicationMutation, CreateCandidateApplicationMutationVariables>;
export const AddCandidateDocument = gql`
    mutation AddCandidate($source: String!, $sourceVersion: String!, $rawCandidateData: String!, $linkedInUrl: String, $sourceUrl: String) {
  addCandidate(
    rawCandidateData: $rawCandidateData
    source: $source
    linkedInUrl: $linkedInUrl
    sourceVersion: $sourceVersion
    sourceUrl: $sourceUrl
  ) {
    ...BaseCandidateInfoFragment
  }
}
    ${BaseCandidateInfoFragmentFragmentDoc}`;
export type AddCandidateMutationFn = Apollo.MutationFunction<AddCandidateMutation, AddCandidateMutationVariables>;

/**
 * __useAddCandidateMutation__
 *
 * To run a mutation, you first call `useAddCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateMutation, { data, loading, error }] = useAddCandidateMutation({
 *   variables: {
 *      source: // value for 'source'
 *      sourceVersion: // value for 'sourceVersion'
 *      rawCandidateData: // value for 'rawCandidateData'
 *      linkedInUrl: // value for 'linkedInUrl'
 *      sourceUrl: // value for 'sourceUrl'
 *   },
 * });
 */
export function useAddCandidateMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidateMutation, AddCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidateMutation, AddCandidateMutationVariables>(AddCandidateDocument, options);
      }
export type AddCandidateMutationHookResult = ReturnType<typeof useAddCandidateMutation>;
export type AddCandidateMutationResult = Apollo.MutationResult<AddCandidateMutation>;
export type AddCandidateMutationOptions = Apollo.BaseMutationOptions<AddCandidateMutation, AddCandidateMutationVariables>;
export const CreateCandidateFromExtensionDocument = gql`
    mutation CreateCandidateFromExtension($source: String!, $sourceVersion: String!, $rawCandidateData: String!, $linkedInUrl: String) {
  addCandidate(
    rawCandidateData: $rawCandidateData
    source: $source
    linkedInUrl: $linkedInUrl
    sourceVersion: $sourceVersion
  ) {
    ...BaseCandidateInfoFragment
  }
}
    ${BaseCandidateInfoFragmentFragmentDoc}`;
export type CreateCandidateFromExtensionMutationFn = Apollo.MutationFunction<CreateCandidateFromExtensionMutation, CreateCandidateFromExtensionMutationVariables>;

/**
 * __useCreateCandidateFromExtensionMutation__
 *
 * To run a mutation, you first call `useCreateCandidateFromExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateFromExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateFromExtensionMutation, { data, loading, error }] = useCreateCandidateFromExtensionMutation({
 *   variables: {
 *      source: // value for 'source'
 *      sourceVersion: // value for 'sourceVersion'
 *      rawCandidateData: // value for 'rawCandidateData'
 *      linkedInUrl: // value for 'linkedInUrl'
 *   },
 * });
 */
export function useCreateCandidateFromExtensionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateFromExtensionMutation, CreateCandidateFromExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateFromExtensionMutation, CreateCandidateFromExtensionMutationVariables>(CreateCandidateFromExtensionDocument, options);
      }
export type CreateCandidateFromExtensionMutationHookResult = ReturnType<typeof useCreateCandidateFromExtensionMutation>;
export type CreateCandidateFromExtensionMutationResult = Apollo.MutationResult<CreateCandidateFromExtensionMutation>;
export type CreateCandidateFromExtensionMutationOptions = Apollo.BaseMutationOptions<CreateCandidateFromExtensionMutation, CreateCandidateFromExtensionMutationVariables>;
export const GetCandidateExperienceDocument = gql`
    query GetCandidateExperience($input: GetCandidateExperienceInput!) {
  getCandidateExperience(input: $input) {
    skillsExperience {
      skillName
      yearsOfExperience
      isFulfilled
    }
  }
}
    `;

/**
 * __useGetCandidateExperienceQuery__
 *
 * To run a query within a React component, call `useGetCandidateExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateExperienceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateExperienceQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables> & ({ variables: GetCandidateExperienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables>(GetCandidateExperienceDocument, options);
      }
export function useGetCandidateExperienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables>(GetCandidateExperienceDocument, options);
        }
export function useGetCandidateExperienceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables>(GetCandidateExperienceDocument, options);
        }
export type GetCandidateExperienceQueryHookResult = ReturnType<typeof useGetCandidateExperienceQuery>;
export type GetCandidateExperienceLazyQueryHookResult = ReturnType<typeof useGetCandidateExperienceLazyQuery>;
export type GetCandidateExperienceSuspenseQueryHookResult = ReturnType<typeof useGetCandidateExperienceSuspenseQuery>;
export type GetCandidateExperienceQueryResult = Apollo.QueryResult<GetCandidateExperienceQuery, GetCandidateExperienceQueryVariables>;
export const GetCvDownloadLinkDocument = gql`
    query GetCvDownloadLink($candidateId: String!) {
  getCvDownloadLink(candidateId: $candidateId) {
    url
  }
}
    `;

/**
 * __useGetCvDownloadLinkQuery__
 *
 * To run a query within a React component, call `useGetCvDownloadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCvDownloadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCvDownloadLinkQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetCvDownloadLinkQuery(baseOptions: Apollo.QueryHookOptions<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables> & ({ variables: GetCvDownloadLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables>(GetCvDownloadLinkDocument, options);
      }
export function useGetCvDownloadLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables>(GetCvDownloadLinkDocument, options);
        }
export function useGetCvDownloadLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables>(GetCvDownloadLinkDocument, options);
        }
export type GetCvDownloadLinkQueryHookResult = ReturnType<typeof useGetCvDownloadLinkQuery>;
export type GetCvDownloadLinkLazyQueryHookResult = ReturnType<typeof useGetCvDownloadLinkLazyQuery>;
export type GetCvDownloadLinkSuspenseQueryHookResult = ReturnType<typeof useGetCvDownloadLinkSuspenseQuery>;
export type GetCvDownloadLinkQueryResult = Apollo.QueryResult<GetCvDownloadLinkQuery, GetCvDownloadLinkQueryVariables>;
export const AddCandidateNoteDocument = gql`
    mutation AddCandidateNote($input: AddCandidateNoteInput!) {
  addCandidateNote(input: $input) {
    id
  }
}
    `;
export type AddCandidateNoteMutationFn = Apollo.MutationFunction<AddCandidateNoteMutation, AddCandidateNoteMutationVariables>;

/**
 * __useAddCandidateNoteMutation__
 *
 * To run a mutation, you first call `useAddCandidateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateNoteMutation, { data, loading, error }] = useAddCandidateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCandidateNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidateNoteMutation, AddCandidateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidateNoteMutation, AddCandidateNoteMutationVariables>(AddCandidateNoteDocument, options);
      }
export type AddCandidateNoteMutationHookResult = ReturnType<typeof useAddCandidateNoteMutation>;
export type AddCandidateNoteMutationResult = Apollo.MutationResult<AddCandidateNoteMutation>;
export type AddCandidateNoteMutationOptions = Apollo.BaseMutationOptions<AddCandidateNoteMutation, AddCandidateNoteMutationVariables>;
export const CreateShareableLinkDocument = gql`
    mutation CreateShareableLink($input: CreateShareableLink!) {
  createShareableLink(input: $input) {
    id
    url
  }
}
    `;
export type CreateShareableLinkMutationFn = Apollo.MutationFunction<CreateShareableLinkMutation, CreateShareableLinkMutationVariables>;

/**
 * __useCreateShareableLinkMutation__
 *
 * To run a mutation, you first call `useCreateShareableLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareableLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareableLinkMutation, { data, loading, error }] = useCreateShareableLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShareableLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateShareableLinkMutation, CreateShareableLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShareableLinkMutation, CreateShareableLinkMutationVariables>(CreateShareableLinkDocument, options);
      }
export type CreateShareableLinkMutationHookResult = ReturnType<typeof useCreateShareableLinkMutation>;
export type CreateShareableLinkMutationResult = Apollo.MutationResult<CreateShareableLinkMutation>;
export type CreateShareableLinkMutationOptions = Apollo.BaseMutationOptions<CreateShareableLinkMutation, CreateShareableLinkMutationVariables>;
export const CopyShareableLinkDocument = gql`
    mutation CopyShareableLink($input: CopyShareableLinkInput!) {
  copyShareableLink(input: $input) {
    id
    url
  }
}
    `;
export type CopyShareableLinkMutationFn = Apollo.MutationFunction<CopyShareableLinkMutation, CopyShareableLinkMutationVariables>;

/**
 * __useCopyShareableLinkMutation__
 *
 * To run a mutation, you first call `useCopyShareableLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyShareableLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyShareableLinkMutation, { data, loading, error }] = useCopyShareableLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyShareableLinkMutation(baseOptions?: Apollo.MutationHookOptions<CopyShareableLinkMutation, CopyShareableLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyShareableLinkMutation, CopyShareableLinkMutationVariables>(CopyShareableLinkDocument, options);
      }
export type CopyShareableLinkMutationHookResult = ReturnType<typeof useCopyShareableLinkMutation>;
export type CopyShareableLinkMutationResult = Apollo.MutationResult<CopyShareableLinkMutation>;
export type CopyShareableLinkMutationOptions = Apollo.BaseMutationOptions<CopyShareableLinkMutation, CopyShareableLinkMutationVariables>;
export const ReIngestCandidateDocument = gql`
    mutation ReIngestCandidate($candidateId: String!) {
  reIngestCandidate(candidateId: $candidateId) {
    id
  }
}
    `;
export type ReIngestCandidateMutationFn = Apollo.MutationFunction<ReIngestCandidateMutation, ReIngestCandidateMutationVariables>;

/**
 * __useReIngestCandidateMutation__
 *
 * To run a mutation, you first call `useReIngestCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReIngestCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reIngestCandidateMutation, { data, loading, error }] = useReIngestCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useReIngestCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ReIngestCandidateMutation, ReIngestCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReIngestCandidateMutation, ReIngestCandidateMutationVariables>(ReIngestCandidateDocument, options);
      }
export type ReIngestCandidateMutationHookResult = ReturnType<typeof useReIngestCandidateMutation>;
export type ReIngestCandidateMutationResult = Apollo.MutationResult<ReIngestCandidateMutation>;
export type ReIngestCandidateMutationOptions = Apollo.BaseMutationOptions<ReIngestCandidateMutation, ReIngestCandidateMutationVariables>;
export const EditProfileChunkDocument = gql`
    mutation EditProfileChunk($input: EditProfileChunk!) {
  editProfileChunk(input: $input) {
    id
  }
}
    `;
export type EditProfileChunkMutationFn = Apollo.MutationFunction<EditProfileChunkMutation, EditProfileChunkMutationVariables>;

/**
 * __useEditProfileChunkMutation__
 *
 * To run a mutation, you first call `useEditProfileChunkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileChunkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileChunkMutation, { data, loading, error }] = useEditProfileChunkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProfileChunkMutation(baseOptions?: Apollo.MutationHookOptions<EditProfileChunkMutation, EditProfileChunkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProfileChunkMutation, EditProfileChunkMutationVariables>(EditProfileChunkDocument, options);
      }
export type EditProfileChunkMutationHookResult = ReturnType<typeof useEditProfileChunkMutation>;
export type EditProfileChunkMutationResult = Apollo.MutationResult<EditProfileChunkMutation>;
export type EditProfileChunkMutationOptions = Apollo.BaseMutationOptions<EditProfileChunkMutation, EditProfileChunkMutationVariables>;
export const UpdateShareableLinkDocument = gql`
    mutation UpdateShareableLink($input: UpdateShareableLinkInput!) {
  updateShareableLink(input: $input) {
    id
  }
}
    `;
export type UpdateShareableLinkMutationFn = Apollo.MutationFunction<UpdateShareableLinkMutation, UpdateShareableLinkMutationVariables>;

/**
 * __useUpdateShareableLinkMutation__
 *
 * To run a mutation, you first call `useUpdateShareableLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareableLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareableLinkMutation, { data, loading, error }] = useUpdateShareableLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareableLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShareableLinkMutation, UpdateShareableLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShareableLinkMutation, UpdateShareableLinkMutationVariables>(UpdateShareableLinkDocument, options);
      }
export type UpdateShareableLinkMutationHookResult = ReturnType<typeof useUpdateShareableLinkMutation>;
export type UpdateShareableLinkMutationResult = Apollo.MutationResult<UpdateShareableLinkMutation>;
export type UpdateShareableLinkMutationOptions = Apollo.BaseMutationOptions<UpdateShareableLinkMutation, UpdateShareableLinkMutationVariables>;
export const SearchCandidatesDocument = gql`
    query SearchCandidates($input: SearchCandidatesInput!) {
  searchCandidates(input: $input) {
    items {
      id
      createdAt
      lastOpenedAt
      fullName
      liHeadline
      linkedInUrl
      githubURL
      avatarThumbS3Key
      skills {
        skillName
        yearsOfExperience
      }
    }
    total
  }
}
    `;

/**
 * __useSearchCandidatesQuery__
 *
 * To run a query within a React component, call `useSearchCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCandidatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCandidatesQuery(baseOptions: Apollo.QueryHookOptions<SearchCandidatesQuery, SearchCandidatesQueryVariables> & ({ variables: SearchCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCandidatesQuery, SearchCandidatesQueryVariables>(SearchCandidatesDocument, options);
      }
export function useSearchCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCandidatesQuery, SearchCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCandidatesQuery, SearchCandidatesQueryVariables>(SearchCandidatesDocument, options);
        }
export function useSearchCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCandidatesQuery, SearchCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCandidatesQuery, SearchCandidatesQueryVariables>(SearchCandidatesDocument, options);
        }
export type SearchCandidatesQueryHookResult = ReturnType<typeof useSearchCandidatesQuery>;
export type SearchCandidatesLazyQueryHookResult = ReturnType<typeof useSearchCandidatesLazyQuery>;
export type SearchCandidatesSuspenseQueryHookResult = ReturnType<typeof useSearchCandidatesSuspenseQuery>;
export type SearchCandidatesQueryResult = Apollo.QueryResult<SearchCandidatesQuery, SearchCandidatesQueryVariables>;
export const ListCandidateCompaniesDocument = gql`
    query ListCandidateCompanies($input: SearchInput!) {
  listCandidateCompanies(input: $input) {
    companies {
      id
      name
    }
  }
}
    `;

/**
 * __useListCandidateCompaniesQuery__
 *
 * To run a query within a React component, call `useListCandidateCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidateCompaniesQuery(baseOptions: Apollo.QueryHookOptions<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables> & ({ variables: ListCandidateCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables>(ListCandidateCompaniesDocument, options);
      }
export function useListCandidateCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables>(ListCandidateCompaniesDocument, options);
        }
export function useListCandidateCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables>(ListCandidateCompaniesDocument, options);
        }
export type ListCandidateCompaniesQueryHookResult = ReturnType<typeof useListCandidateCompaniesQuery>;
export type ListCandidateCompaniesLazyQueryHookResult = ReturnType<typeof useListCandidateCompaniesLazyQuery>;
export type ListCandidateCompaniesSuspenseQueryHookResult = ReturnType<typeof useListCandidateCompaniesSuspenseQuery>;
export type ListCandidateCompaniesQueryResult = Apollo.QueryResult<ListCandidateCompaniesQuery, ListCandidateCompaniesQueryVariables>;
export const ListCandidateLocationsDocument = gql`
    query ListCandidateLocations($input: SearchInput!) {
  listCandidateLocations(input: $input) {
    locations {
      id
      name
    }
  }
}
    `;

/**
 * __useListCandidateLocationsQuery__
 *
 * To run a query within a React component, call `useListCandidateLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidateLocationsQuery(baseOptions: Apollo.QueryHookOptions<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables> & ({ variables: ListCandidateLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables>(ListCandidateLocationsDocument, options);
      }
export function useListCandidateLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables>(ListCandidateLocationsDocument, options);
        }
export function useListCandidateLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables>(ListCandidateLocationsDocument, options);
        }
export type ListCandidateLocationsQueryHookResult = ReturnType<typeof useListCandidateLocationsQuery>;
export type ListCandidateLocationsLazyQueryHookResult = ReturnType<typeof useListCandidateLocationsLazyQuery>;
export type ListCandidateLocationsSuspenseQueryHookResult = ReturnType<typeof useListCandidateLocationsSuspenseQuery>;
export type ListCandidateLocationsQueryResult = Apollo.QueryResult<ListCandidateLocationsQuery, ListCandidateLocationsQueryVariables>;
export const ListCandidateJobTitlesDocument = gql`
    query ListCandidateJobTitles($input: SearchInput!) {
  listCandidateJobTitles(input: $input) {
    jobTitles {
      id
      title
    }
  }
}
    `;

/**
 * __useListCandidateJobTitlesQuery__
 *
 * To run a query within a React component, call `useListCandidateJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateJobTitlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidateJobTitlesQuery(baseOptions: Apollo.QueryHookOptions<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables> & ({ variables: ListCandidateJobTitlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables>(ListCandidateJobTitlesDocument, options);
      }
export function useListCandidateJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables>(ListCandidateJobTitlesDocument, options);
        }
export function useListCandidateJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables>(ListCandidateJobTitlesDocument, options);
        }
export type ListCandidateJobTitlesQueryHookResult = ReturnType<typeof useListCandidateJobTitlesQuery>;
export type ListCandidateJobTitlesLazyQueryHookResult = ReturnType<typeof useListCandidateJobTitlesLazyQuery>;
export type ListCandidateJobTitlesSuspenseQueryHookResult = ReturnType<typeof useListCandidateJobTitlesSuspenseQuery>;
export type ListCandidateJobTitlesQueryResult = Apollo.QueryResult<ListCandidateJobTitlesQuery, ListCandidateJobTitlesQueryVariables>;
export const ListCandidateSchoolsDocument = gql`
    query ListCandidateSchools($input: SearchInput!) {
  listCandidateSchools(input: $input) {
    schools {
      id
      name
    }
  }
}
    `;

/**
 * __useListCandidateSchoolsQuery__
 *
 * To run a query within a React component, call `useListCandidateSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidateSchoolsQuery(baseOptions: Apollo.QueryHookOptions<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables> & ({ variables: ListCandidateSchoolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables>(ListCandidateSchoolsDocument, options);
      }
export function useListCandidateSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables>(ListCandidateSchoolsDocument, options);
        }
export function useListCandidateSchoolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables>(ListCandidateSchoolsDocument, options);
        }
export type ListCandidateSchoolsQueryHookResult = ReturnType<typeof useListCandidateSchoolsQuery>;
export type ListCandidateSchoolsLazyQueryHookResult = ReturnType<typeof useListCandidateSchoolsLazyQuery>;
export type ListCandidateSchoolsSuspenseQueryHookResult = ReturnType<typeof useListCandidateSchoolsSuspenseQuery>;
export type ListCandidateSchoolsQueryResult = Apollo.QueryResult<ListCandidateSchoolsQuery, ListCandidateSchoolsQueryVariables>;
export const RecordUserInviteDocument = gql`
    mutation RecordUserInvite($input: RecordUserInvite!) {
  recordUserInvite(input: $input) {
    id
  }
}
    `;
export type RecordUserInviteMutationFn = Apollo.MutationFunction<RecordUserInviteMutation, RecordUserInviteMutationVariables>;

/**
 * __useRecordUserInviteMutation__
 *
 * To run a mutation, you first call `useRecordUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUserInviteMutation, { data, loading, error }] = useRecordUserInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<RecordUserInviteMutation, RecordUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordUserInviteMutation, RecordUserInviteMutationVariables>(RecordUserInviteDocument, options);
      }
export type RecordUserInviteMutationHookResult = ReturnType<typeof useRecordUserInviteMutation>;
export type RecordUserInviteMutationResult = Apollo.MutationResult<RecordUserInviteMutation>;
export type RecordUserInviteMutationOptions = Apollo.BaseMutationOptions<RecordUserInviteMutation, RecordUserInviteMutationVariables>;
export const SaveCandidateSearchDocument = gql`
    mutation SaveCandidateSearch($input: SaveCandidateSearch!) {
  saveCandidateSearch(input: $input) {
    ...CandidateSearchOutput
  }
}
    ${CandidateSearchOutputFragmentDoc}`;
export type SaveCandidateSearchMutationFn = Apollo.MutationFunction<SaveCandidateSearchMutation, SaveCandidateSearchMutationVariables>;

/**
 * __useSaveCandidateSearchMutation__
 *
 * To run a mutation, you first call `useSaveCandidateSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCandidateSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCandidateSearchMutation, { data, loading, error }] = useSaveCandidateSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCandidateSearchMutation(baseOptions?: Apollo.MutationHookOptions<SaveCandidateSearchMutation, SaveCandidateSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCandidateSearchMutation, SaveCandidateSearchMutationVariables>(SaveCandidateSearchDocument, options);
      }
export type SaveCandidateSearchMutationHookResult = ReturnType<typeof useSaveCandidateSearchMutation>;
export type SaveCandidateSearchMutationResult = Apollo.MutationResult<SaveCandidateSearchMutation>;
export type SaveCandidateSearchMutationOptions = Apollo.BaseMutationOptions<SaveCandidateSearchMutation, SaveCandidateSearchMutationVariables>;
export const CandidateSearchDocument = gql`
    query CandidateSearch($input: SearchInput!) {
  candidateSearch(input: $input) {
    items {
      ...CandidateSearchOutput
    }
    total
  }
}
    ${CandidateSearchOutputFragmentDoc}`;

/**
 * __useCandidateSearchQuery__
 *
 * To run a query within a React component, call `useCandidateSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateSearchQuery(baseOptions: Apollo.QueryHookOptions<CandidateSearchQuery, CandidateSearchQueryVariables> & ({ variables: CandidateSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateSearchQuery, CandidateSearchQueryVariables>(CandidateSearchDocument, options);
      }
export function useCandidateSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateSearchQuery, CandidateSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateSearchQuery, CandidateSearchQueryVariables>(CandidateSearchDocument, options);
        }
export function useCandidateSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateSearchQuery, CandidateSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateSearchQuery, CandidateSearchQueryVariables>(CandidateSearchDocument, options);
        }
export type CandidateSearchQueryHookResult = ReturnType<typeof useCandidateSearchQuery>;
export type CandidateSearchLazyQueryHookResult = ReturnType<typeof useCandidateSearchLazyQuery>;
export type CandidateSearchSuspenseQueryHookResult = ReturnType<typeof useCandidateSearchSuspenseQuery>;
export type CandidateSearchQueryResult = Apollo.QueryResult<CandidateSearchQuery, CandidateSearchQueryVariables>;
export const UpdateCandidateSearchDocument = gql`
    mutation UpdateCandidateSearch($id: String!, $data: SaveCandidateSearch!) {
  updateCandidateSearch(id: $id, data: $data) {
    ...CandidateSearchOutput
  }
}
    ${CandidateSearchOutputFragmentDoc}`;
export type UpdateCandidateSearchMutationFn = Apollo.MutationFunction<UpdateCandidateSearchMutation, UpdateCandidateSearchMutationVariables>;

/**
 * __useUpdateCandidateSearchMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateSearchMutation, { data, loading, error }] = useUpdateCandidateSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCandidateSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateSearchMutation, UpdateCandidateSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateSearchMutation, UpdateCandidateSearchMutationVariables>(UpdateCandidateSearchDocument, options);
      }
export type UpdateCandidateSearchMutationHookResult = ReturnType<typeof useUpdateCandidateSearchMutation>;
export type UpdateCandidateSearchMutationResult = Apollo.MutationResult<UpdateCandidateSearchMutation>;
export type UpdateCandidateSearchMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateSearchMutation, UpdateCandidateSearchMutationVariables>;
export const DeleteCandidateSearchDocument = gql`
    mutation DeleteCandidateSearch($id: String!) {
  deleteCandidateSearch(id: $id) {
    id
  }
}
    `;
export type DeleteCandidateSearchMutationFn = Apollo.MutationFunction<DeleteCandidateSearchMutation, DeleteCandidateSearchMutationVariables>;

/**
 * __useDeleteCandidateSearchMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateSearchMutation, { data, loading, error }] = useDeleteCandidateSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCandidateSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateSearchMutation, DeleteCandidateSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateSearchMutation, DeleteCandidateSearchMutationVariables>(DeleteCandidateSearchDocument, options);
      }
export type DeleteCandidateSearchMutationHookResult = ReturnType<typeof useDeleteCandidateSearchMutation>;
export type DeleteCandidateSearchMutationResult = Apollo.MutationResult<DeleteCandidateSearchMutation>;
export type DeleteCandidateSearchMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateSearchMutation, DeleteCandidateSearchMutationVariables>;
export const CandidateContactHistoryDocument = gql`
    query CandidateContactHistory($candidateId: String!, $pagination: OffsetPagination!) {
  candidateContactHistory(candidateId: $candidateId, pagination: $pagination) {
    items {
      resourceId
      type
      user {
        id
        name
      }
      placedAt
      emailDetails {
        subject
        content
      }
      smsDetails {
        content
      }
      callDetails {
        callDuration
      }
    }
    total
  }
}
    `;

/**
 * __useCandidateContactHistoryQuery__
 *
 * To run a query within a React component, call `useCandidateContactHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateContactHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateContactHistoryQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCandidateContactHistoryQuery(baseOptions: Apollo.QueryHookOptions<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables> & ({ variables: CandidateContactHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables>(CandidateContactHistoryDocument, options);
      }
export function useCandidateContactHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables>(CandidateContactHistoryDocument, options);
        }
export function useCandidateContactHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables>(CandidateContactHistoryDocument, options);
        }
export type CandidateContactHistoryQueryHookResult = ReturnType<typeof useCandidateContactHistoryQuery>;
export type CandidateContactHistoryLazyQueryHookResult = ReturnType<typeof useCandidateContactHistoryLazyQuery>;
export type CandidateContactHistorySuspenseQueryHookResult = ReturnType<typeof useCandidateContactHistorySuspenseQuery>;
export type CandidateContactHistoryQueryResult = Apollo.QueryResult<CandidateContactHistoryQuery, CandidateContactHistoryQueryVariables>;
export const GetShadowProfileDocument = gql`
    query GetShadowProfile($shareableLinkId: String!) {
  getShadowProfile(shareableLinkId: $shareableLinkId) {
    title
    logo {
      s3Bucket
      s3Key
    }
    isObfuscated
    ctaTitle
    ctaUrl
    feedbackChatId
    profile {
      id
      websites {
        url
        label
      }
      firstName
      lastName
      avatarS3Bucket
      avatarThumbS3Key
      avatarThumbOrigUrl
      liHeadline
      liSummary
      isStudent
      country
      yearsOfExperience
      workExperience {
        id
        company {
          id
          name
        }
        isTopCompany
        roles {
          id
          title
          description
          start
          end
          skills {
            id
            name
          }
        }
      }
      projects {
        id
        title
        description
        skills {
          id
          name
        }
        timePeriodStartMonth
        timePeriodStartYear
        timePeriodEndMonth
        timePeriodEndYear
      }
      education {
        id
        name
        isTopSchool
        startDate
        endDate
        degree
      }
      certificates
      skills {
        skillName
        yearsOfExperience
      }
    }
  }
}
    `;

/**
 * __useGetShadowProfileQuery__
 *
 * To run a query within a React component, call `useGetShadowProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShadowProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShadowProfileQuery({
 *   variables: {
 *      shareableLinkId: // value for 'shareableLinkId'
 *   },
 * });
 */
export function useGetShadowProfileQuery(baseOptions: Apollo.QueryHookOptions<GetShadowProfileQuery, GetShadowProfileQueryVariables> & ({ variables: GetShadowProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShadowProfileQuery, GetShadowProfileQueryVariables>(GetShadowProfileDocument, options);
      }
export function useGetShadowProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShadowProfileQuery, GetShadowProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShadowProfileQuery, GetShadowProfileQueryVariables>(GetShadowProfileDocument, options);
        }
export function useGetShadowProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShadowProfileQuery, GetShadowProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShadowProfileQuery, GetShadowProfileQueryVariables>(GetShadowProfileDocument, options);
        }
export type GetShadowProfileQueryHookResult = ReturnType<typeof useGetShadowProfileQuery>;
export type GetShadowProfileLazyQueryHookResult = ReturnType<typeof useGetShadowProfileLazyQuery>;
export type GetShadowProfileSuspenseQueryHookResult = ReturnType<typeof useGetShadowProfileSuspenseQuery>;
export type GetShadowProfileQueryResult = Apollo.QueryResult<GetShadowProfileQuery, GetShadowProfileQueryVariables>;
export const CreateCandidateFeedbackChatDocument = gql`
    mutation CreateCandidateFeedbackChat($shareableLinkId: String!, $comment: String!) {
  createCandidateFeedbackChat(
    shareableLinkId: $shareableLinkId
    comment: $comment
  ) {
    id
    aiReplyTaskId
  }
}
    `;
export type CreateCandidateFeedbackChatMutationFn = Apollo.MutationFunction<CreateCandidateFeedbackChatMutation, CreateCandidateFeedbackChatMutationVariables>;

/**
 * __useCreateCandidateFeedbackChatMutation__
 *
 * To run a mutation, you first call `useCreateCandidateFeedbackChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateFeedbackChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateFeedbackChatMutation, { data, loading, error }] = useCreateCandidateFeedbackChatMutation({
 *   variables: {
 *      shareableLinkId: // value for 'shareableLinkId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateCandidateFeedbackChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateFeedbackChatMutation, CreateCandidateFeedbackChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateFeedbackChatMutation, CreateCandidateFeedbackChatMutationVariables>(CreateCandidateFeedbackChatDocument, options);
      }
export type CreateCandidateFeedbackChatMutationHookResult = ReturnType<typeof useCreateCandidateFeedbackChatMutation>;
export type CreateCandidateFeedbackChatMutationResult = Apollo.MutationResult<CreateCandidateFeedbackChatMutation>;
export type CreateCandidateFeedbackChatMutationOptions = Apollo.BaseMutationOptions<CreateCandidateFeedbackChatMutation, CreateCandidateFeedbackChatMutationVariables>;
export const OnCandidateUpdatedDocument = gql`
    subscription OnCandidateUpdated($candidateId: String!) {
  onCandidateUpdated(candidateId: $candidateId) {
    candidateId
    mergedToCandidateId
  }
}
    `;

/**
 * __useOnCandidateUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnCandidateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCandidateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCandidateUpdatedSubscription({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useOnCandidateUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCandidateUpdatedSubscription, OnCandidateUpdatedSubscriptionVariables> & ({ variables: OnCandidateUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCandidateUpdatedSubscription, OnCandidateUpdatedSubscriptionVariables>(OnCandidateUpdatedDocument, options);
      }
export type OnCandidateUpdatedSubscriptionHookResult = ReturnType<typeof useOnCandidateUpdatedSubscription>;
export type OnCandidateUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnCandidateUpdatedSubscription>;
export const CandidateUpdatedDocument = gql`
    mutation candidateUpdated($candidateId: String!, $mergedToCandidateId: String) {
  candidateUpdated(
    candidateId: $candidateId
    mergedToCandidateId: $mergedToCandidateId
  ) {
    candidateId
    mergedToCandidateId
  }
}
    `;
export type CandidateUpdatedMutationFn = Apollo.MutationFunction<CandidateUpdatedMutation, CandidateUpdatedMutationVariables>;

/**
 * __useCandidateUpdatedMutation__
 *
 * To run a mutation, you first call `useCandidateUpdatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateUpdatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateUpdatedMutation, { data, loading, error }] = useCandidateUpdatedMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      mergedToCandidateId: // value for 'mergedToCandidateId'
 *   },
 * });
 */
export function useCandidateUpdatedMutation(baseOptions?: Apollo.MutationHookOptions<CandidateUpdatedMutation, CandidateUpdatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateUpdatedMutation, CandidateUpdatedMutationVariables>(CandidateUpdatedDocument, options);
      }
export type CandidateUpdatedMutationHookResult = ReturnType<typeof useCandidateUpdatedMutation>;
export type CandidateUpdatedMutationResult = Apollo.MutationResult<CandidateUpdatedMutation>;
export type CandidateUpdatedMutationOptions = Apollo.BaseMutationOptions<CandidateUpdatedMutation, CandidateUpdatedMutationVariables>;
export const CreateCandidateApplicationsDocument = gql`
    mutation CreateCandidateApplications($input: [CreateCandidateApplication!]!) {
  createCandidateApplications(input: $input) {
    id
  }
}
    `;
export type CreateCandidateApplicationsMutationFn = Apollo.MutationFunction<CreateCandidateApplicationsMutation, CreateCandidateApplicationsMutationVariables>;

/**
 * __useCreateCandidateApplicationsMutation__
 *
 * To run a mutation, you first call `useCreateCandidateApplicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateApplicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateApplicationsMutation, { data, loading, error }] = useCreateCandidateApplicationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateApplicationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateApplicationsMutation, CreateCandidateApplicationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateApplicationsMutation, CreateCandidateApplicationsMutationVariables>(CreateCandidateApplicationsDocument, options);
      }
export type CreateCandidateApplicationsMutationHookResult = ReturnType<typeof useCreateCandidateApplicationsMutation>;
export type CreateCandidateApplicationsMutationResult = Apollo.MutationResult<CreateCandidateApplicationsMutation>;
export type CreateCandidateApplicationsMutationOptions = Apollo.BaseMutationOptions<CreateCandidateApplicationsMutation, CreateCandidateApplicationsMutationVariables>;
export const InterviewCandidateProfileQueryDocument = gql`
    query InterviewCandidateProfileQuery($candidateId: String!) {
  listCandidateInterviews(candidateId: $candidateId) {
    SOFT_SKILLS {
      ...CandidateInterviewFragment
    }
    TECHNICAL {
      ...CandidateInterviewFragment
    }
  }
  getCandidate(input: {id: $candidateId}) {
    id
    firstName
    lastName
    avatarThumbS3Key
    linkedInUrl
    phoneNumbers
    emailAddresses {
      emailAddress
      type
    }
    slugs
    birthday
    githubURL
    websites {
      url
      label
    }
  }
}
    ${CandidateInterviewFragmentFragmentDoc}`;

/**
 * __useInterviewCandidateProfileQueryQuery__
 *
 * To run a query within a React component, call `useInterviewCandidateProfileQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewCandidateProfileQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewCandidateProfileQueryQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useInterviewCandidateProfileQueryQuery(baseOptions: Apollo.QueryHookOptions<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables> & ({ variables: InterviewCandidateProfileQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables>(InterviewCandidateProfileQueryDocument, options);
      }
export function useInterviewCandidateProfileQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables>(InterviewCandidateProfileQueryDocument, options);
        }
export function useInterviewCandidateProfileQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables>(InterviewCandidateProfileQueryDocument, options);
        }
export type InterviewCandidateProfileQueryQueryHookResult = ReturnType<typeof useInterviewCandidateProfileQueryQuery>;
export type InterviewCandidateProfileQueryLazyQueryHookResult = ReturnType<typeof useInterviewCandidateProfileQueryLazyQuery>;
export type InterviewCandidateProfileQuerySuspenseQueryHookResult = ReturnType<typeof useInterviewCandidateProfileQuerySuspenseQuery>;
export type InterviewCandidateProfileQueryQueryResult = Apollo.QueryResult<InterviewCandidateProfileQueryQuery, InterviewCandidateProfileQueryQueryVariables>;
export const UpdateCandidateInterviewSectionsDocument = gql`
    mutation UpdateCandidateInterviewSections($data: CandidateInterviewSectionsInput!) {
  updateCandidateInterviewSections(data: $data) {
    ...CandidateInterviewFragment
  }
}
    ${CandidateInterviewFragmentFragmentDoc}`;
export type UpdateCandidateInterviewSectionsMutationFn = Apollo.MutationFunction<UpdateCandidateInterviewSectionsMutation, UpdateCandidateInterviewSectionsMutationVariables>;

/**
 * __useUpdateCandidateInterviewSectionsMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateInterviewSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateInterviewSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateInterviewSectionsMutation, { data, loading, error }] = useUpdateCandidateInterviewSectionsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCandidateInterviewSectionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateInterviewSectionsMutation, UpdateCandidateInterviewSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateInterviewSectionsMutation, UpdateCandidateInterviewSectionsMutationVariables>(UpdateCandidateInterviewSectionsDocument, options);
      }
export type UpdateCandidateInterviewSectionsMutationHookResult = ReturnType<typeof useUpdateCandidateInterviewSectionsMutation>;
export type UpdateCandidateInterviewSectionsMutationResult = Apollo.MutationResult<UpdateCandidateInterviewSectionsMutation>;
export type UpdateCandidateInterviewSectionsMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateInterviewSectionsMutation, UpdateCandidateInterviewSectionsMutationVariables>;
export const AddCandidateFormResponseDocument = gql`
    mutation AddCandidateFormResponse($data: [CandidateFormResponseInput!]!, $sections: [String!]!, $type: InterviewType!) {
  addCandidateFormResponse(data: $data, sections: $sections, type: $type) {
    id
    FormQuestion {
      ...FormQuestionFragment
    }
    Candidate {
      id
    }
    User {
      id
    }
    responseValue
  }
}
    ${FormQuestionFragmentFragmentDoc}`;
export type AddCandidateFormResponseMutationFn = Apollo.MutationFunction<AddCandidateFormResponseMutation, AddCandidateFormResponseMutationVariables>;

/**
 * __useAddCandidateFormResponseMutation__
 *
 * To run a mutation, you first call `useAddCandidateFormResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateFormResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateFormResponseMutation, { data, loading, error }] = useAddCandidateFormResponseMutation({
 *   variables: {
 *      data: // value for 'data'
 *      sections: // value for 'sections'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddCandidateFormResponseMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidateFormResponseMutation, AddCandidateFormResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidateFormResponseMutation, AddCandidateFormResponseMutationVariables>(AddCandidateFormResponseDocument, options);
      }
export type AddCandidateFormResponseMutationHookResult = ReturnType<typeof useAddCandidateFormResponseMutation>;
export type AddCandidateFormResponseMutationResult = Apollo.MutationResult<AddCandidateFormResponseMutation>;
export type AddCandidateFormResponseMutationOptions = Apollo.BaseMutationOptions<AddCandidateFormResponseMutation, AddCandidateFormResponseMutationVariables>;
export const GetCandidateListExportDocument = gql`
    query GetCandidateListExport($listId: String!) {
  getCandidateListExport(listId: $listId) {
    csvUrl
  }
}
    `;

/**
 * __useGetCandidateListExportQuery__
 *
 * To run a query within a React component, call `useGetCandidateListExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateListExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateListExportQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetCandidateListExportQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateListExportQuery, GetCandidateListExportQueryVariables> & ({ variables: GetCandidateListExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateListExportQuery, GetCandidateListExportQueryVariables>(GetCandidateListExportDocument, options);
      }
export function useGetCandidateListExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateListExportQuery, GetCandidateListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateListExportQuery, GetCandidateListExportQueryVariables>(GetCandidateListExportDocument, options);
        }
export function useGetCandidateListExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateListExportQuery, GetCandidateListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateListExportQuery, GetCandidateListExportQueryVariables>(GetCandidateListExportDocument, options);
        }
export type GetCandidateListExportQueryHookResult = ReturnType<typeof useGetCandidateListExportQuery>;
export type GetCandidateListExportLazyQueryHookResult = ReturnType<typeof useGetCandidateListExportLazyQuery>;
export type GetCandidateListExportSuspenseQueryHookResult = ReturnType<typeof useGetCandidateListExportSuspenseQuery>;
export type GetCandidateListExportQueryResult = Apollo.QueryResult<GetCandidateListExportQuery, GetCandidateListExportQueryVariables>;
export const ListTopMatchesDocument = gql`
    query ListTopMatches($candidateId: String!, $take: Int!) {
  listTopCandidateVacancyMatches(candidateId: $candidateId, take: $take) {
    candidateId
    vacancy {
      id
      name
      clientName
    }
    match {
      match
    }
  }
}
    `;

/**
 * __useListTopMatchesQuery__
 *
 * To run a query within a React component, call `useListTopMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTopMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTopMatchesQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useListTopMatchesQuery(baseOptions: Apollo.QueryHookOptions<ListTopMatchesQuery, ListTopMatchesQueryVariables> & ({ variables: ListTopMatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTopMatchesQuery, ListTopMatchesQueryVariables>(ListTopMatchesDocument, options);
      }
export function useListTopMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTopMatchesQuery, ListTopMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTopMatchesQuery, ListTopMatchesQueryVariables>(ListTopMatchesDocument, options);
        }
export function useListTopMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTopMatchesQuery, ListTopMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTopMatchesQuery, ListTopMatchesQueryVariables>(ListTopMatchesDocument, options);
        }
export type ListTopMatchesQueryHookResult = ReturnType<typeof useListTopMatchesQuery>;
export type ListTopMatchesLazyQueryHookResult = ReturnType<typeof useListTopMatchesLazyQuery>;
export type ListTopMatchesSuspenseQueryHookResult = ReturnType<typeof useListTopMatchesSuspenseQuery>;
export type ListTopMatchesQueryResult = Apollo.QueryResult<ListTopMatchesQuery, ListTopMatchesQueryVariables>;
export const GetCandidateVacancyMatchWithExperienceDocument = gql`
    query GetCandidateVacancyMatchWithExperience($candidateId: String!, $vacancyId: String!) {
  getCandidateVacancyMatch(
    candidateId: $candidateId
    vacancyId: $vacancyId
    markAsViewed: true
  ) {
    vacancy {
      ...VacancyOutputFragment
    }
    match {
      match
      adjustedMatch
      mustHaveMatch {
        skills {
          match
          name
          matchType
        }
      }
      niceToHaveMatch {
        skills {
          match
          matchType
          name
        }
      }
    }
  }
  getCandidateExperience(
    input: {candidateId: $candidateId, vacancyId: $vacancyId}
  ) {
    skillsExperience {
      skillName
      yearsOfExperience
      isFulfilled
    }
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useGetCandidateVacancyMatchWithExperienceQuery__
 *
 * To run a query within a React component, call `useGetCandidateVacancyMatchWithExperienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateVacancyMatchWithExperienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateVacancyMatchWithExperienceQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useGetCandidateVacancyMatchWithExperienceQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables> & ({ variables: GetCandidateVacancyMatchWithExperienceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables>(GetCandidateVacancyMatchWithExperienceDocument, options);
      }
export function useGetCandidateVacancyMatchWithExperienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables>(GetCandidateVacancyMatchWithExperienceDocument, options);
        }
export function useGetCandidateVacancyMatchWithExperienceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables>(GetCandidateVacancyMatchWithExperienceDocument, options);
        }
export type GetCandidateVacancyMatchWithExperienceQueryHookResult = ReturnType<typeof useGetCandidateVacancyMatchWithExperienceQuery>;
export type GetCandidateVacancyMatchWithExperienceLazyQueryHookResult = ReturnType<typeof useGetCandidateVacancyMatchWithExperienceLazyQuery>;
export type GetCandidateVacancyMatchWithExperienceSuspenseQueryHookResult = ReturnType<typeof useGetCandidateVacancyMatchWithExperienceSuspenseQuery>;
export type GetCandidateVacancyMatchWithExperienceQueryResult = Apollo.QueryResult<GetCandidateVacancyMatchWithExperienceQuery, GetCandidateVacancyMatchWithExperienceQueryVariables>;
export const GetCandidateVacancyMatchDocument = gql`
    query GetCandidateVacancyMatch($candidateId: String!, $vacancyId: String!, $candidateRawId: String, $markAsViewed: Boolean, $algorithm: CandidateMatchAlgorithm) {
  getCandidateVacancyMatch(
    candidateId: $candidateId
    vacancyId: $vacancyId
    candidateRawId: $candidateRawId
    markAsViewed: $markAsViewed
    algorithm: $algorithm
  ) {
    vacancy {
      id
      name
    }
    match {
      match
      explanation
      adjustedMatch
      mustHaveMatch {
        skills {
          match
          name
          matchType
        }
      }
      niceToHaveMatch {
        skills {
          match
          matchType
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCandidateVacancyMatchQuery__
 *
 * To run a query within a React component, call `useGetCandidateVacancyMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateVacancyMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateVacancyMatchQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      vacancyId: // value for 'vacancyId'
 *      candidateRawId: // value for 'candidateRawId'
 *      markAsViewed: // value for 'markAsViewed'
 *      algorithm: // value for 'algorithm'
 *   },
 * });
 */
export function useGetCandidateVacancyMatchQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables> & ({ variables: GetCandidateVacancyMatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables>(GetCandidateVacancyMatchDocument, options);
      }
export function useGetCandidateVacancyMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables>(GetCandidateVacancyMatchDocument, options);
        }
export function useGetCandidateVacancyMatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables>(GetCandidateVacancyMatchDocument, options);
        }
export type GetCandidateVacancyMatchQueryHookResult = ReturnType<typeof useGetCandidateVacancyMatchQuery>;
export type GetCandidateVacancyMatchLazyQueryHookResult = ReturnType<typeof useGetCandidateVacancyMatchLazyQuery>;
export type GetCandidateVacancyMatchSuspenseQueryHookResult = ReturnType<typeof useGetCandidateVacancyMatchSuspenseQuery>;
export type GetCandidateVacancyMatchQueryResult = Apollo.QueryResult<GetCandidateVacancyMatchQuery, GetCandidateVacancyMatchQueryVariables>;
export const NewCandidateMatchDocument = gql`
    subscription NewCandidateMatch($candidateId: String!) {
  newCandidateMatch(candidateId: $candidateId) {
    id
    candidateId
    vacancyId
    clientId
    match
    adjustedMatch
  }
}
    `;

/**
 * __useNewCandidateMatchSubscription__
 *
 * To run a query within a React component, call `useNewCandidateMatchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewCandidateMatchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewCandidateMatchSubscription({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useNewCandidateMatchSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewCandidateMatchSubscription, NewCandidateMatchSubscriptionVariables> & ({ variables: NewCandidateMatchSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewCandidateMatchSubscription, NewCandidateMatchSubscriptionVariables>(NewCandidateMatchDocument, options);
      }
export type NewCandidateMatchSubscriptionHookResult = ReturnType<typeof useNewCandidateMatchSubscription>;
export type NewCandidateMatchSubscriptionResult = Apollo.SubscriptionResult<NewCandidateMatchSubscription>;
export const NewVacancyMatchDocument = gql`
    subscription NewVacancyMatch($vacancyId: String!) {
  newVacancyMatch(vacancyId: $vacancyId) {
    id
    candidateId
    vacancyId
    clientId
    match
    adjustedMatch
  }
}
    `;

/**
 * __useNewVacancyMatchSubscription__
 *
 * To run a query within a React component, call `useNewVacancyMatchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewVacancyMatchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewVacancyMatchSubscription({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useNewVacancyMatchSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewVacancyMatchSubscription, NewVacancyMatchSubscriptionVariables> & ({ variables: NewVacancyMatchSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewVacancyMatchSubscription, NewVacancyMatchSubscriptionVariables>(NewVacancyMatchDocument, options);
      }
export type NewVacancyMatchSubscriptionHookResult = ReturnType<typeof useNewVacancyMatchSubscription>;
export type NewVacancyMatchSubscriptionResult = Apollo.SubscriptionResult<NewVacancyMatchSubscription>;
export const SearchCertificatesDocument = gql`
    query SearchCertificates($input: SearchInput!) {
  searchCertificates(input: $input) {
    items {
      name
      id
    }
    total
    page
  }
}
    `;

/**
 * __useSearchCertificatesQuery__
 *
 * To run a query within a React component, call `useSearchCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCertificatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCertificatesQuery(baseOptions: Apollo.QueryHookOptions<SearchCertificatesQuery, SearchCertificatesQueryVariables> & ({ variables: SearchCertificatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCertificatesQuery, SearchCertificatesQueryVariables>(SearchCertificatesDocument, options);
      }
export function useSearchCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCertificatesQuery, SearchCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCertificatesQuery, SearchCertificatesQueryVariables>(SearchCertificatesDocument, options);
        }
export function useSearchCertificatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCertificatesQuery, SearchCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCertificatesQuery, SearchCertificatesQueryVariables>(SearchCertificatesDocument, options);
        }
export type SearchCertificatesQueryHookResult = ReturnType<typeof useSearchCertificatesQuery>;
export type SearchCertificatesLazyQueryHookResult = ReturnType<typeof useSearchCertificatesLazyQuery>;
export type SearchCertificatesSuspenseQueryHookResult = ReturnType<typeof useSearchCertificatesSuspenseQuery>;
export type SearchCertificatesQueryResult = Apollo.QueryResult<SearchCertificatesQuery, SearchCertificatesQueryVariables>;
export const MessageVoteDocument = gql`
    mutation MessageVote($input: MessageVoteInput!) {
  voteOnMessage(input: $input) {
    ...ChatMessageFields
  }
}
    ${ChatMessageFieldsFragmentDoc}`;
export type MessageVoteMutationFn = Apollo.MutationFunction<MessageVoteMutation, MessageVoteMutationVariables>;

/**
 * __useMessageVoteMutation__
 *
 * To run a mutation, you first call `useMessageVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageVoteMutation, { data, loading, error }] = useMessageVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageVoteMutation(baseOptions?: Apollo.MutationHookOptions<MessageVoteMutation, MessageVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MessageVoteMutation, MessageVoteMutationVariables>(MessageVoteDocument, options);
      }
export type MessageVoteMutationHookResult = ReturnType<typeof useMessageVoteMutation>;
export type MessageVoteMutationResult = Apollo.MutationResult<MessageVoteMutation>;
export type MessageVoteMutationOptions = Apollo.BaseMutationOptions<MessageVoteMutation, MessageVoteMutationVariables>;
export const SendAiChatMessageDocument = gql`
    mutation SendAiChatMessage($input: SendChatMessageInput!) {
  sendChatMessage(input: $input) {
    chatId
    taskId
  }
}
    `;
export type SendAiChatMessageMutationFn = Apollo.MutationFunction<SendAiChatMessageMutation, SendAiChatMessageMutationVariables>;

/**
 * __useSendAiChatMessageMutation__
 *
 * To run a mutation, you first call `useSendAiChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAiChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAiChatMessageMutation, { data, loading, error }] = useSendAiChatMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAiChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendAiChatMessageMutation, SendAiChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAiChatMessageMutation, SendAiChatMessageMutationVariables>(SendAiChatMessageDocument, options);
      }
export type SendAiChatMessageMutationHookResult = ReturnType<typeof useSendAiChatMessageMutation>;
export type SendAiChatMessageMutationResult = Apollo.MutationResult<SendAiChatMessageMutation>;
export type SendAiChatMessageMutationOptions = Apollo.BaseMutationOptions<SendAiChatMessageMutation, SendAiChatMessageMutationVariables>;
export const GetChatDocument = gql`
    query GetChat($chatId: String!) {
  getChat(chatId: $chatId) {
    chatId
    rows {
      ...ChatMessageFields
    }
    vacancy {
      ...VacancySummary
    }
  }
}
    ${ChatMessageFieldsFragmentDoc}
${VacancySummaryFragmentDoc}`;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables> & ({ variables: GetChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export function useGetChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatSuspenseQueryHookResult = ReturnType<typeof useGetChatSuspenseQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQuery, GetChatQueryVariables>;
export const ListAiPromptsDocument = gql`
    query ListAiPrompts($input: ListAiPromptsInput!) {
  listAiPrompts(input: $input) {
    items {
      ...AiPrompt
    }
    total
  }
}
    ${AiPromptFragmentDoc}`;

/**
 * __useListAiPromptsQuery__
 *
 * To run a query within a React component, call `useListAiPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAiPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAiPromptsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListAiPromptsQuery(baseOptions: Apollo.QueryHookOptions<ListAiPromptsQuery, ListAiPromptsQueryVariables> & ({ variables: ListAiPromptsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAiPromptsQuery, ListAiPromptsQueryVariables>(ListAiPromptsDocument, options);
      }
export function useListAiPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAiPromptsQuery, ListAiPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAiPromptsQuery, ListAiPromptsQueryVariables>(ListAiPromptsDocument, options);
        }
export function useListAiPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAiPromptsQuery, ListAiPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAiPromptsQuery, ListAiPromptsQueryVariables>(ListAiPromptsDocument, options);
        }
export type ListAiPromptsQueryHookResult = ReturnType<typeof useListAiPromptsQuery>;
export type ListAiPromptsLazyQueryHookResult = ReturnType<typeof useListAiPromptsLazyQuery>;
export type ListAiPromptsSuspenseQueryHookResult = ReturnType<typeof useListAiPromptsSuspenseQuery>;
export type ListAiPromptsQueryResult = Apollo.QueryResult<ListAiPromptsQuery, ListAiPromptsQueryVariables>;
export const AddAiPromptDocument = gql`
    mutation AddAiPrompt($input: AiPromptInput!) {
  addAiPrompt(input: $input) {
    ...AiPrompt
  }
}
    ${AiPromptFragmentDoc}`;
export type AddAiPromptMutationFn = Apollo.MutationFunction<AddAiPromptMutation, AddAiPromptMutationVariables>;

/**
 * __useAddAiPromptMutation__
 *
 * To run a mutation, you first call `useAddAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiPromptMutation, { data, loading, error }] = useAddAiPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<AddAiPromptMutation, AddAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAiPromptMutation, AddAiPromptMutationVariables>(AddAiPromptDocument, options);
      }
export type AddAiPromptMutationHookResult = ReturnType<typeof useAddAiPromptMutation>;
export type AddAiPromptMutationResult = Apollo.MutationResult<AddAiPromptMutation>;
export type AddAiPromptMutationOptions = Apollo.BaseMutationOptions<AddAiPromptMutation, AddAiPromptMutationVariables>;
export const DeleteAiPromptDocument = gql`
    mutation DeleteAiPrompt($id: String!) {
  deleteAiPrompt(id: $id) {
    id
  }
}
    `;
export type DeleteAiPromptMutationFn = Apollo.MutationFunction<DeleteAiPromptMutation, DeleteAiPromptMutationVariables>;

/**
 * __useDeleteAiPromptMutation__
 *
 * To run a mutation, you first call `useDeleteAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiPromptMutation, { data, loading, error }] = useDeleteAiPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAiPromptMutation, DeleteAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAiPromptMutation, DeleteAiPromptMutationVariables>(DeleteAiPromptDocument, options);
      }
export type DeleteAiPromptMutationHookResult = ReturnType<typeof useDeleteAiPromptMutation>;
export type DeleteAiPromptMutationResult = Apollo.MutationResult<DeleteAiPromptMutation>;
export type DeleteAiPromptMutationOptions = Apollo.BaseMutationOptions<DeleteAiPromptMutation, DeleteAiPromptMutationVariables>;
export const TouchAiPromptDocument = gql`
    mutation TouchAiPrompt($id: String!) {
  touchAiPrompt(id: $id) {
    ...AiPrompt
  }
}
    ${AiPromptFragmentDoc}`;
export type TouchAiPromptMutationFn = Apollo.MutationFunction<TouchAiPromptMutation, TouchAiPromptMutationVariables>;

/**
 * __useTouchAiPromptMutation__
 *
 * To run a mutation, you first call `useTouchAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTouchAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [touchAiPromptMutation, { data, loading, error }] = useTouchAiPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTouchAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<TouchAiPromptMutation, TouchAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TouchAiPromptMutation, TouchAiPromptMutationVariables>(TouchAiPromptDocument, options);
      }
export type TouchAiPromptMutationHookResult = ReturnType<typeof useTouchAiPromptMutation>;
export type TouchAiPromptMutationResult = Apollo.MutationResult<TouchAiPromptMutation>;
export type TouchAiPromptMutationOptions = Apollo.BaseMutationOptions<TouchAiPromptMutation, TouchAiPromptMutationVariables>;
export const ChatHealthDocument = gql`
    query ChatHealth {
  chatHealth {
    id
  }
}
    `;

/**
 * __useChatHealthQuery__
 *
 * To run a query within a React component, call `useChatHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatHealthQuery(baseOptions?: Apollo.QueryHookOptions<ChatHealthQuery, ChatHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatHealthQuery, ChatHealthQueryVariables>(ChatHealthDocument, options);
      }
export function useChatHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatHealthQuery, ChatHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatHealthQuery, ChatHealthQueryVariables>(ChatHealthDocument, options);
        }
export function useChatHealthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatHealthQuery, ChatHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatHealthQuery, ChatHealthQueryVariables>(ChatHealthDocument, options);
        }
export type ChatHealthQueryHookResult = ReturnType<typeof useChatHealthQuery>;
export type ChatHealthLazyQueryHookResult = ReturnType<typeof useChatHealthLazyQuery>;
export type ChatHealthSuspenseQueryHookResult = ReturnType<typeof useChatHealthSuspenseQuery>;
export type ChatHealthQueryResult = Apollo.QueryResult<ChatHealthQuery, ChatHealthQueryVariables>;
export const InitiateVacancyClientTokenCheckoutDocument = gql`
    mutation InitiateVacancyClientTokenCheckout($input: VacancyClientTokenCheckout!) {
  initiateVacancyClientTokenCheckout(input: $input) {
    sessionId
    clientSecret
  }
}
    `;
export type InitiateVacancyClientTokenCheckoutMutationFn = Apollo.MutationFunction<InitiateVacancyClientTokenCheckoutMutation, InitiateVacancyClientTokenCheckoutMutationVariables>;

/**
 * __useInitiateVacancyClientTokenCheckoutMutation__
 *
 * To run a mutation, you first call `useInitiateVacancyClientTokenCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateVacancyClientTokenCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateVacancyClientTokenCheckoutMutation, { data, loading, error }] = useInitiateVacancyClientTokenCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateVacancyClientTokenCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<InitiateVacancyClientTokenCheckoutMutation, InitiateVacancyClientTokenCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateVacancyClientTokenCheckoutMutation, InitiateVacancyClientTokenCheckoutMutationVariables>(InitiateVacancyClientTokenCheckoutDocument, options);
      }
export type InitiateVacancyClientTokenCheckoutMutationHookResult = ReturnType<typeof useInitiateVacancyClientTokenCheckoutMutation>;
export type InitiateVacancyClientTokenCheckoutMutationResult = Apollo.MutationResult<InitiateVacancyClientTokenCheckoutMutation>;
export type InitiateVacancyClientTokenCheckoutMutationOptions = Apollo.BaseMutationOptions<InitiateVacancyClientTokenCheckoutMutation, InitiateVacancyClientTokenCheckoutMutationVariables>;
export const AddCandidateToClientTokenDocument = gql`
    mutation AddCandidateToClientToken($input: AddCandidateToClientTokenInput!) {
  addCandidateToClientToken(input: $input) {
    ...ClientToken
  }
}
    ${ClientTokenFragmentDoc}`;
export type AddCandidateToClientTokenMutationFn = Apollo.MutationFunction<AddCandidateToClientTokenMutation, AddCandidateToClientTokenMutationVariables>;

/**
 * __useAddCandidateToClientTokenMutation__
 *
 * To run a mutation, you first call `useAddCandidateToClientTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateToClientTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateToClientTokenMutation, { data, loading, error }] = useAddCandidateToClientTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCandidateToClientTokenMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidateToClientTokenMutation, AddCandidateToClientTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidateToClientTokenMutation, AddCandidateToClientTokenMutationVariables>(AddCandidateToClientTokenDocument, options);
      }
export type AddCandidateToClientTokenMutationHookResult = ReturnType<typeof useAddCandidateToClientTokenMutation>;
export type AddCandidateToClientTokenMutationResult = Apollo.MutationResult<AddCandidateToClientTokenMutation>;
export type AddCandidateToClientTokenMutationOptions = Apollo.BaseMutationOptions<AddCandidateToClientTokenMutation, AddCandidateToClientTokenMutationVariables>;
export const LookUpEmailAsyncV2Document = gql`
    mutation LookUpEmailAsyncV2($input: LookUpEmailInput!) {
  lookUpContactInfoAsyncV2(input: $input) {
    ...LookUpContactInfoAsyncFragment
  }
}
    ${LookUpContactInfoAsyncFragmentFragmentDoc}`;
export type LookUpEmailAsyncV2MutationFn = Apollo.MutationFunction<LookUpEmailAsyncV2Mutation, LookUpEmailAsyncV2MutationVariables>;

/**
 * __useLookUpEmailAsyncV2Mutation__
 *
 * To run a mutation, you first call `useLookUpEmailAsyncV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLookUpEmailAsyncV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lookUpEmailAsyncV2Mutation, { data, loading, error }] = useLookUpEmailAsyncV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLookUpEmailAsyncV2Mutation(baseOptions?: Apollo.MutationHookOptions<LookUpEmailAsyncV2Mutation, LookUpEmailAsyncV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LookUpEmailAsyncV2Mutation, LookUpEmailAsyncV2MutationVariables>(LookUpEmailAsyncV2Document, options);
      }
export type LookUpEmailAsyncV2MutationHookResult = ReturnType<typeof useLookUpEmailAsyncV2Mutation>;
export type LookUpEmailAsyncV2MutationResult = Apollo.MutationResult<LookUpEmailAsyncV2Mutation>;
export type LookUpEmailAsyncV2MutationOptions = Apollo.BaseMutationOptions<LookUpEmailAsyncV2Mutation, LookUpEmailAsyncV2MutationVariables>;
export const GetVoiceTokenDocument = gql`
    mutation getVoiceToken {
  getVoiceToken {
    token
  }
}
    `;
export type GetVoiceTokenMutationFn = Apollo.MutationFunction<GetVoiceTokenMutation, GetVoiceTokenMutationVariables>;

/**
 * __useGetVoiceTokenMutation__
 *
 * To run a mutation, you first call `useGetVoiceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVoiceTokenMutation, { data, loading, error }] = useGetVoiceTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetVoiceTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetVoiceTokenMutation, GetVoiceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetVoiceTokenMutation, GetVoiceTokenMutationVariables>(GetVoiceTokenDocument, options);
      }
export type GetVoiceTokenMutationHookResult = ReturnType<typeof useGetVoiceTokenMutation>;
export type GetVoiceTokenMutationResult = Apollo.MutationResult<GetVoiceTokenMutation>;
export type GetVoiceTokenMutationOptions = Apollo.BaseMutationOptions<GetVoiceTokenMutation, GetVoiceTokenMutationVariables>;
export const DialDocument = gql`
    mutation dial($input: Dial!) {
  dial(input: $input) {
    ...CallDetail
  }
}
    ${CallDetailFragmentDoc}`;
export type DialMutationFn = Apollo.MutationFunction<DialMutation, DialMutationVariables>;

/**
 * __useDialMutation__
 *
 * To run a mutation, you first call `useDialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dialMutation, { data, loading, error }] = useDialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDialMutation(baseOptions?: Apollo.MutationHookOptions<DialMutation, DialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DialMutation, DialMutationVariables>(DialDocument, options);
      }
export type DialMutationHookResult = ReturnType<typeof useDialMutation>;
export type DialMutationResult = Apollo.MutationResult<DialMutation>;
export type DialMutationOptions = Apollo.BaseMutationOptions<DialMutation, DialMutationVariables>;
export const RequestUploadPreRecordedMessageDocument = gql`
    mutation requestUploadPreRecordedMessage($input: RequestUploadPreRecordedMessageInput!) {
  requestUploadPreRecordedMessage(input: $input) {
    url
    key
  }
}
    `;
export type RequestUploadPreRecordedMessageMutationFn = Apollo.MutationFunction<RequestUploadPreRecordedMessageMutation, RequestUploadPreRecordedMessageMutationVariables>;

/**
 * __useRequestUploadPreRecordedMessageMutation__
 *
 * To run a mutation, you first call `useRequestUploadPreRecordedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUploadPreRecordedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUploadPreRecordedMessageMutation, { data, loading, error }] = useRequestUploadPreRecordedMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestUploadPreRecordedMessageMutation(baseOptions?: Apollo.MutationHookOptions<RequestUploadPreRecordedMessageMutation, RequestUploadPreRecordedMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUploadPreRecordedMessageMutation, RequestUploadPreRecordedMessageMutationVariables>(RequestUploadPreRecordedMessageDocument, options);
      }
export type RequestUploadPreRecordedMessageMutationHookResult = ReturnType<typeof useRequestUploadPreRecordedMessageMutation>;
export type RequestUploadPreRecordedMessageMutationResult = Apollo.MutationResult<RequestUploadPreRecordedMessageMutation>;
export type RequestUploadPreRecordedMessageMutationOptions = Apollo.BaseMutationOptions<RequestUploadPreRecordedMessageMutation, RequestUploadPreRecordedMessageMutationVariables>;
export const PlayMessageOnCallDocument = gql`
    mutation playMessageOnCall($input: PlayMessageOnCallInput!) {
  playMessageOnCall(input: $input) {
    id
  }
}
    `;
export type PlayMessageOnCallMutationFn = Apollo.MutationFunction<PlayMessageOnCallMutation, PlayMessageOnCallMutationVariables>;

/**
 * __usePlayMessageOnCallMutation__
 *
 * To run a mutation, you first call `usePlayMessageOnCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlayMessageOnCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playMessageOnCallMutation, { data, loading, error }] = usePlayMessageOnCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlayMessageOnCallMutation(baseOptions?: Apollo.MutationHookOptions<PlayMessageOnCallMutation, PlayMessageOnCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlayMessageOnCallMutation, PlayMessageOnCallMutationVariables>(PlayMessageOnCallDocument, options);
      }
export type PlayMessageOnCallMutationHookResult = ReturnType<typeof usePlayMessageOnCallMutation>;
export type PlayMessageOnCallMutationResult = Apollo.MutationResult<PlayMessageOnCallMutation>;
export type PlayMessageOnCallMutationOptions = Apollo.BaseMutationOptions<PlayMessageOnCallMutation, PlayMessageOnCallMutationVariables>;
export const UpdateCallDocument = gql`
    mutation updateCall($input: UpdateCallInput!) {
  updateCall(input: $input) {
    id
    userMessage
  }
}
    `;
export type UpdateCallMutationFn = Apollo.MutationFunction<UpdateCallMutation, UpdateCallMutationVariables>;

/**
 * __useUpdateCallMutation__
 *
 * To run a mutation, you first call `useUpdateCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallMutation, { data, loading, error }] = useUpdateCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCallMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallMutation, UpdateCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallMutation, UpdateCallMutationVariables>(UpdateCallDocument, options);
      }
export type UpdateCallMutationHookResult = ReturnType<typeof useUpdateCallMutation>;
export type UpdateCallMutationResult = Apollo.MutationResult<UpdateCallMutation>;
export type UpdateCallMutationOptions = Apollo.BaseMutationOptions<UpdateCallMutation, UpdateCallMutationVariables>;
export const ListPreRecordedMessagesDocument = gql`
    query listPreRecordedMessages($input: ListPreRecordedMessagesInput!) {
  listPreRecordedMessages(input: $input) {
    items {
      ...PrecordedMessageDetail
    }
    total
  }
}
    ${PrecordedMessageDetailFragmentDoc}`;

/**
 * __useListPreRecordedMessagesQuery__
 *
 * To run a query within a React component, call `useListPreRecordedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPreRecordedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPreRecordedMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListPreRecordedMessagesQuery(baseOptions: Apollo.QueryHookOptions<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables> & ({ variables: ListPreRecordedMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables>(ListPreRecordedMessagesDocument, options);
      }
export function useListPreRecordedMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables>(ListPreRecordedMessagesDocument, options);
        }
export function useListPreRecordedMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables>(ListPreRecordedMessagesDocument, options);
        }
export type ListPreRecordedMessagesQueryHookResult = ReturnType<typeof useListPreRecordedMessagesQuery>;
export type ListPreRecordedMessagesLazyQueryHookResult = ReturnType<typeof useListPreRecordedMessagesLazyQuery>;
export type ListPreRecordedMessagesSuspenseQueryHookResult = ReturnType<typeof useListPreRecordedMessagesSuspenseQuery>;
export type ListPreRecordedMessagesQueryResult = Apollo.QueryResult<ListPreRecordedMessagesQuery, ListPreRecordedMessagesQueryVariables>;
export const GetPreRecordedMessageDocument = gql`
    query getPreRecordedMessage($id: String!) {
  getPreRecordedMessage(id: $id) {
    message {
      ...PrecordedMessageDetail
    }
    url
  }
}
    ${PrecordedMessageDetailFragmentDoc}`;

/**
 * __useGetPreRecordedMessageQuery__
 *
 * To run a query within a React component, call `useGetPreRecordedMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreRecordedMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreRecordedMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPreRecordedMessageQuery(baseOptions: Apollo.QueryHookOptions<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables> & ({ variables: GetPreRecordedMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables>(GetPreRecordedMessageDocument, options);
      }
export function useGetPreRecordedMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables>(GetPreRecordedMessageDocument, options);
        }
export function useGetPreRecordedMessageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables>(GetPreRecordedMessageDocument, options);
        }
export type GetPreRecordedMessageQueryHookResult = ReturnType<typeof useGetPreRecordedMessageQuery>;
export type GetPreRecordedMessageLazyQueryHookResult = ReturnType<typeof useGetPreRecordedMessageLazyQuery>;
export type GetPreRecordedMessageSuspenseQueryHookResult = ReturnType<typeof useGetPreRecordedMessageSuspenseQuery>;
export type GetPreRecordedMessageQueryResult = Apollo.QueryResult<GetPreRecordedMessageQuery, GetPreRecordedMessageQueryVariables>;
export const ListCallsDocument = gql`
    query ListCalls($input: ListCallsInput!) {
  listCalls(input: $input) {
    items {
      ...CallDetail
    }
    total
  }
}
    ${CallDetailFragmentDoc}`;

/**
 * __useListCallsQuery__
 *
 * To run a query within a React component, call `useListCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCallsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCallsQuery(baseOptions: Apollo.QueryHookOptions<ListCallsQuery, ListCallsQueryVariables> & ({ variables: ListCallsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCallsQuery, ListCallsQueryVariables>(ListCallsDocument, options);
      }
export function useListCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCallsQuery, ListCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCallsQuery, ListCallsQueryVariables>(ListCallsDocument, options);
        }
export function useListCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCallsQuery, ListCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCallsQuery, ListCallsQueryVariables>(ListCallsDocument, options);
        }
export type ListCallsQueryHookResult = ReturnType<typeof useListCallsQuery>;
export type ListCallsLazyQueryHookResult = ReturnType<typeof useListCallsLazyQuery>;
export type ListCallsSuspenseQueryHookResult = ReturnType<typeof useListCallsSuspenseQuery>;
export type ListCallsQueryResult = Apollo.QueryResult<ListCallsQuery, ListCallsQueryVariables>;
export const OnCallUpdatedDocument = gql`
    subscription OnCallUpdated($twilioCallSid: String!) {
  onCallUpdated(twilioCallSid: $twilioCallSid) {
    id
    twilioCallSid
    userMessage
    dialAction
    status
  }
}
    `;

/**
 * __useOnCallUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnCallUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCallUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCallUpdatedSubscription({
 *   variables: {
 *      twilioCallSid: // value for 'twilioCallSid'
 *   },
 * });
 */
export function useOnCallUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnCallUpdatedSubscription, OnCallUpdatedSubscriptionVariables> & ({ variables: OnCallUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCallUpdatedSubscription, OnCallUpdatedSubscriptionVariables>(OnCallUpdatedDocument, options);
      }
export type OnCallUpdatedSubscriptionHookResult = ReturnType<typeof useOnCallUpdatedSubscription>;
export type OnCallUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnCallUpdatedSubscription>;
export const RequestUploadCandidateResumeDocument = gql`
    mutation RequestUploadCandidateResume($vacancyId: String, $fileName: String!, $contentType: String!) {
  requestUploadCandidateResume(
    input: {vacancyId: $vacancyId, fileName: $fileName, contentType: $contentType}
  ) {
    url
    candidateId
  }
}
    `;
export type RequestUploadCandidateResumeMutationFn = Apollo.MutationFunction<RequestUploadCandidateResumeMutation, RequestUploadCandidateResumeMutationVariables>;

/**
 * __useRequestUploadCandidateResumeMutation__
 *
 * To run a mutation, you first call `useRequestUploadCandidateResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUploadCandidateResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUploadCandidateResumeMutation, { data, loading, error }] = useRequestUploadCandidateResumeMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useRequestUploadCandidateResumeMutation(baseOptions?: Apollo.MutationHookOptions<RequestUploadCandidateResumeMutation, RequestUploadCandidateResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUploadCandidateResumeMutation, RequestUploadCandidateResumeMutationVariables>(RequestUploadCandidateResumeDocument, options);
      }
export type RequestUploadCandidateResumeMutationHookResult = ReturnType<typeof useRequestUploadCandidateResumeMutation>;
export type RequestUploadCandidateResumeMutationResult = Apollo.MutationResult<RequestUploadCandidateResumeMutation>;
export type RequestUploadCandidateResumeMutationOptions = Apollo.BaseMutationOptions<RequestUploadCandidateResumeMutation, RequestUploadCandidateResumeMutationVariables>;
export const DomainCategoriesDocument = gql`
    query DomainCategories {
  domainCategories {
    items {
      ...DomainCategory
    }
  }
}
    ${DomainCategoryFragmentDoc}`;

/**
 * __useDomainCategoriesQuery__
 *
 * To run a query within a React component, call `useDomainCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDomainCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<DomainCategoriesQuery, DomainCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainCategoriesQuery, DomainCategoriesQueryVariables>(DomainCategoriesDocument, options);
      }
export function useDomainCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainCategoriesQuery, DomainCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainCategoriesQuery, DomainCategoriesQueryVariables>(DomainCategoriesDocument, options);
        }
export function useDomainCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainCategoriesQuery, DomainCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainCategoriesQuery, DomainCategoriesQueryVariables>(DomainCategoriesDocument, options);
        }
export type DomainCategoriesQueryHookResult = ReturnType<typeof useDomainCategoriesQuery>;
export type DomainCategoriesLazyQueryHookResult = ReturnType<typeof useDomainCategoriesLazyQuery>;
export type DomainCategoriesSuspenseQueryHookResult = ReturnType<typeof useDomainCategoriesSuspenseQuery>;
export type DomainCategoriesQueryResult = Apollo.QueryResult<DomainCategoriesQuery, DomainCategoriesQueryVariables>;
export const CreateDomainCategoryDocument = gql`
    mutation CreateDomainCategory($input: AddDomainCategoryInput!) {
  addDomainCategory(input: $input) {
    ...DomainCategory
  }
}
    ${DomainCategoryFragmentDoc}`;
export type CreateDomainCategoryMutationFn = Apollo.MutationFunction<CreateDomainCategoryMutation, CreateDomainCategoryMutationVariables>;

/**
 * __useCreateDomainCategoryMutation__
 *
 * To run a mutation, you first call `useCreateDomainCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDomainCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDomainCategoryMutation, { data, loading, error }] = useCreateDomainCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDomainCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDomainCategoryMutation, CreateDomainCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDomainCategoryMutation, CreateDomainCategoryMutationVariables>(CreateDomainCategoryDocument, options);
      }
export type CreateDomainCategoryMutationHookResult = ReturnType<typeof useCreateDomainCategoryMutation>;
export type CreateDomainCategoryMutationResult = Apollo.MutationResult<CreateDomainCategoryMutation>;
export type CreateDomainCategoryMutationOptions = Apollo.BaseMutationOptions<CreateDomainCategoryMutation, CreateDomainCategoryMutationVariables>;
export const UpdateDomainCategoryDocument = gql`
    mutation UpdateDomainCategory($input: UpdateDomainCategoryInput!) {
  updateDomainCategory(input: $input) {
    ...DomainCategory
  }
}
    ${DomainCategoryFragmentDoc}`;
export type UpdateDomainCategoryMutationFn = Apollo.MutationFunction<UpdateDomainCategoryMutation, UpdateDomainCategoryMutationVariables>;

/**
 * __useUpdateDomainCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateDomainCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainCategoryMutation, { data, loading, error }] = useUpdateDomainCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDomainCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDomainCategoryMutation, UpdateDomainCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainCategoryMutation, UpdateDomainCategoryMutationVariables>(UpdateDomainCategoryDocument, options);
      }
export type UpdateDomainCategoryMutationHookResult = ReturnType<typeof useUpdateDomainCategoryMutation>;
export type UpdateDomainCategoryMutationResult = Apollo.MutationResult<UpdateDomainCategoryMutation>;
export type UpdateDomainCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateDomainCategoryMutation, UpdateDomainCategoryMutationVariables>;
export const DeleteDomainCategoryDocument = gql`
    mutation DeleteDomainCategory($input: DeleteDomainCategoryInput!) {
  deleteDomainCategory(input: $input) {
    ...DomainCategory
  }
}
    ${DomainCategoryFragmentDoc}`;
export type DeleteDomainCategoryMutationFn = Apollo.MutationFunction<DeleteDomainCategoryMutation, DeleteDomainCategoryMutationVariables>;

/**
 * __useDeleteDomainCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteDomainCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDomainCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDomainCategoryMutation, { data, loading, error }] = useDeleteDomainCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDomainCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDomainCategoryMutation, DeleteDomainCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDomainCategoryMutation, DeleteDomainCategoryMutationVariables>(DeleteDomainCategoryDocument, options);
      }
export type DeleteDomainCategoryMutationHookResult = ReturnType<typeof useDeleteDomainCategoryMutation>;
export type DeleteDomainCategoryMutationResult = Apollo.MutationResult<DeleteDomainCategoryMutation>;
export type DeleteDomainCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteDomainCategoryMutation, DeleteDomainCategoryMutationVariables>;
export const ListInAppMessagesDocument = gql`
    query ListInAppMessages($input: GetAllMessages!) {
  getAllMessages(input: $input) {
    messages {
      id
      audienceTypesPositive
      audienceTypesNegative
      bodyHtml
      sizeCreated
      sizeRead
    }
    total
  }
}
    `;

/**
 * __useListInAppMessagesQuery__
 *
 * To run a query within a React component, call `useListInAppMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInAppMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInAppMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListInAppMessagesQuery(baseOptions: Apollo.QueryHookOptions<ListInAppMessagesQuery, ListInAppMessagesQueryVariables> & ({ variables: ListInAppMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInAppMessagesQuery, ListInAppMessagesQueryVariables>(ListInAppMessagesDocument, options);
      }
export function useListInAppMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInAppMessagesQuery, ListInAppMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInAppMessagesQuery, ListInAppMessagesQueryVariables>(ListInAppMessagesDocument, options);
        }
export function useListInAppMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListInAppMessagesQuery, ListInAppMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInAppMessagesQuery, ListInAppMessagesQueryVariables>(ListInAppMessagesDocument, options);
        }
export type ListInAppMessagesQueryHookResult = ReturnType<typeof useListInAppMessagesQuery>;
export type ListInAppMessagesLazyQueryHookResult = ReturnType<typeof useListInAppMessagesLazyQuery>;
export type ListInAppMessagesSuspenseQueryHookResult = ReturnType<typeof useListInAppMessagesSuspenseQuery>;
export type ListInAppMessagesQueryResult = Apollo.QueryResult<ListInAppMessagesQuery, ListInAppMessagesQueryVariables>;
export const GetAudienceSizeDocument = gql`
    query GetAudienceSize($input: GetAudienceSizeInput!) {
  getAudienceSize(input: $input) {
    size
  }
}
    `;

/**
 * __useGetAudienceSizeQuery__
 *
 * To run a query within a React component, call `useGetAudienceSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceSizeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAudienceSizeQuery(baseOptions: Apollo.QueryHookOptions<GetAudienceSizeQuery, GetAudienceSizeQueryVariables> & ({ variables: GetAudienceSizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceSizeQuery, GetAudienceSizeQueryVariables>(GetAudienceSizeDocument, options);
      }
export function useGetAudienceSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceSizeQuery, GetAudienceSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceSizeQuery, GetAudienceSizeQueryVariables>(GetAudienceSizeDocument, options);
        }
export function useGetAudienceSizeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAudienceSizeQuery, GetAudienceSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAudienceSizeQuery, GetAudienceSizeQueryVariables>(GetAudienceSizeDocument, options);
        }
export type GetAudienceSizeQueryHookResult = ReturnType<typeof useGetAudienceSizeQuery>;
export type GetAudienceSizeLazyQueryHookResult = ReturnType<typeof useGetAudienceSizeLazyQuery>;
export type GetAudienceSizeSuspenseQueryHookResult = ReturnType<typeof useGetAudienceSizeSuspenseQuery>;
export type GetAudienceSizeQueryResult = Apollo.QueryResult<GetAudienceSizeQuery, GetAudienceSizeQueryVariables>;
export const CreateInAppMessageDocument = gql`
    mutation CreateInAppMessage($input: CreateInAppMessageInput!) {
  createInAppMessage(input: $input) {
    id
  }
}
    `;
export type CreateInAppMessageMutationFn = Apollo.MutationFunction<CreateInAppMessageMutation, CreateInAppMessageMutationVariables>;

/**
 * __useCreateInAppMessageMutation__
 *
 * To run a mutation, you first call `useCreateInAppMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInAppMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInAppMessageMutation, { data, loading, error }] = useCreateInAppMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInAppMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateInAppMessageMutation, CreateInAppMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInAppMessageMutation, CreateInAppMessageMutationVariables>(CreateInAppMessageDocument, options);
      }
export type CreateInAppMessageMutationHookResult = ReturnType<typeof useCreateInAppMessageMutation>;
export type CreateInAppMessageMutationResult = Apollo.MutationResult<CreateInAppMessageMutation>;
export type CreateInAppMessageMutationOptions = Apollo.BaseMutationOptions<CreateInAppMessageMutation, CreateInAppMessageMutationVariables>;
export const RecordInAppMessageInteractionDocument = gql`
    mutation RecordInAppMessageInteraction($input: RecordInteraction!) {
  recordInteraction(input: $input) {
    id
  }
}
    `;
export type RecordInAppMessageInteractionMutationFn = Apollo.MutationFunction<RecordInAppMessageInteractionMutation, RecordInAppMessageInteractionMutationVariables>;

/**
 * __useRecordInAppMessageInteractionMutation__
 *
 * To run a mutation, you first call `useRecordInAppMessageInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordInAppMessageInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordInAppMessageInteractionMutation, { data, loading, error }] = useRecordInAppMessageInteractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordInAppMessageInteractionMutation(baseOptions?: Apollo.MutationHookOptions<RecordInAppMessageInteractionMutation, RecordInAppMessageInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordInAppMessageInteractionMutation, RecordInAppMessageInteractionMutationVariables>(RecordInAppMessageInteractionDocument, options);
      }
export type RecordInAppMessageInteractionMutationHookResult = ReturnType<typeof useRecordInAppMessageInteractionMutation>;
export type RecordInAppMessageInteractionMutationResult = Apollo.MutationResult<RecordInAppMessageInteractionMutation>;
export type RecordInAppMessageInteractionMutationOptions = Apollo.BaseMutationOptions<RecordInAppMessageInteractionMutation, RecordInAppMessageInteractionMutationVariables>;
export const UpdateInAppMessageDocument = gql`
    mutation UpdateInAppMessage($id: String!, $input: UpdateInAppMessageInput!) {
  updateMessage(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateInAppMessageMutationFn = Apollo.MutationFunction<UpdateInAppMessageMutation, UpdateInAppMessageMutationVariables>;

/**
 * __useUpdateInAppMessageMutation__
 *
 * To run a mutation, you first call `useUpdateInAppMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInAppMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInAppMessageMutation, { data, loading, error }] = useUpdateInAppMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInAppMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInAppMessageMutation, UpdateInAppMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInAppMessageMutation, UpdateInAppMessageMutationVariables>(UpdateInAppMessageDocument, options);
      }
export type UpdateInAppMessageMutationHookResult = ReturnType<typeof useUpdateInAppMessageMutation>;
export type UpdateInAppMessageMutationResult = Apollo.MutationResult<UpdateInAppMessageMutation>;
export type UpdateInAppMessageMutationOptions = Apollo.BaseMutationOptions<UpdateInAppMessageMutation, UpdateInAppMessageMutationVariables>;
export const GetAllInAppMessagesForUserDocument = gql`
    query GetAllInAppMessagesForUser {
  getMessagesForUser {
    total
    messages {
      id
      bodyHtml
    }
  }
}
    `;

/**
 * __useGetAllInAppMessagesForUserQuery__
 *
 * To run a query within a React component, call `useGetAllInAppMessagesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllInAppMessagesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllInAppMessagesForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllInAppMessagesForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>(GetAllInAppMessagesForUserDocument, options);
      }
export function useGetAllInAppMessagesForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>(GetAllInAppMessagesForUserDocument, options);
        }
export function useGetAllInAppMessagesForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>(GetAllInAppMessagesForUserDocument, options);
        }
export type GetAllInAppMessagesForUserQueryHookResult = ReturnType<typeof useGetAllInAppMessagesForUserQuery>;
export type GetAllInAppMessagesForUserLazyQueryHookResult = ReturnType<typeof useGetAllInAppMessagesForUserLazyQuery>;
export type GetAllInAppMessagesForUserSuspenseQueryHookResult = ReturnType<typeof useGetAllInAppMessagesForUserSuspenseQuery>;
export type GetAllInAppMessagesForUserQueryResult = Apollo.QueryResult<GetAllInAppMessagesForUserQuery, GetAllInAppMessagesForUserQueryVariables>;
export const InterviewProfilerListingsDocument = gql`
    query InterviewProfilerListings {
  listFormSections {
    id
    name
    order
    FormSectionGroup {
      id
      name
    }
  }
  listFormTemplates {
    id
    name
    tags
    FormSections {
      id
      name
      order
      FormSectionGroup {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useInterviewProfilerListingsQuery__
 *
 * To run a query within a React component, call `useInterviewProfilerListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewProfilerListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewProfilerListingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewProfilerListingsQuery(baseOptions?: Apollo.QueryHookOptions<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>(InterviewProfilerListingsDocument, options);
      }
export function useInterviewProfilerListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>(InterviewProfilerListingsDocument, options);
        }
export function useInterviewProfilerListingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>(InterviewProfilerListingsDocument, options);
        }
export type InterviewProfilerListingsQueryHookResult = ReturnType<typeof useInterviewProfilerListingsQuery>;
export type InterviewProfilerListingsLazyQueryHookResult = ReturnType<typeof useInterviewProfilerListingsLazyQuery>;
export type InterviewProfilerListingsSuspenseQueryHookResult = ReturnType<typeof useInterviewProfilerListingsSuspenseQuery>;
export type InterviewProfilerListingsQueryResult = Apollo.QueryResult<InterviewProfilerListingsQuery, InterviewProfilerListingsQueryVariables>;
export const GetFormQuestionDocument = gql`
    query GetFormQuestion($questionId: String!) {
  getFormQuestion(questionId: $questionId) {
    id
    label
    hint
    questionType
    questionOptions
    isHidden
    visibilityType
    order
  }
}
    `;

/**
 * __useGetFormQuestionQuery__
 *
 * To run a query within a React component, call `useGetFormQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetFormQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetFormQuestionQuery, GetFormQuestionQueryVariables> & ({ variables: GetFormQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormQuestionQuery, GetFormQuestionQueryVariables>(GetFormQuestionDocument, options);
      }
export function useGetFormQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuestionQuery, GetFormQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormQuestionQuery, GetFormQuestionQueryVariables>(GetFormQuestionDocument, options);
        }
export function useGetFormQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormQuestionQuery, GetFormQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormQuestionQuery, GetFormQuestionQueryVariables>(GetFormQuestionDocument, options);
        }
export type GetFormQuestionQueryHookResult = ReturnType<typeof useGetFormQuestionQuery>;
export type GetFormQuestionLazyQueryHookResult = ReturnType<typeof useGetFormQuestionLazyQuery>;
export type GetFormQuestionSuspenseQueryHookResult = ReturnType<typeof useGetFormQuestionSuspenseQuery>;
export type GetFormQuestionQueryResult = Apollo.QueryResult<GetFormQuestionQuery, GetFormQuestionQueryVariables>;
export const AddFormQuestionDocument = gql`
    mutation AddFormQuestion($label: String!, $hint: String, $questionType: QuestionType!, $questionOptions: [String!]!, $isHidden: Boolean, $visibilityType: QuestionVisibilityType, $formSectionId: String, $isActive: Boolean!) {
  addFormQuestion(
    data: {label: $label, hint: $hint, questionType: $questionType, questionOptions: $questionOptions, isHidden: $isHidden, visibilityType: $visibilityType, formSectionId: $formSectionId, isActive: $isActive}
  ) {
    id
    label
    hint
    questionType
    questionOptions
    isHidden
    visibilityType
    order
    FormSection {
      id
      name
      order
      staticSectionType
    }
  }
}
    `;
export type AddFormQuestionMutationFn = Apollo.MutationFunction<AddFormQuestionMutation, AddFormQuestionMutationVariables>;

/**
 * __useAddFormQuestionMutation__
 *
 * To run a mutation, you first call `useAddFormQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFormQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFormQuestionMutation, { data, loading, error }] = useAddFormQuestionMutation({
 *   variables: {
 *      label: // value for 'label'
 *      hint: // value for 'hint'
 *      questionType: // value for 'questionType'
 *      questionOptions: // value for 'questionOptions'
 *      isHidden: // value for 'isHidden'
 *      visibilityType: // value for 'visibilityType'
 *      formSectionId: // value for 'formSectionId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useAddFormQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AddFormQuestionMutation, AddFormQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFormQuestionMutation, AddFormQuestionMutationVariables>(AddFormQuestionDocument, options);
      }
export type AddFormQuestionMutationHookResult = ReturnType<typeof useAddFormQuestionMutation>;
export type AddFormQuestionMutationResult = Apollo.MutationResult<AddFormQuestionMutation>;
export type AddFormQuestionMutationOptions = Apollo.BaseMutationOptions<AddFormQuestionMutation, AddFormQuestionMutationVariables>;
export const UpdateFormQuestionDocument = gql`
    mutation UpdateFormQuestion($questionId: String!, $label: String!, $hint: String, $questionType: QuestionType!, $questionOptions: [String!]!, $isHidden: Boolean, $visibilityType: QuestionVisibilityType, $formSectionId: String, $isActive: Boolean!, $order: Int) {
  updateFormQuestion(
    questionId: $questionId
    data: {label: $label, hint: $hint, questionType: $questionType, questionOptions: $questionOptions, isHidden: $isHidden, visibilityType: $visibilityType, formSectionId: $formSectionId, isActive: $isActive, order: $order}
  ) {
    count
  }
}
    `;
export type UpdateFormQuestionMutationFn = Apollo.MutationFunction<UpdateFormQuestionMutation, UpdateFormQuestionMutationVariables>;

/**
 * __useUpdateFormQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateFormQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormQuestionMutation, { data, loading, error }] = useUpdateFormQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      label: // value for 'label'
 *      hint: // value for 'hint'
 *      questionType: // value for 'questionType'
 *      questionOptions: // value for 'questionOptions'
 *      isHidden: // value for 'isHidden'
 *      visibilityType: // value for 'visibilityType'
 *      formSectionId: // value for 'formSectionId'
 *      isActive: // value for 'isActive'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUpdateFormQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormQuestionMutation, UpdateFormQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormQuestionMutation, UpdateFormQuestionMutationVariables>(UpdateFormQuestionDocument, options);
      }
export type UpdateFormQuestionMutationHookResult = ReturnType<typeof useUpdateFormQuestionMutation>;
export type UpdateFormQuestionMutationResult = Apollo.MutationResult<UpdateFormQuestionMutation>;
export type UpdateFormQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateFormQuestionMutation, UpdateFormQuestionMutationVariables>;
export const RequestUploadInterviewGalleryItemDocument = gql`
    mutation RequestUploadInterviewGalleryItem($data: GalleryPreUpload!) {
  requestUploadInterviewGalleryItem(data: $data) {
    uploadUrl
    s3Key
  }
}
    `;
export type RequestUploadInterviewGalleryItemMutationFn = Apollo.MutationFunction<RequestUploadInterviewGalleryItemMutation, RequestUploadInterviewGalleryItemMutationVariables>;

/**
 * __useRequestUploadInterviewGalleryItemMutation__
 *
 * To run a mutation, you first call `useRequestUploadInterviewGalleryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUploadInterviewGalleryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUploadInterviewGalleryItemMutation, { data, loading, error }] = useRequestUploadInterviewGalleryItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRequestUploadInterviewGalleryItemMutation(baseOptions?: Apollo.MutationHookOptions<RequestUploadInterviewGalleryItemMutation, RequestUploadInterviewGalleryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUploadInterviewGalleryItemMutation, RequestUploadInterviewGalleryItemMutationVariables>(RequestUploadInterviewGalleryItemDocument, options);
      }
export type RequestUploadInterviewGalleryItemMutationHookResult = ReturnType<typeof useRequestUploadInterviewGalleryItemMutation>;
export type RequestUploadInterviewGalleryItemMutationResult = Apollo.MutationResult<RequestUploadInterviewGalleryItemMutation>;
export type RequestUploadInterviewGalleryItemMutationOptions = Apollo.BaseMutationOptions<RequestUploadInterviewGalleryItemMutation, RequestUploadInterviewGalleryItemMutationVariables>;
export const RemoveInterviewGalleryItemDocument = gql`
    mutation RemoveInterviewGalleryItem($data: CandidateFormResponseInput!, $s3Key: String!) {
  removeInterviewGalleryItem(data: $data, s3Key: $s3Key) {
    count
  }
}
    `;
export type RemoveInterviewGalleryItemMutationFn = Apollo.MutationFunction<RemoveInterviewGalleryItemMutation, RemoveInterviewGalleryItemMutationVariables>;

/**
 * __useRemoveInterviewGalleryItemMutation__
 *
 * To run a mutation, you first call `useRemoveInterviewGalleryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInterviewGalleryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInterviewGalleryItemMutation, { data, loading, error }] = useRemoveInterviewGalleryItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *      s3Key: // value for 's3Key'
 *   },
 * });
 */
export function useRemoveInterviewGalleryItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInterviewGalleryItemMutation, RemoveInterviewGalleryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInterviewGalleryItemMutation, RemoveInterviewGalleryItemMutationVariables>(RemoveInterviewGalleryItemDocument, options);
      }
export type RemoveInterviewGalleryItemMutationHookResult = ReturnType<typeof useRemoveInterviewGalleryItemMutation>;
export type RemoveInterviewGalleryItemMutationResult = Apollo.MutationResult<RemoveInterviewGalleryItemMutation>;
export type RemoveInterviewGalleryItemMutationOptions = Apollo.BaseMutationOptions<RemoveInterviewGalleryItemMutation, RemoveInterviewGalleryItemMutationVariables>;
export const ListFormSectionsDocument = gql`
    query ListFormSections {
  listFormSections {
    id
    name
    description
    order
    staticSectionType
    FormSectionGroup {
      ...FormSectionGroupFragment
    }
  }
}
    ${FormSectionGroupFragmentFragmentDoc}`;

/**
 * __useListFormSectionsQuery__
 *
 * To run a query within a React component, call `useListFormSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFormSectionsQuery(baseOptions?: Apollo.QueryHookOptions<ListFormSectionsQuery, ListFormSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormSectionsQuery, ListFormSectionsQueryVariables>(ListFormSectionsDocument, options);
      }
export function useListFormSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormSectionsQuery, ListFormSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormSectionsQuery, ListFormSectionsQueryVariables>(ListFormSectionsDocument, options);
        }
export function useListFormSectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFormSectionsQuery, ListFormSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFormSectionsQuery, ListFormSectionsQueryVariables>(ListFormSectionsDocument, options);
        }
export type ListFormSectionsQueryHookResult = ReturnType<typeof useListFormSectionsQuery>;
export type ListFormSectionsLazyQueryHookResult = ReturnType<typeof useListFormSectionsLazyQuery>;
export type ListFormSectionsSuspenseQueryHookResult = ReturnType<typeof useListFormSectionsSuspenseQuery>;
export type ListFormSectionsQueryResult = Apollo.QueryResult<ListFormSectionsQuery, ListFormSectionsQueryVariables>;
export const GetFormSectionDocument = gql`
    query GetFormSection($sectionId: String!) {
  getFormSection(sectionId: $sectionId) {
    id
    name
    description
    order
    staticSectionType
    FormQuestions {
      ...FormSectionQuestionFragment
    }
    FormSectionGroup {
      ...FormSectionGroupFragment
    }
  }
}
    ${FormSectionQuestionFragmentFragmentDoc}
${FormSectionGroupFragmentFragmentDoc}`;

/**
 * __useGetFormSectionQuery__
 *
 * To run a query within a React component, call `useGetFormSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSectionQuery({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGetFormSectionQuery(baseOptions: Apollo.QueryHookOptions<GetFormSectionQuery, GetFormSectionQueryVariables> & ({ variables: GetFormSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormSectionQuery, GetFormSectionQueryVariables>(GetFormSectionDocument, options);
      }
export function useGetFormSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormSectionQuery, GetFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormSectionQuery, GetFormSectionQueryVariables>(GetFormSectionDocument, options);
        }
export function useGetFormSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormSectionQuery, GetFormSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormSectionQuery, GetFormSectionQueryVariables>(GetFormSectionDocument, options);
        }
export type GetFormSectionQueryHookResult = ReturnType<typeof useGetFormSectionQuery>;
export type GetFormSectionLazyQueryHookResult = ReturnType<typeof useGetFormSectionLazyQuery>;
export type GetFormSectionSuspenseQueryHookResult = ReturnType<typeof useGetFormSectionSuspenseQuery>;
export type GetFormSectionQueryResult = Apollo.QueryResult<GetFormSectionQuery, GetFormSectionQueryVariables>;
export const AddFormSectionDocument = gql`
    mutation AddFormSection($name: String!, $description: String, $formSectionGroupId: String) {
  addFormSection(
    name: $name
    description: $description
    formSectionGroupId: $formSectionGroupId
  ) {
    id
    name
    description
    staticSectionType
    FormQuestions {
      ...FormSectionQuestionFragment
    }
    FormSectionGroup {
      ...FormSectionGroupFragment
    }
  }
}
    ${FormSectionQuestionFragmentFragmentDoc}
${FormSectionGroupFragmentFragmentDoc}`;
export type AddFormSectionMutationFn = Apollo.MutationFunction<AddFormSectionMutation, AddFormSectionMutationVariables>;

/**
 * __useAddFormSectionMutation__
 *
 * To run a mutation, you first call `useAddFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFormSectionMutation, { data, loading, error }] = useAddFormSectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      formSectionGroupId: // value for 'formSectionGroupId'
 *   },
 * });
 */
export function useAddFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<AddFormSectionMutation, AddFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFormSectionMutation, AddFormSectionMutationVariables>(AddFormSectionDocument, options);
      }
export type AddFormSectionMutationHookResult = ReturnType<typeof useAddFormSectionMutation>;
export type AddFormSectionMutationResult = Apollo.MutationResult<AddFormSectionMutation>;
export type AddFormSectionMutationOptions = Apollo.BaseMutationOptions<AddFormSectionMutation, AddFormSectionMutationVariables>;
export const UpdateFormSectionDocument = gql`
    mutation UpdateFormSection($sectionId: String!, $data: FormSectionData!) {
  updateFormSection(sectionId: $sectionId, data: $data) {
    count
  }
}
    `;
export type UpdateFormSectionMutationFn = Apollo.MutationFunction<UpdateFormSectionMutation, UpdateFormSectionMutationVariables>;

/**
 * __useUpdateFormSectionMutation__
 *
 * To run a mutation, you first call `useUpdateFormSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSectionMutation, { data, loading, error }] = useUpdateFormSectionMutation({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormSectionMutation, UpdateFormSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormSectionMutation, UpdateFormSectionMutationVariables>(UpdateFormSectionDocument, options);
      }
export type UpdateFormSectionMutationHookResult = ReturnType<typeof useUpdateFormSectionMutation>;
export type UpdateFormSectionMutationResult = Apollo.MutationResult<UpdateFormSectionMutation>;
export type UpdateFormSectionMutationOptions = Apollo.BaseMutationOptions<UpdateFormSectionMutation, UpdateFormSectionMutationVariables>;
export const ListFormSectionGroupsDocument = gql`
    query ListFormSectionGroups {
  listFormSectionGroups {
    id
    name
    FormSections {
      id
      name
      order
    }
  }
}
    `;

/**
 * __useListFormSectionGroupsQuery__
 *
 * To run a query within a React component, call `useListFormSectionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormSectionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormSectionGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFormSectionGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>(ListFormSectionGroupsDocument, options);
      }
export function useListFormSectionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>(ListFormSectionGroupsDocument, options);
        }
export function useListFormSectionGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>(ListFormSectionGroupsDocument, options);
        }
export type ListFormSectionGroupsQueryHookResult = ReturnType<typeof useListFormSectionGroupsQuery>;
export type ListFormSectionGroupsLazyQueryHookResult = ReturnType<typeof useListFormSectionGroupsLazyQuery>;
export type ListFormSectionGroupsSuspenseQueryHookResult = ReturnType<typeof useListFormSectionGroupsSuspenseQuery>;
export type ListFormSectionGroupsQueryResult = Apollo.QueryResult<ListFormSectionGroupsQuery, ListFormSectionGroupsQueryVariables>;
export const AddFormSectionGroupDocument = gql`
    mutation AddFormSectionGroup($name: String!) {
  addFormSectionGroup(name: $name) {
    id
    name
  }
}
    `;
export type AddFormSectionGroupMutationFn = Apollo.MutationFunction<AddFormSectionGroupMutation, AddFormSectionGroupMutationVariables>;

/**
 * __useAddFormSectionGroupMutation__
 *
 * To run a mutation, you first call `useAddFormSectionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFormSectionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFormSectionGroupMutation, { data, loading, error }] = useAddFormSectionGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddFormSectionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddFormSectionGroupMutation, AddFormSectionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFormSectionGroupMutation, AddFormSectionGroupMutationVariables>(AddFormSectionGroupDocument, options);
      }
export type AddFormSectionGroupMutationHookResult = ReturnType<typeof useAddFormSectionGroupMutation>;
export type AddFormSectionGroupMutationResult = Apollo.MutationResult<AddFormSectionGroupMutation>;
export type AddFormSectionGroupMutationOptions = Apollo.BaseMutationOptions<AddFormSectionGroupMutation, AddFormSectionGroupMutationVariables>;
export const UpdateFormSectionGroupDocument = gql`
    mutation UpdateFormSectionGroup($formSectionGroupId: String!, $data: FormSectionGroupData!) {
  updateFormSectionGroup(formSectionGroupId: $formSectionGroupId, data: $data) {
    count
  }
}
    `;
export type UpdateFormSectionGroupMutationFn = Apollo.MutationFunction<UpdateFormSectionGroupMutation, UpdateFormSectionGroupMutationVariables>;

/**
 * __useUpdateFormSectionGroupMutation__
 *
 * To run a mutation, you first call `useUpdateFormSectionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormSectionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormSectionGroupMutation, { data, loading, error }] = useUpdateFormSectionGroupMutation({
 *   variables: {
 *      formSectionGroupId: // value for 'formSectionGroupId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormSectionGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormSectionGroupMutation, UpdateFormSectionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormSectionGroupMutation, UpdateFormSectionGroupMutationVariables>(UpdateFormSectionGroupDocument, options);
      }
export type UpdateFormSectionGroupMutationHookResult = ReturnType<typeof useUpdateFormSectionGroupMutation>;
export type UpdateFormSectionGroupMutationResult = Apollo.MutationResult<UpdateFormSectionGroupMutation>;
export type UpdateFormSectionGroupMutationOptions = Apollo.BaseMutationOptions<UpdateFormSectionGroupMutation, UpdateFormSectionGroupMutationVariables>;
export const ListFormTemplatesDocument = gql`
    query ListFormTemplates {
  listFormTemplates {
    id
    name
    description
    tags
    FormSections {
      id
      name
      description
      order
      FormSectionGroup {
        ...FormSectionGroupFragment
      }
    }
  }
}
    ${FormSectionGroupFragmentFragmentDoc}`;

/**
 * __useListFormTemplatesQuery__
 *
 * To run a query within a React component, call `useListFormTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFormTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>(ListFormTemplatesDocument, options);
      }
export function useListFormTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>(ListFormTemplatesDocument, options);
        }
export function useListFormTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>(ListFormTemplatesDocument, options);
        }
export type ListFormTemplatesQueryHookResult = ReturnType<typeof useListFormTemplatesQuery>;
export type ListFormTemplatesLazyQueryHookResult = ReturnType<typeof useListFormTemplatesLazyQuery>;
export type ListFormTemplatesSuspenseQueryHookResult = ReturnType<typeof useListFormTemplatesSuspenseQuery>;
export type ListFormTemplatesQueryResult = Apollo.QueryResult<ListFormTemplatesQuery, ListFormTemplatesQueryVariables>;
export const GetFormTemplateDocument = gql`
    query GetFormTemplate($templateId: String!) {
  getFormTemplate(templateId: $templateId) {
    id
    name
    description
    tags
    FormSections {
      id
      name
      description
      order
      FormSectionGroup {
        ...FormSectionGroupFragment
      }
    }
  }
}
    ${FormSectionGroupFragmentFragmentDoc}`;

/**
 * __useGetFormTemplateQuery__
 *
 * To run a query within a React component, call `useGetFormTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetFormTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetFormTemplateQuery, GetFormTemplateQueryVariables> & ({ variables: GetFormTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormTemplateQuery, GetFormTemplateQueryVariables>(GetFormTemplateDocument, options);
      }
export function useGetFormTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormTemplateQuery, GetFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormTemplateQuery, GetFormTemplateQueryVariables>(GetFormTemplateDocument, options);
        }
export function useGetFormTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFormTemplateQuery, GetFormTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormTemplateQuery, GetFormTemplateQueryVariables>(GetFormTemplateDocument, options);
        }
export type GetFormTemplateQueryHookResult = ReturnType<typeof useGetFormTemplateQuery>;
export type GetFormTemplateLazyQueryHookResult = ReturnType<typeof useGetFormTemplateLazyQuery>;
export type GetFormTemplateSuspenseQueryHookResult = ReturnType<typeof useGetFormTemplateSuspenseQuery>;
export type GetFormTemplateQueryResult = Apollo.QueryResult<GetFormTemplateQuery, GetFormTemplateQueryVariables>;
export const AddFormTemplateDocument = gql`
    mutation AddFormTemplate($name: String!, $tags: [String!]) {
  addFormTemplate(name: $name, tags: $tags) {
    id
    name
    description
    tags
    FormSections {
      id
      name
      description
      order
      FormSectionGroup {
        ...FormSectionGroupFragment
      }
    }
  }
}
    ${FormSectionGroupFragmentFragmentDoc}`;
export type AddFormTemplateMutationFn = Apollo.MutationFunction<AddFormTemplateMutation, AddFormTemplateMutationVariables>;

/**
 * __useAddFormTemplateMutation__
 *
 * To run a mutation, you first call `useAddFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFormTemplateMutation, { data, loading, error }] = useAddFormTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useAddFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddFormTemplateMutation, AddFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFormTemplateMutation, AddFormTemplateMutationVariables>(AddFormTemplateDocument, options);
      }
export type AddFormTemplateMutationHookResult = ReturnType<typeof useAddFormTemplateMutation>;
export type AddFormTemplateMutationResult = Apollo.MutationResult<AddFormTemplateMutation>;
export type AddFormTemplateMutationOptions = Apollo.BaseMutationOptions<AddFormTemplateMutation, AddFormTemplateMutationVariables>;
export const UpdateFormTemplateDocument = gql`
    mutation UpdateFormTemplate($templateId: String!, $data: FormTemplateData!) {
  updateFormTemplate(templateId: $templateId, data: $data) {
    count
  }
}
    `;
export type UpdateFormTemplateMutationFn = Apollo.MutationFunction<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;

/**
 * __useUpdateFormTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFormTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormTemplateMutation, { data, loading, error }] = useUpdateFormTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>(UpdateFormTemplateDocument, options);
      }
export type UpdateFormTemplateMutationHookResult = ReturnType<typeof useUpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationResult = Apollo.MutationResult<UpdateFormTemplateMutation>;
export type UpdateFormTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateFormTemplateMutation, UpdateFormTemplateMutationVariables>;
export const SaveJetBridgeAuthDocument = gql`
    mutation SaveJetBridgeAuth($auth: SaveJetBridgeAuthInput!) {
  saveJetBridgeAuth(auth: $auth) {
    ...AtsIntegrationStatusFragment
  }
}
    ${AtsIntegrationStatusFragmentFragmentDoc}`;
export type SaveJetBridgeAuthMutationFn = Apollo.MutationFunction<SaveJetBridgeAuthMutation, SaveJetBridgeAuthMutationVariables>;

/**
 * __useSaveJetBridgeAuthMutation__
 *
 * To run a mutation, you first call `useSaveJetBridgeAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJetBridgeAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJetBridgeAuthMutation, { data, loading, error }] = useSaveJetBridgeAuthMutation({
 *   variables: {
 *      auth: // value for 'auth'
 *   },
 * });
 */
export function useSaveJetBridgeAuthMutation(baseOptions?: Apollo.MutationHookOptions<SaveJetBridgeAuthMutation, SaveJetBridgeAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveJetBridgeAuthMutation, SaveJetBridgeAuthMutationVariables>(SaveJetBridgeAuthDocument, options);
      }
export type SaveJetBridgeAuthMutationHookResult = ReturnType<typeof useSaveJetBridgeAuthMutation>;
export type SaveJetBridgeAuthMutationResult = Apollo.MutationResult<SaveJetBridgeAuthMutation>;
export type SaveJetBridgeAuthMutationOptions = Apollo.BaseMutationOptions<SaveJetBridgeAuthMutation, SaveJetBridgeAuthMutationVariables>;
export const ListJobLeadsDocument = gql`
    query ListJobLeads($input: ListJobLeadsInput!) {
  listJobLeads(input: $input) {
    items {
      ...JobLead
    }
    total
  }
}
    ${JobLeadFragmentDoc}`;

/**
 * __useListJobLeadsQuery__
 *
 * To run a query within a React component, call `useListJobLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobLeadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListJobLeadsQuery(baseOptions: Apollo.QueryHookOptions<ListJobLeadsQuery, ListJobLeadsQueryVariables> & ({ variables: ListJobLeadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobLeadsQuery, ListJobLeadsQueryVariables>(ListJobLeadsDocument, options);
      }
export function useListJobLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobLeadsQuery, ListJobLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobLeadsQuery, ListJobLeadsQueryVariables>(ListJobLeadsDocument, options);
        }
export function useListJobLeadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobLeadsQuery, ListJobLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobLeadsQuery, ListJobLeadsQueryVariables>(ListJobLeadsDocument, options);
        }
export type ListJobLeadsQueryHookResult = ReturnType<typeof useListJobLeadsQuery>;
export type ListJobLeadsLazyQueryHookResult = ReturnType<typeof useListJobLeadsLazyQuery>;
export type ListJobLeadsSuspenseQueryHookResult = ReturnType<typeof useListJobLeadsSuspenseQuery>;
export type ListJobLeadsQueryResult = Apollo.QueryResult<ListJobLeadsQuery, ListJobLeadsQueryVariables>;
export const GetJobLeadDocument = gql`
    query GetJobLead($id: String!) {
  getJobLead(id: $id) {
    ...JobLead
    relatedJobs {
      id
      title
    }
  }
}
    ${JobLeadFragmentDoc}`;

/**
 * __useGetJobLeadQuery__
 *
 * To run a query within a React component, call `useGetJobLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobLeadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobLeadQuery(baseOptions: Apollo.QueryHookOptions<GetJobLeadQuery, GetJobLeadQueryVariables> & ({ variables: GetJobLeadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobLeadQuery, GetJobLeadQueryVariables>(GetJobLeadDocument, options);
      }
export function useGetJobLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobLeadQuery, GetJobLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobLeadQuery, GetJobLeadQueryVariables>(GetJobLeadDocument, options);
        }
export function useGetJobLeadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobLeadQuery, GetJobLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobLeadQuery, GetJobLeadQueryVariables>(GetJobLeadDocument, options);
        }
export type GetJobLeadQueryHookResult = ReturnType<typeof useGetJobLeadQuery>;
export type GetJobLeadLazyQueryHookResult = ReturnType<typeof useGetJobLeadLazyQuery>;
export type GetJobLeadSuspenseQueryHookResult = ReturnType<typeof useGetJobLeadSuspenseQuery>;
export type GetJobLeadQueryResult = Apollo.QueryResult<GetJobLeadQuery, GetJobLeadQueryVariables>;
export const ListJobLeadSearchesDocument = gql`
    query ListJobLeadSearches($input: ListJobLeadSearchesInput!) {
  listJobLeadSearches(input: $input) {
    items {
      ...JobLeadSearch
    }
    total
  }
}
    ${JobLeadSearchFragmentDoc}`;

/**
 * __useListJobLeadSearchesQuery__
 *
 * To run a query within a React component, call `useListJobLeadSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobLeadSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobLeadSearchesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListJobLeadSearchesQuery(baseOptions: Apollo.QueryHookOptions<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables> & ({ variables: ListJobLeadSearchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables>(ListJobLeadSearchesDocument, options);
      }
export function useListJobLeadSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables>(ListJobLeadSearchesDocument, options);
        }
export function useListJobLeadSearchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables>(ListJobLeadSearchesDocument, options);
        }
export type ListJobLeadSearchesQueryHookResult = ReturnType<typeof useListJobLeadSearchesQuery>;
export type ListJobLeadSearchesLazyQueryHookResult = ReturnType<typeof useListJobLeadSearchesLazyQuery>;
export type ListJobLeadSearchesSuspenseQueryHookResult = ReturnType<typeof useListJobLeadSearchesSuspenseQuery>;
export type ListJobLeadSearchesQueryResult = Apollo.QueryResult<ListJobLeadSearchesQuery, ListJobLeadSearchesQueryVariables>;
export const ListCompanyMembersDocument = gql`
    query ListCompanyMembers($input: ListCompanyMembersInput!) {
  listCompanyMembers(input: $input) {
    items {
      id
      firstName
      lastName
      emailAddresses {
        emailAddress
        type
      }
      phoneNumbers {
        phoneNumber
        type
      }
      linkedInUrl
      company {
        id
        name
      }
      headline
    }
    total
  }
}
    `;

/**
 * __useListCompanyMembersQuery__
 *
 * To run a query within a React component, call `useListCompanyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyMembersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCompanyMembersQuery(baseOptions: Apollo.QueryHookOptions<ListCompanyMembersQuery, ListCompanyMembersQueryVariables> & ({ variables: ListCompanyMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCompanyMembersQuery, ListCompanyMembersQueryVariables>(ListCompanyMembersDocument, options);
      }
export function useListCompanyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCompanyMembersQuery, ListCompanyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCompanyMembersQuery, ListCompanyMembersQueryVariables>(ListCompanyMembersDocument, options);
        }
export function useListCompanyMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCompanyMembersQuery, ListCompanyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCompanyMembersQuery, ListCompanyMembersQueryVariables>(ListCompanyMembersDocument, options);
        }
export type ListCompanyMembersQueryHookResult = ReturnType<typeof useListCompanyMembersQuery>;
export type ListCompanyMembersLazyQueryHookResult = ReturnType<typeof useListCompanyMembersLazyQuery>;
export type ListCompanyMembersSuspenseQueryHookResult = ReturnType<typeof useListCompanyMembersSuspenseQuery>;
export type ListCompanyMembersQueryResult = Apollo.QueryResult<ListCompanyMembersQuery, ListCompanyMembersQueryVariables>;
export const JobLeadListsDocument = gql`
    query JobLeadLists($input: ListJobLeadListsInput!) {
  jobLeadLists(input: $input) {
    items {
      id
      name
    }
    total
  }
}
    `;

/**
 * __useJobLeadListsQuery__
 *
 * To run a query within a React component, call `useJobLeadListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLeadListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLeadListsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobLeadListsQuery(baseOptions: Apollo.QueryHookOptions<JobLeadListsQuery, JobLeadListsQueryVariables> & ({ variables: JobLeadListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobLeadListsQuery, JobLeadListsQueryVariables>(JobLeadListsDocument, options);
      }
export function useJobLeadListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobLeadListsQuery, JobLeadListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobLeadListsQuery, JobLeadListsQueryVariables>(JobLeadListsDocument, options);
        }
export function useJobLeadListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobLeadListsQuery, JobLeadListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobLeadListsQuery, JobLeadListsQueryVariables>(JobLeadListsDocument, options);
        }
export type JobLeadListsQueryHookResult = ReturnType<typeof useJobLeadListsQuery>;
export type JobLeadListsLazyQueryHookResult = ReturnType<typeof useJobLeadListsLazyQuery>;
export type JobLeadListsSuspenseQueryHookResult = ReturnType<typeof useJobLeadListsSuspenseQuery>;
export type JobLeadListsQueryResult = Apollo.QueryResult<JobLeadListsQuery, JobLeadListsQueryVariables>;
export const CompanyMemberListsDocument = gql`
    query CompanyMemberLists($input: ListCompanyMemberListsInput!) {
  companyMemberLists(input: $input) {
    items {
      id
      name
    }
    total
  }
}
    `;

/**
 * __useCompanyMemberListsQuery__
 *
 * To run a query within a React component, call `useCompanyMemberListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyMemberListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyMemberListsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyMemberListsQuery(baseOptions: Apollo.QueryHookOptions<CompanyMemberListsQuery, CompanyMemberListsQueryVariables> & ({ variables: CompanyMemberListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyMemberListsQuery, CompanyMemberListsQueryVariables>(CompanyMemberListsDocument, options);
      }
export function useCompanyMemberListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyMemberListsQuery, CompanyMemberListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyMemberListsQuery, CompanyMemberListsQueryVariables>(CompanyMemberListsDocument, options);
        }
export function useCompanyMemberListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyMemberListsQuery, CompanyMemberListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyMemberListsQuery, CompanyMemberListsQueryVariables>(CompanyMemberListsDocument, options);
        }
export type CompanyMemberListsQueryHookResult = ReturnType<typeof useCompanyMemberListsQuery>;
export type CompanyMemberListsLazyQueryHookResult = ReturnType<typeof useCompanyMemberListsLazyQuery>;
export type CompanyMemberListsSuspenseQueryHookResult = ReturnType<typeof useCompanyMemberListsSuspenseQuery>;
export type CompanyMemberListsQueryResult = Apollo.QueryResult<CompanyMemberListsQuery, CompanyMemberListsQueryVariables>;
export const ListLocationsDocument = gql`
    query ListLocations($input: ListLocationsInput!) {
  listLocations(input: $input) {
    items {
      id
      name
      coords {
        lat
        lng
      }
    }
    total
  }
}
    `;

/**
 * __useListLocationsQuery__
 *
 * To run a query within a React component, call `useListLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListLocationsQuery(baseOptions: Apollo.QueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables> & ({ variables: ListLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
      }
export function useListLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
        }
export function useListLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
        }
export type ListLocationsQueryHookResult = ReturnType<typeof useListLocationsQuery>;
export type ListLocationsLazyQueryHookResult = ReturnType<typeof useListLocationsLazyQuery>;
export type ListLocationsSuspenseQueryHookResult = ReturnType<typeof useListLocationsSuspenseQuery>;
export type ListLocationsQueryResult = Apollo.QueryResult<ListLocationsQuery, ListLocationsQueryVariables>;
export const ListCompaniesDocument = gql`
    query ListCompanies($input: ListCompaniesInput!) {
  listCompanies(input: $input) {
    items {
      id
      name
    }
    total
  }
}
    `;

/**
 * __useListCompaniesQuery__
 *
 * To run a query within a React component, call `useListCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompaniesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCompaniesQuery(baseOptions: Apollo.QueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables> & ({ variables: ListCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCompaniesQuery, ListCompaniesQueryVariables>(ListCompaniesDocument, options);
      }
export function useListCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCompaniesQuery, ListCompaniesQueryVariables>(ListCompaniesDocument, options);
        }
export function useListCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCompaniesQuery, ListCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCompaniesQuery, ListCompaniesQueryVariables>(ListCompaniesDocument, options);
        }
export type ListCompaniesQueryHookResult = ReturnType<typeof useListCompaniesQuery>;
export type ListCompaniesLazyQueryHookResult = ReturnType<typeof useListCompaniesLazyQuery>;
export type ListCompaniesSuspenseQueryHookResult = ReturnType<typeof useListCompaniesSuspenseQuery>;
export type ListCompaniesQueryResult = Apollo.QueryResult<ListCompaniesQuery, ListCompaniesQueryVariables>;
export const ListJobLeadJobTitlesDocument = gql`
    query ListJobLeadJobTitles($input: ListJobLeadJobTitlesInput!) {
  listJobLeadJobTitles(input: $input) {
    items {
      id
      title
    }
    total
  }
}
    `;

/**
 * __useListJobLeadJobTitlesQuery__
 *
 * To run a query within a React component, call `useListJobLeadJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobLeadJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobLeadJobTitlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListJobLeadJobTitlesQuery(baseOptions: Apollo.QueryHookOptions<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables> & ({ variables: ListJobLeadJobTitlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables>(ListJobLeadJobTitlesDocument, options);
      }
export function useListJobLeadJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables>(ListJobLeadJobTitlesDocument, options);
        }
export function useListJobLeadJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables>(ListJobLeadJobTitlesDocument, options);
        }
export type ListJobLeadJobTitlesQueryHookResult = ReturnType<typeof useListJobLeadJobTitlesQuery>;
export type ListJobLeadJobTitlesLazyQueryHookResult = ReturnType<typeof useListJobLeadJobTitlesLazyQuery>;
export type ListJobLeadJobTitlesSuspenseQueryHookResult = ReturnType<typeof useListJobLeadJobTitlesSuspenseQuery>;
export type ListJobLeadJobTitlesQueryResult = Apollo.QueryResult<ListJobLeadJobTitlesQuery, ListJobLeadJobTitlesQueryVariables>;
export const CreateVacancyFromJobLeadDocument = gql`
    mutation CreateVacancyFromJobLead($id: String!) {
  createVacancyFromJobLead(id: $id) {
    ...VacancyOutputFragment
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;
export type CreateVacancyFromJobLeadMutationFn = Apollo.MutationFunction<CreateVacancyFromJobLeadMutation, CreateVacancyFromJobLeadMutationVariables>;

/**
 * __useCreateVacancyFromJobLeadMutation__
 *
 * To run a mutation, you first call `useCreateVacancyFromJobLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacancyFromJobLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacancyFromJobLeadMutation, { data, loading, error }] = useCreateVacancyFromJobLeadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateVacancyFromJobLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacancyFromJobLeadMutation, CreateVacancyFromJobLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVacancyFromJobLeadMutation, CreateVacancyFromJobLeadMutationVariables>(CreateVacancyFromJobLeadDocument, options);
      }
export type CreateVacancyFromJobLeadMutationHookResult = ReturnType<typeof useCreateVacancyFromJobLeadMutation>;
export type CreateVacancyFromJobLeadMutationResult = Apollo.MutationResult<CreateVacancyFromJobLeadMutation>;
export type CreateVacancyFromJobLeadMutationOptions = Apollo.BaseMutationOptions<CreateVacancyFromJobLeadMutation, CreateVacancyFromJobLeadMutationVariables>;
export const UpsertJobLeadSearchDocument = gql`
    mutation UpsertJobLeadSearch($input: UpsertJobLeadSearchInput!) {
  upsertJobLeadSearch(input: $input) {
    ...JobLeadSearch
  }
}
    ${JobLeadSearchFragmentDoc}`;
export type UpsertJobLeadSearchMutationFn = Apollo.MutationFunction<UpsertJobLeadSearchMutation, UpsertJobLeadSearchMutationVariables>;

/**
 * __useUpsertJobLeadSearchMutation__
 *
 * To run a mutation, you first call `useUpsertJobLeadSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertJobLeadSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertJobLeadSearchMutation, { data, loading, error }] = useUpsertJobLeadSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertJobLeadSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpsertJobLeadSearchMutation, UpsertJobLeadSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertJobLeadSearchMutation, UpsertJobLeadSearchMutationVariables>(UpsertJobLeadSearchDocument, options);
      }
export type UpsertJobLeadSearchMutationHookResult = ReturnType<typeof useUpsertJobLeadSearchMutation>;
export type UpsertJobLeadSearchMutationResult = Apollo.MutationResult<UpsertJobLeadSearchMutation>;
export type UpsertJobLeadSearchMutationOptions = Apollo.BaseMutationOptions<UpsertJobLeadSearchMutation, UpsertJobLeadSearchMutationVariables>;
export const DeleteJobLeadSearchDocument = gql`
    mutation DeleteJobLeadSearch($id: String!) {
  deleteJobLeadSearch(id: $id) {
    id
  }
}
    `;
export type DeleteJobLeadSearchMutationFn = Apollo.MutationFunction<DeleteJobLeadSearchMutation, DeleteJobLeadSearchMutationVariables>;

/**
 * __useDeleteJobLeadSearchMutation__
 *
 * To run a mutation, you first call `useDeleteJobLeadSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobLeadSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobLeadSearchMutation, { data, loading, error }] = useDeleteJobLeadSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobLeadSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobLeadSearchMutation, DeleteJobLeadSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobLeadSearchMutation, DeleteJobLeadSearchMutationVariables>(DeleteJobLeadSearchDocument, options);
      }
export type DeleteJobLeadSearchMutationHookResult = ReturnType<typeof useDeleteJobLeadSearchMutation>;
export type DeleteJobLeadSearchMutationResult = Apollo.MutationResult<DeleteJobLeadSearchMutation>;
export type DeleteJobLeadSearchMutationOptions = Apollo.BaseMutationOptions<DeleteJobLeadSearchMutation, DeleteJobLeadSearchMutationVariables>;
export const AddJobLeadsToListDocument = gql`
    mutation AddJobLeadsToList($input: AddJobLeadsToListInput!) {
  addJobLeadsToList(input: $input) {
    count
  }
}
    `;
export type AddJobLeadsToListMutationFn = Apollo.MutationFunction<AddJobLeadsToListMutation, AddJobLeadsToListMutationVariables>;

/**
 * __useAddJobLeadsToListMutation__
 *
 * To run a mutation, you first call `useAddJobLeadsToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobLeadsToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobLeadsToListMutation, { data, loading, error }] = useAddJobLeadsToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJobLeadsToListMutation(baseOptions?: Apollo.MutationHookOptions<AddJobLeadsToListMutation, AddJobLeadsToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobLeadsToListMutation, AddJobLeadsToListMutationVariables>(AddJobLeadsToListDocument, options);
      }
export type AddJobLeadsToListMutationHookResult = ReturnType<typeof useAddJobLeadsToListMutation>;
export type AddJobLeadsToListMutationResult = Apollo.MutationResult<AddJobLeadsToListMutation>;
export type AddJobLeadsToListMutationOptions = Apollo.BaseMutationOptions<AddJobLeadsToListMutation, AddJobLeadsToListMutationVariables>;
export const RemoveJobLeadsFromListDocument = gql`
    mutation RemoveJobLeadsFromList($input: RemoveJobLeadsFromListInput!) {
  removeJobLeadsFromList(input: $input) {
    count
  }
}
    `;
export type RemoveJobLeadsFromListMutationFn = Apollo.MutationFunction<RemoveJobLeadsFromListMutation, RemoveJobLeadsFromListMutationVariables>;

/**
 * __useRemoveJobLeadsFromListMutation__
 *
 * To run a mutation, you first call `useRemoveJobLeadsFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJobLeadsFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJobLeadsFromListMutation, { data, loading, error }] = useRemoveJobLeadsFromListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveJobLeadsFromListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJobLeadsFromListMutation, RemoveJobLeadsFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveJobLeadsFromListMutation, RemoveJobLeadsFromListMutationVariables>(RemoveJobLeadsFromListDocument, options);
      }
export type RemoveJobLeadsFromListMutationHookResult = ReturnType<typeof useRemoveJobLeadsFromListMutation>;
export type RemoveJobLeadsFromListMutationResult = Apollo.MutationResult<RemoveJobLeadsFromListMutation>;
export type RemoveJobLeadsFromListMutationOptions = Apollo.BaseMutationOptions<RemoveJobLeadsFromListMutation, RemoveJobLeadsFromListMutationVariables>;
export const AddCompanyMembersToListDocument = gql`
    mutation AddCompanyMembersToList($input: AddCompanyMembersToListInput!) {
  addCompanyMembersToList(input: $input) {
    count
  }
}
    `;
export type AddCompanyMembersToListMutationFn = Apollo.MutationFunction<AddCompanyMembersToListMutation, AddCompanyMembersToListMutationVariables>;

/**
 * __useAddCompanyMembersToListMutation__
 *
 * To run a mutation, you first call `useAddCompanyMembersToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMembersToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMembersToListMutation, { data, loading, error }] = useAddCompanyMembersToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyMembersToListMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyMembersToListMutation, AddCompanyMembersToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyMembersToListMutation, AddCompanyMembersToListMutationVariables>(AddCompanyMembersToListDocument, options);
      }
export type AddCompanyMembersToListMutationHookResult = ReturnType<typeof useAddCompanyMembersToListMutation>;
export type AddCompanyMembersToListMutationResult = Apollo.MutationResult<AddCompanyMembersToListMutation>;
export type AddCompanyMembersToListMutationOptions = Apollo.BaseMutationOptions<AddCompanyMembersToListMutation, AddCompanyMembersToListMutationVariables>;
export const RemoveCompanyMembersFromListDocument = gql`
    mutation RemoveCompanyMembersFromList($input: RemoveCompanyMembersFromListInput!) {
  removeCompanyMembersFromList(input: $input) {
    count
  }
}
    `;
export type RemoveCompanyMembersFromListMutationFn = Apollo.MutationFunction<RemoveCompanyMembersFromListMutation, RemoveCompanyMembersFromListMutationVariables>;

/**
 * __useRemoveCompanyMembersFromListMutation__
 *
 * To run a mutation, you first call `useRemoveCompanyMembersFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompanyMembersFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompanyMembersFromListMutation, { data, loading, error }] = useRemoveCompanyMembersFromListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCompanyMembersFromListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompanyMembersFromListMutation, RemoveCompanyMembersFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompanyMembersFromListMutation, RemoveCompanyMembersFromListMutationVariables>(RemoveCompanyMembersFromListDocument, options);
      }
export type RemoveCompanyMembersFromListMutationHookResult = ReturnType<typeof useRemoveCompanyMembersFromListMutation>;
export type RemoveCompanyMembersFromListMutationResult = Apollo.MutationResult<RemoveCompanyMembersFromListMutation>;
export type RemoveCompanyMembersFromListMutationOptions = Apollo.BaseMutationOptions<RemoveCompanyMembersFromListMutation, RemoveCompanyMembersFromListMutationVariables>;
export const FetchCompanyInformationDocument = gql`
    mutation FetchCompanyInformation($companyId: String!) {
  fetchCompanyInformation(id: $companyId) {
    id
    name
  }
}
    `;
export type FetchCompanyInformationMutationFn = Apollo.MutationFunction<FetchCompanyInformationMutation, FetchCompanyInformationMutationVariables>;

/**
 * __useFetchCompanyInformationMutation__
 *
 * To run a mutation, you first call `useFetchCompanyInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchCompanyInformationMutation, { data, loading, error }] = useFetchCompanyInformationMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyInformationMutation(baseOptions?: Apollo.MutationHookOptions<FetchCompanyInformationMutation, FetchCompanyInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchCompanyInformationMutation, FetchCompanyInformationMutationVariables>(FetchCompanyInformationDocument, options);
      }
export type FetchCompanyInformationMutationHookResult = ReturnType<typeof useFetchCompanyInformationMutation>;
export type FetchCompanyInformationMutationResult = Apollo.MutationResult<FetchCompanyInformationMutation>;
export type FetchCompanyInformationMutationOptions = Apollo.BaseMutationOptions<FetchCompanyInformationMutation, FetchCompanyInformationMutationVariables>;
export const DeleteJobLeadListDocument = gql`
    mutation DeleteJobLeadList($id: String!) {
  deleteJobLeadList(id: $id) {
    id
  }
}
    `;
export type DeleteJobLeadListMutationFn = Apollo.MutationFunction<DeleteJobLeadListMutation, DeleteJobLeadListMutationVariables>;

/**
 * __useDeleteJobLeadListMutation__
 *
 * To run a mutation, you first call `useDeleteJobLeadListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobLeadListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobLeadListMutation, { data, loading, error }] = useDeleteJobLeadListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobLeadListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobLeadListMutation, DeleteJobLeadListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobLeadListMutation, DeleteJobLeadListMutationVariables>(DeleteJobLeadListDocument, options);
      }
export type DeleteJobLeadListMutationHookResult = ReturnType<typeof useDeleteJobLeadListMutation>;
export type DeleteJobLeadListMutationResult = Apollo.MutationResult<DeleteJobLeadListMutation>;
export type DeleteJobLeadListMutationOptions = Apollo.BaseMutationOptions<DeleteJobLeadListMutation, DeleteJobLeadListMutationVariables>;
export const DeleteCompanyMemberListDocument = gql`
    mutation DeleteCompanyMemberList($id: String!) {
  deleteCompanyMemberList(id: $id) {
    id
  }
}
    `;
export type DeleteCompanyMemberListMutationFn = Apollo.MutationFunction<DeleteCompanyMemberListMutation, DeleteCompanyMemberListMutationVariables>;

/**
 * __useDeleteCompanyMemberListMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMemberListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMemberListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMemberListMutation, { data, loading, error }] = useDeleteCompanyMemberListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMemberListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMemberListMutation, DeleteCompanyMemberListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMemberListMutation, DeleteCompanyMemberListMutationVariables>(DeleteCompanyMemberListDocument, options);
      }
export type DeleteCompanyMemberListMutationHookResult = ReturnType<typeof useDeleteCompanyMemberListMutation>;
export type DeleteCompanyMemberListMutationResult = Apollo.MutationResult<DeleteCompanyMemberListMutation>;
export type DeleteCompanyMemberListMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMemberListMutation, DeleteCompanyMemberListMutationVariables>;
export const SaveSequencerAuthDocument = gql`
    mutation SaveSequencerAuth($auth: SaveSequencerAuthInput!) {
  saveSequencerAuth(auth: $auth) {
    ...SequencerAuthStatusFragment
  }
}
    ${SequencerAuthStatusFragmentFragmentDoc}`;
export type SaveSequencerAuthMutationFn = Apollo.MutationFunction<SaveSequencerAuthMutation, SaveSequencerAuthMutationVariables>;

/**
 * __useSaveSequencerAuthMutation__
 *
 * To run a mutation, you first call `useSaveSequencerAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSequencerAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSequencerAuthMutation, { data, loading, error }] = useSaveSequencerAuthMutation({
 *   variables: {
 *      auth: // value for 'auth'
 *   },
 * });
 */
export function useSaveSequencerAuthMutation(baseOptions?: Apollo.MutationHookOptions<SaveSequencerAuthMutation, SaveSequencerAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSequencerAuthMutation, SaveSequencerAuthMutationVariables>(SaveSequencerAuthDocument, options);
      }
export type SaveSequencerAuthMutationHookResult = ReturnType<typeof useSaveSequencerAuthMutation>;
export type SaveSequencerAuthMutationResult = Apollo.MutationResult<SaveSequencerAuthMutation>;
export type SaveSequencerAuthMutationOptions = Apollo.BaseMutationOptions<SaveSequencerAuthMutation, SaveSequencerAuthMutationVariables>;
export const GetSequencerAuthStatusDocument = gql`
    query GetSequencerAuthStatus {
  getSequencerAuthStatus {
    ...SequencerAuthStatusFragment
  }
}
    ${SequencerAuthStatusFragmentFragmentDoc}`;

/**
 * __useGetSequencerAuthStatusQuery__
 *
 * To run a query within a React component, call `useGetSequencerAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequencerAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequencerAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSequencerAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>(GetSequencerAuthStatusDocument, options);
      }
export function useGetSequencerAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>(GetSequencerAuthStatusDocument, options);
        }
export function useGetSequencerAuthStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>(GetSequencerAuthStatusDocument, options);
        }
export type GetSequencerAuthStatusQueryHookResult = ReturnType<typeof useGetSequencerAuthStatusQuery>;
export type GetSequencerAuthStatusLazyQueryHookResult = ReturnType<typeof useGetSequencerAuthStatusLazyQuery>;
export type GetSequencerAuthStatusSuspenseQueryHookResult = ReturnType<typeof useGetSequencerAuthStatusSuspenseQuery>;
export type GetSequencerAuthStatusQueryResult = Apollo.QueryResult<GetSequencerAuthStatusQuery, GetSequencerAuthStatusQueryVariables>;
export const SendContactSequenceDocument = gql`
    mutation SendContactSequence($input: SendContactSequenceArgs!) {
  sendContactSequence(input: $input) {
    ...SendContactSequenceOutput
  }
}
    ${SendContactSequenceOutputFragmentDoc}`;
export type SendContactSequenceMutationFn = Apollo.MutationFunction<SendContactSequenceMutation, SendContactSequenceMutationVariables>;

/**
 * __useSendContactSequenceMutation__
 *
 * To run a mutation, you first call `useSendContactSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactSequenceMutation, { data, loading, error }] = useSendContactSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendContactSequenceMutation(baseOptions?: Apollo.MutationHookOptions<SendContactSequenceMutation, SendContactSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactSequenceMutation, SendContactSequenceMutationVariables>(SendContactSequenceDocument, options);
      }
export type SendContactSequenceMutationHookResult = ReturnType<typeof useSendContactSequenceMutation>;
export type SendContactSequenceMutationResult = Apollo.MutationResult<SendContactSequenceMutation>;
export type SendContactSequenceMutationOptions = Apollo.BaseMutationOptions<SendContactSequenceMutation, SendContactSequenceMutationVariables>;
export const UnauthenticateSequencerDocument = gql`
    mutation UnauthenticateSequencer {
  unauthenticateSequencer {
    ...SequencerAuthStatusFragment
  }
}
    ${SequencerAuthStatusFragmentFragmentDoc}`;
export type UnauthenticateSequencerMutationFn = Apollo.MutationFunction<UnauthenticateSequencerMutation, UnauthenticateSequencerMutationVariables>;

/**
 * __useUnauthenticateSequencerMutation__
 *
 * To run a mutation, you first call `useUnauthenticateSequencerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnauthenticateSequencerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unauthenticateSequencerMutation, { data, loading, error }] = useUnauthenticateSequencerMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnauthenticateSequencerMutation(baseOptions?: Apollo.MutationHookOptions<UnauthenticateSequencerMutation, UnauthenticateSequencerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnauthenticateSequencerMutation, UnauthenticateSequencerMutationVariables>(UnauthenticateSequencerDocument, options);
      }
export type UnauthenticateSequencerMutationHookResult = ReturnType<typeof useUnauthenticateSequencerMutation>;
export type UnauthenticateSequencerMutationResult = Apollo.MutationResult<UnauthenticateSequencerMutation>;
export type UnauthenticateSequencerMutationOptions = Apollo.BaseMutationOptions<UnauthenticateSequencerMutation, UnauthenticateSequencerMutationVariables>;
export const ListCandidateContactHistoryDocument = gql`
    query ListCandidateContactHistory($filter: CandidateContactHistoryFilter, $pagination: OffsetPagination) {
  listCandidateContactHistory(filter: $filter, pagination: $pagination) {
    items {
      ...CandidateContactHistoryItem
    }
    total
    nextToken
    stats {
      ...CandidateContactHistoryStats
    }
  }
}
    ${CandidateContactHistoryItemFragmentDoc}
${CandidateContactHistoryStatsFragmentDoc}`;

/**
 * __useListCandidateContactHistoryQuery__
 *
 * To run a query within a React component, call `useListCandidateContactHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateContactHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateContactHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListCandidateContactHistoryQuery(baseOptions?: Apollo.QueryHookOptions<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>(ListCandidateContactHistoryDocument, options);
      }
export function useListCandidateContactHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>(ListCandidateContactHistoryDocument, options);
        }
export function useListCandidateContactHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>(ListCandidateContactHistoryDocument, options);
        }
export type ListCandidateContactHistoryQueryHookResult = ReturnType<typeof useListCandidateContactHistoryQuery>;
export type ListCandidateContactHistoryLazyQueryHookResult = ReturnType<typeof useListCandidateContactHistoryLazyQuery>;
export type ListCandidateContactHistorySuspenseQueryHookResult = ReturnType<typeof useListCandidateContactHistorySuspenseQuery>;
export type ListCandidateContactHistoryQueryResult = Apollo.QueryResult<ListCandidateContactHistoryQuery, ListCandidateContactHistoryQueryVariables>;
export const ListCandidateContactHistoryWithTrackingDocument = gql`
    query ListCandidateContactHistoryWithTracking($filter: CandidateContactHistoryFilter, $pagination: OffsetPagination) {
  listCandidateContactHistory(filter: $filter, pagination: $pagination) {
    items {
      ...CandidateContactHistoryItemWithTracking
    }
    total
    nextToken
    stats {
      ...CandidateContactHistoryStats
    }
  }
}
    ${CandidateContactHistoryItemWithTrackingFragmentDoc}
${CandidateContactHistoryStatsFragmentDoc}`;

/**
 * __useListCandidateContactHistoryWithTrackingQuery__
 *
 * To run a query within a React component, call `useListCandidateContactHistoryWithTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateContactHistoryWithTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateContactHistoryWithTrackingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListCandidateContactHistoryWithTrackingQuery(baseOptions?: Apollo.QueryHookOptions<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>(ListCandidateContactHistoryWithTrackingDocument, options);
      }
export function useListCandidateContactHistoryWithTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>(ListCandidateContactHistoryWithTrackingDocument, options);
        }
export function useListCandidateContactHistoryWithTrackingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>(ListCandidateContactHistoryWithTrackingDocument, options);
        }
export type ListCandidateContactHistoryWithTrackingQueryHookResult = ReturnType<typeof useListCandidateContactHistoryWithTrackingQuery>;
export type ListCandidateContactHistoryWithTrackingLazyQueryHookResult = ReturnType<typeof useListCandidateContactHistoryWithTrackingLazyQuery>;
export type ListCandidateContactHistoryWithTrackingSuspenseQueryHookResult = ReturnType<typeof useListCandidateContactHistoryWithTrackingSuspenseQuery>;
export type ListCandidateContactHistoryWithTrackingQueryResult = Apollo.QueryResult<ListCandidateContactHistoryWithTrackingQuery, ListCandidateContactHistoryWithTrackingQueryVariables>;
export const GetEmailCompletionDocument = gql`
    mutation GetEmailCompletion($input: GetEmailCompletion!) {
  getEmailCompletion(input: $input) {
    subject
    body
    id
  }
}
    `;
export type GetEmailCompletionMutationFn = Apollo.MutationFunction<GetEmailCompletionMutation, GetEmailCompletionMutationVariables>;

/**
 * __useGetEmailCompletionMutation__
 *
 * To run a mutation, you first call `useGetEmailCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEmailCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEmailCompletionMutation, { data, loading, error }] = useGetEmailCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailCompletionMutation(baseOptions?: Apollo.MutationHookOptions<GetEmailCompletionMutation, GetEmailCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEmailCompletionMutation, GetEmailCompletionMutationVariables>(GetEmailCompletionDocument, options);
      }
export type GetEmailCompletionMutationHookResult = ReturnType<typeof useGetEmailCompletionMutation>;
export type GetEmailCompletionMutationResult = Apollo.MutationResult<GetEmailCompletionMutation>;
export type GetEmailCompletionMutationOptions = Apollo.BaseMutationOptions<GetEmailCompletionMutation, GetEmailCompletionMutationVariables>;
export const SaveEmailToTrainDocument = gql`
    mutation SaveEmailToTrain($input: SaveTrainedEmailInput!) {
  saveTrainedEmail(input: $input) {
    id
  }
}
    `;
export type SaveEmailToTrainMutationFn = Apollo.MutationFunction<SaveEmailToTrainMutation, SaveEmailToTrainMutationVariables>;

/**
 * __useSaveEmailToTrainMutation__
 *
 * To run a mutation, you first call `useSaveEmailToTrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailToTrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailToTrainMutation, { data, loading, error }] = useSaveEmailToTrainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveEmailToTrainMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailToTrainMutation, SaveEmailToTrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailToTrainMutation, SaveEmailToTrainMutationVariables>(SaveEmailToTrainDocument, options);
      }
export type SaveEmailToTrainMutationHookResult = ReturnType<typeof useSaveEmailToTrainMutation>;
export type SaveEmailToTrainMutationResult = Apollo.MutationResult<SaveEmailToTrainMutation>;
export type SaveEmailToTrainMutationOptions = Apollo.BaseMutationOptions<SaveEmailToTrainMutation, SaveEmailToTrainMutationVariables>;
export const GetEmailsToTrainDocument = gql`
    query GetEmailsToTrain {
  getEmailsToTrain {
    id
    prompt
    aiEmail
    trainingEmail
    candidate {
      id
      linkedInUrl
    }
  }
}
    `;

/**
 * __useGetEmailsToTrainQuery__
 *
 * To run a query within a React component, call `useGetEmailsToTrainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailsToTrainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailsToTrainQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailsToTrainQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>(GetEmailsToTrainDocument, options);
      }
export function useGetEmailsToTrainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>(GetEmailsToTrainDocument, options);
        }
export function useGetEmailsToTrainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>(GetEmailsToTrainDocument, options);
        }
export type GetEmailsToTrainQueryHookResult = ReturnType<typeof useGetEmailsToTrainQuery>;
export type GetEmailsToTrainLazyQueryHookResult = ReturnType<typeof useGetEmailsToTrainLazyQuery>;
export type GetEmailsToTrainSuspenseQueryHookResult = ReturnType<typeof useGetEmailsToTrainSuspenseQuery>;
export type GetEmailsToTrainQueryResult = Apollo.QueryResult<GetEmailsToTrainQuery, GetEmailsToTrainQueryVariables>;
export const CancelSequenceDocument = gql`
    mutation CancelSequence($input: CancelSequenceInput!) {
  cancelSequence(input: $input) {
    messagesCount
  }
}
    `;
export type CancelSequenceMutationFn = Apollo.MutationFunction<CancelSequenceMutation, CancelSequenceMutationVariables>;

/**
 * __useCancelSequenceMutation__
 *
 * To run a mutation, you first call `useCancelSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSequenceMutation, { data, loading, error }] = useCancelSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSequenceMutation(baseOptions?: Apollo.MutationHookOptions<CancelSequenceMutation, CancelSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSequenceMutation, CancelSequenceMutationVariables>(CancelSequenceDocument, options);
      }
export type CancelSequenceMutationHookResult = ReturnType<typeof useCancelSequenceMutation>;
export type CancelSequenceMutationResult = Apollo.MutationResult<CancelSequenceMutation>;
export type CancelSequenceMutationOptions = Apollo.BaseMutationOptions<CancelSequenceMutation, CancelSequenceMutationVariables>;
export const ListCandidateScheduledEmailsDocument = gql`
    query ListCandidateScheduledEmails($candidateId: String!) {
  listCandidateScheduledEmails(candidateId: $candidateId) {
    sendAfter
    from
    subject
    threadId
    emailSequenceId
  }
}
    `;

/**
 * __useListCandidateScheduledEmailsQuery__
 *
 * To run a query within a React component, call `useListCandidateScheduledEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateScheduledEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateScheduledEmailsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useListCandidateScheduledEmailsQuery(baseOptions: Apollo.QueryHookOptions<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables> & ({ variables: ListCandidateScheduledEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables>(ListCandidateScheduledEmailsDocument, options);
      }
export function useListCandidateScheduledEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables>(ListCandidateScheduledEmailsDocument, options);
        }
export function useListCandidateScheduledEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables>(ListCandidateScheduledEmailsDocument, options);
        }
export type ListCandidateScheduledEmailsQueryHookResult = ReturnType<typeof useListCandidateScheduledEmailsQuery>;
export type ListCandidateScheduledEmailsLazyQueryHookResult = ReturnType<typeof useListCandidateScheduledEmailsLazyQuery>;
export type ListCandidateScheduledEmailsSuspenseQueryHookResult = ReturnType<typeof useListCandidateScheduledEmailsSuspenseQuery>;
export type ListCandidateScheduledEmailsQueryResult = Apollo.QueryResult<ListCandidateScheduledEmailsQuery, ListCandidateScheduledEmailsQueryVariables>;
export const UpdateSequencesDocument = gql`
    mutation UpdateSequences($input: UpdateEmailsInput!) {
  updateEmails(input: $input) {
    id
  }
}
    `;
export type UpdateSequencesMutationFn = Apollo.MutationFunction<UpdateSequencesMutation, UpdateSequencesMutationVariables>;

/**
 * __useUpdateSequencesMutation__
 *
 * To run a mutation, you first call `useUpdateSequencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSequencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSequencesMutation, { data, loading, error }] = useUpdateSequencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSequencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSequencesMutation, UpdateSequencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSequencesMutation, UpdateSequencesMutationVariables>(UpdateSequencesDocument, options);
      }
export type UpdateSequencesMutationHookResult = ReturnType<typeof useUpdateSequencesMutation>;
export type UpdateSequencesMutationResult = Apollo.MutationResult<UpdateSequencesMutation>;
export type UpdateSequencesMutationOptions = Apollo.BaseMutationOptions<UpdateSequencesMutation, UpdateSequencesMutationVariables>;
export const GetEmailSequenceDetailsDocument = gql`
    mutation GetEmailSequenceDetails($input: GetEmailSequenceInput!) {
  getEmailSequenceDetails(input: $input) {
    id
    state
    emails {
      subject
      bodyHtml
    }
  }
}
    `;
export type GetEmailSequenceDetailsMutationFn = Apollo.MutationFunction<GetEmailSequenceDetailsMutation, GetEmailSequenceDetailsMutationVariables>;

/**
 * __useGetEmailSequenceDetailsMutation__
 *
 * To run a mutation, you first call `useGetEmailSequenceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEmailSequenceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEmailSequenceDetailsMutation, { data, loading, error }] = useGetEmailSequenceDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailSequenceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetEmailSequenceDetailsMutation, GetEmailSequenceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEmailSequenceDetailsMutation, GetEmailSequenceDetailsMutationVariables>(GetEmailSequenceDetailsDocument, options);
      }
export type GetEmailSequenceDetailsMutationHookResult = ReturnType<typeof useGetEmailSequenceDetailsMutation>;
export type GetEmailSequenceDetailsMutationResult = Apollo.MutationResult<GetEmailSequenceDetailsMutation>;
export type GetEmailSequenceDetailsMutationOptions = Apollo.BaseMutationOptions<GetEmailSequenceDetailsMutation, GetEmailSequenceDetailsMutationVariables>;
export const PresignUploadPublicAssetsDocument = gql`
    mutation PresignUploadPublicAssets($input: PresignUploadAssetsInput!) {
  presignUploadPublicAssets(input: $input) {
    presignedUrls {
      url
      key
      fileName
    }
  }
}
    `;
export type PresignUploadPublicAssetsMutationFn = Apollo.MutationFunction<PresignUploadPublicAssetsMutation, PresignUploadPublicAssetsMutationVariables>;

/**
 * __usePresignUploadPublicAssetsMutation__
 *
 * To run a mutation, you first call `usePresignUploadPublicAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePresignUploadPublicAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [presignUploadPublicAssetsMutation, { data, loading, error }] = usePresignUploadPublicAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePresignUploadPublicAssetsMutation(baseOptions?: Apollo.MutationHookOptions<PresignUploadPublicAssetsMutation, PresignUploadPublicAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PresignUploadPublicAssetsMutation, PresignUploadPublicAssetsMutationVariables>(PresignUploadPublicAssetsDocument, options);
      }
export type PresignUploadPublicAssetsMutationHookResult = ReturnType<typeof usePresignUploadPublicAssetsMutation>;
export type PresignUploadPublicAssetsMutationResult = Apollo.MutationResult<PresignUploadPublicAssetsMutation>;
export type PresignUploadPublicAssetsMutationOptions = Apollo.BaseMutationOptions<PresignUploadPublicAssetsMutation, PresignUploadPublicAssetsMutationVariables>;
export const SaveHumanMatchDocument = gql`
    mutation SaveHumanMatch($input: SaveHumanMatch!) {
  saveHumanMatch(input: $input) {
    id
  }
}
    `;
export type SaveHumanMatchMutationFn = Apollo.MutationFunction<SaveHumanMatchMutation, SaveHumanMatchMutationVariables>;

/**
 * __useSaveHumanMatchMutation__
 *
 * To run a mutation, you first call `useSaveHumanMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHumanMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHumanMatchMutation, { data, loading, error }] = useSaveHumanMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHumanMatchMutation(baseOptions?: Apollo.MutationHookOptions<SaveHumanMatchMutation, SaveHumanMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveHumanMatchMutation, SaveHumanMatchMutationVariables>(SaveHumanMatchDocument, options);
      }
export type SaveHumanMatchMutationHookResult = ReturnType<typeof useSaveHumanMatchMutation>;
export type SaveHumanMatchMutationResult = Apollo.MutationResult<SaveHumanMatchMutation>;
export type SaveHumanMatchMutationOptions = Apollo.BaseMutationOptions<SaveHumanMatchMutation, SaveHumanMatchMutationVariables>;
export const RecordMatchViewedDocument = gql`
    mutation RecordMatchViewed($matchId: String!) {
  recordMatchViewed(matchId: $matchId) {
    id
  }
}
    `;
export type RecordMatchViewedMutationFn = Apollo.MutationFunction<RecordMatchViewedMutation, RecordMatchViewedMutationVariables>;

/**
 * __useRecordMatchViewedMutation__
 *
 * To run a mutation, you first call `useRecordMatchViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordMatchViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordMatchViewedMutation, { data, loading, error }] = useRecordMatchViewedMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useRecordMatchViewedMutation(baseOptions?: Apollo.MutationHookOptions<RecordMatchViewedMutation, RecordMatchViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordMatchViewedMutation, RecordMatchViewedMutationVariables>(RecordMatchViewedDocument, options);
      }
export type RecordMatchViewedMutationHookResult = ReturnType<typeof useRecordMatchViewedMutation>;
export type RecordMatchViewedMutationResult = Apollo.MutationResult<RecordMatchViewedMutation>;
export type RecordMatchViewedMutationOptions = Apollo.BaseMutationOptions<RecordMatchViewedMutation, RecordMatchViewedMutationVariables>;
export const ApproveCandidateMatchDocument = gql`
    mutation ApproveCandidateMatch($matchId: String!) {
  approveCandidateMatch(matchId: $matchId) {
    id
  }
}
    `;
export type ApproveCandidateMatchMutationFn = Apollo.MutationFunction<ApproveCandidateMatchMutation, ApproveCandidateMatchMutationVariables>;

/**
 * __useApproveCandidateMatchMutation__
 *
 * To run a mutation, you first call `useApproveCandidateMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCandidateMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCandidateMatchMutation, { data, loading, error }] = useApproveCandidateMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useApproveCandidateMatchMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCandidateMatchMutation, ApproveCandidateMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCandidateMatchMutation, ApproveCandidateMatchMutationVariables>(ApproveCandidateMatchDocument, options);
      }
export type ApproveCandidateMatchMutationHookResult = ReturnType<typeof useApproveCandidateMatchMutation>;
export type ApproveCandidateMatchMutationResult = Apollo.MutationResult<ApproveCandidateMatchMutation>;
export type ApproveCandidateMatchMutationOptions = Apollo.BaseMutationOptions<ApproveCandidateMatchMutation, ApproveCandidateMatchMutationVariables>;
export const ListCandidateVacancyMatchesDocument = gql`
    query ListCandidateVacancyMatches($vacancyId: String, $candidateId: String, $query: String, $take: Int, $page: Int, $includeNoApproved: Boolean, $includeVacanciesWithoutMatches: Boolean, $kickOffMatchesForOpenVacancies: Boolean, $type: MatchType) {
  listCandidateVacancyMatches(
    vacancyId: $vacancyId
    candidateId: $candidateId
    query: $query
    take: $take
    page: $page
    includeNoApproved: $includeNoApproved
    includeVacanciesWithoutMatches: $includeVacanciesWithoutMatches
    kickOffMatchesForOpenVacancies: $kickOffMatchesForOpenVacancies
    type: $type
  ) {
    items {
      vacancy {
        id
        name
      }
      match {
        id
        match
        matchType
        viewedAt
        createdAt
      }
      approvedAt
      candidate {
        id
        firstName
        lastName
        liHeadline
        avatarS3Bucket
        avatarThumbS3Key
        linkedInUrl
      }
      isNewMatch
    }
    page
    total
  }
}
    `;

/**
 * __useListCandidateVacancyMatchesQuery__
 *
 * To run a query within a React component, call `useListCandidateVacancyMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateVacancyMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateVacancyMatchesQuery({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      candidateId: // value for 'candidateId'
 *      query: // value for 'query'
 *      take: // value for 'take'
 *      page: // value for 'page'
 *      includeNoApproved: // value for 'includeNoApproved'
 *      includeVacanciesWithoutMatches: // value for 'includeVacanciesWithoutMatches'
 *      kickOffMatchesForOpenVacancies: // value for 'kickOffMatchesForOpenVacancies'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useListCandidateVacancyMatchesQuery(baseOptions?: Apollo.QueryHookOptions<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>(ListCandidateVacancyMatchesDocument, options);
      }
export function useListCandidateVacancyMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>(ListCandidateVacancyMatchesDocument, options);
        }
export function useListCandidateVacancyMatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>(ListCandidateVacancyMatchesDocument, options);
        }
export type ListCandidateVacancyMatchesQueryHookResult = ReturnType<typeof useListCandidateVacancyMatchesQuery>;
export type ListCandidateVacancyMatchesLazyQueryHookResult = ReturnType<typeof useListCandidateVacancyMatchesLazyQuery>;
export type ListCandidateVacancyMatchesSuspenseQueryHookResult = ReturnType<typeof useListCandidateVacancyMatchesSuspenseQuery>;
export type ListCandidateVacancyMatchesQueryResult = Apollo.QueryResult<ListCandidateVacancyMatchesQuery, ListCandidateVacancyMatchesQueryVariables>;
export const CreateCandidateVacancyMatchDocument = gql`
    mutation CreateCandidateVacancyMatch($vacancyId: String!, $candidateLinkedInUrl: String!) {
  createNewCandidateMatch(
    input: {humanAssistedMatch: {candidateLinkedInUrl: $candidateLinkedInUrl, vacancyId: $vacancyId}}
  ) {
    id
  }
}
    `;
export type CreateCandidateVacancyMatchMutationFn = Apollo.MutationFunction<CreateCandidateVacancyMatchMutation, CreateCandidateVacancyMatchMutationVariables>;

/**
 * __useCreateCandidateVacancyMatchMutation__
 *
 * To run a mutation, you first call `useCreateCandidateVacancyMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateVacancyMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateVacancyMatchMutation, { data, loading, error }] = useCreateCandidateVacancyMatchMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      candidateLinkedInUrl: // value for 'candidateLinkedInUrl'
 *   },
 * });
 */
export function useCreateCandidateVacancyMatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateVacancyMatchMutation, CreateCandidateVacancyMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateVacancyMatchMutation, CreateCandidateVacancyMatchMutationVariables>(CreateCandidateVacancyMatchDocument, options);
      }
export type CreateCandidateVacancyMatchMutationHookResult = ReturnType<typeof useCreateCandidateVacancyMatchMutation>;
export type CreateCandidateVacancyMatchMutationResult = Apollo.MutationResult<CreateCandidateVacancyMatchMutation>;
export type CreateCandidateVacancyMatchMutationOptions = Apollo.BaseMutationOptions<CreateCandidateVacancyMatchMutation, CreateCandidateVacancyMatchMutationVariables>;
export const DeleteCandidateVacancyMatchDocument = gql`
    mutation DeleteCandidateVacancyMatch($vacancyId: String!, $candidateId: String!) {
  deleteCandidateMatch(
    input: {candidateId: $candidateId, vacancyId: $vacancyId, type: HUMAN_ASSISTED}
  ) {
    count
  }
}
    `;
export type DeleteCandidateVacancyMatchMutationFn = Apollo.MutationFunction<DeleteCandidateVacancyMatchMutation, DeleteCandidateVacancyMatchMutationVariables>;

/**
 * __useDeleteCandidateVacancyMatchMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateVacancyMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateVacancyMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateVacancyMatchMutation, { data, loading, error }] = useDeleteCandidateVacancyMatchMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useDeleteCandidateVacancyMatchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateVacancyMatchMutation, DeleteCandidateVacancyMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateVacancyMatchMutation, DeleteCandidateVacancyMatchMutationVariables>(DeleteCandidateVacancyMatchDocument, options);
      }
export type DeleteCandidateVacancyMatchMutationHookResult = ReturnType<typeof useDeleteCandidateVacancyMatchMutation>;
export type DeleteCandidateVacancyMatchMutationResult = Apollo.MutationResult<DeleteCandidateVacancyMatchMutation>;
export type DeleteCandidateVacancyMatchMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateVacancyMatchMutation, DeleteCandidateVacancyMatchMutationVariables>;
export const SendSlackNotificationDocument = gql`
    mutation SendSlackNotification($input: SendSlackNotificationInput!) {
  sendSlackNotification(input: $input) {
    id
  }
}
    `;
export type SendSlackNotificationMutationFn = Apollo.MutationFunction<SendSlackNotificationMutation, SendSlackNotificationMutationVariables>;

/**
 * __useSendSlackNotificationMutation__
 *
 * To run a mutation, you first call `useSendSlackNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSlackNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSlackNotificationMutation, { data, loading, error }] = useSendSlackNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSlackNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendSlackNotificationMutation, SendSlackNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSlackNotificationMutation, SendSlackNotificationMutationVariables>(SendSlackNotificationDocument, options);
      }
export type SendSlackNotificationMutationHookResult = ReturnType<typeof useSendSlackNotificationMutation>;
export type SendSlackNotificationMutationResult = Apollo.MutationResult<SendSlackNotificationMutation>;
export type SendSlackNotificationMutationOptions = Apollo.BaseMutationOptions<SendSlackNotificationMutation, SendSlackNotificationMutationVariables>;
export const GetAllTeamMetricsDocument = gql`
    query GetAllTeamMetrics {
  getAllTeamMetrics {
    id
    label
  }
}
    `;

/**
 * __useGetAllTeamMetricsQuery__
 *
 * To run a query within a React component, call `useGetAllTeamMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTeamMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTeamMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTeamMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>(GetAllTeamMetricsDocument, options);
      }
export function useGetAllTeamMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>(GetAllTeamMetricsDocument, options);
        }
export function useGetAllTeamMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>(GetAllTeamMetricsDocument, options);
        }
export type GetAllTeamMetricsQueryHookResult = ReturnType<typeof useGetAllTeamMetricsQuery>;
export type GetAllTeamMetricsLazyQueryHookResult = ReturnType<typeof useGetAllTeamMetricsLazyQuery>;
export type GetAllTeamMetricsSuspenseQueryHookResult = ReturnType<typeof useGetAllTeamMetricsSuspenseQuery>;
export type GetAllTeamMetricsQueryResult = Apollo.QueryResult<GetAllTeamMetricsQuery, GetAllTeamMetricsQueryVariables>;
export const GetTeamPerformanceDocument = gql`
    query GetTeamPerformance($startedAt: AWSDateTime!, $endedAt: AWSDateTime!) {
  getTeamPerformance(timeRange: {start: $startedAt, end: $endedAt}) {
    topPerformers {
      user {
        id
        name
        avatar
      }
      metrics {
        id
        label
        value
      }
    }
    underPerformers {
      user {
        id
        name
        avatar
      }
      metrics {
        id
        label
        value
      }
    }
  }
}
    `;

/**
 * __useGetTeamPerformanceQuery__
 *
 * To run a query within a React component, call `useGetTeamPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamPerformanceQuery({
 *   variables: {
 *      startedAt: // value for 'startedAt'
 *      endedAt: // value for 'endedAt'
 *   },
 * });
 */
export function useGetTeamPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables> & ({ variables: GetTeamPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables>(GetTeamPerformanceDocument, options);
      }
export function useGetTeamPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables>(GetTeamPerformanceDocument, options);
        }
export function useGetTeamPerformanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables>(GetTeamPerformanceDocument, options);
        }
export type GetTeamPerformanceQueryHookResult = ReturnType<typeof useGetTeamPerformanceQuery>;
export type GetTeamPerformanceLazyQueryHookResult = ReturnType<typeof useGetTeamPerformanceLazyQuery>;
export type GetTeamPerformanceSuspenseQueryHookResult = ReturnType<typeof useGetTeamPerformanceSuspenseQuery>;
export type GetTeamPerformanceQueryResult = Apollo.QueryResult<GetTeamPerformanceQuery, GetTeamPerformanceQueryVariables>;
export const SearchSchoolsDocument = gql`
    query SearchSchools($input: SearchInput!) {
  searchSchools(input: $input) {
    items {
      name
      location
      countryCode
      rank
    }
    total
    page
  }
}
    `;

/**
 * __useSearchSchoolsQuery__
 *
 * To run a query within a React component, call `useSearchSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSchoolsQuery(baseOptions: Apollo.QueryHookOptions<SearchSchoolsQuery, SearchSchoolsQueryVariables> & ({ variables: SearchSchoolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSchoolsQuery, SearchSchoolsQueryVariables>(SearchSchoolsDocument, options);
      }
export function useSearchSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSchoolsQuery, SearchSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSchoolsQuery, SearchSchoolsQueryVariables>(SearchSchoolsDocument, options);
        }
export function useSearchSchoolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSchoolsQuery, SearchSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSchoolsQuery, SearchSchoolsQueryVariables>(SearchSchoolsDocument, options);
        }
export type SearchSchoolsQueryHookResult = ReturnType<typeof useSearchSchoolsQuery>;
export type SearchSchoolsLazyQueryHookResult = ReturnType<typeof useSearchSchoolsLazyQuery>;
export type SearchSchoolsSuspenseQueryHookResult = ReturnType<typeof useSearchSchoolsSuspenseQuery>;
export type SearchSchoolsQueryResult = Apollo.QueryResult<SearchSchoolsQuery, SearchSchoolsQueryVariables>;
export const ListSequenceTemplatesDocument = gql`
    query ListSequenceTemplates($input: ListSequenceTemplatesInput!) {
  listSequenceTemplates(input: $input) {
    items {
      ...SequenceTemplateFragment
    }
    nextToken
    total
  }
}
    ${SequenceTemplateFragmentFragmentDoc}`;

/**
 * __useListSequenceTemplatesQuery__
 *
 * To run a query within a React component, call `useListSequenceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSequenceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSequenceTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListSequenceTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables> & ({ variables: ListSequenceTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables>(ListSequenceTemplatesDocument, options);
      }
export function useListSequenceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables>(ListSequenceTemplatesDocument, options);
        }
export function useListSequenceTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables>(ListSequenceTemplatesDocument, options);
        }
export type ListSequenceTemplatesQueryHookResult = ReturnType<typeof useListSequenceTemplatesQuery>;
export type ListSequenceTemplatesLazyQueryHookResult = ReturnType<typeof useListSequenceTemplatesLazyQuery>;
export type ListSequenceTemplatesSuspenseQueryHookResult = ReturnType<typeof useListSequenceTemplatesSuspenseQuery>;
export type ListSequenceTemplatesQueryResult = Apollo.QueryResult<ListSequenceTemplatesQuery, ListSequenceTemplatesQueryVariables>;
export const CreateSequenceTemplateDocument = gql`
    mutation CreateSequenceTemplate($input: CreateSequenceTemplateArgsV2!) {
  createSequenceTemplateV2(input: $input) {
    ...SequenceTemplateFragment
  }
}
    ${SequenceTemplateFragmentFragmentDoc}`;
export type CreateSequenceTemplateMutationFn = Apollo.MutationFunction<CreateSequenceTemplateMutation, CreateSequenceTemplateMutationVariables>;

/**
 * __useCreateSequenceTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSequenceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSequenceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSequenceTemplateMutation, { data, loading, error }] = useCreateSequenceTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSequenceTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateSequenceTemplateMutation, CreateSequenceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSequenceTemplateMutation, CreateSequenceTemplateMutationVariables>(CreateSequenceTemplateDocument, options);
      }
export type CreateSequenceTemplateMutationHookResult = ReturnType<typeof useCreateSequenceTemplateMutation>;
export type CreateSequenceTemplateMutationResult = Apollo.MutationResult<CreateSequenceTemplateMutation>;
export type CreateSequenceTemplateMutationOptions = Apollo.BaseMutationOptions<CreateSequenceTemplateMutation, CreateSequenceTemplateMutationVariables>;
export const UpdateSequenceTemplateDocument = gql`
    mutation UpdateSequenceTemplate($input: UpdateSequenceTemplateArgsV2!) {
  updateSequenceTemplateV2(input: $input) {
    ...SequenceTemplateFragment
  }
}
    ${SequenceTemplateFragmentFragmentDoc}`;
export type UpdateSequenceTemplateMutationFn = Apollo.MutationFunction<UpdateSequenceTemplateMutation, UpdateSequenceTemplateMutationVariables>;

/**
 * __useUpdateSequenceTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSequenceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSequenceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSequenceTemplateMutation, { data, loading, error }] = useUpdateSequenceTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSequenceTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSequenceTemplateMutation, UpdateSequenceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSequenceTemplateMutation, UpdateSequenceTemplateMutationVariables>(UpdateSequenceTemplateDocument, options);
      }
export type UpdateSequenceTemplateMutationHookResult = ReturnType<typeof useUpdateSequenceTemplateMutation>;
export type UpdateSequenceTemplateMutationResult = Apollo.MutationResult<UpdateSequenceTemplateMutation>;
export type UpdateSequenceTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateSequenceTemplateMutation, UpdateSequenceTemplateMutationVariables>;
export const DeleteSequenceTemplateDocument = gql`
    mutation DeleteSequenceTemplate($id: String!) {
  deleteSequenceTemplate(id: $id) {
    id
  }
}
    `;
export type DeleteSequenceTemplateMutationFn = Apollo.MutationFunction<DeleteSequenceTemplateMutation, DeleteSequenceTemplateMutationVariables>;

/**
 * __useDeleteSequenceTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSequenceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSequenceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSequenceTemplateMutation, { data, loading, error }] = useDeleteSequenceTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSequenceTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSequenceTemplateMutation, DeleteSequenceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSequenceTemplateMutation, DeleteSequenceTemplateMutationVariables>(DeleteSequenceTemplateDocument, options);
      }
export type DeleteSequenceTemplateMutationHookResult = ReturnType<typeof useDeleteSequenceTemplateMutation>;
export type DeleteSequenceTemplateMutationResult = Apollo.MutationResult<DeleteSequenceTemplateMutation>;
export type DeleteSequenceTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteSequenceTemplateMutation, DeleteSequenceTemplateMutationVariables>;
export const SearchSkillsDocument = gql`
    query SearchSkills($input: SearchSkillInput!) {
  searchSkills(input: $input) {
    items {
      ...Skill
    }
    total
    page
  }
}
    ${SkillFragmentDoc}`;

/**
 * __useSearchSkillsQuery__
 *
 * To run a query within a React component, call `useSearchSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSkillsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSkillsQuery(baseOptions: Apollo.QueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables> & ({ variables: SearchSkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
      }
export function useSearchSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
        }
export function useSearchSkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchSkillsQuery, SearchSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSkillsQuery, SearchSkillsQueryVariables>(SearchSkillsDocument, options);
        }
export type SearchSkillsQueryHookResult = ReturnType<typeof useSearchSkillsQuery>;
export type SearchSkillsLazyQueryHookResult = ReturnType<typeof useSearchSkillsLazyQuery>;
export type SearchSkillsSuspenseQueryHookResult = ReturnType<typeof useSearchSkillsSuspenseQuery>;
export type SearchSkillsQueryResult = Apollo.QueryResult<SearchSkillsQuery, SearchSkillsQueryVariables>;
export const GetSkillsForTitlesDocument = gql`
    query GetSkillsForTitles($input: GetSkillsForTitle!) {
  getSkillsForTitle(input: $input) {
    title
    isGettingAsync
    skills {
      name
      synonyms
    }
  }
}
    `;

/**
 * __useGetSkillsForTitlesQuery__
 *
 * To run a query within a React component, call `useGetSkillsForTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsForTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsForTitlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSkillsForTitlesQuery(baseOptions: Apollo.QueryHookOptions<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables> & ({ variables: GetSkillsForTitlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables>(GetSkillsForTitlesDocument, options);
      }
export function useGetSkillsForTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables>(GetSkillsForTitlesDocument, options);
        }
export function useGetSkillsForTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables>(GetSkillsForTitlesDocument, options);
        }
export type GetSkillsForTitlesQueryHookResult = ReturnType<typeof useGetSkillsForTitlesQuery>;
export type GetSkillsForTitlesLazyQueryHookResult = ReturnType<typeof useGetSkillsForTitlesLazyQuery>;
export type GetSkillsForTitlesSuspenseQueryHookResult = ReturnType<typeof useGetSkillsForTitlesSuspenseQuery>;
export type GetSkillsForTitlesQueryResult = Apollo.QueryResult<GetSkillsForTitlesQuery, GetSkillsForTitlesQueryVariables>;
export const OnJobTitleSkillsAvailableDocument = gql`
    subscription OnJobTitleSkillsAvailable($jobTitle: String!) {
  onJobTitleSkillsAvailable(jobTitle: $jobTitle) {
    jobTitle
  }
}
    `;

/**
 * __useOnJobTitleSkillsAvailableSubscription__
 *
 * To run a query within a React component, call `useOnJobTitleSkillsAvailableSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnJobTitleSkillsAvailableSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnJobTitleSkillsAvailableSubscription({
 *   variables: {
 *      jobTitle: // value for 'jobTitle'
 *   },
 * });
 */
export function useOnJobTitleSkillsAvailableSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnJobTitleSkillsAvailableSubscription, OnJobTitleSkillsAvailableSubscriptionVariables> & ({ variables: OnJobTitleSkillsAvailableSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnJobTitleSkillsAvailableSubscription, OnJobTitleSkillsAvailableSubscriptionVariables>(OnJobTitleSkillsAvailableDocument, options);
      }
export type OnJobTitleSkillsAvailableSubscriptionHookResult = ReturnType<typeof useOnJobTitleSkillsAvailableSubscription>;
export type OnJobTitleSkillsAvailableSubscriptionResult = Apollo.SubscriptionResult<OnJobTitleSkillsAvailableSubscription>;
export const JobTitleSkillsAvailableDocument = gql`
    mutation jobTitleSkillsAvailable($jobTitle: String!) {
  jobTitleSkillsAvailable(jobTitle: $jobTitle) {
    jobTitle
  }
}
    `;
export type JobTitleSkillsAvailableMutationFn = Apollo.MutationFunction<JobTitleSkillsAvailableMutation, JobTitleSkillsAvailableMutationVariables>;

/**
 * __useJobTitleSkillsAvailableMutation__
 *
 * To run a mutation, you first call `useJobTitleSkillsAvailableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobTitleSkillsAvailableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobTitleSkillsAvailableMutation, { data, loading, error }] = useJobTitleSkillsAvailableMutation({
 *   variables: {
 *      jobTitle: // value for 'jobTitle'
 *   },
 * });
 */
export function useJobTitleSkillsAvailableMutation(baseOptions?: Apollo.MutationHookOptions<JobTitleSkillsAvailableMutation, JobTitleSkillsAvailableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobTitleSkillsAvailableMutation, JobTitleSkillsAvailableMutationVariables>(JobTitleSkillsAvailableDocument, options);
      }
export type JobTitleSkillsAvailableMutationHookResult = ReturnType<typeof useJobTitleSkillsAvailableMutation>;
export type JobTitleSkillsAvailableMutationResult = Apollo.MutationResult<JobTitleSkillsAvailableMutation>;
export type JobTitleSkillsAvailableMutationOptions = Apollo.BaseMutationOptions<JobTitleSkillsAvailableMutation, JobTitleSkillsAvailableMutationVariables>;
export const ListSkillPhrasesDocument = gql`
    query ListSkillPhrases($input: ListSkillPhrasesInput!) {
  listSkillPhrases(input: $input) {
    items {
      ...SkillPhraseFields
    }
    total
  }
}
    ${SkillPhraseFieldsFragmentDoc}`;

/**
 * __useListSkillPhrasesQuery__
 *
 * To run a query within a React component, call `useListSkillPhrasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSkillPhrasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSkillPhrasesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListSkillPhrasesQuery(baseOptions: Apollo.QueryHookOptions<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables> & ({ variables: ListSkillPhrasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables>(ListSkillPhrasesDocument, options);
      }
export function useListSkillPhrasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables>(ListSkillPhrasesDocument, options);
        }
export function useListSkillPhrasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables>(ListSkillPhrasesDocument, options);
        }
export type ListSkillPhrasesQueryHookResult = ReturnType<typeof useListSkillPhrasesQuery>;
export type ListSkillPhrasesLazyQueryHookResult = ReturnType<typeof useListSkillPhrasesLazyQuery>;
export type ListSkillPhrasesSuspenseQueryHookResult = ReturnType<typeof useListSkillPhrasesSuspenseQuery>;
export type ListSkillPhrasesQueryResult = Apollo.QueryResult<ListSkillPhrasesQuery, ListSkillPhrasesQueryVariables>;
export const AddSkillPhraseDocument = gql`
    mutation AddSkillPhrase($input: SkillPhraseInput!) {
  addSkillPhrase(input: $input) {
    ...SkillPhraseFields
  }
}
    ${SkillPhraseFieldsFragmentDoc}`;
export type AddSkillPhraseMutationFn = Apollo.MutationFunction<AddSkillPhraseMutation, AddSkillPhraseMutationVariables>;

/**
 * __useAddSkillPhraseMutation__
 *
 * To run a mutation, you first call `useAddSkillPhraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSkillPhraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSkillPhraseMutation, { data, loading, error }] = useAddSkillPhraseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSkillPhraseMutation(baseOptions?: Apollo.MutationHookOptions<AddSkillPhraseMutation, AddSkillPhraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSkillPhraseMutation, AddSkillPhraseMutationVariables>(AddSkillPhraseDocument, options);
      }
export type AddSkillPhraseMutationHookResult = ReturnType<typeof useAddSkillPhraseMutation>;
export type AddSkillPhraseMutationResult = Apollo.MutationResult<AddSkillPhraseMutation>;
export type AddSkillPhraseMutationOptions = Apollo.BaseMutationOptions<AddSkillPhraseMutation, AddSkillPhraseMutationVariables>;
export const DeleteSkillPhraseDocument = gql`
    mutation DeleteSkillPhrase($id: String!) {
  deleteSkillPhrase(id: $id) {
    id
  }
}
    `;
export type DeleteSkillPhraseMutationFn = Apollo.MutationFunction<DeleteSkillPhraseMutation, DeleteSkillPhraseMutationVariables>;

/**
 * __useDeleteSkillPhraseMutation__
 *
 * To run a mutation, you first call `useDeleteSkillPhraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillPhraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillPhraseMutation, { data, loading, error }] = useDeleteSkillPhraseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSkillPhraseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillPhraseMutation, DeleteSkillPhraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillPhraseMutation, DeleteSkillPhraseMutationVariables>(DeleteSkillPhraseDocument, options);
      }
export type DeleteSkillPhraseMutationHookResult = ReturnType<typeof useDeleteSkillPhraseMutation>;
export type DeleteSkillPhraseMutationResult = Apollo.MutationResult<DeleteSkillPhraseMutation>;
export type DeleteSkillPhraseMutationOptions = Apollo.BaseMutationOptions<DeleteSkillPhraseMutation, DeleteSkillPhraseMutationVariables>;
export const ListMessageThreadsDocument = gql`
    query ListMessageThreads($input: ListThreads!) {
  listThreads(input: $input) {
    threads {
      ...MessageThread
    }
    total
    unreadCount
  }
}
    ${MessageThreadFragmentDoc}`;

/**
 * __useListMessageThreadsQuery__
 *
 * To run a query within a React component, call `useListMessageThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMessageThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMessageThreadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListMessageThreadsQuery(baseOptions: Apollo.QueryHookOptions<ListMessageThreadsQuery, ListMessageThreadsQueryVariables> & ({ variables: ListMessageThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>(ListMessageThreadsDocument, options);
      }
export function useListMessageThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>(ListMessageThreadsDocument, options);
        }
export function useListMessageThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>(ListMessageThreadsDocument, options);
        }
export type ListMessageThreadsQueryHookResult = ReturnType<typeof useListMessageThreadsQuery>;
export type ListMessageThreadsLazyQueryHookResult = ReturnType<typeof useListMessageThreadsLazyQuery>;
export type ListMessageThreadsSuspenseQueryHookResult = ReturnType<typeof useListMessageThreadsSuspenseQuery>;
export type ListMessageThreadsQueryResult = Apollo.QueryResult<ListMessageThreadsQuery, ListMessageThreadsQueryVariables>;
export const ListThreadMessagesDocument = gql`
    query ListThreadMessages($input: ListMessages!) {
  listMessages(input: $input) {
    messages {
      ...TelephonyMessage
    }
    total
  }
}
    ${TelephonyMessageFragmentDoc}`;

/**
 * __useListThreadMessagesQuery__
 *
 * To run a query within a React component, call `useListThreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListThreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListThreadMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListThreadMessagesQuery(baseOptions: Apollo.QueryHookOptions<ListThreadMessagesQuery, ListThreadMessagesQueryVariables> & ({ variables: ListThreadMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListThreadMessagesQuery, ListThreadMessagesQueryVariables>(ListThreadMessagesDocument, options);
      }
export function useListThreadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListThreadMessagesQuery, ListThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListThreadMessagesQuery, ListThreadMessagesQueryVariables>(ListThreadMessagesDocument, options);
        }
export function useListThreadMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListThreadMessagesQuery, ListThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListThreadMessagesQuery, ListThreadMessagesQueryVariables>(ListThreadMessagesDocument, options);
        }
export type ListThreadMessagesQueryHookResult = ReturnType<typeof useListThreadMessagesQuery>;
export type ListThreadMessagesLazyQueryHookResult = ReturnType<typeof useListThreadMessagesLazyQuery>;
export type ListThreadMessagesSuspenseQueryHookResult = ReturnType<typeof useListThreadMessagesSuspenseQuery>;
export type ListThreadMessagesQueryResult = Apollo.QueryResult<ListThreadMessagesQuery, ListThreadMessagesQueryVariables>;
export const GetCandidateThreadDocument = gql`
    query GetCandidateThread($input: GetCandidateThreadInput!) {
  getCandidateThread(input: $input) {
    thread {
      ...CandidateThread
    }
  }
}
    ${CandidateThreadFragmentDoc}`;

/**
 * __useGetCandidateThreadQuery__
 *
 * To run a query within a React component, call `useGetCandidateThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateThreadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateThreadQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateThreadQuery, GetCandidateThreadQueryVariables> & ({ variables: GetCandidateThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateThreadQuery, GetCandidateThreadQueryVariables>(GetCandidateThreadDocument, options);
      }
export function useGetCandidateThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateThreadQuery, GetCandidateThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateThreadQuery, GetCandidateThreadQueryVariables>(GetCandidateThreadDocument, options);
        }
export function useGetCandidateThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateThreadQuery, GetCandidateThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateThreadQuery, GetCandidateThreadQueryVariables>(GetCandidateThreadDocument, options);
        }
export type GetCandidateThreadQueryHookResult = ReturnType<typeof useGetCandidateThreadQuery>;
export type GetCandidateThreadLazyQueryHookResult = ReturnType<typeof useGetCandidateThreadLazyQuery>;
export type GetCandidateThreadSuspenseQueryHookResult = ReturnType<typeof useGetCandidateThreadSuspenseQuery>;
export type GetCandidateThreadQueryResult = Apollo.QueryResult<GetCandidateThreadQuery, GetCandidateThreadQueryVariables>;
export const SendMessageDocument = gql`
    mutation sendMessage($input: SendMessage!) {
  sendMessage(input: $input) {
    ...TelephonyMessage
  }
}
    ${TelephonyMessageFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const MessageSentDocument = gql`
    mutation messageSent($input: MessageSent!) {
  messageSent(input: $input) {
    ...MessageSent
  }
}
    ${MessageSentFragmentDoc}`;
export type MessageSentMutationFn = Apollo.MutationFunction<MessageSentMutation, MessageSentMutationVariables>;

/**
 * __useMessageSentMutation__
 *
 * To run a mutation, you first call `useMessageSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageSentMutation, { data, loading, error }] = useMessageSentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageSentMutation(baseOptions?: Apollo.MutationHookOptions<MessageSentMutation, MessageSentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MessageSentMutation, MessageSentMutationVariables>(MessageSentDocument, options);
      }
export type MessageSentMutationHookResult = ReturnType<typeof useMessageSentMutation>;
export type MessageSentMutationResult = Apollo.MutationResult<MessageSentMutation>;
export type MessageSentMutationOptions = Apollo.BaseMutationOptions<MessageSentMutation, MessageSentMutationVariables>;
export const MarkMessagesAsReadDocument = gql`
    mutation markMessagesAsRead($input: MarkMessageAsRead!) {
  markMessagesAsRead(input: $input) {
    id
  }
}
    `;
export type MarkMessagesAsReadMutationFn = Apollo.MutationFunction<MarkMessagesAsReadMutation, MarkMessagesAsReadMutationVariables>;

/**
 * __useMarkMessagesAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessagesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessagesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessagesAsReadMutation, { data, loading, error }] = useMarkMessagesAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkMessagesAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkMessagesAsReadMutation, MarkMessagesAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMessagesAsReadMutation, MarkMessagesAsReadMutationVariables>(MarkMessagesAsReadDocument, options);
      }
export type MarkMessagesAsReadMutationHookResult = ReturnType<typeof useMarkMessagesAsReadMutation>;
export type MarkMessagesAsReadMutationResult = Apollo.MutationResult<MarkMessagesAsReadMutation>;
export type MarkMessagesAsReadMutationOptions = Apollo.BaseMutationOptions<MarkMessagesAsReadMutation, MarkMessagesAsReadMutationVariables>;
export const UpdateThreadDocument = gql`
    mutation updateThread($input: UpdateThreadInput!) {
  updateThread(input: $input) {
    id
  }
}
    `;
export type UpdateThreadMutationFn = Apollo.MutationFunction<UpdateThreadMutation, UpdateThreadMutationVariables>;

/**
 * __useUpdateThreadMutation__
 *
 * To run a mutation, you first call `useUpdateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreadMutation, { data, loading, error }] = useUpdateThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThreadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThreadMutation, UpdateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThreadMutation, UpdateThreadMutationVariables>(UpdateThreadDocument, options);
      }
export type UpdateThreadMutationHookResult = ReturnType<typeof useUpdateThreadMutation>;
export type UpdateThreadMutationResult = Apollo.MutationResult<UpdateThreadMutation>;
export type UpdateThreadMutationOptions = Apollo.BaseMutationOptions<UpdateThreadMutation, UpdateThreadMutationVariables>;
export const OnMessageSentDocument = gql`
    subscription onMessageSent($tenantId: String!, $threadId: String) {
  messageSent(tenantId: $tenantId, threadId: $threadId) {
    ...MessageSent
  }
}
    ${MessageSentFragmentDoc}`;

/**
 * __useOnMessageSentSubscription__
 *
 * To run a query within a React component, call `useOnMessageSentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageSentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageSentSubscription({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useOnMessageSentSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnMessageSentSubscription, OnMessageSentSubscriptionVariables> & ({ variables: OnMessageSentSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMessageSentSubscription, OnMessageSentSubscriptionVariables>(OnMessageSentDocument, options);
      }
export type OnMessageSentSubscriptionHookResult = ReturnType<typeof useOnMessageSentSubscription>;
export type OnMessageSentSubscriptionResult = Apollo.SubscriptionResult<OnMessageSentSubscription>;
export const OnTaskStatusUpdateDocument = gql`
    subscription onTaskStatusUpdate($id: String!) {
  onTaskStatusUpdate(id: $id) {
    id
    status
    timestamp
    data
  }
}
    `;

/**
 * __useOnTaskStatusUpdateSubscription__
 *
 * To run a query within a React component, call `useOnTaskStatusUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTaskStatusUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTaskStatusUpdateSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnTaskStatusUpdateSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnTaskStatusUpdateSubscription, OnTaskStatusUpdateSubscriptionVariables> & ({ variables: OnTaskStatusUpdateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTaskStatusUpdateSubscription, OnTaskStatusUpdateSubscriptionVariables>(OnTaskStatusUpdateDocument, options);
      }
export type OnTaskStatusUpdateSubscriptionHookResult = ReturnType<typeof useOnTaskStatusUpdateSubscription>;
export type OnTaskStatusUpdateSubscriptionResult = Apollo.SubscriptionResult<OnTaskStatusUpdateSubscription>;
export const UpdateTaskStatusDocument = gql`
    mutation updateTaskStatus($id: String!, $update: TaskStatusUpdate!) {
  updateTaskStatus(id: $id, update: $update) {
    id
    status
    timestamp
    data
  }
}
    `;
export type UpdateTaskStatusMutationFn = Apollo.MutationFunction<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>;

/**
 * __useUpdateTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatusMutation, { data, loading, error }] = useUpdateTaskStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument, options);
      }
export type UpdateTaskStatusMutationHookResult = ReturnType<typeof useUpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationResult = Apollo.MutationResult<UpdateTaskStatusMutation>;
export type UpdateTaskStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>;
export const UseInviteDocument = gql`
    mutation UseInvite($code: String!) {
  useInvite(code: $code) {
    success
    error
    rateLimited
    team {
      ...Team
    }
  }
}
    ${TeamFragmentDoc}`;
export type UseInviteMutationFn = Apollo.MutationFunction<UseInviteMutation, UseInviteMutationVariables>;

/**
 * __useUseInviteMutation__
 *
 * To run a mutation, you first call `useUseInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useInviteMutation, { data, loading, error }] = useUseInviteMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUseInviteMutation(baseOptions?: Apollo.MutationHookOptions<UseInviteMutation, UseInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseInviteMutation, UseInviteMutationVariables>(UseInviteDocument, options);
      }
export type UseInviteMutationHookResult = ReturnType<typeof useUseInviteMutation>;
export type UseInviteMutationResult = Apollo.MutationResult<UseInviteMutation>;
export type UseInviteMutationOptions = Apollo.BaseMutationOptions<UseInviteMutation, UseInviteMutationVariables>;
export const TeamDocument = gql`
    query Team {
  team {
    ...Team
  }
}
    ${TeamFragmentDoc}`;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamQuery(baseOptions?: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export function useTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamSuspenseQueryHookResult = ReturnType<typeof useTeamSuspenseQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export const ListTeamInvitesDocument = gql`
    query ListTeamInvites {
  listTeamInvites {
    team {
      ...Team
    }
    invites {
      ...Invite
    }
  }
}
    ${TeamFragmentDoc}
${InviteFragmentDoc}`;

/**
 * __useListTeamInvitesQuery__
 *
 * To run a query within a React component, call `useListTeamInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTeamInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTeamInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTeamInvitesQuery(baseOptions?: Apollo.QueryHookOptions<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>(ListTeamInvitesDocument, options);
      }
export function useListTeamInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>(ListTeamInvitesDocument, options);
        }
export function useListTeamInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>(ListTeamInvitesDocument, options);
        }
export type ListTeamInvitesQueryHookResult = ReturnType<typeof useListTeamInvitesQuery>;
export type ListTeamInvitesLazyQueryHookResult = ReturnType<typeof useListTeamInvitesLazyQuery>;
export type ListTeamInvitesSuspenseQueryHookResult = ReturnType<typeof useListTeamInvitesSuspenseQuery>;
export type ListTeamInvitesQueryResult = Apollo.QueryResult<ListTeamInvitesQuery, ListTeamInvitesQueryVariables>;
export const SendTeamInviteDocument = gql`
    mutation SendTeamInvite($input: SendTeamInvite!) {
  sendTeamInvite(input: $input) {
    ...InviteResult
  }
}
    ${InviteResultFragmentDoc}`;
export type SendTeamInviteMutationFn = Apollo.MutationFunction<SendTeamInviteMutation, SendTeamInviteMutationVariables>;

/**
 * __useSendTeamInviteMutation__
 *
 * To run a mutation, you first call `useSendTeamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTeamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTeamInviteMutation, { data, loading, error }] = useSendTeamInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTeamInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendTeamInviteMutation, SendTeamInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTeamInviteMutation, SendTeamInviteMutationVariables>(SendTeamInviteDocument, options);
      }
export type SendTeamInviteMutationHookResult = ReturnType<typeof useSendTeamInviteMutation>;
export type SendTeamInviteMutationResult = Apollo.MutationResult<SendTeamInviteMutation>;
export type SendTeamInviteMutationOptions = Apollo.BaseMutationOptions<SendTeamInviteMutation, SendTeamInviteMutationVariables>;
export const CancelTeamInviteDocument = gql`
    mutation CancelTeamInvite($input: CancelTeamInvite!) {
  cancelTeamInvite(input: $input) {
    canceledInviteId
  }
}
    `;
export type CancelTeamInviteMutationFn = Apollo.MutationFunction<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>;

/**
 * __useCancelTeamInviteMutation__
 *
 * To run a mutation, you first call `useCancelTeamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTeamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTeamInviteMutation, { data, loading, error }] = useCancelTeamInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelTeamInviteMutation(baseOptions?: Apollo.MutationHookOptions<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>(CancelTeamInviteDocument, options);
      }
export type CancelTeamInviteMutationHookResult = ReturnType<typeof useCancelTeamInviteMutation>;
export type CancelTeamInviteMutationResult = Apollo.MutationResult<CancelTeamInviteMutation>;
export type CancelTeamInviteMutationOptions = Apollo.BaseMutationOptions<CancelTeamInviteMutation, CancelTeamInviteMutationVariables>;
export const RemoveUserFromTeamDocument = gql`
    mutation RemoveUserFromTeam($input: RemoveUserFromTeam!) {
  removeUserFromTeam(input: $input) {
    ...RemoveUserFromTeamResult
  }
}
    ${RemoveUserFromTeamResultFragmentDoc}`;
export type RemoveUserFromTeamMutationFn = Apollo.MutationFunction<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>;

/**
 * __useRemoveUserFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromTeamMutation, { data, loading, error }] = useRemoveUserFromTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>(RemoveUserFromTeamDocument, options);
      }
export type RemoveUserFromTeamMutationHookResult = ReturnType<typeof useRemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationResult = Apollo.MutationResult<RemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>;
export const SetTeamNameDocument = gql`
    mutation SetTeamName($input: SetTeamName!) {
  setTeamName(input: $input) {
    team {
      ...Team
    }
  }
}
    ${TeamFragmentDoc}`;
export type SetTeamNameMutationFn = Apollo.MutationFunction<SetTeamNameMutation, SetTeamNameMutationVariables>;

/**
 * __useSetTeamNameMutation__
 *
 * To run a mutation, you first call `useSetTeamNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamNameMutation, { data, loading, error }] = useSetTeamNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTeamNameMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamNameMutation, SetTeamNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamNameMutation, SetTeamNameMutationVariables>(SetTeamNameDocument, options);
      }
export type SetTeamNameMutationHookResult = ReturnType<typeof useSetTeamNameMutation>;
export type SetTeamNameMutationResult = Apollo.MutationResult<SetTeamNameMutation>;
export type SetTeamNameMutationOptions = Apollo.BaseMutationOptions<SetTeamNameMutation, SetTeamNameMutationVariables>;
export const ChangeTeamRolesDocument = gql`
    mutation ChangeTeamRoles($input: ChangeTeamRoles!) {
  changeTeamRoles(input: $input) {
    user {
      roles
    }
  }
}
    `;
export type ChangeTeamRolesMutationFn = Apollo.MutationFunction<ChangeTeamRolesMutation, ChangeTeamRolesMutationVariables>;

/**
 * __useChangeTeamRolesMutation__
 *
 * To run a mutation, you first call `useChangeTeamRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTeamRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTeamRolesMutation, { data, loading, error }] = useChangeTeamRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTeamRolesMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTeamRolesMutation, ChangeTeamRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTeamRolesMutation, ChangeTeamRolesMutationVariables>(ChangeTeamRolesDocument, options);
      }
export type ChangeTeamRolesMutationHookResult = ReturnType<typeof useChangeTeamRolesMutation>;
export type ChangeTeamRolesMutationResult = Apollo.MutationResult<ChangeTeamRolesMutation>;
export type ChangeTeamRolesMutationOptions = Apollo.BaseMutationOptions<ChangeTeamRolesMutation, ChangeTeamRolesMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($input: UpdateTenantInput!) {
  updateTenant(input: $input) {
    id
    isTrackingUserActivity
  }
}
    `;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const RecordUserActivityDocument = gql`
    mutation RecordUserActivity($userActivity: UserActivityArgs!) {
  recordUserActivity(userActivity: $userActivity) {
    id
  }
}
    `;
export type RecordUserActivityMutationFn = Apollo.MutationFunction<RecordUserActivityMutation, RecordUserActivityMutationVariables>;

/**
 * __useRecordUserActivityMutation__
 *
 * To run a mutation, you first call `useRecordUserActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUserActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUserActivityMutation, { data, loading, error }] = useRecordUserActivityMutation({
 *   variables: {
 *      userActivity: // value for 'userActivity'
 *   },
 * });
 */
export function useRecordUserActivityMutation(baseOptions?: Apollo.MutationHookOptions<RecordUserActivityMutation, RecordUserActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordUserActivityMutation, RecordUserActivityMutationVariables>(RecordUserActivityDocument, options);
      }
export type RecordUserActivityMutationHookResult = ReturnType<typeof useRecordUserActivityMutation>;
export type RecordUserActivityMutationResult = Apollo.MutationResult<RecordUserActivityMutation>;
export type RecordUserActivityMutationOptions = Apollo.BaseMutationOptions<RecordUserActivityMutation, RecordUserActivityMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($user: UserInput!) {
  updateUser(user: $user) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GenerateAuthChallengeTokenDocument = gql`
    mutation GenerateAuthChallengeToken {
  generateAuthChallengeToken {
    token
  }
}
    `;
export type GenerateAuthChallengeTokenMutationFn = Apollo.MutationFunction<GenerateAuthChallengeTokenMutation, GenerateAuthChallengeTokenMutationVariables>;

/**
 * __useGenerateAuthChallengeTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAuthChallengeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuthChallengeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAuthChallengeTokenMutation, { data, loading, error }] = useGenerateAuthChallengeTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateAuthChallengeTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAuthChallengeTokenMutation, GenerateAuthChallengeTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAuthChallengeTokenMutation, GenerateAuthChallengeTokenMutationVariables>(GenerateAuthChallengeTokenDocument, options);
      }
export type GenerateAuthChallengeTokenMutationHookResult = ReturnType<typeof useGenerateAuthChallengeTokenMutation>;
export type GenerateAuthChallengeTokenMutationResult = Apollo.MutationResult<GenerateAuthChallengeTokenMutation>;
export type GenerateAuthChallengeTokenMutationOptions = Apollo.BaseMutationOptions<GenerateAuthChallengeTokenMutation, GenerateAuthChallengeTokenMutationVariables>;
export const OnboardUserDocument = gql`
    mutation OnboardUser($input: OnboardUserInput!) {
  onboardUser(input: $input) {
    id
  }
}
    `;
export type OnboardUserMutationFn = Apollo.MutationFunction<OnboardUserMutation, OnboardUserMutationVariables>;

/**
 * __useOnboardUserMutation__
 *
 * To run a mutation, you first call `useOnboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardUserMutation, { data, loading, error }] = useOnboardUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardUserMutation(baseOptions?: Apollo.MutationHookOptions<OnboardUserMutation, OnboardUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardUserMutation, OnboardUserMutationVariables>(OnboardUserDocument, options);
      }
export type OnboardUserMutationHookResult = ReturnType<typeof useOnboardUserMutation>;
export type OnboardUserMutationResult = Apollo.MutationResult<OnboardUserMutation>;
export type OnboardUserMutationOptions = Apollo.BaseMutationOptions<OnboardUserMutation, OnboardUserMutationVariables>;
export const GetUserDocument = gql`
    query GetUser {
  getUser {
    id
    name
    emailAddress
    calendlyLink
    linkedInConnectionRequestNote
    autoInvite
    atsId
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const ListUsersOfSameTenantDocument = gql`
    query ListUsersOfSameTenant {
  listUsersOfSameTenant {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useListUsersOfSameTenantQuery__
 *
 * To run a query within a React component, call `useListUsersOfSameTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersOfSameTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersOfSameTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useListUsersOfSameTenantQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>(ListUsersOfSameTenantDocument, options);
      }
export function useListUsersOfSameTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>(ListUsersOfSameTenantDocument, options);
        }
export function useListUsersOfSameTenantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>(ListUsersOfSameTenantDocument, options);
        }
export type ListUsersOfSameTenantQueryHookResult = ReturnType<typeof useListUsersOfSameTenantQuery>;
export type ListUsersOfSameTenantLazyQueryHookResult = ReturnType<typeof useListUsersOfSameTenantLazyQuery>;
export type ListUsersOfSameTenantSuspenseQueryHookResult = ReturnType<typeof useListUsersOfSameTenantSuspenseQuery>;
export type ListUsersOfSameTenantQueryResult = Apollo.QueryResult<ListUsersOfSameTenantQuery, ListUsersOfSameTenantQueryVariables>;
export const AuthenticationContextDocument = gql`
    query AuthenticationContext {
  getUser {
    ...User
    userName
    linkedInConnectionRequestNote
    bccAtsAddress
    jdRewriteCustomInstructions
    featureFlags {
      atsIntegrations
      clientTokens
      skillPopup
      candidateMatch
      stackRank
      micros
      candidateSearch
      jobLeads
      telephony
      sms
      tasks
      autoInvite
    }
    tenantLogoKey
    shouldGetStatsUpdate
    preferences {
      ...UserPreferences
    }
  }
  getBillingStatus {
    ...BillingStatusFragment
  }
  listProducts {
    ...BillingProductFragment
  }
  getAtsIntegrationStatus {
    ...AtsIntegrationStatusFragment
  }
  getSequencerAuthStatus {
    ...SequencerAuthStatusFragment
  }
}
    ${UserFragmentDoc}
${UserPreferencesFragmentDoc}
${BillingStatusFragmentFragmentDoc}
${BillingProductFragmentFragmentDoc}
${AtsIntegrationStatusFragmentFragmentDoc}
${SequencerAuthStatusFragmentFragmentDoc}`;

/**
 * __useAuthenticationContextQuery__
 *
 * To run a query within a React component, call `useAuthenticationContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticationContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticationContextQuery(baseOptions?: Apollo.QueryHookOptions<AuthenticationContextQuery, AuthenticationContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticationContextQuery, AuthenticationContextQueryVariables>(AuthenticationContextDocument, options);
      }
export function useAuthenticationContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticationContextQuery, AuthenticationContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticationContextQuery, AuthenticationContextQueryVariables>(AuthenticationContextDocument, options);
        }
export function useAuthenticationContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthenticationContextQuery, AuthenticationContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthenticationContextQuery, AuthenticationContextQueryVariables>(AuthenticationContextDocument, options);
        }
export type AuthenticationContextQueryHookResult = ReturnType<typeof useAuthenticationContextQuery>;
export type AuthenticationContextLazyQueryHookResult = ReturnType<typeof useAuthenticationContextLazyQuery>;
export type AuthenticationContextSuspenseQueryHookResult = ReturnType<typeof useAuthenticationContextSuspenseQuery>;
export type AuthenticationContextQueryResult = Apollo.QueryResult<AuthenticationContextQuery, AuthenticationContextQueryVariables>;
export const RecordCandidateUserActionDocument = gql`
    mutation RecordCandidateUserAction($input: CandidateUserAction!) {
  recordCandidateUserAction(input: $input) {
    id
  }
}
    `;
export type RecordCandidateUserActionMutationFn = Apollo.MutationFunction<RecordCandidateUserActionMutation, RecordCandidateUserActionMutationVariables>;

/**
 * __useRecordCandidateUserActionMutation__
 *
 * To run a mutation, you first call `useRecordCandidateUserActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCandidateUserActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCandidateUserActionMutation, { data, loading, error }] = useRecordCandidateUserActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCandidateUserActionMutation(baseOptions?: Apollo.MutationHookOptions<RecordCandidateUserActionMutation, RecordCandidateUserActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCandidateUserActionMutation, RecordCandidateUserActionMutationVariables>(RecordCandidateUserActionDocument, options);
      }
export type RecordCandidateUserActionMutationHookResult = ReturnType<typeof useRecordCandidateUserActionMutation>;
export type RecordCandidateUserActionMutationResult = Apollo.MutationResult<RecordCandidateUserActionMutation>;
export type RecordCandidateUserActionMutationOptions = Apollo.BaseMutationOptions<RecordCandidateUserActionMutation, RecordCandidateUserActionMutationVariables>;
export const RequestUploadLogoDocument = gql`
    mutation RequestUploadLogo($input: RequestUploadLogoInput!) {
  requestUploadLogo(input: $input) {
    url
    key
  }
}
    `;
export type RequestUploadLogoMutationFn = Apollo.MutationFunction<RequestUploadLogoMutation, RequestUploadLogoMutationVariables>;

/**
 * __useRequestUploadLogoMutation__
 *
 * To run a mutation, you first call `useRequestUploadLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUploadLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUploadLogoMutation, { data, loading, error }] = useRequestUploadLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestUploadLogoMutation(baseOptions?: Apollo.MutationHookOptions<RequestUploadLogoMutation, RequestUploadLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUploadLogoMutation, RequestUploadLogoMutationVariables>(RequestUploadLogoDocument, options);
      }
export type RequestUploadLogoMutationHookResult = ReturnType<typeof useRequestUploadLogoMutation>;
export type RequestUploadLogoMutationResult = Apollo.MutationResult<RequestUploadLogoMutation>;
export type RequestUploadLogoMutationOptions = Apollo.BaseMutationOptions<RequestUploadLogoMutation, RequestUploadLogoMutationVariables>;
export const ListUsersWithoutVacanciesDocument = gql`
    query ListUsersWithoutVacancies($input: ListUserWithoutVacanciesInput!) {
  listUsersWithoutVacancies(input: $input) {
    total
    users {
      id
      linkedInUrl
      name
      avatarUrl
      emailAddress
    }
  }
}
    `;

/**
 * __useListUsersWithoutVacanciesQuery__
 *
 * To run a query within a React component, call `useListUsersWithoutVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersWithoutVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersWithoutVacanciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListUsersWithoutVacanciesQuery(baseOptions: Apollo.QueryHookOptions<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables> & ({ variables: ListUsersWithoutVacanciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables>(ListUsersWithoutVacanciesDocument, options);
      }
export function useListUsersWithoutVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables>(ListUsersWithoutVacanciesDocument, options);
        }
export function useListUsersWithoutVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables>(ListUsersWithoutVacanciesDocument, options);
        }
export type ListUsersWithoutVacanciesQueryHookResult = ReturnType<typeof useListUsersWithoutVacanciesQuery>;
export type ListUsersWithoutVacanciesLazyQueryHookResult = ReturnType<typeof useListUsersWithoutVacanciesLazyQuery>;
export type ListUsersWithoutVacanciesSuspenseQueryHookResult = ReturnType<typeof useListUsersWithoutVacanciesSuspenseQuery>;
export type ListUsersWithoutVacanciesQueryResult = Apollo.QueryResult<ListUsersWithoutVacanciesQuery, ListUsersWithoutVacanciesQueryVariables>;
export const DeleteLogoDocument = gql`
    mutation DeleteLogo($input: DeleteLogoInput!) {
  deleteLogo(input: $input) {
    id
  }
}
    `;
export type DeleteLogoMutationFn = Apollo.MutationFunction<DeleteLogoMutation, DeleteLogoMutationVariables>;

/**
 * __useDeleteLogoMutation__
 *
 * To run a mutation, you first call `useDeleteLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogoMutation, { data, loading, error }] = useDeleteLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLogoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLogoMutation, DeleteLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLogoMutation, DeleteLogoMutationVariables>(DeleteLogoDocument, options);
      }
export type DeleteLogoMutationHookResult = ReturnType<typeof useDeleteLogoMutation>;
export type DeleteLogoMutationResult = Apollo.MutationResult<DeleteLogoMutation>;
export type DeleteLogoMutationOptions = Apollo.BaseMutationOptions<DeleteLogoMutation, DeleteLogoMutationVariables>;
export const UpdateUserPreferencesDocument = gql`
    mutation UpdateUserPreferences($preferences: UserPreferencesInput!) {
  updateUserPreferences(preferences: $preferences) {
    ...UserPreferences
  }
}
    ${UserPreferencesFragmentDoc}`;
export type UpdateUserPreferencesMutationFn = Apollo.MutationFunction<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>;

/**
 * __useUpdateUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesMutation, { data, loading, error }] = useUpdateUserPreferencesMutation({
 *   variables: {
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useUpdateUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>(UpdateUserPreferencesDocument, options);
      }
export type UpdateUserPreferencesMutationHookResult = ReturnType<typeof useUpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationResult = Apollo.MutationResult<UpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>;
export const AdminDisableUserDocument = gql`
    mutation adminDisableUser($userId: String!) {
  adminDisableUser(userId: $userId) {
    id
  }
}
    `;
export type AdminDisableUserMutationFn = Apollo.MutationFunction<AdminDisableUserMutation, AdminDisableUserMutationVariables>;

/**
 * __useAdminDisableUserMutation__
 *
 * To run a mutation, you first call `useAdminDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisableUserMutation, { data, loading, error }] = useAdminDisableUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminDisableUserMutation, AdminDisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDisableUserMutation, AdminDisableUserMutationVariables>(AdminDisableUserDocument, options);
      }
export type AdminDisableUserMutationHookResult = ReturnType<typeof useAdminDisableUserMutation>;
export type AdminDisableUserMutationResult = Apollo.MutationResult<AdminDisableUserMutation>;
export type AdminDisableUserMutationOptions = Apollo.BaseMutationOptions<AdminDisableUserMutation, AdminDisableUserMutationVariables>;
export const AdminEnableUserDocument = gql`
    mutation adminEnableUser($userId: String!) {
  adminEnableUser(userId: $userId) {
    id
  }
}
    `;
export type AdminEnableUserMutationFn = Apollo.MutationFunction<AdminEnableUserMutation, AdminEnableUserMutationVariables>;

/**
 * __useAdminEnableUserMutation__
 *
 * To run a mutation, you first call `useAdminEnableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminEnableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminEnableUserMutation, { data, loading, error }] = useAdminEnableUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminEnableUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminEnableUserMutation, AdminEnableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminEnableUserMutation, AdminEnableUserMutationVariables>(AdminEnableUserDocument, options);
      }
export type AdminEnableUserMutationHookResult = ReturnType<typeof useAdminEnableUserMutation>;
export type AdminEnableUserMutationResult = Apollo.MutationResult<AdminEnableUserMutation>;
export type AdminEnableUserMutationOptions = Apollo.BaseMutationOptions<AdminEnableUserMutation, AdminEnableUserMutationVariables>;
export const AdminListAllUsersDocument = gql`
    query AdminListAllUsers($input: SearchInput!) {
  adminListUsers(input: $input) {
    items {
      id
      name
      emailAddress
      tenant {
        id
        name
      }
      deletedAt
    }
    total
  }
}
    `;

/**
 * __useAdminListAllUsersQuery__
 *
 * To run a query within a React component, call `useAdminListAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListAllUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminListAllUsersQuery(baseOptions: Apollo.QueryHookOptions<AdminListAllUsersQuery, AdminListAllUsersQueryVariables> & ({ variables: AdminListAllUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListAllUsersQuery, AdminListAllUsersQueryVariables>(AdminListAllUsersDocument, options);
      }
export function useAdminListAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListAllUsersQuery, AdminListAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListAllUsersQuery, AdminListAllUsersQueryVariables>(AdminListAllUsersDocument, options);
        }
export function useAdminListAllUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminListAllUsersQuery, AdminListAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListAllUsersQuery, AdminListAllUsersQueryVariables>(AdminListAllUsersDocument, options);
        }
export type AdminListAllUsersQueryHookResult = ReturnType<typeof useAdminListAllUsersQuery>;
export type AdminListAllUsersLazyQueryHookResult = ReturnType<typeof useAdminListAllUsersLazyQuery>;
export type AdminListAllUsersSuspenseQueryHookResult = ReturnType<typeof useAdminListAllUsersSuspenseQuery>;
export type AdminListAllUsersQueryResult = Apollo.QueryResult<AdminListAllUsersQuery, AdminListAllUsersQueryVariables>;
export const GetUserFeatureFlagsDocument = gql`
    query GetUserFeatureFlags {
  getUser {
    featureFlags {
      atsIntegrations
      clientTokens
      skillPopup
      candidateMatch
      stackRank
      micros
      candidateSearch
      jobLeads
      telephony
      sms
      tasks
    }
  }
}
    `;

/**
 * __useGetUserFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetUserFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>(GetUserFeatureFlagsDocument, options);
      }
export function useGetUserFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>(GetUserFeatureFlagsDocument, options);
        }
export function useGetUserFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>(GetUserFeatureFlagsDocument, options);
        }
export type GetUserFeatureFlagsQueryHookResult = ReturnType<typeof useGetUserFeatureFlagsQuery>;
export type GetUserFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetUserFeatureFlagsLazyQuery>;
export type GetUserFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useGetUserFeatureFlagsSuspenseQuery>;
export type GetUserFeatureFlagsQueryResult = Apollo.QueryResult<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>;
export const RecordLiConnectionRequestSentDocument = gql`
    mutation RecordLiConnectionRequestSent($url: String!, $recordedAt: String, $vacancyId: String) {
  recordUserActivity(
    userActivity: {event: LI_CONNECTION_REQUEST_SENT, url: $url, recordedAt: $recordedAt, vacancyId: $vacancyId}
  ) {
    id
  }
}
    `;
export type RecordLiConnectionRequestSentMutationFn = Apollo.MutationFunction<RecordLiConnectionRequestSentMutation, RecordLiConnectionRequestSentMutationVariables>;

/**
 * __useRecordLiConnectionRequestSentMutation__
 *
 * To run a mutation, you first call `useRecordLiConnectionRequestSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordLiConnectionRequestSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordLiConnectionRequestSentMutation, { data, loading, error }] = useRecordLiConnectionRequestSentMutation({
 *   variables: {
 *      url: // value for 'url'
 *      recordedAt: // value for 'recordedAt'
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useRecordLiConnectionRequestSentMutation(baseOptions?: Apollo.MutationHookOptions<RecordLiConnectionRequestSentMutation, RecordLiConnectionRequestSentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordLiConnectionRequestSentMutation, RecordLiConnectionRequestSentMutationVariables>(RecordLiConnectionRequestSentDocument, options);
      }
export type RecordLiConnectionRequestSentMutationHookResult = ReturnType<typeof useRecordLiConnectionRequestSentMutation>;
export type RecordLiConnectionRequestSentMutationResult = Apollo.MutationResult<RecordLiConnectionRequestSentMutation>;
export type RecordLiConnectionRequestSentMutationOptions = Apollo.BaseMutationOptions<RecordLiConnectionRequestSentMutation, RecordLiConnectionRequestSentMutationVariables>;
export const UserPersonalStatsDocument = gql`
    query UserPersonalStats($input: UserPersonalStatsInput!) {
  userPersonalStats(input: $input) {
    id
    name
    avatarUrl
    summary {
      autoInviteSent
    }
  }
}
    `;

/**
 * __useUserPersonalStatsQuery__
 *
 * To run a query within a React component, call `useUserPersonalStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPersonalStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPersonalStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPersonalStatsQuery(baseOptions: Apollo.QueryHookOptions<UserPersonalStatsQuery, UserPersonalStatsQueryVariables> & ({ variables: UserPersonalStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPersonalStatsQuery, UserPersonalStatsQueryVariables>(UserPersonalStatsDocument, options);
      }
export function useUserPersonalStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPersonalStatsQuery, UserPersonalStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPersonalStatsQuery, UserPersonalStatsQueryVariables>(UserPersonalStatsDocument, options);
        }
export function useUserPersonalStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserPersonalStatsQuery, UserPersonalStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPersonalStatsQuery, UserPersonalStatsQueryVariables>(UserPersonalStatsDocument, options);
        }
export type UserPersonalStatsQueryHookResult = ReturnType<typeof useUserPersonalStatsQuery>;
export type UserPersonalStatsLazyQueryHookResult = ReturnType<typeof useUserPersonalStatsLazyQuery>;
export type UserPersonalStatsSuspenseQueryHookResult = ReturnType<typeof useUserPersonalStatsSuspenseQuery>;
export type UserPersonalStatsQueryResult = Apollo.QueryResult<UserPersonalStatsQuery, UserPersonalStatsQueryVariables>;
export const RecordUserActivityMutationDocument = gql`
    mutation RecordUserActivityMutation($event: UserActivityEvent, $endedAt: String, $startedAt: String, $sessionId: String, $url: String!, $recordedAt: String, $vacancyId: String, $attributes: AWSJSON) {
  recordUserActivity(
    userActivity: {event: $event, endedAt: $endedAt, startedAt: $startedAt, sessionId: $sessionId, url: $url, recordedAt: $recordedAt, vacancyId: $vacancyId, attributes: $attributes}
  ) {
    id
  }
}
    `;
export type RecordUserActivityMutationMutationFn = Apollo.MutationFunction<RecordUserActivityMutationMutation, RecordUserActivityMutationMutationVariables>;

/**
 * __useRecordUserActivityMutationMutation__
 *
 * To run a mutation, you first call `useRecordUserActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUserActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUserActivityMutationMutation, { data, loading, error }] = useRecordUserActivityMutationMutation({
 *   variables: {
 *      event: // value for 'event'
 *      endedAt: // value for 'endedAt'
 *      startedAt: // value for 'startedAt'
 *      sessionId: // value for 'sessionId'
 *      url: // value for 'url'
 *      recordedAt: // value for 'recordedAt'
 *      vacancyId: // value for 'vacancyId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useRecordUserActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<RecordUserActivityMutationMutation, RecordUserActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordUserActivityMutationMutation, RecordUserActivityMutationMutationVariables>(RecordUserActivityMutationDocument, options);
      }
export type RecordUserActivityMutationMutationHookResult = ReturnType<typeof useRecordUserActivityMutationMutation>;
export type RecordUserActivityMutationMutationResult = Apollo.MutationResult<RecordUserActivityMutationMutation>;
export type RecordUserActivityMutationMutationOptions = Apollo.BaseMutationOptions<RecordUserActivityMutationMutation, RecordUserActivityMutationMutationVariables>;
export const GetUserActivityEventsDocument = gql`
    query GetUserActivityEvents($userIds: [ID!]!, $timeRange: TimeRange!, $skipCloseProximityEvents: Boolean, $skippedIndividualEvents: [String!]) {
  userActivities(
    input: {userIds: $userIds, timeRange: $timeRange, includeIndividualEvents: true, skipCloseProximityEvents: $skipCloseProximityEvents, skippedIndividualEvents: $skippedIndividualEvents}
  ) {
    users {
      items {
        id
        name
        avatarUrl
        timeZone
        events {
          name
          recordedAt
          vacancy
          offset
          color
          domainCategory {
            id
            name
            color
          }
        }
        summary {
          ...SummaryFields
        }
      }
    }
  }
}
    ${SummaryFieldsFragmentDoc}`;

/**
 * __useGetUserActivityEventsQuery__
 *
 * To run a query within a React component, call `useGetUserActivityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivityEventsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      timeRange: // value for 'timeRange'
 *      skipCloseProximityEvents: // value for 'skipCloseProximityEvents'
 *      skippedIndividualEvents: // value for 'skippedIndividualEvents'
 *   },
 * });
 */
export function useGetUserActivityEventsQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables> & ({ variables: GetUserActivityEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables>(GetUserActivityEventsDocument, options);
      }
export function useGetUserActivityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables>(GetUserActivityEventsDocument, options);
        }
export function useGetUserActivityEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables>(GetUserActivityEventsDocument, options);
        }
export type GetUserActivityEventsQueryHookResult = ReturnType<typeof useGetUserActivityEventsQuery>;
export type GetUserActivityEventsLazyQueryHookResult = ReturnType<typeof useGetUserActivityEventsLazyQuery>;
export type GetUserActivityEventsSuspenseQueryHookResult = ReturnType<typeof useGetUserActivityEventsSuspenseQuery>;
export type GetUserActivityEventsQueryResult = Apollo.QueryResult<GetUserActivityEventsQuery, GetUserActivityEventsQueryVariables>;
export const GetVacancySummariesDocument = gql`
    query GetVacancySummaries($userIds: [ID!]!, $timeRange: TimeRange!) {
  userActivities(input: {userIds: $userIds, timeRange: $timeRange}) {
    users {
      items {
        id
        name
        avatarUrl
        timeZone
        vacancySummaries {
          id
          name
          summary {
            ...SummaryFields
          }
        }
      }
    }
  }
}
    ${SummaryFieldsFragmentDoc}`;

/**
 * __useGetVacancySummariesQuery__
 *
 * To run a query within a React component, call `useGetVacancySummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacancySummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacancySummariesQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetVacancySummariesQuery(baseOptions: Apollo.QueryHookOptions<GetVacancySummariesQuery, GetVacancySummariesQueryVariables> & ({ variables: GetVacancySummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVacancySummariesQuery, GetVacancySummariesQueryVariables>(GetVacancySummariesDocument, options);
      }
export function useGetVacancySummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVacancySummariesQuery, GetVacancySummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVacancySummariesQuery, GetVacancySummariesQueryVariables>(GetVacancySummariesDocument, options);
        }
export function useGetVacancySummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVacancySummariesQuery, GetVacancySummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVacancySummariesQuery, GetVacancySummariesQueryVariables>(GetVacancySummariesDocument, options);
        }
export type GetVacancySummariesQueryHookResult = ReturnType<typeof useGetVacancySummariesQuery>;
export type GetVacancySummariesLazyQueryHookResult = ReturnType<typeof useGetVacancySummariesLazyQuery>;
export type GetVacancySummariesSuspenseQueryHookResult = ReturnType<typeof useGetVacancySummariesSuspenseQuery>;
export type GetVacancySummariesQueryResult = Apollo.QueryResult<GetVacancySummariesQuery, GetVacancySummariesQueryVariables>;
export const GetUserActivitySummariesDocument = gql`
    query GetUserActivitySummaries($userIds: [ID!], $timeRange: TimeRange!, $sortBy: UserActivitySummarySortBy, $searchInput: SearchInput) {
  userActivities(
    input: {userIds: $userIds, timeRange: $timeRange, sortBy: $sortBy, searchInput: $searchInput}
  ) {
    users {
      items {
        id
        name
        avatarUrl
        summary {
          ...SummaryFields
        }
      }
      total
    }
  }
}
    ${SummaryFieldsFragmentDoc}`;

/**
 * __useGetUserActivitySummariesQuery__
 *
 * To run a query within a React component, call `useGetUserActivitySummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivitySummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivitySummariesQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      timeRange: // value for 'timeRange'
 *      sortBy: // value for 'sortBy'
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useGetUserActivitySummariesQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables> & ({ variables: GetUserActivitySummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables>(GetUserActivitySummariesDocument, options);
      }
export function useGetUserActivitySummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables>(GetUserActivitySummariesDocument, options);
        }
export function useGetUserActivitySummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables>(GetUserActivitySummariesDocument, options);
        }
export type GetUserActivitySummariesQueryHookResult = ReturnType<typeof useGetUserActivitySummariesQuery>;
export type GetUserActivitySummariesLazyQueryHookResult = ReturnType<typeof useGetUserActivitySummariesLazyQuery>;
export type GetUserActivitySummariesSuspenseQueryHookResult = ReturnType<typeof useGetUserActivitySummariesSuspenseQuery>;
export type GetUserActivitySummariesQueryResult = Apollo.QueryResult<GetUserActivitySummariesQuery, GetUserActivitySummariesQueryVariables>;
export const GetUserActivityHighlightsDocument = gql`
    query GetUserActivityHighlights($userIds: [ID!], $timeRange: TimeRange!) {
  userActivities(input: {userIds: $userIds, timeRange: $timeRange}) {
    highlights {
      topPerformer {
        id
        name
        avatarUrl
        summary {
          ...SummaryFields
        }
      }
      underPerformers {
        id
        name
        summary {
          ...SummaryFields
        }
      }
    }
  }
}
    ${SummaryFieldsFragmentDoc}`;

/**
 * __useGetUserActivityHighlightsQuery__
 *
 * To run a query within a React component, call `useGetUserActivityHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivityHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivityHighlightsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetUserActivityHighlightsQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables> & ({ variables: GetUserActivityHighlightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables>(GetUserActivityHighlightsDocument, options);
      }
export function useGetUserActivityHighlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables>(GetUserActivityHighlightsDocument, options);
        }
export function useGetUserActivityHighlightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables>(GetUserActivityHighlightsDocument, options);
        }
export type GetUserActivityHighlightsQueryHookResult = ReturnType<typeof useGetUserActivityHighlightsQuery>;
export type GetUserActivityHighlightsLazyQueryHookResult = ReturnType<typeof useGetUserActivityHighlightsLazyQuery>;
export type GetUserActivityHighlightsSuspenseQueryHookResult = ReturnType<typeof useGetUserActivityHighlightsSuspenseQuery>;
export type GetUserActivityHighlightsQueryResult = Apollo.QueryResult<GetUserActivityHighlightsQuery, GetUserActivityHighlightsQueryVariables>;
export const GetVacancyUserActivitiesDocument = gql`
    query GetVacancyUserActivities($vacancyIds: [ID!]!) {
  userActivities(input: {vacancyIds: $vacancyIds}) {
    users {
      items {
        id
        name
        avatarUrl
        summary {
          ...SummaryFields
        }
      }
    }
  }
}
    ${SummaryFieldsFragmentDoc}`;

/**
 * __useGetVacancyUserActivitiesQuery__
 *
 * To run a query within a React component, call `useGetVacancyUserActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacancyUserActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacancyUserActivitiesQuery({
 *   variables: {
 *      vacancyIds: // value for 'vacancyIds'
 *   },
 * });
 */
export function useGetVacancyUserActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables> & ({ variables: GetVacancyUserActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables>(GetVacancyUserActivitiesDocument, options);
      }
export function useGetVacancyUserActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables>(GetVacancyUserActivitiesDocument, options);
        }
export function useGetVacancyUserActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables>(GetVacancyUserActivitiesDocument, options);
        }
export type GetVacancyUserActivitiesQueryHookResult = ReturnType<typeof useGetVacancyUserActivitiesQuery>;
export type GetVacancyUserActivitiesLazyQueryHookResult = ReturnType<typeof useGetVacancyUserActivitiesLazyQuery>;
export type GetVacancyUserActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetVacancyUserActivitiesSuspenseQuery>;
export type GetVacancyUserActivitiesQueryResult = Apollo.QueryResult<GetVacancyUserActivitiesQuery, GetVacancyUserActivitiesQueryVariables>;
export const GetUserActivitySummaryForEachDayDocument = gql`
    query GetUserActivitySummaryForEachDay($userIds: [ID!]!, $timeRange: TimeRange!) {
  userActivities(input: {userIds: $userIds, timeRange: $timeRange}) {
    users {
      items {
        id
        name
        dailySummaries {
          date
          summary {
            ...SummaryFields
          }
        }
      }
    }
  }
}
    ${SummaryFieldsFragmentDoc}`;

/**
 * __useGetUserActivitySummaryForEachDayQuery__
 *
 * To run a query within a React component, call `useGetUserActivitySummaryForEachDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivitySummaryForEachDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivitySummaryForEachDayQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetUserActivitySummaryForEachDayQuery(baseOptions: Apollo.QueryHookOptions<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables> & ({ variables: GetUserActivitySummaryForEachDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables>(GetUserActivitySummaryForEachDayDocument, options);
      }
export function useGetUserActivitySummaryForEachDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables>(GetUserActivitySummaryForEachDayDocument, options);
        }
export function useGetUserActivitySummaryForEachDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables>(GetUserActivitySummaryForEachDayDocument, options);
        }
export type GetUserActivitySummaryForEachDayQueryHookResult = ReturnType<typeof useGetUserActivitySummaryForEachDayQuery>;
export type GetUserActivitySummaryForEachDayLazyQueryHookResult = ReturnType<typeof useGetUserActivitySummaryForEachDayLazyQuery>;
export type GetUserActivitySummaryForEachDaySuspenseQueryHookResult = ReturnType<typeof useGetUserActivitySummaryForEachDaySuspenseQuery>;
export type GetUserActivitySummaryForEachDayQueryResult = Apollo.QueryResult<GetUserActivitySummaryForEachDayQuery, GetUserActivitySummaryForEachDayQueryVariables>;
export const GetUserActivityTeamAverageDocument = gql`
    query GetUserActivityTeamAverage($timeRange: TimeRange) {
  userActivities(input: {timeRange: $timeRange}) {
    average {
      profilesViewed
      emailsSent
      emailRepliesReceived
      hoursWorked
      score
    }
  }
}
    `;

/**
 * __useGetUserActivityTeamAverageQuery__
 *
 * To run a query within a React component, call `useGetUserActivityTeamAverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserActivityTeamAverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserActivityTeamAverageQuery({
 *   variables: {
 *      timeRange: // value for 'timeRange'
 *   },
 * });
 */
export function useGetUserActivityTeamAverageQuery(baseOptions?: Apollo.QueryHookOptions<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>(GetUserActivityTeamAverageDocument, options);
      }
export function useGetUserActivityTeamAverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>(GetUserActivityTeamAverageDocument, options);
        }
export function useGetUserActivityTeamAverageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>(GetUserActivityTeamAverageDocument, options);
        }
export type GetUserActivityTeamAverageQueryHookResult = ReturnType<typeof useGetUserActivityTeamAverageQuery>;
export type GetUserActivityTeamAverageLazyQueryHookResult = ReturnType<typeof useGetUserActivityTeamAverageLazyQuery>;
export type GetUserActivityTeamAverageSuspenseQueryHookResult = ReturnType<typeof useGetUserActivityTeamAverageSuspenseQuery>;
export type GetUserActivityTeamAverageQueryResult = Apollo.QueryResult<GetUserActivityTeamAverageQuery, GetUserActivityTeamAverageQueryVariables>;
export const DomainTimeSpentDocument = gql`
    query DomainTimeSpent($input: DomainTimeSpentInput!) {
  domainTimeSpent(input: $input) {
    items {
      domain
      timeSpent
    }
    total
  }
}
    `;

/**
 * __useDomainTimeSpentQuery__
 *
 * To run a query within a React component, call `useDomainTimeSpentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainTimeSpentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainTimeSpentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDomainTimeSpentQuery(baseOptions: Apollo.QueryHookOptions<DomainTimeSpentQuery, DomainTimeSpentQueryVariables> & ({ variables: DomainTimeSpentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainTimeSpentQuery, DomainTimeSpentQueryVariables>(DomainTimeSpentDocument, options);
      }
export function useDomainTimeSpentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainTimeSpentQuery, DomainTimeSpentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainTimeSpentQuery, DomainTimeSpentQueryVariables>(DomainTimeSpentDocument, options);
        }
export function useDomainTimeSpentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainTimeSpentQuery, DomainTimeSpentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainTimeSpentQuery, DomainTimeSpentQueryVariables>(DomainTimeSpentDocument, options);
        }
export type DomainTimeSpentQueryHookResult = ReturnType<typeof useDomainTimeSpentQuery>;
export type DomainTimeSpentLazyQueryHookResult = ReturnType<typeof useDomainTimeSpentLazyQuery>;
export type DomainTimeSpentSuspenseQueryHookResult = ReturnType<typeof useDomainTimeSpentSuspenseQuery>;
export type DomainTimeSpentQueryResult = Apollo.QueryResult<DomainTimeSpentQuery, DomainTimeSpentQueryVariables>;
export const ListUserTasksDocument = gql`
    query ListUserTasks($input: ListUserTasksInput!) {
  listUserTasks(input: $input) {
    total
    items {
      id
      title
      description
      assigneeUserId
      creatorUserId
      createdAt
      deadlineAt
      doneAt
      Assignee {
        name
      }
      Creator {
        name
      }
      Candidate {
        firstName
        lastName
        id
      }
    }
  }
}
    `;

/**
 * __useListUserTasksQuery__
 *
 * To run a query within a React component, call `useListUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserTasksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListUserTasksQuery(baseOptions: Apollo.QueryHookOptions<ListUserTasksQuery, ListUserTasksQueryVariables> & ({ variables: ListUserTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserTasksQuery, ListUserTasksQueryVariables>(ListUserTasksDocument, options);
      }
export function useListUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserTasksQuery, ListUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserTasksQuery, ListUserTasksQueryVariables>(ListUserTasksDocument, options);
        }
export function useListUserTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListUserTasksQuery, ListUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListUserTasksQuery, ListUserTasksQueryVariables>(ListUserTasksDocument, options);
        }
export type ListUserTasksQueryHookResult = ReturnType<typeof useListUserTasksQuery>;
export type ListUserTasksLazyQueryHookResult = ReturnType<typeof useListUserTasksLazyQuery>;
export type ListUserTasksSuspenseQueryHookResult = ReturnType<typeof useListUserTasksSuspenseQuery>;
export type ListUserTasksQueryResult = Apollo.QueryResult<ListUserTasksQuery, ListUserTasksQueryVariables>;
export const CreateUserTaskDocument = gql`
    mutation CreateUserTask($input: CreateUserTaskInput!) {
  createUserTask(input: $input) {
    id
  }
}
    `;
export type CreateUserTaskMutationFn = Apollo.MutationFunction<CreateUserTaskMutation, CreateUserTaskMutationVariables>;

/**
 * __useCreateUserTaskMutation__
 *
 * To run a mutation, you first call `useCreateUserTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTaskMutation, { data, loading, error }] = useCreateUserTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserTaskMutation, CreateUserTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserTaskMutation, CreateUserTaskMutationVariables>(CreateUserTaskDocument, options);
      }
export type CreateUserTaskMutationHookResult = ReturnType<typeof useCreateUserTaskMutation>;
export type CreateUserTaskMutationResult = Apollo.MutationResult<CreateUserTaskMutation>;
export type CreateUserTaskMutationOptions = Apollo.BaseMutationOptions<CreateUserTaskMutation, CreateUserTaskMutationVariables>;
export const MarkUserTaskAsDoneDocument = gql`
    mutation MarkUserTaskAsDone($id: String!) {
  markUserTaskAsDone(id: $id) {
    id
  }
}
    `;
export type MarkUserTaskAsDoneMutationFn = Apollo.MutationFunction<MarkUserTaskAsDoneMutation, MarkUserTaskAsDoneMutationVariables>;

/**
 * __useMarkUserTaskAsDoneMutation__
 *
 * To run a mutation, you first call `useMarkUserTaskAsDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserTaskAsDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserTaskAsDoneMutation, { data, loading, error }] = useMarkUserTaskAsDoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUserTaskAsDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserTaskAsDoneMutation, MarkUserTaskAsDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserTaskAsDoneMutation, MarkUserTaskAsDoneMutationVariables>(MarkUserTaskAsDoneDocument, options);
      }
export type MarkUserTaskAsDoneMutationHookResult = ReturnType<typeof useMarkUserTaskAsDoneMutation>;
export type MarkUserTaskAsDoneMutationResult = Apollo.MutationResult<MarkUserTaskAsDoneMutation>;
export type MarkUserTaskAsDoneMutationOptions = Apollo.BaseMutationOptions<MarkUserTaskAsDoneMutation, MarkUserTaskAsDoneMutationVariables>;
export const MarkUserTaskAsNotDoneDocument = gql`
    mutation MarkUserTaskAsNotDone($id: String!) {
  markUserTaskAsNotDone(id: $id) {
    id
  }
}
    `;
export type MarkUserTaskAsNotDoneMutationFn = Apollo.MutationFunction<MarkUserTaskAsNotDoneMutation, MarkUserTaskAsNotDoneMutationVariables>;

/**
 * __useMarkUserTaskAsNotDoneMutation__
 *
 * To run a mutation, you first call `useMarkUserTaskAsNotDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserTaskAsNotDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserTaskAsNotDoneMutation, { data, loading, error }] = useMarkUserTaskAsNotDoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkUserTaskAsNotDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserTaskAsNotDoneMutation, MarkUserTaskAsNotDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserTaskAsNotDoneMutation, MarkUserTaskAsNotDoneMutationVariables>(MarkUserTaskAsNotDoneDocument, options);
      }
export type MarkUserTaskAsNotDoneMutationHookResult = ReturnType<typeof useMarkUserTaskAsNotDoneMutation>;
export type MarkUserTaskAsNotDoneMutationResult = Apollo.MutationResult<MarkUserTaskAsNotDoneMutation>;
export type MarkUserTaskAsNotDoneMutationOptions = Apollo.BaseMutationOptions<MarkUserTaskAsNotDoneMutation, MarkUserTaskAsNotDoneMutationVariables>;
export const DeleteUserTaskDocument = gql`
    mutation DeleteUserTask($id: String!) {
  deleteUserTask(id: $id) {
    id
  }
}
    `;
export type DeleteUserTaskMutationFn = Apollo.MutationFunction<DeleteUserTaskMutation, DeleteUserTaskMutationVariables>;

/**
 * __useDeleteUserTaskMutation__
 *
 * To run a mutation, you first call `useDeleteUserTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTaskMutation, { data, loading, error }] = useDeleteUserTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTaskMutation, DeleteUserTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTaskMutation, DeleteUserTaskMutationVariables>(DeleteUserTaskDocument, options);
      }
export type DeleteUserTaskMutationHookResult = ReturnType<typeof useDeleteUserTaskMutation>;
export type DeleteUserTaskMutationResult = Apollo.MutationResult<DeleteUserTaskMutation>;
export type DeleteUserTaskMutationOptions = Apollo.BaseMutationOptions<DeleteUserTaskMutation, DeleteUserTaskMutationVariables>;
export const CloseVacancyDocument = gql`
    mutation CloseVacancy($vacancyId: String!) {
  updateVacancy(vacancyId: $vacancyId, vacancyStatus: CLOSED) {
    id
    status
  }
}
    `;
export type CloseVacancyMutationFn = Apollo.MutationFunction<CloseVacancyMutation, CloseVacancyMutationVariables>;

/**
 * __useCloseVacancyMutation__
 *
 * To run a mutation, you first call `useCloseVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeVacancyMutation, { data, loading, error }] = useCloseVacancyMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useCloseVacancyMutation(baseOptions?: Apollo.MutationHookOptions<CloseVacancyMutation, CloseVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseVacancyMutation, CloseVacancyMutationVariables>(CloseVacancyDocument, options);
      }
export type CloseVacancyMutationHookResult = ReturnType<typeof useCloseVacancyMutation>;
export type CloseVacancyMutationResult = Apollo.MutationResult<CloseVacancyMutation>;
export type CloseVacancyMutationOptions = Apollo.BaseMutationOptions<CloseVacancyMutation, CloseVacancyMutationVariables>;
export const UpdateVacancyMetaDocument = gql`
    mutation UpdateVacancyMeta($key: String!, $meta: String!, $vacancyId: String!) {
  assignVacancyMeta(key: $key, meta: $meta, vacancyId: $vacancyId) {
    id
  }
}
    `;
export type UpdateVacancyMetaMutationFn = Apollo.MutationFunction<UpdateVacancyMetaMutation, UpdateVacancyMetaMutationVariables>;

/**
 * __useUpdateVacancyMetaMutation__
 *
 * To run a mutation, you first call `useUpdateVacancyMetaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacancyMetaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacancyMetaMutation, { data, loading, error }] = useUpdateVacancyMetaMutation({
 *   variables: {
 *      key: // value for 'key'
 *      meta: // value for 'meta'
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useUpdateVacancyMetaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacancyMetaMutation, UpdateVacancyMetaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacancyMetaMutation, UpdateVacancyMetaMutationVariables>(UpdateVacancyMetaDocument, options);
      }
export type UpdateVacancyMetaMutationHookResult = ReturnType<typeof useUpdateVacancyMetaMutation>;
export type UpdateVacancyMetaMutationResult = Apollo.MutationResult<UpdateVacancyMetaMutation>;
export type UpdateVacancyMetaMutationOptions = Apollo.BaseMutationOptions<UpdateVacancyMetaMutation, UpdateVacancyMetaMutationVariables>;
export const UpdateVacancyStateDocument = gql`
    mutation UpdateVacancyState($vacancyId: String!, $vacancyStatus: VacancyStatus!) {
  updateVacancy(vacancyId: $vacancyId, vacancyStatus: $vacancyStatus) {
    id
  }
}
    `;
export type UpdateVacancyStateMutationFn = Apollo.MutationFunction<UpdateVacancyStateMutation, UpdateVacancyStateMutationVariables>;

/**
 * __useUpdateVacancyStateMutation__
 *
 * To run a mutation, you first call `useUpdateVacancyStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacancyStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacancyStateMutation, { data, loading, error }] = useUpdateVacancyStateMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      vacancyStatus: // value for 'vacancyStatus'
 *   },
 * });
 */
export function useUpdateVacancyStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacancyStateMutation, UpdateVacancyStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacancyStateMutation, UpdateVacancyStateMutationVariables>(UpdateVacancyStateDocument, options);
      }
export type UpdateVacancyStateMutationHookResult = ReturnType<typeof useUpdateVacancyStateMutation>;
export type UpdateVacancyStateMutationResult = Apollo.MutationResult<UpdateVacancyStateMutation>;
export type UpdateVacancyStateMutationOptions = Apollo.BaseMutationOptions<UpdateVacancyStateMutation, UpdateVacancyStateMutationVariables>;
export const GetFullVacancyInfoDocument = gql`
    query GetFullVacancyInfo($vacancyId: String!) {
  getVacancy(input: {vacancyId: $vacancyId}) {
    ...VacancyOutputFragment
    location {
      city
      country
      region
    }
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useGetFullVacancyInfoQuery__
 *
 * To run a query within a React component, call `useGetFullVacancyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullVacancyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullVacancyInfoQuery({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useGetFullVacancyInfoQuery(baseOptions: Apollo.QueryHookOptions<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables> & ({ variables: GetFullVacancyInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables>(GetFullVacancyInfoDocument, options);
      }
export function useGetFullVacancyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables>(GetFullVacancyInfoDocument, options);
        }
export function useGetFullVacancyInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables>(GetFullVacancyInfoDocument, options);
        }
export type GetFullVacancyInfoQueryHookResult = ReturnType<typeof useGetFullVacancyInfoQuery>;
export type GetFullVacancyInfoLazyQueryHookResult = ReturnType<typeof useGetFullVacancyInfoLazyQuery>;
export type GetFullVacancyInfoSuspenseQueryHookResult = ReturnType<typeof useGetFullVacancyInfoSuspenseQuery>;
export type GetFullVacancyInfoQueryResult = Apollo.QueryResult<GetFullVacancyInfoQuery, GetFullVacancyInfoQueryVariables>;
export const FindVacancyByLinkDocument = gql`
    query FindVacancyByLink($atsLink: String!) {
  getVacancy(input: {atsLink: $atsLink}) {
    id
    name
  }
}
    `;

/**
 * __useFindVacancyByLinkQuery__
 *
 * To run a query within a React component, call `useFindVacancyByLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVacancyByLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVacancyByLinkQuery({
 *   variables: {
 *      atsLink: // value for 'atsLink'
 *   },
 * });
 */
export function useFindVacancyByLinkQuery(baseOptions: Apollo.QueryHookOptions<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables> & ({ variables: FindVacancyByLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables>(FindVacancyByLinkDocument, options);
      }
export function useFindVacancyByLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables>(FindVacancyByLinkDocument, options);
        }
export function useFindVacancyByLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables>(FindVacancyByLinkDocument, options);
        }
export type FindVacancyByLinkQueryHookResult = ReturnType<typeof useFindVacancyByLinkQuery>;
export type FindVacancyByLinkLazyQueryHookResult = ReturnType<typeof useFindVacancyByLinkLazyQuery>;
export type FindVacancyByLinkSuspenseQueryHookResult = ReturnType<typeof useFindVacancyByLinkSuspenseQuery>;
export type FindVacancyByLinkQueryResult = Apollo.QueryResult<FindVacancyByLinkQuery, FindVacancyByLinkQueryVariables>;
export const GetVacancySkillsDocument = gql`
    query GetVacancySkills($vacancyId: String!) {
  getVacancy(input: {vacancyId: $vacancyId}) {
    id
    skills {
      yearsOfExperience
      skill {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetVacancySkillsQuery__
 *
 * To run a query within a React component, call `useGetVacancySkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacancySkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacancySkillsQuery({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useGetVacancySkillsQuery(baseOptions: Apollo.QueryHookOptions<GetVacancySkillsQuery, GetVacancySkillsQueryVariables> & ({ variables: GetVacancySkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVacancySkillsQuery, GetVacancySkillsQueryVariables>(GetVacancySkillsDocument, options);
      }
export function useGetVacancySkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVacancySkillsQuery, GetVacancySkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVacancySkillsQuery, GetVacancySkillsQueryVariables>(GetVacancySkillsDocument, options);
        }
export function useGetVacancySkillsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVacancySkillsQuery, GetVacancySkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVacancySkillsQuery, GetVacancySkillsQueryVariables>(GetVacancySkillsDocument, options);
        }
export type GetVacancySkillsQueryHookResult = ReturnType<typeof useGetVacancySkillsQuery>;
export type GetVacancySkillsLazyQueryHookResult = ReturnType<typeof useGetVacancySkillsLazyQuery>;
export type GetVacancySkillsSuspenseQueryHookResult = ReturnType<typeof useGetVacancySkillsSuspenseQuery>;
export type GetVacancySkillsQueryResult = Apollo.QueryResult<GetVacancySkillsQuery, GetVacancySkillsQueryVariables>;
export const AddSkillsToVacancyDocument = gql`
    mutation AddSkillsToVacancy($vacancyId: String!, $appendSkills: [DesiredSkill!]) {
  updateVacancy2(
    input: {vacancyId: $vacancyId, data: {appendSkills: $appendSkills}}
  ) {
    id
  }
}
    `;
export type AddSkillsToVacancyMutationFn = Apollo.MutationFunction<AddSkillsToVacancyMutation, AddSkillsToVacancyMutationVariables>;

/**
 * __useAddSkillsToVacancyMutation__
 *
 * To run a mutation, you first call `useAddSkillsToVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSkillsToVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSkillsToVacancyMutation, { data, loading, error }] = useAddSkillsToVacancyMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      appendSkills: // value for 'appendSkills'
 *   },
 * });
 */
export function useAddSkillsToVacancyMutation(baseOptions?: Apollo.MutationHookOptions<AddSkillsToVacancyMutation, AddSkillsToVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSkillsToVacancyMutation, AddSkillsToVacancyMutationVariables>(AddSkillsToVacancyDocument, options);
      }
export type AddSkillsToVacancyMutationHookResult = ReturnType<typeof useAddSkillsToVacancyMutation>;
export type AddSkillsToVacancyMutationResult = Apollo.MutationResult<AddSkillsToVacancyMutation>;
export type AddSkillsToVacancyMutationOptions = Apollo.BaseMutationOptions<AddSkillsToVacancyMutation, AddSkillsToVacancyMutationVariables>;
export const UpdateVacancyDocument = gql`
    mutation UpdateVacancy($vacancyId: String!, $name: String, $description: String, $atsLink: String, $clientName: String, $location: [LocationInput!], $vacancyStatus: VacancyStatus, $skills: [DesiredSkill!], $requiredCertificates: [CertificateInput!], $previousIndustries: [String!], $aiChecks: [AiCheck!], $vertical: Vertical, $elevatorPitch: String, $benefitsTemplateFragment: String, $responsibilitiesFragment: String, $disclosureTemplateFragment: String, $positiveOPCs: [String!], $negativeOPCs: [String!], $isStackRankRequired: Boolean, $shouldSearchCandidates: Boolean, $phoneNumber: String, $positionType: PositionType, $schedulingLink: String) {
  updateVacancy(
    vacancyId: $vacancyId
    name: $name
    description: $description
    atsLink: $atsLink
    clientName: $clientName
    location: $location
    vacancyStatus: $vacancyStatus
    skills: $skills
    requiredCertificates: $requiredCertificates
    previousIndustries: $previousIndustries
    aiChecks: $aiChecks
    vertical: $vertical
    elevatorPitch: $elevatorPitch
    benefitsTemplateFragment: $benefitsTemplateFragment
    responsibilitiesFragment: $responsibilitiesFragment
    disclosureTemplateFragment: $disclosureTemplateFragment
    positiveOPCs: $positiveOPCs
    negativeOPCs: $negativeOPCs
    isStackRankRequired: $isStackRankRequired
    shouldSearchCandidates: $shouldSearchCandidates
    phoneNumber: $phoneNumber
    positionType: $positionType
    schedulingLink: $schedulingLink
  ) {
    id
    name
    description
    vertical
    elevatorPitch
    benefitsTemplateFragment
    responsibilitiesFragment
    skills {
      yearsOfExperience
      skill {
        id
        name
      }
    }
    positiveOPCs
    negativeOPCs
    isStackRankRequired
    recruitmentType
    schedulingLink
    clientName
  }
}
    `;
export type UpdateVacancyMutationFn = Apollo.MutationFunction<UpdateVacancyMutation, UpdateVacancyMutationVariables>;

/**
 * __useUpdateVacancyMutation__
 *
 * To run a mutation, you first call `useUpdateVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacancyMutation, { data, loading, error }] = useUpdateVacancyMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      atsLink: // value for 'atsLink'
 *      clientName: // value for 'clientName'
 *      location: // value for 'location'
 *      vacancyStatus: // value for 'vacancyStatus'
 *      skills: // value for 'skills'
 *      requiredCertificates: // value for 'requiredCertificates'
 *      previousIndustries: // value for 'previousIndustries'
 *      aiChecks: // value for 'aiChecks'
 *      vertical: // value for 'vertical'
 *      elevatorPitch: // value for 'elevatorPitch'
 *      benefitsTemplateFragment: // value for 'benefitsTemplateFragment'
 *      responsibilitiesFragment: // value for 'responsibilitiesFragment'
 *      disclosureTemplateFragment: // value for 'disclosureTemplateFragment'
 *      positiveOPCs: // value for 'positiveOPCs'
 *      negativeOPCs: // value for 'negativeOPCs'
 *      isStackRankRequired: // value for 'isStackRankRequired'
 *      shouldSearchCandidates: // value for 'shouldSearchCandidates'
 *      phoneNumber: // value for 'phoneNumber'
 *      positionType: // value for 'positionType'
 *      schedulingLink: // value for 'schedulingLink'
 *   },
 * });
 */
export function useUpdateVacancyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacancyMutation, UpdateVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacancyMutation, UpdateVacancyMutationVariables>(UpdateVacancyDocument, options);
      }
export type UpdateVacancyMutationHookResult = ReturnType<typeof useUpdateVacancyMutation>;
export type UpdateVacancyMutationResult = Apollo.MutationResult<UpdateVacancyMutation>;
export type UpdateVacancyMutationOptions = Apollo.BaseMutationOptions<UpdateVacancyMutation, UpdateVacancyMutationVariables>;
export const UpdateVacancy2Document = gql`
    mutation UpdateVacancy2($input: UpdateVacancy2Input!) {
  updateVacancy2(input: $input) {
    id
    name
    description
    vertical
    elevatorPitch
    benefitsTemplateFragment
    responsibilitiesFragment
    skills {
      yearsOfExperience
      skill {
        id
        name
      }
    }
    positiveOPCs
    negativeOPCs
    isStackRankRequired
    recruitmentType
    schedulingLink
    clientName
  }
}
    `;
export type UpdateVacancy2MutationFn = Apollo.MutationFunction<UpdateVacancy2Mutation, UpdateVacancy2MutationVariables>;

/**
 * __useUpdateVacancy2Mutation__
 *
 * To run a mutation, you first call `useUpdateVacancy2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacancy2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacancy2Mutation, { data, loading, error }] = useUpdateVacancy2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVacancy2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacancy2Mutation, UpdateVacancy2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacancy2Mutation, UpdateVacancy2MutationVariables>(UpdateVacancy2Document, options);
      }
export type UpdateVacancy2MutationHookResult = ReturnType<typeof useUpdateVacancy2Mutation>;
export type UpdateVacancy2MutationResult = Apollo.MutationResult<UpdateVacancy2Mutation>;
export type UpdateVacancy2MutationOptions = Apollo.BaseMutationOptions<UpdateVacancy2Mutation, UpdateVacancy2MutationVariables>;
export const UpsertVacancyDocument = gql`
    mutation UpsertVacancy($input: UpsertVacancyInput!) {
  upsertVacancy(input: $input) {
    ...VacancyOutputFragment
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;
export type UpsertVacancyMutationFn = Apollo.MutationFunction<UpsertVacancyMutation, UpsertVacancyMutationVariables>;

/**
 * __useUpsertVacancyMutation__
 *
 * To run a mutation, you first call `useUpsertVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVacancyMutation, { data, loading, error }] = useUpsertVacancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertVacancyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertVacancyMutation, UpsertVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertVacancyMutation, UpsertVacancyMutationVariables>(UpsertVacancyDocument, options);
      }
export type UpsertVacancyMutationHookResult = ReturnType<typeof useUpsertVacancyMutation>;
export type UpsertVacancyMutationResult = Apollo.MutationResult<UpsertVacancyMutation>;
export type UpsertVacancyMutationOptions = Apollo.BaseMutationOptions<UpsertVacancyMutation, UpsertVacancyMutationVariables>;
export const DashboardListVacanciesDocument = gql`
    query DashboardListVacancies($search: String, $take: Int!, $page: Int, $inStatus: [VacancyStatus!], $vacancyIds: [String!], $forStackRank: Boolean, $includeNewMatchesCount: Boolean) {
  listVacancies(
    search: $search
    take: $take
    page: $page
    inStatus: $inStatus
    vacancyIds: $vacancyIds
    forStackRank: $forStackRank
    includeNewMatchesCount: $includeNewMatchesCount
  ) {
    items {
      ...VacancyOutputFragment
    }
    page
    total
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useDashboardListVacanciesQuery__
 *
 * To run a query within a React component, call `useDashboardListVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardListVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardListVacanciesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      page: // value for 'page'
 *      inStatus: // value for 'inStatus'
 *      vacancyIds: // value for 'vacancyIds'
 *      forStackRank: // value for 'forStackRank'
 *      includeNewMatchesCount: // value for 'includeNewMatchesCount'
 *   },
 * });
 */
export function useDashboardListVacanciesQuery(baseOptions: Apollo.QueryHookOptions<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables> & ({ variables: DashboardListVacanciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables>(DashboardListVacanciesDocument, options);
      }
export function useDashboardListVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables>(DashboardListVacanciesDocument, options);
        }
export function useDashboardListVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables>(DashboardListVacanciesDocument, options);
        }
export type DashboardListVacanciesQueryHookResult = ReturnType<typeof useDashboardListVacanciesQuery>;
export type DashboardListVacanciesLazyQueryHookResult = ReturnType<typeof useDashboardListVacanciesLazyQuery>;
export type DashboardListVacanciesSuspenseQueryHookResult = ReturnType<typeof useDashboardListVacanciesSuspenseQuery>;
export type DashboardListVacanciesQueryResult = Apollo.QueryResult<DashboardListVacanciesQuery, DashboardListVacanciesQueryVariables>;
export const ListVacanciesDocument = gql`
    query ListVacancies($search: String, $nextToken: String, $orderBy: [FieldOrder!], $inStatus: [VacancyStatus!], $take: Int!, $page: Int, $idToken: String) {
  listVacancies(
    search: $search
    inStatus: $inStatus
    take: $take
    page: $page
    idToken: $idToken
    orderBy: $orderBy
  ) {
    items {
      ...VacancyOutputFragment
    }
    page
    total
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useListVacanciesQuery__
 *
 * To run a query within a React component, call `useListVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVacanciesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      nextToken: // value for 'nextToken'
 *      orderBy: // value for 'orderBy'
 *      inStatus: // value for 'inStatus'
 *      take: // value for 'take'
 *      page: // value for 'page'
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useListVacanciesQuery(baseOptions: Apollo.QueryHookOptions<ListVacanciesQuery, ListVacanciesQueryVariables> & ({ variables: ListVacanciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListVacanciesQuery, ListVacanciesQueryVariables>(ListVacanciesDocument, options);
      }
export function useListVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListVacanciesQuery, ListVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListVacanciesQuery, ListVacanciesQueryVariables>(ListVacanciesDocument, options);
        }
export function useListVacanciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListVacanciesQuery, ListVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListVacanciesQuery, ListVacanciesQueryVariables>(ListVacanciesDocument, options);
        }
export type ListVacanciesQueryHookResult = ReturnType<typeof useListVacanciesQuery>;
export type ListVacanciesLazyQueryHookResult = ReturnType<typeof useListVacanciesLazyQuery>;
export type ListVacanciesSuspenseQueryHookResult = ReturnType<typeof useListVacanciesSuspenseQuery>;
export type ListVacanciesQueryResult = Apollo.QueryResult<ListVacanciesQuery, ListVacanciesQueryVariables>;
export const SearchVacanciesQueryDocument = gql`
    query SearchVacanciesQuery($name: String!, $take: Int = 3, $idToken: String, $page: Int = 1, $inStatus: [VacancyStatus!], $crossTenantSearch: Boolean) {
  listVacancies(
    search: $name
    take: $take
    idToken: $idToken
    page: $page
    inStatus: $inStatus
    crossTenantSearch: $crossTenantSearch
  ) {
    items {
      ...VacancyOutputFragment
    }
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useSearchVacanciesQueryQuery__
 *
 * To run a query within a React component, call `useSearchVacanciesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVacanciesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVacanciesQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *      take: // value for 'take'
 *      idToken: // value for 'idToken'
 *      page: // value for 'page'
 *      inStatus: // value for 'inStatus'
 *      crossTenantSearch: // value for 'crossTenantSearch'
 *   },
 * });
 */
export function useSearchVacanciesQueryQuery(baseOptions: Apollo.QueryHookOptions<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables> & ({ variables: SearchVacanciesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables>(SearchVacanciesQueryDocument, options);
      }
export function useSearchVacanciesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables>(SearchVacanciesQueryDocument, options);
        }
export function useSearchVacanciesQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables>(SearchVacanciesQueryDocument, options);
        }
export type SearchVacanciesQueryQueryHookResult = ReturnType<typeof useSearchVacanciesQueryQuery>;
export type SearchVacanciesQueryLazyQueryHookResult = ReturnType<typeof useSearchVacanciesQueryLazyQuery>;
export type SearchVacanciesQuerySuspenseQueryHookResult = ReturnType<typeof useSearchVacanciesQuerySuspenseQuery>;
export type SearchVacanciesQueryQueryResult = Apollo.QueryResult<SearchVacanciesQueryQuery, SearchVacanciesQueryQueryVariables>;
export const SearchVacanciesLiteDocument = gql`
    query SearchVacanciesLite($name: String!, $take: Int = 3, $idToken: String, $page: Int = 1, $inStatus: [VacancyStatus!], $crossTenantSearch: Boolean, $onlyWithOpenTokens: Boolean) {
  listVacancies(
    search: $name
    take: $take
    idToken: $idToken
    page: $page
    inStatus: $inStatus
    crossTenantSearch: $crossTenantSearch
    onlyWithOpenTokens: $onlyWithOpenTokens
  ) {
    items {
      id
      name
      clientName
      status
      atsLink
      isEnriched
      clientTokens {
        ...ClientToken
      }
    }
  }
}
    ${ClientTokenFragmentDoc}`;

/**
 * __useSearchVacanciesLiteQuery__
 *
 * To run a query within a React component, call `useSearchVacanciesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVacanciesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVacanciesLiteQuery({
 *   variables: {
 *      name: // value for 'name'
 *      take: // value for 'take'
 *      idToken: // value for 'idToken'
 *      page: // value for 'page'
 *      inStatus: // value for 'inStatus'
 *      crossTenantSearch: // value for 'crossTenantSearch'
 *      onlyWithOpenTokens: // value for 'onlyWithOpenTokens'
 *   },
 * });
 */
export function useSearchVacanciesLiteQuery(baseOptions: Apollo.QueryHookOptions<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables> & ({ variables: SearchVacanciesLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables>(SearchVacanciesLiteDocument, options);
      }
export function useSearchVacanciesLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables>(SearchVacanciesLiteDocument, options);
        }
export function useSearchVacanciesLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables>(SearchVacanciesLiteDocument, options);
        }
export type SearchVacanciesLiteQueryHookResult = ReturnType<typeof useSearchVacanciesLiteQuery>;
export type SearchVacanciesLiteLazyQueryHookResult = ReturnType<typeof useSearchVacanciesLiteLazyQuery>;
export type SearchVacanciesLiteSuspenseQueryHookResult = ReturnType<typeof useSearchVacanciesLiteSuspenseQuery>;
export type SearchVacanciesLiteQueryResult = Apollo.QueryResult<SearchVacanciesLiteQuery, SearchVacanciesLiteQueryVariables>;
export const CreateVacancyMutationDocument = gql`
    mutation CreateVacancyMutation($name: String!, $client: ClientInput, $location: [LocationInput!], $skills: [DesiredSkill!], $requiredCertificates: [CertificateInput!], $previousIndustries: [String!], $aiChecks: [AiCheck!], $vertical: Vertical!, $atsLink: String, $elevatorPitch: String, $benefitsTemplateFragment: String, $responsibilitiesFragment: String, $disclosureTemplateFragment: String, $status: VacancyStatus, $positiveOPCs: [String!], $negativeOPCs: [String!], $isStackRankRequired: Boolean) {
  createVacancy(
    name: $name
    client: $client
    location: $location
    skills: $skills
    requiredCertificates: $requiredCertificates
    previousIndustries: $previousIndustries
    aiChecks: $aiChecks
    vertical: $vertical
    atsLink: $atsLink
    elevatorPitch: $elevatorPitch
    benefitsTemplateFragment: $benefitsTemplateFragment
    responsibilitiesFragment: $responsibilitiesFragment
    disclosureTemplateFragment: $disclosureTemplateFragment
    status: $status
    positiveOPCs: $positiveOPCs
    negativeOPCs: $negativeOPCs
    isStackRankRequired: $isStackRankRequired
  ) {
    id
    name
  }
}
    `;
export type CreateVacancyMutationMutationFn = Apollo.MutationFunction<CreateVacancyMutationMutation, CreateVacancyMutationMutationVariables>;

/**
 * __useCreateVacancyMutationMutation__
 *
 * To run a mutation, you first call `useCreateVacancyMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacancyMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacancyMutationMutation, { data, loading, error }] = useCreateVacancyMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      client: // value for 'client'
 *      location: // value for 'location'
 *      skills: // value for 'skills'
 *      requiredCertificates: // value for 'requiredCertificates'
 *      previousIndustries: // value for 'previousIndustries'
 *      aiChecks: // value for 'aiChecks'
 *      vertical: // value for 'vertical'
 *      atsLink: // value for 'atsLink'
 *      elevatorPitch: // value for 'elevatorPitch'
 *      benefitsTemplateFragment: // value for 'benefitsTemplateFragment'
 *      responsibilitiesFragment: // value for 'responsibilitiesFragment'
 *      disclosureTemplateFragment: // value for 'disclosureTemplateFragment'
 *      status: // value for 'status'
 *      positiveOPCs: // value for 'positiveOPCs'
 *      negativeOPCs: // value for 'negativeOPCs'
 *      isStackRankRequired: // value for 'isStackRankRequired'
 *   },
 * });
 */
export function useCreateVacancyMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacancyMutationMutation, CreateVacancyMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVacancyMutationMutation, CreateVacancyMutationMutationVariables>(CreateVacancyMutationDocument, options);
      }
export type CreateVacancyMutationMutationHookResult = ReturnType<typeof useCreateVacancyMutationMutation>;
export type CreateVacancyMutationMutationResult = Apollo.MutationResult<CreateVacancyMutationMutation>;
export type CreateVacancyMutationMutationOptions = Apollo.BaseMutationOptions<CreateVacancyMutationMutation, CreateVacancyMutationMutationVariables>;
export const RemoveCandidateFromListDocument = gql`
    mutation RemoveCandidateFromList($candidateId: String!, $listId: String!) {
  removeCandidateFromList(candidateId: $candidateId, listId: $listId) {
    id
  }
}
    `;
export type RemoveCandidateFromListMutationFn = Apollo.MutationFunction<RemoveCandidateFromListMutation, RemoveCandidateFromListMutationVariables>;

/**
 * __useRemoveCandidateFromListMutation__
 *
 * To run a mutation, you first call `useRemoveCandidateFromListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCandidateFromListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCandidateFromListMutation, { data, loading, error }] = useRemoveCandidateFromListMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useRemoveCandidateFromListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCandidateFromListMutation, RemoveCandidateFromListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCandidateFromListMutation, RemoveCandidateFromListMutationVariables>(RemoveCandidateFromListDocument, options);
      }
export type RemoveCandidateFromListMutationHookResult = ReturnType<typeof useRemoveCandidateFromListMutation>;
export type RemoveCandidateFromListMutationResult = Apollo.MutationResult<RemoveCandidateFromListMutation>;
export type RemoveCandidateFromListMutationOptions = Apollo.BaseMutationOptions<RemoveCandidateFromListMutation, RemoveCandidateFromListMutationVariables>;
export const AddCandidateToListsDocument = gql`
    mutation AddCandidateToLists($candidateId: String!, $vacancyLists: [VacancyList!]!) {
  addCandidateToLists(candidateId: $candidateId, vacancyLists: $vacancyLists) {
    id
  }
}
    `;
export type AddCandidateToListsMutationFn = Apollo.MutationFunction<AddCandidateToListsMutation, AddCandidateToListsMutationVariables>;

/**
 * __useAddCandidateToListsMutation__
 *
 * To run a mutation, you first call `useAddCandidateToListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidateToListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidateToListsMutation, { data, loading, error }] = useAddCandidateToListsMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      vacancyLists: // value for 'vacancyLists'
 *   },
 * });
 */
export function useAddCandidateToListsMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidateToListsMutation, AddCandidateToListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidateToListsMutation, AddCandidateToListsMutationVariables>(AddCandidateToListsDocument, options);
      }
export type AddCandidateToListsMutationHookResult = ReturnType<typeof useAddCandidateToListsMutation>;
export type AddCandidateToListsMutationResult = Apollo.MutationResult<AddCandidateToListsMutation>;
export type AddCandidateToListsMutationOptions = Apollo.BaseMutationOptions<AddCandidateToListsMutation, AddCandidateToListsMutationVariables>;
export const GetMiniVacancyByIdDocument = gql`
    query GetMiniVacancyById($vacancyId: String!) {
  getVacancy(input: {vacancyId: $vacancyId}) {
    ...VacancyOutputFragment
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useGetMiniVacancyByIdQuery__
 *
 * To run a query within a React component, call `useGetMiniVacancyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiniVacancyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiniVacancyByIdQuery({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useGetMiniVacancyByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables> & ({ variables: GetMiniVacancyByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables>(GetMiniVacancyByIdDocument, options);
      }
export function useGetMiniVacancyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables>(GetMiniVacancyByIdDocument, options);
        }
export function useGetMiniVacancyByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables>(GetMiniVacancyByIdDocument, options);
        }
export type GetMiniVacancyByIdQueryHookResult = ReturnType<typeof useGetMiniVacancyByIdQuery>;
export type GetMiniVacancyByIdLazyQueryHookResult = ReturnType<typeof useGetMiniVacancyByIdLazyQuery>;
export type GetMiniVacancyByIdSuspenseQueryHookResult = ReturnType<typeof useGetMiniVacancyByIdSuspenseQuery>;
export type GetMiniVacancyByIdQueryResult = Apollo.QueryResult<GetMiniVacancyByIdQuery, GetMiniVacancyByIdQueryVariables>;
export const CreateMiniVacancyDocument = gql`
    mutation CreateMiniVacancy($clientId: String, $name: String, $description: String, $requiredCertificates: [CertificateInput!], $skills: [DesiredSkill!], $location: [LocationInput!], $vertical: Vertical!, $atsLink: String, $elevatorPitch: String, $benefitsTemplateFragment: String, $responsibilitiesFragment: String, $disclosureTemplateFragment: String, $status: VacancyStatus, $positiveOPCs: [String!], $negativeOPCs: [String!], $isStackRankRequired: Boolean) {
  createVacancy(
    description: $description
    client: {id: $clientId}
    name: $name
    vertical: $vertical
    atsLink: $atsLink
    requiredCertificates: $requiredCertificates
    skills: $skills
    location: $location
    benefitsTemplateFragment: $benefitsTemplateFragment
    elevatorPitch: $elevatorPitch
    responsibilitiesFragment: $responsibilitiesFragment
    status: $status
    disclosureTemplateFragment: $disclosureTemplateFragment
    positiveOPCs: $positiveOPCs
    negativeOPCs: $negativeOPCs
    isStackRankRequired: $isStackRankRequired
  ) {
    ...VacancyOutputFragment
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;
export type CreateMiniVacancyMutationFn = Apollo.MutationFunction<CreateMiniVacancyMutation, CreateMiniVacancyMutationVariables>;

/**
 * __useCreateMiniVacancyMutation__
 *
 * To run a mutation, you first call `useCreateMiniVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMiniVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMiniVacancyMutation, { data, loading, error }] = useCreateMiniVacancyMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      requiredCertificates: // value for 'requiredCertificates'
 *      skills: // value for 'skills'
 *      location: // value for 'location'
 *      vertical: // value for 'vertical'
 *      atsLink: // value for 'atsLink'
 *      elevatorPitch: // value for 'elevatorPitch'
 *      benefitsTemplateFragment: // value for 'benefitsTemplateFragment'
 *      responsibilitiesFragment: // value for 'responsibilitiesFragment'
 *      disclosureTemplateFragment: // value for 'disclosureTemplateFragment'
 *      status: // value for 'status'
 *      positiveOPCs: // value for 'positiveOPCs'
 *      negativeOPCs: // value for 'negativeOPCs'
 *      isStackRankRequired: // value for 'isStackRankRequired'
 *   },
 * });
 */
export function useCreateMiniVacancyMutation(baseOptions?: Apollo.MutationHookOptions<CreateMiniVacancyMutation, CreateMiniVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMiniVacancyMutation, CreateMiniVacancyMutationVariables>(CreateMiniVacancyDocument, options);
      }
export type CreateMiniVacancyMutationHookResult = ReturnType<typeof useCreateMiniVacancyMutation>;
export type CreateMiniVacancyMutationResult = Apollo.MutationResult<CreateMiniVacancyMutation>;
export type CreateMiniVacancyMutationOptions = Apollo.BaseMutationOptions<CreateMiniVacancyMutation, CreateMiniVacancyMutationVariables>;
export const DeleteVacancyDocument = gql`
    mutation DeleteVacancy($id: String!) {
  deleteVacancy(id: $id) {
    id
  }
}
    `;
export type DeleteVacancyMutationFn = Apollo.MutationFunction<DeleteVacancyMutation, DeleteVacancyMutationVariables>;

/**
 * __useDeleteVacancyMutation__
 *
 * To run a mutation, you first call `useDeleteVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVacancyMutation, { data, loading, error }] = useDeleteVacancyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVacancyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVacancyMutation, DeleteVacancyMutationVariables>(DeleteVacancyDocument, options);
      }
export type DeleteVacancyMutationHookResult = ReturnType<typeof useDeleteVacancyMutation>;
export type DeleteVacancyMutationResult = Apollo.MutationResult<DeleteVacancyMutation>;
export type DeleteVacancyMutationOptions = Apollo.BaseMutationOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>;
export const InitParseDescriptionDocument = gql`
    mutation initParseDescription($name: String, $description: String, $url: String, $vertical: Vertical!, $vacancyId: String, $shouldGenerateName: Boolean, $taskId: String, $parseForNameTaskId: String, $parseForSkillsTaskId: String, $parseForElevatorPitchTaskId: String, $parseForBenefitsTaskId: String, $parseForDisclosureTaskId: String, $parseForResponsibilitiesTaskId: String, $shouldCreateClientVacancyChat: Boolean, $skip: [ParseTask!]) {
  initParseDescription(
    name: $name
    description: $description
    url: $url
    vertical: $vertical
    vacancyId: $vacancyId
    taskId: $taskId
    parseForBenefitsTaskId: $parseForBenefitsTaskId
    parseForDisclosureTaskId: $parseForDisclosureTaskId
    parseForResponsibilitiesTaskId: $parseForResponsibilitiesTaskId
    shouldGenerateName: $shouldGenerateName
    parseForNameTaskId: $parseForNameTaskId
    parseForSkillsTaskId: $parseForSkillsTaskId
    parseForElevatorPitchTaskId: $parseForElevatorPitchTaskId
    shouldCreateClientVacancyChat: $shouldCreateClientVacancyChat
    skip: $skip
  ) {
    success
    vacancyId
    vacancy {
      ...VacancyOutputFragment
    }
    taskId
    clientVacancyChatId
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;
export type InitParseDescriptionMutationFn = Apollo.MutationFunction<InitParseDescriptionMutation, InitParseDescriptionMutationVariables>;

/**
 * __useInitParseDescriptionMutation__
 *
 * To run a mutation, you first call `useInitParseDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitParseDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initParseDescriptionMutation, { data, loading, error }] = useInitParseDescriptionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      url: // value for 'url'
 *      vertical: // value for 'vertical'
 *      vacancyId: // value for 'vacancyId'
 *      shouldGenerateName: // value for 'shouldGenerateName'
 *      taskId: // value for 'taskId'
 *      parseForNameTaskId: // value for 'parseForNameTaskId'
 *      parseForSkillsTaskId: // value for 'parseForSkillsTaskId'
 *      parseForElevatorPitchTaskId: // value for 'parseForElevatorPitchTaskId'
 *      parseForBenefitsTaskId: // value for 'parseForBenefitsTaskId'
 *      parseForDisclosureTaskId: // value for 'parseForDisclosureTaskId'
 *      parseForResponsibilitiesTaskId: // value for 'parseForResponsibilitiesTaskId'
 *      shouldCreateClientVacancyChat: // value for 'shouldCreateClientVacancyChat'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useInitParseDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<InitParseDescriptionMutation, InitParseDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitParseDescriptionMutation, InitParseDescriptionMutationVariables>(InitParseDescriptionDocument, options);
      }
export type InitParseDescriptionMutationHookResult = ReturnType<typeof useInitParseDescriptionMutation>;
export type InitParseDescriptionMutationResult = Apollo.MutationResult<InitParseDescriptionMutation>;
export type InitParseDescriptionMutationOptions = Apollo.BaseMutationOptions<InitParseDescriptionMutation, InitParseDescriptionMutationVariables>;
export const OnVacancyUpdatedDocument = gql`
    subscription onVacancyUpdated($id: String!) {
  onVacancyUpdated(id: $id) {
    ...VacancyOutputFragment
  }
}
    ${VacancyOutputFragmentFragmentDoc}`;

/**
 * __useOnVacancyUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnVacancyUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnVacancyUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnVacancyUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnVacancyUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnVacancyUpdatedSubscription, OnVacancyUpdatedSubscriptionVariables> & ({ variables: OnVacancyUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnVacancyUpdatedSubscription, OnVacancyUpdatedSubscriptionVariables>(OnVacancyUpdatedDocument, options);
      }
export type OnVacancyUpdatedSubscriptionHookResult = ReturnType<typeof useOnVacancyUpdatedSubscription>;
export type OnVacancyUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnVacancyUpdatedSubscription>;
export const VacancyUpdatedDocument = gql`
    mutation vacancyUpdated($stringifiedVacancy: String!) {
  vacancyUpdated(stringifiedVacancy: $stringifiedVacancy) {
    id
    name
    description
    skills {
      ...VacancySkill
    }
    top3Skills
    location {
      country
    }
    vertical
    atsLink
    requiredCertificates {
      id
      name
    }
    elevatorPitch
  }
}
    ${VacancySkillFragmentDoc}`;
export type VacancyUpdatedMutationFn = Apollo.MutationFunction<VacancyUpdatedMutation, VacancyUpdatedMutationVariables>;

/**
 * __useVacancyUpdatedMutation__
 *
 * To run a mutation, you first call `useVacancyUpdatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVacancyUpdatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vacancyUpdatedMutation, { data, loading, error }] = useVacancyUpdatedMutation({
 *   variables: {
 *      stringifiedVacancy: // value for 'stringifiedVacancy'
 *   },
 * });
 */
export function useVacancyUpdatedMutation(baseOptions?: Apollo.MutationHookOptions<VacancyUpdatedMutation, VacancyUpdatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VacancyUpdatedMutation, VacancyUpdatedMutationVariables>(VacancyUpdatedDocument, options);
      }
export type VacancyUpdatedMutationHookResult = ReturnType<typeof useVacancyUpdatedMutation>;
export type VacancyUpdatedMutationResult = Apollo.MutationResult<VacancyUpdatedMutation>;
export type VacancyUpdatedMutationOptions = Apollo.BaseMutationOptions<VacancyUpdatedMutation, VacancyUpdatedMutationVariables>;
export const GetCandidateApplicationsDocument = gql`
    query GetCandidateApplications($input: GetCandidateApplicationsInput!) {
  getCandidateApplications(input: $input) {
    items {
      id
      score
      status
      candidate {
        id
        avatarS3Bucket
        avatarThumbS3Key
        avatarThumbOrigUrl
        firstName
        lastName
        liHeadline
        linkedInUrl
        positiveOPCs
        negativeOPCs
        workExperience {
          company {
            id
            name
          }
        }
      }
      survey {
        question
        result
        isRequired
        answer
        favorableAnswer
      }
      hasCV
    }
    total
    totalCVCount
  }
}
    `;

/**
 * __useGetCandidateApplicationsQuery__
 *
 * To run a query within a React component, call `useGetCandidateApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateApplicationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateApplicationsQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables> & ({ variables: GetCandidateApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables>(GetCandidateApplicationsDocument, options);
      }
export function useGetCandidateApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables>(GetCandidateApplicationsDocument, options);
        }
export function useGetCandidateApplicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables>(GetCandidateApplicationsDocument, options);
        }
export type GetCandidateApplicationsQueryHookResult = ReturnType<typeof useGetCandidateApplicationsQuery>;
export type GetCandidateApplicationsLazyQueryHookResult = ReturnType<typeof useGetCandidateApplicationsLazyQuery>;
export type GetCandidateApplicationsSuspenseQueryHookResult = ReturnType<typeof useGetCandidateApplicationsSuspenseQuery>;
export type GetCandidateApplicationsQueryResult = Apollo.QueryResult<GetCandidateApplicationsQuery, GetCandidateApplicationsQueryVariables>;
export const ListJobTitlesDocument = gql`
    query ListJobTitles($input: ListJobTitlesInput!) {
  listJobTitles(input: $input) {
    items {
      id
      title
      correlatedJobTitles {
        id
        title
      }
    }
    total
  }
}
    `;

/**
 * __useListJobTitlesQuery__
 *
 * To run a query within a React component, call `useListJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobTitlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListJobTitlesQuery(baseOptions: Apollo.QueryHookOptions<ListJobTitlesQuery, ListJobTitlesQueryVariables> & ({ variables: ListJobTitlesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListJobTitlesQuery, ListJobTitlesQueryVariables>(ListJobTitlesDocument, options);
      }
export function useListJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobTitlesQuery, ListJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListJobTitlesQuery, ListJobTitlesQueryVariables>(ListJobTitlesDocument, options);
        }
export function useListJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListJobTitlesQuery, ListJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListJobTitlesQuery, ListJobTitlesQueryVariables>(ListJobTitlesDocument, options);
        }
export type ListJobTitlesQueryHookResult = ReturnType<typeof useListJobTitlesQuery>;
export type ListJobTitlesLazyQueryHookResult = ReturnType<typeof useListJobTitlesLazyQuery>;
export type ListJobTitlesSuspenseQueryHookResult = ReturnType<typeof useListJobTitlesSuspenseQuery>;
export type ListJobTitlesQueryResult = Apollo.QueryResult<ListJobTitlesQuery, ListJobTitlesQueryVariables>;
export const CreateJobTitleDocument = gql`
    mutation CreateJobTitle($input: CreateJobTitleInput!) {
  createJobTitle(input: $input) {
    id
    title
    correlatedJobTitles {
      id
      title
    }
  }
}
    `;
export type CreateJobTitleMutationFn = Apollo.MutationFunction<CreateJobTitleMutation, CreateJobTitleMutationVariables>;

/**
 * __useCreateJobTitleMutation__
 *
 * To run a mutation, you first call `useCreateJobTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobTitleMutation, { data, loading, error }] = useCreateJobTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobTitleMutation, CreateJobTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobTitleMutation, CreateJobTitleMutationVariables>(CreateJobTitleDocument, options);
      }
export type CreateJobTitleMutationHookResult = ReturnType<typeof useCreateJobTitleMutation>;
export type CreateJobTitleMutationResult = Apollo.MutationResult<CreateJobTitleMutation>;
export type CreateJobTitleMutationOptions = Apollo.BaseMutationOptions<CreateJobTitleMutation, CreateJobTitleMutationVariables>;